/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type {
  AccountManagerNotifyRequest,
  AccountingPurchaseOrderLineItemCost,
  AllowedMaterialSpec,
  ApiAccountsV1AccountManagerNotifyCreate400,
  ApiAccountsV1BankDetailsListParams,
  ApiAccountsV1PortsListParams,
  ApiAccountsV1SigninRequestCreate400,
  ApiAccountsV1SigninVerifyCreate400,
  ApiAccountsV1SignupRequestCreate400,
  ApiAccountsV1SignupVerifyCreate400,
  ApiAccountsV1UserRetrieve400,
  ApiDataV1PurchaserPipelineRetrieveParams,
  ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams,
  ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams,
  ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams,
  ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams,
  ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams,
  ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams,
  ApiDealsV1Create400,
  ApiDealsV1DealChoicesListParams,
  ApiDealsV1SellerTransactionHistoryRetrieveParams,
  ApiDocumentsV1DocumentsExternalListParams,
  ApiDocumentsV1DocumentsListParams,
  ApiEvidenceV1BulkDeleteCreate400,
  ApiEvidenceV1BulkUpdateSiteMaterialPartialUpdate400,
  ApiEvidenceV1DataPartialUpdate400,
  ApiEvidenceV1EvidenceSessionRetrieve400,
  ApiEvidenceV1EvidenceSessionRetrieveParams,
  ApiEvidenceV1EvidenceTypesRetrieve200,
  ApiEvidenceV1SiteMaterialSamplesEvidenceListParams,
  ApiFeatureFlagsRetrieve200,
  ApiGradesV1ReportRetrieveParams,
  ApiInspectionsV1CompaniesListParams,
  ApiInspectionsV1EvidenceListParams,
  ApiInspectionsV1InspectionLoadsListParams,
  ApiInspectionsV1ListParams,
  ApiInspectionsV1LoadsListParams,
  ApiInspectionsV2ListParams,
  ApiLogisticsV1LoadsEvidenceListParams,
  ApiLogisticsV1LoadsListParams,
  ApiLogisticsV1ShipmentsListParams,
  ApiMarketingMediaV1SiteMaterialBulkCreateCreate400,
  ApiMaterialV1MaterialProductsListParams,
  ApiMaterialsV1AllowedMaterialSpecsListParams,
  ApiMaterialsV1MaterialComponentsListParams,
  ApiMaterialsV1MaterialGradesRetrieveParams,
  ApiMaterialsV1MaterialOriginsRetrieveParams,
  ApiMaterialsV1MaterialProductsCreate400,
  ApiMaterialsV1MaterialProductsUpdate400,
  ApiMaterialsV1MaterialsListParams,
  ApiMaterialsV1MaterialsSupportedComponentsList400,
  ApiOrdersV1PurchaseOrdersCreate400,
  ApiOrdersV1PurchaseOrdersUpdatePartialUpdate400,
  ApiOrdersV1SalesOrdersCreate400,
  ApiOrdersV1SalesOrdersCustomerUpdatePartialUpdate400,
  ApiOrdersV1SalesOrdersRetrieve400,
  ApiOrdersV1SalesOrdersUpdatePartialUpdate400,
  ApiPostDealFinanceV1ProfitabilityCalculatorCreate400,
  ApiPostDealTrackerV1CarriersRetrieveParams,
  ApiQualityExternalUploadV1Create400,
  ApiQualityExternalUploadV1EvidenceListParams,
  ApiQualitySessionsV1SiteMaterialSessionSampleCreate400,
  ApiQualitySessionsV1SiteMaterialSessionsEvidenceListParams,
  ApiQualitySessionsV1SiteMaterialSessionsPartialUpdate400,
  ApiQualitySessionsV1TradeCompanySessionEvidenceListParams,
  ApiQualitySessionsV1TradeCompanySessionSampleCreate400,
  ApiQualitySessionsV1TradeCompanySessionsPartialUpdate400,
  ApiSamplesV1SamplesBuyerCreate400,
  ApiSamplesV1SamplesBuyerEvidenceListParams,
  ApiSamplesV1SamplesBuyerLoadListRetrieve400,
  ApiSamplesV1SamplesBuyerUpdate400,
  ApiSamplesV1SamplesCreate400,
  ApiSamplesV1SamplesEvidenceListParams,
  ApiSamplesV1SamplesListRetrieve400,
  ApiSamplesV1SamplesUpdate400,
  ApiSamplesV1SiteMaterialSessionSampleEvidenceListParams,
  ApiSamplesV1TradeCompanySessionSampleEvidenceListParams,
  ApiSelfserveV1EnabledMaterialSpecsRetrieveParams,
  ApiSelfserveV1MaterialDemandCreateCreate400,
  ApiSelfserveV1MaterialSupplyList400,
  ApiSelfserveV1MaterialSupplyListParams,
  ApiSelfserveV2NewCreate422,
  ApiSelfserveV2OrdersListParams,
  ApiSelfserveV2OrdersPartialUpdate400,
  ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams,
  ApiTicketsV1FindListParams,
  ApiTradeV1AvailableTonnesForBuyer400,
  ApiTradeV1AvailableTonnesForBuyerParams,
  ApiTradeV1BuySignalsCreate400,
  ApiTradeV1BuySignalsList400,
  ApiTradeV1BuySignalsListParams,
  ApiTradeV1BuySignalsUpdate400,
  ApiTradeV1BuyerMaterialSpecificationsCreate400,
  ApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate400,
  ApiTradeV1BuyerMaterialSpecificationsUpdate400,
  ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieve400,
  ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveParams,
  ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieve400,
  ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveParams,
  ApiTradeV1DemandSignalsCalculateOptimalPriceCreate400,
  ApiTradeV1DemandSignalsCalculateSellPriceCreate400,
  ApiTradeV1DemandSignalsCreate400,
  ApiTradeV1DemandSignalsList400,
  ApiTradeV1DemandSignalsListParams,
  ApiTradeV1DemandSignalsMaterialSpecsRetrieve400,
  ApiTradeV1DemandSignalsMaterialSpecsRetrieveParams,
  ApiTradeV1DemandSignalsMaterialsRetrieve400,
  ApiTradeV1DemandSignalsUpdate400,
  ApiTradeV1MarketIndexPricesLatestRetrieve400,
  ApiTradeV1MarketIndexPricesLatestRetrieveParams,
  ApiTradeV1MarketIndexPricesRetrieve400,
  ApiTradeV1MarketIndexPricesRetrieveParams,
  ApiTradeV1MaterialListingsBidCreate400,
  ApiTradeV1MaterialListingsForBuyerCreate400,
  ApiTradeV1MaterialListingsList400,
  ApiTradeV1MaterialListingsListParams,
  ApiTradeV1MaterialListingsOffersCreate400,
  ApiTradeV1PackagingSpecificationsUpdate400,
  ApiTradeV1SellOfferConfirmCreate400,
  ApiTradeV1SellerOutreachSiteMaterialOffersCreate400,
  ApiTradeV1SellerOutreachSiteMaterialOffersSendCreate400,
  ApiTradeV1SiteMaterialsCreate400,
  ApiTradeV1SiteMaterialsEvidenceListParams,
  ApiTradeV1SiteMaterialsEvidenceSessionsRetrieveParams,
  ApiTradeV1SiteMaterialsLatestOfferRespondCreate400,
  ApiTradeV1SiteMaterialsLatestOfferRetrieveParams,
  ApiTradeV1SiteMaterialsUpdate400,
  ApiTradeV1SupplySignalCalculateBuyPriceCreate400,
  ApiTradeV1SupplySignalsCreate400,
  ApiTradeV1SupplySignalsUpdate400,
  ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400,
  ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams,
  ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams,
  ApiTradeV1TradeCompaniesCreate400,
  ApiTradeV1TradeCompaniesEmployeesRetrieveParams,
  ApiTradeV1TradeCompaniesListParams,
  ApiTradeV1TradeCompaniesPackagingSpecificationsCreate400,
  ApiTradeV1TradeCompaniesPaymentTermsListParams,
  ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams,
  ApiTradeV1TradeCompanyLeadsListParams,
  ApiTradeV1TradeSitesEvidenceListParams,
  ApiTradeV1TradeSitesListParams,
  ApiTradeV2DemandSignalsBulkMatchSiteMaterialsList400,
  ApiTradeV2DemandSignalsBulkMatchSiteMaterialsListParams,
  ApiTransportPricesV1EstimateCreate400,
  ApiTransportPricesV1TransitTimeEstimateCreate400,
  ApiV1OmnisearchParams,
  ApiV1SalesOrderDocumentListExternalParams,
  AssignedAccountManagersResponse,
  AvailableMaterialSupplyItem,
  AvailableMaterialSupplyResponseDTO,
  BaleLoadedRequestBody,
  BankDetails,
  BulkDeleteRequest,
  BulkRefreshOceanRatesInput,
  BulkRefreshOceanRatesOutput,
  BuyerLoadDetail,
  BuyerLoadSampleWithBreakdown,
  BuyerLoadsList,
  BuyerMaterialSpecificationsListResponse,
  BuyerSampleDetails,
  BuyerSampleList,
  CalculateBuyPriceForSupplySignalRequestDTO,
  CalculateOptimalPricesForSiteMaterialsAndDemandSignalsRequestDTO,
  CalculateSellPriceForDemandSignalsRequestDTO,
  CarrierList,
  ConvertMarketIndexPercentageToPriceResponse,
  ConvertPriceToMarketIndexPercentageResponse,
  CreateBuyerMaterialSpecificationResponse,
  CreateBuyerSampleDTO,
  CreateDealDTO,
  CreateExternalUpload,
  CreateInspection,
  CreateInspectionCompany,
  CreateMaterialDemandRequestDTO,
  CreateMaterialListingBidRequestDTO,
  CreateMaterialListingOfferRequestDTO,
  CreateMaterialProductDTO,
  CreateMaterialProductOutput,
  CreatePackagingSpecificationDTO,
  CreatePackagingSpecificationsResponse,
  CreatePurchaseOrderDTO,
  CreateSalesOrderDTO,
  CreateSampleDTO,
  CreateSiteMaterialDTO,
  CreateSiteMaterialResponse,
  CreateSiteMaterialSessionSample,
  CreateSupportTicket,
  CreateTradeCompanySessionSample,
  CustomUserInfoDTO,
  Deal,
  DealCreateResponse,
  DemandSignalCreateDTO,
  DemandSignalMaterialsList,
  DemandSignalMaterialsSpecsList,
  DemandSignalUpdateDTO,
  DocumentContextURLOutput,
  DocumentCreate,
  DocumentInfo,
  DocumentPreSignedURLInput,
  DocumentPreSignedURLOutput,
  DocumentSigningURLResponse,
  DocumentUpload,
  DummyPOCreateRequest,
  DummyPODetailV2,
  ErrorResponse,
  Event,
  Evidence,
  EvidenceSessionDetails,
  ExternalInspection,
  ExternalSiteMaterialSessionList,
  ExternalUploadWithUser,
  FullBuyerMaterialSpecification,
  FullDemandSignalDTO,
  FullMaterialSupportedComponent,
  FullPurchaseOrderInfo,
  FullSalesOrderInfo,
  FullSiteMaterialSession,
  FullTradeCompany,
  FullTradeCompanySession,
  GeneratePDFInput,
  GeneratePDFOutput,
  GeneratePDFResponse,
  GenerateUploadUrlRequest,
  GenerateUploadUrlResponse,
  GradeList,
  GroundControlConfigApi,
  HistoricalPricesPerMarketIndex,
  Input,
  Inspection,
  InspectionCompany,
  InspectionLink,
  InspectionLoad,
  Inspector,
  InvoiceLineItemCost,
  LatestPricesDTO,
  ListResponseEnabledMaterialSpecs,
  Load,
  ManuallyMarkPartyAsSigned,
  MarketingMediaBulkCreateRequest,
  Material,
  MaterialColourList,
  MaterialFormList,
  MaterialGradeList,
  MaterialListingDetailResponseDTO,
  MaterialListingListResponse,
  MaterialListingSumTonnesResponse,
  MaterialListingsForBuyerRequestDTO,
  MaterialListingsForBuyerResponseDTO,
  MaterialOfferDTO,
  MaterialOriginList,
  MaterialProductInfoDetails,
  MaterialRegionList,
  OmnisearchResponse,
  PackagingSpecificationsListResponse,
  PaginatedAllowedMaterialSpecList,
  PaginatedBankDetailsList,
  PaginatedDealChoicesList,
  PaginatedDocumentInfoList,
  PaginatedDummyPODetailV2List,
  PaginatedEvidenceList,
  PaginatedExternalCustomerDocumentList,
  PaginatedGetTicketsOutputList,
  PaginatedInspectionCompanyList,
  PaginatedInspectionDTOList,
  PaginatedInspectionLoadList,
  PaginatedListInspectionList,
  PaginatedLoadList,
  PaginatedMatchedSiteMaterialV2List,
  PaginatedMaterialList,
  PaginatedMaterialProductInfoListItemList,
  PaginatedPortList,
  PaginatedPurchaserLoadSummaryDTOList,
  PaginatedPurchaserSalesOrderSummaryDTOList,
  PaginatedPurchaserShipmentSummaryDTOList,
  PaginatedShipmentInfoList,
  PaginatedSimpleCompanyPaymentTermsList,
  PaginatedSimpleLoadList,
  PaginatedSimpleTradeCompanyLeadListItemList,
  PaginatedSimpleTradeCompanyListItemList,
  PaginatedSimpleTradeSiteListItemList,
  PatchedBulkUpdateData,
  PatchedCustomerUpdateSalesOrderDTO,
  PatchedDeal,
  PatchedDocumentUpdate,
  PatchedDummyPODetailV2,
  PatchedEvidenceData,
  PatchedInspection,
  PatchedInspectionCompany,
  PatchedInspectionLoad,
  PatchedInspector,
  PatchedShipmentUpdate,
  PatchedSiteMaterialSessionUpdateDTO,
  PatchedTradeCompanySessionUpdateDTO,
  PatchedUpdatePurchaseOrderDTO,
  PatchedUpdateSalesOrderDTO,
  PaymentRequestsCreationResponse,
  PaymentTermPrice,
  PayoutCreationResponse,
  PointToPointTransportCostBreakdownResultDTO,
  Port,
  PortChoicesResponse,
  PostDealDealhubFilterChoicesPortsRetrieveParams,
  PreSignedURLInput,
  PreSignedURLOutput,
  PricedDemandSignalDTO,
  PricedSupplySignalDTO,
  ProcessUploadRequest,
  ProcessUploadResponse,
  ProfitabilityCalculationRequest,
  ProfitabilityEstimateDTO,
  PurchaseOrdersListParams,
  PurchaserPipelineTable,
  PushSubscriptionInput,
  QualityReport,
  ReceivableInvoiceLineItemRevenue,
  SalesOrderListParams,
  SampleDetails,
  SampleList,
  SelfExportPurchaserSummariesRequest,
  SelfExportPurchaserSummariesResponse,
  SellDashboardResponseDTO,
  SellOfferConfirmDTO,
  SendSigningEmailResponse,
  ShipmentCreate,
  ShipmentInfo,
  SignIn,
  SignInResult,
  SignInVerify,
  SignInVerifyResult,
  SignOutResult,
  SignUp,
  SignUpResult,
  SignUpVerify,
  SignUpVerifyResult,
  SimpleExternalUploadDTO,
  SimpleMaterialComponent,
  SimpleResponse,
  SimpleSalesOrder,
  SimpleSigningParty,
  SimpleSiteMaterialSessionSample,
  SimpleTradeCompanySessionSample,
  SimpleTradeSiteListResponse,
  SinglePaymentRequest,
  SiteMaterialDetail,
  SiteMaterialLatestOfferAnswerRequest,
  SiteMaterialLatestOfferDetail,
  SiteMaterialListResponse,
  SiteMaterialOfferAnswerResponse,
  SiteMaterialOfferCreateRequestDTO,
  SiteMaterialOfferCreateResponseDTO,
  SiteMaterialSampleWithBreakdown,
  SiteMaterialSessionCreateDTO,
  SiteMaterialSessionCreateResponse,
  SiteMaterialSessionGeneratePDFResponse,
  SiteMaterialSessionList,
  SiteMaterialSessionSampleWithAverageFeatures,
  SiteWithTradeCompany,
  StaffExportPurchaserSummariesRequest,
  StaffExportPurchaserSummariesResponse,
  SupplySignalCreateDTO,
  SupplySignalCreateUpdateResponse,
  SupplySignalUpdateDTO,
  Ticket,
  TradeCompanyCreateEndUser,
  TradeCompanyCreateResponse,
  TradeCompanyEmployeesListResponse,
  TradeCompanySessionCreateDTO,
  TradeCompanySessionCreateResponse,
  TradeCompanySessionList,
  TradeCompanySessionSampleWithAverageFeatures,
  TransactionHistoryResponseDTO,
  TransitTimeEstimateInput,
  TransitTimeEstimateResultDTO,
  TransportCostEstimateInput,
  UpdateBuyerSampleDTO,
  UpdateMaterialProductDTO,
  UpdateMaterialProductOutput,
  UpdatePackagingSpecificationDTO,
  UpdateSampleDTO,
  UpdateSiteMaterialDTO,
  UpsertBuyerMaterialSpecification,
} from '../../schemas';
import { customAxios } from '../../custom-instance';
import type { ErrorType, BodyType } from '../../custom-instance';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<{ [Q in P]: T[P] }, { -readonly [Q in P]: T[P] }, P>;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object ? NonReadonly<NonNullable<T[P]>> : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Notify account manager in Slack.
 */
export const apiAccountsV1AccountManagerNotifyCreate = (
  accountManagerId: number,
  accountManagerNotifyRequest: BodyType<AccountManagerNotifyRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/accounts/v1/account-manager/${accountManagerId}/notify/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: accountManagerNotifyRequest,
      signal,
    },
    options
  );
};

export const getApiAccountsV1AccountManagerNotifyCreateMutationOptions = <
  TError = ErrorType<ApiAccountsV1AccountManagerNotifyCreate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountsV1AccountManagerNotifyCreate>>,
    TError,
    { accountManagerId: number; data: BodyType<AccountManagerNotifyRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiAccountsV1AccountManagerNotifyCreate>>,
  TError,
  { accountManagerId: number; data: BodyType<AccountManagerNotifyRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAccountsV1AccountManagerNotifyCreate>>,
    { accountManagerId: number; data: BodyType<AccountManagerNotifyRequest> }
  > = (props) => {
    const { accountManagerId, data } = props ?? {};

    return apiAccountsV1AccountManagerNotifyCreate(accountManagerId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAccountsV1AccountManagerNotifyCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountsV1AccountManagerNotifyCreate>>
>;
export type ApiAccountsV1AccountManagerNotifyCreateMutationBody = BodyType<AccountManagerNotifyRequest>;
export type ApiAccountsV1AccountManagerNotifyCreateMutationError =
  ErrorType<ApiAccountsV1AccountManagerNotifyCreate400>;

export const useApiAccountsV1AccountManagerNotifyCreate = <
  TError = ErrorType<ApiAccountsV1AccountManagerNotifyCreate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountsV1AccountManagerNotifyCreate>>,
    TError,
    { accountManagerId: number; data: BodyType<AccountManagerNotifyRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiAccountsV1AccountManagerNotifyCreate>>,
  TError,
  { accountManagerId: number; data: BodyType<AccountManagerNotifyRequest> },
  TContext
> => {
  const mutationOptions = getApiAccountsV1AccountManagerNotifyCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiAccountsV1BankDetailsList = (
  params?: ApiAccountsV1BankDetailsListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedBankDetailsList>(
    { url: `/api/accounts/v1/bank-details/`, method: 'GET', params, signal },
    options
  );
};

export const getApiAccountsV1BankDetailsListQueryKey = (params?: ApiAccountsV1BankDetailsListParams) => {
  return [`/api/accounts/v1/bank-details/`, ...(params ? [params] : [])] as const;
};

export const getApiAccountsV1BankDetailsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiAccountsV1BankDetailsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiAccountsV1BankDetailsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>> = ({ signal }) =>
    apiAccountsV1BankDetailsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiAccountsV1BankDetailsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>
>;
export type ApiAccountsV1BankDetailsListQueryError = ErrorType<ErrorResponse>;

export function useApiAccountsV1BankDetailsList<
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiAccountsV1BankDetailsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1BankDetailsList<
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiAccountsV1BankDetailsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1BankDetailsList<
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiAccountsV1BankDetailsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiAccountsV1BankDetailsList<
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiAccountsV1BankDetailsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiAccountsV1BankDetailsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiAccountsV1BankDetailsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiAccountsV1BankDetailsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiAccountsV1BankDetailsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>> = ({ signal }) =>
    apiAccountsV1BankDetailsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiAccountsV1BankDetailsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>
>;
export type ApiAccountsV1BankDetailsListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiAccountsV1BankDetailsListSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiAccountsV1BankDetailsListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1BankDetailsListSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiAccountsV1BankDetailsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1BankDetailsListSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiAccountsV1BankDetailsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiAccountsV1BankDetailsListSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiAccountsV1BankDetailsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiAccountsV1BankDetailsListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiAccountsV1BankDetailsRetrieve = (
  bankDetailsId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<BankDetails>(
    { url: `/api/accounts/v1/bank-details/${bankDetailsId}/`, method: 'GET', signal },
    options
  );
};

export const getApiAccountsV1BankDetailsRetrieveQueryKey = (bankDetailsId: number) => {
  return [`/api/accounts/v1/bank-details/${bankDetailsId}/`] as const;
};

export const getApiAccountsV1BankDetailsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  bankDetailsId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiAccountsV1BankDetailsRetrieveQueryKey(bankDetailsId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>> = ({ signal }) =>
    apiAccountsV1BankDetailsRetrieve(bankDetailsId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!bankDetailsId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiAccountsV1BankDetailsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>
>;
export type ApiAccountsV1BankDetailsRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiAccountsV1BankDetailsRetrieve<
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  bankDetailsId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1BankDetailsRetrieve<
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  bankDetailsId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1BankDetailsRetrieve<
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  bankDetailsId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiAccountsV1BankDetailsRetrieve<
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  bankDetailsId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiAccountsV1BankDetailsRetrieveQueryOptions(bankDetailsId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiAccountsV1BankDetailsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  bankDetailsId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiAccountsV1BankDetailsRetrieveQueryKey(bankDetailsId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>> = ({ signal }) =>
    apiAccountsV1BankDetailsRetrieve(bankDetailsId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiAccountsV1BankDetailsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>
>;
export type ApiAccountsV1BankDetailsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiAccountsV1BankDetailsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  bankDetailsId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1BankDetailsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  bankDetailsId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1BankDetailsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  bankDetailsId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiAccountsV1BankDetailsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  bankDetailsId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiAccountsV1BankDetailsRetrieveSuspenseQueryOptions(bankDetailsId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiAccountsV1PortsList = (
  params?: ApiAccountsV1PortsListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedPortList>({ url: `/api/accounts/v1/ports/`, method: 'GET', params, signal }, options);
};

export const getApiAccountsV1PortsListQueryKey = (params?: ApiAccountsV1PortsListParams) => {
  return [`/api/accounts/v1/ports/`, ...(params ? [params] : [])] as const;
};

export const getApiAccountsV1PortsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiAccountsV1PortsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiAccountsV1PortsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1PortsList>>> = ({ signal }) =>
    apiAccountsV1PortsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiAccountsV1PortsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiAccountsV1PortsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1PortsList>>>;
export type ApiAccountsV1PortsListQueryError = ErrorType<unknown>;

export function useApiAccountsV1PortsList<
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiAccountsV1PortsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1PortsList<
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiAccountsV1PortsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1PortsList<
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiAccountsV1PortsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiAccountsV1PortsList<
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiAccountsV1PortsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiAccountsV1PortsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiAccountsV1PortsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiAccountsV1PortsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiAccountsV1PortsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1PortsList>>> = ({ signal }) =>
    apiAccountsV1PortsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiAccountsV1PortsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiAccountsV1PortsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1PortsList>>>;
export type ApiAccountsV1PortsListSuspenseQueryError = ErrorType<unknown>;

export function useApiAccountsV1PortsListSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiAccountsV1PortsListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1PortsListSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiAccountsV1PortsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1PortsListSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiAccountsV1PortsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiAccountsV1PortsListSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiAccountsV1PortsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiAccountsV1PortsListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiAccountsV1PortsRetrieve = (
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Port>({ url: `/api/accounts/v1/ports/${id}/`, method: 'GET', signal }, options);
};

export const getApiAccountsV1PortsRetrieveQueryKey = (id: number) => {
  return [`/api/accounts/v1/ports/${id}/`] as const;
};

export const getApiAccountsV1PortsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiAccountsV1PortsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>> = ({ signal }) =>
    apiAccountsV1PortsRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiAccountsV1PortsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>>;
export type ApiAccountsV1PortsRetrieveQueryError = ErrorType<unknown>;

export function useApiAccountsV1PortsRetrieve<
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1PortsRetrieve<
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1PortsRetrieve<
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiAccountsV1PortsRetrieve<
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiAccountsV1PortsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiAccountsV1PortsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiAccountsV1PortsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>> = ({ signal }) =>
    apiAccountsV1PortsRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiAccountsV1PortsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>
>;
export type ApiAccountsV1PortsRetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiAccountsV1PortsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1PortsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1PortsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiAccountsV1PortsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiAccountsV1PortsRetrieveSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Starts OTP flow for either email or phone depending on whats provided.
 */
export const apiAccountsV1SigninRequestCreate = (
  signIn: BodyType<SignIn>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SignInResult>(
    {
      url: `/api/accounts/v1/signin/request/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: signIn,
      signal,
    },
    options
  );
};

export const getApiAccountsV1SigninRequestCreateMutationOptions = <
  TError = ErrorType<ApiAccountsV1SigninRequestCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountsV1SigninRequestCreate>>,
    TError,
    { data: BodyType<SignIn> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiAccountsV1SigninRequestCreate>>,
  TError,
  { data: BodyType<SignIn> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAccountsV1SigninRequestCreate>>,
    { data: BodyType<SignIn> }
  > = (props) => {
    const { data } = props ?? {};

    return apiAccountsV1SigninRequestCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAccountsV1SigninRequestCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountsV1SigninRequestCreate>>
>;
export type ApiAccountsV1SigninRequestCreateMutationBody = BodyType<SignIn>;
export type ApiAccountsV1SigninRequestCreateMutationError = ErrorType<
  ApiAccountsV1SigninRequestCreate400 | ErrorResponse
>;

export const useApiAccountsV1SigninRequestCreate = <
  TError = ErrorType<ApiAccountsV1SigninRequestCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountsV1SigninRequestCreate>>,
    TError,
    { data: BodyType<SignIn> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiAccountsV1SigninRequestCreate>>,
  TError,
  { data: BodyType<SignIn> },
  TContext
> => {
  const mutationOptions = getApiAccountsV1SigninRequestCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Checks email/phone verification code.
 */
export const apiAccountsV1SigninVerifyCreate = (
  signInVerify: BodyType<SignInVerify>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SignInVerifyResult>(
    {
      url: `/api/accounts/v1/signin/verify/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: signInVerify,
      signal,
    },
    options
  );
};

export const getApiAccountsV1SigninVerifyCreateMutationOptions = <
  TError = ErrorType<ApiAccountsV1SigninVerifyCreate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountsV1SigninVerifyCreate>>,
    TError,
    { data: BodyType<SignInVerify> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiAccountsV1SigninVerifyCreate>>,
  TError,
  { data: BodyType<SignInVerify> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAccountsV1SigninVerifyCreate>>,
    { data: BodyType<SignInVerify> }
  > = (props) => {
    const { data } = props ?? {};

    return apiAccountsV1SigninVerifyCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAccountsV1SigninVerifyCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountsV1SigninVerifyCreate>>
>;
export type ApiAccountsV1SigninVerifyCreateMutationBody = BodyType<SignInVerify>;
export type ApiAccountsV1SigninVerifyCreateMutationError = ErrorType<ApiAccountsV1SigninVerifyCreate400>;

export const useApiAccountsV1SigninVerifyCreate = <
  TError = ErrorType<ApiAccountsV1SigninVerifyCreate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountsV1SigninVerifyCreate>>,
    TError,
    { data: BodyType<SignInVerify> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiAccountsV1SigninVerifyCreate>>,
  TError,
  { data: BodyType<SignInVerify> },
  TContext
> => {
  const mutationOptions = getApiAccountsV1SigninVerifyCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Logs out the user.
 */
export const apiAccountsV1SignoutCreate = (options?: SecondParameter<typeof customAxios>, signal?: AbortSignal) => {
  return customAxios<SignOutResult>({ url: `/api/accounts/v1/signout/`, method: 'POST', signal }, options);
};

export const getApiAccountsV1SignoutCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1SignoutCreate>>, TError, void, TContext>;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1SignoutCreate>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAccountsV1SignoutCreate>>, void> = () => {
    return apiAccountsV1SignoutCreate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAccountsV1SignoutCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountsV1SignoutCreate>>
>;

export type ApiAccountsV1SignoutCreateMutationError = ErrorType<ErrorResponse>;

export const useApiAccountsV1SignoutCreate = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1SignoutCreate>>, TError, void, TContext>;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<Awaited<ReturnType<typeof apiAccountsV1SignoutCreate>>, TError, void, TContext> => {
  const mutationOptions = getApiAccountsV1SignoutCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Registers a new user.
 */
export const apiAccountsV1SignupRequestCreate = (
  signUp: BodyType<SignUp>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SignUpResult>(
    {
      url: `/api/accounts/v1/signup/request/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: signUp,
      signal,
    },
    options
  );
};

export const getApiAccountsV1SignupRequestCreateMutationOptions = <
  TError = ErrorType<ApiAccountsV1SignupRequestCreate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountsV1SignupRequestCreate>>,
    TError,
    { data: BodyType<SignUp> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiAccountsV1SignupRequestCreate>>,
  TError,
  { data: BodyType<SignUp> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAccountsV1SignupRequestCreate>>,
    { data: BodyType<SignUp> }
  > = (props) => {
    const { data } = props ?? {};

    return apiAccountsV1SignupRequestCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAccountsV1SignupRequestCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountsV1SignupRequestCreate>>
>;
export type ApiAccountsV1SignupRequestCreateMutationBody = BodyType<SignUp>;
export type ApiAccountsV1SignupRequestCreateMutationError = ErrorType<ApiAccountsV1SignupRequestCreate400>;

export const useApiAccountsV1SignupRequestCreate = <
  TError = ErrorType<ApiAccountsV1SignupRequestCreate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountsV1SignupRequestCreate>>,
    TError,
    { data: BodyType<SignUp> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiAccountsV1SignupRequestCreate>>,
  TError,
  { data: BodyType<SignUp> },
  TContext
> => {
  const mutationOptions = getApiAccountsV1SignupRequestCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Verifies email verification code.
 */
export const apiAccountsV1SignupVerifyCreate = (
  signUpVerify: BodyType<SignUpVerify>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SignUpVerifyResult>(
    {
      url: `/api/accounts/v1/signup/verify/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: signUpVerify,
      signal,
    },
    options
  );
};

export const getApiAccountsV1SignupVerifyCreateMutationOptions = <
  TError = ErrorType<ApiAccountsV1SignupVerifyCreate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountsV1SignupVerifyCreate>>,
    TError,
    { data: BodyType<SignUpVerify> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiAccountsV1SignupVerifyCreate>>,
  TError,
  { data: BodyType<SignUpVerify> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAccountsV1SignupVerifyCreate>>,
    { data: BodyType<SignUpVerify> }
  > = (props) => {
    const { data } = props ?? {};

    return apiAccountsV1SignupVerifyCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAccountsV1SignupVerifyCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountsV1SignupVerifyCreate>>
>;
export type ApiAccountsV1SignupVerifyCreateMutationBody = BodyType<SignUpVerify>;
export type ApiAccountsV1SignupVerifyCreateMutationError = ErrorType<ApiAccountsV1SignupVerifyCreate400>;

export const useApiAccountsV1SignupVerifyCreate = <
  TError = ErrorType<ApiAccountsV1SignupVerifyCreate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountsV1SignupVerifyCreate>>,
    TError,
    { data: BodyType<SignUpVerify> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiAccountsV1SignupVerifyCreate>>,
  TError,
  { data: BodyType<SignUpVerify> },
  TContext
> => {
  const mutationOptions = getApiAccountsV1SignupVerifyCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Returns the current user's information.
 */
export const apiAccountsV1UserRetrieve = (options?: SecondParameter<typeof customAxios>, signal?: AbortSignal) => {
  return customAxios<CustomUserInfoDTO>({ url: `/api/accounts/v1/user/`, method: 'GET', signal }, options);
};

export const getApiAccountsV1UserRetrieveQueryKey = () => {
  return [`/api/accounts/v1/user/`] as const;
};

export const getApiAccountsV1UserRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>,
  TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiAccountsV1UserRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>> = ({ signal }) =>
    apiAccountsV1UserRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiAccountsV1UserRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>>;
export type ApiAccountsV1UserRetrieveQueryError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>;

export function useApiAccountsV1UserRetrieve<
  TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>,
  TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1UserRetrieve<
  TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>,
  TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1UserRetrieve<
  TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>,
  TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiAccountsV1UserRetrieve<
  TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>,
  TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiAccountsV1UserRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiAccountsV1UserRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>,
  TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiAccountsV1UserRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>> = ({ signal }) =>
    apiAccountsV1UserRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiAccountsV1UserRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>
>;
export type ApiAccountsV1UserRetrieveSuspenseQueryError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>;

export function useApiAccountsV1UserRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>,
  TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>,
>(options: {
  query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1UserRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>,
  TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiAccountsV1UserRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>,
  TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiAccountsV1UserRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>,
  TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiAccountsV1UserRetrieveSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * A wrapper view that receives tasks from Google Cloud Tasks and triggers a service method to process them.

This view validates the task data, and calls the specified method in the configuration (`AsyncTaskHandlerConfig`).

See definition of Async Tasks here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiAsyncTasksAutoMarkPurchaseOrderAsFulfilledCreate = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    { url: `/api/async_tasks/auto-mark-purchase-order-as-fulfilled/`, method: 'POST', signal },
    options
  );
};

export const getApiAsyncTasksAutoMarkPurchaseOrderAsFulfilledCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksAutoMarkPurchaseOrderAsFulfilledCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiAsyncTasksAutoMarkPurchaseOrderAsFulfilledCreate>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAsyncTasksAutoMarkPurchaseOrderAsFulfilledCreate>>,
    void
  > = () => {
    return apiAsyncTasksAutoMarkPurchaseOrderAsFulfilledCreate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAsyncTasksAutoMarkPurchaseOrderAsFulfilledCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAsyncTasksAutoMarkPurchaseOrderAsFulfilledCreate>>
>;

export type ApiAsyncTasksAutoMarkPurchaseOrderAsFulfilledCreateMutationError = ErrorType<ErrorResponse>;

export const useApiAsyncTasksAutoMarkPurchaseOrderAsFulfilledCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksAutoMarkPurchaseOrderAsFulfilledCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiAsyncTasksAutoMarkPurchaseOrderAsFulfilledCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getApiAsyncTasksAutoMarkPurchaseOrderAsFulfilledCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives tasks from Google Cloud Tasks and triggers a service method to process them.

This view validates the task data, and calls the specified method in the configuration (`AsyncTaskHandlerConfig`).

See definition of Async Tasks here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiAsyncTasksAutoMarkSalesOrderAsFulfilledCreate = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    { url: `/api/async_tasks/auto-mark-sales-order-as-fulfilled/`, method: 'POST', signal },
    options
  );
};

export const getApiAsyncTasksAutoMarkSalesOrderAsFulfilledCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksAutoMarkSalesOrderAsFulfilledCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiAsyncTasksAutoMarkSalesOrderAsFulfilledCreate>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAsyncTasksAutoMarkSalesOrderAsFulfilledCreate>>,
    void
  > = () => {
    return apiAsyncTasksAutoMarkSalesOrderAsFulfilledCreate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAsyncTasksAutoMarkSalesOrderAsFulfilledCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAsyncTasksAutoMarkSalesOrderAsFulfilledCreate>>
>;

export type ApiAsyncTasksAutoMarkSalesOrderAsFulfilledCreateMutationError = ErrorType<ErrorResponse>;

export const useApiAsyncTasksAutoMarkSalesOrderAsFulfilledCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksAutoMarkSalesOrderAsFulfilledCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiAsyncTasksAutoMarkSalesOrderAsFulfilledCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getApiAsyncTasksAutoMarkSalesOrderAsFulfilledCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives tasks from Google Cloud Tasks and triggers a service method to process them.

This view validates the task data, and calls the specified method in the configuration (`AsyncTaskHandlerConfig`).

See definition of Async Tasks here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiAsyncTasksCreateMaterialCostsCreate = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    { url: `/api/async_tasks/create-material-costs/`, method: 'POST', signal },
    options
  );
};

export const getApiAsyncTasksCreateMaterialCostsCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksCreateMaterialCostsCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<Awaited<ReturnType<typeof apiAsyncTasksCreateMaterialCostsCreate>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAsyncTasksCreateMaterialCostsCreate>>, void> = () => {
    return apiAsyncTasksCreateMaterialCostsCreate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAsyncTasksCreateMaterialCostsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAsyncTasksCreateMaterialCostsCreate>>
>;

export type ApiAsyncTasksCreateMaterialCostsCreateMutationError = ErrorType<ErrorResponse>;

export const useApiAsyncTasksCreateMaterialCostsCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksCreateMaterialCostsCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<Awaited<ReturnType<typeof apiAsyncTasksCreateMaterialCostsCreate>>, TError, void, TContext> => {
  const mutationOptions = getApiAsyncTasksCreateMaterialCostsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives tasks from Google Cloud Tasks and triggers a service method to process them.

This view validates the task data, and calls the specified method in the configuration (`AsyncTaskHandlerConfig`).

See definition of Async Tasks here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiAsyncTasksCreateMaterialRevenuesCreate = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    { url: `/api/async_tasks/create-material-revenues/`, method: 'POST', signal },
    options
  );
};

export const getApiAsyncTasksCreateMaterialRevenuesCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksCreateMaterialRevenuesCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiAsyncTasksCreateMaterialRevenuesCreate>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAsyncTasksCreateMaterialRevenuesCreate>>,
    void
  > = () => {
    return apiAsyncTasksCreateMaterialRevenuesCreate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAsyncTasksCreateMaterialRevenuesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAsyncTasksCreateMaterialRevenuesCreate>>
>;

export type ApiAsyncTasksCreateMaterialRevenuesCreateMutationError = ErrorType<ErrorResponse>;

export const useApiAsyncTasksCreateMaterialRevenuesCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksCreateMaterialRevenuesCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiAsyncTasksCreateMaterialRevenuesCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getApiAsyncTasksCreateMaterialRevenuesCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives tasks from Google Cloud Tasks and triggers a service method to process them.

This view validates the task data, and calls the specified method in the configuration (`AsyncTaskHandlerConfig`).

See definition of Async Tasks here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiAsyncTasksCreateTransportCostsCreate = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    { url: `/api/async_tasks/create-transport-costs/`, method: 'POST', signal },
    options
  );
};

export const getApiAsyncTasksCreateTransportCostsCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksCreateTransportCostsCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<Awaited<ReturnType<typeof apiAsyncTasksCreateTransportCostsCreate>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAsyncTasksCreateTransportCostsCreate>>,
    void
  > = () => {
    return apiAsyncTasksCreateTransportCostsCreate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAsyncTasksCreateTransportCostsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAsyncTasksCreateTransportCostsCreate>>
>;

export type ApiAsyncTasksCreateTransportCostsCreateMutationError = ErrorType<ErrorResponse>;

export const useApiAsyncTasksCreateTransportCostsCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksCreateTransportCostsCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<Awaited<ReturnType<typeof apiAsyncTasksCreateTransportCostsCreate>>, TError, void, TContext> => {
  const mutationOptions = getApiAsyncTasksCreateTransportCostsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives tasks from Google Cloud Tasks and triggers a service method to process them.

This view validates the task data, and calls the specified method in the configuration (`AsyncTaskHandlerConfig`).

See definition of Async Tasks here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiAsyncTasksExportPurchaserSummariesTaskHandlerCreate = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    { url: `/api/async_tasks/export-purchaser-summaries-task-handler/`, method: 'POST', signal },
    options
  );
};

export const getApiAsyncTasksExportPurchaserSummariesTaskHandlerCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksExportPurchaserSummariesTaskHandlerCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiAsyncTasksExportPurchaserSummariesTaskHandlerCreate>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAsyncTasksExportPurchaserSummariesTaskHandlerCreate>>,
    void
  > = () => {
    return apiAsyncTasksExportPurchaserSummariesTaskHandlerCreate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAsyncTasksExportPurchaserSummariesTaskHandlerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAsyncTasksExportPurchaserSummariesTaskHandlerCreate>>
>;

export type ApiAsyncTasksExportPurchaserSummariesTaskHandlerCreateMutationError = ErrorType<ErrorResponse>;

export const useApiAsyncTasksExportPurchaserSummariesTaskHandlerCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksExportPurchaserSummariesTaskHandlerCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiAsyncTasksExportPurchaserSummariesTaskHandlerCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getApiAsyncTasksExportPurchaserSummariesTaskHandlerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives tasks from Google Cloud Tasks and triggers a service method to process them.

This view validates the task data, and calls the specified method in the configuration (`AsyncTaskHandlerConfig`).

See definition of Async Tasks here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiAsyncTasksMarkEvidenceDeletedInEncordCreate = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    { url: `/api/async_tasks/mark-evidence-deleted-in-encord/`, method: 'POST', signal },
    options
  );
};

export const getApiAsyncTasksMarkEvidenceDeletedInEncordCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksMarkEvidenceDeletedInEncordCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiAsyncTasksMarkEvidenceDeletedInEncordCreate>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAsyncTasksMarkEvidenceDeletedInEncordCreate>>,
    void
  > = () => {
    return apiAsyncTasksMarkEvidenceDeletedInEncordCreate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAsyncTasksMarkEvidenceDeletedInEncordCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAsyncTasksMarkEvidenceDeletedInEncordCreate>>
>;

export type ApiAsyncTasksMarkEvidenceDeletedInEncordCreateMutationError = ErrorType<ErrorResponse>;

export const useApiAsyncTasksMarkEvidenceDeletedInEncordCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksMarkEvidenceDeletedInEncordCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiAsyncTasksMarkEvidenceDeletedInEncordCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getApiAsyncTasksMarkEvidenceDeletedInEncordCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives tasks from Google Cloud Tasks and triggers a service method to process them.

This view validates the task data, and calls the specified method in the configuration (`AsyncTaskHandlerConfig`).

See definition of Async Tasks here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiAsyncTasksProcessUploadedEvidenceFileCreate = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    { url: `/api/async_tasks/process-uploaded-evidence-file/`, method: 'POST', signal },
    options
  );
};

export const getApiAsyncTasksProcessUploadedEvidenceFileCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksProcessUploadedEvidenceFileCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiAsyncTasksProcessUploadedEvidenceFileCreate>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAsyncTasksProcessUploadedEvidenceFileCreate>>,
    void
  > = () => {
    return apiAsyncTasksProcessUploadedEvidenceFileCreate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAsyncTasksProcessUploadedEvidenceFileCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAsyncTasksProcessUploadedEvidenceFileCreate>>
>;

export type ApiAsyncTasksProcessUploadedEvidenceFileCreateMutationError = ErrorType<ErrorResponse>;

export const useApiAsyncTasksProcessUploadedEvidenceFileCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksProcessUploadedEvidenceFileCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiAsyncTasksProcessUploadedEvidenceFileCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getApiAsyncTasksProcessUploadedEvidenceFileCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives tasks from Google Cloud Tasks and triggers a service method to process them.

This view validates the task data, and calls the specified method in the configuration (`AsyncTaskHandlerConfig`).

See definition of Async Tasks here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiAsyncTasksRegisterEvidenceInEncordCreate = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    { url: `/api/async_tasks/register-evidence-in-encord/`, method: 'POST', signal },
    options
  );
};

export const getApiAsyncTasksRegisterEvidenceInEncordCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksRegisterEvidenceInEncordCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiAsyncTasksRegisterEvidenceInEncordCreate>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAsyncTasksRegisterEvidenceInEncordCreate>>,
    void
  > = () => {
    return apiAsyncTasksRegisterEvidenceInEncordCreate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAsyncTasksRegisterEvidenceInEncordCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAsyncTasksRegisterEvidenceInEncordCreate>>
>;

export type ApiAsyncTasksRegisterEvidenceInEncordCreateMutationError = ErrorType<ErrorResponse>;

export const useApiAsyncTasksRegisterEvidenceInEncordCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksRegisterEvidenceInEncordCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiAsyncTasksRegisterEvidenceInEncordCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getApiAsyncTasksRegisterEvidenceInEncordCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives tasks from Google Cloud Tasks and triggers a service method to process them.

This view validates the task data, and calls the specified method in the configuration (`AsyncTaskHandlerConfig`).

See definition of Async Tasks here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiAsyncTasksSaveEvidenceAnnotationInEncordCreate = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    { url: `/api/async_tasks/save-evidence-annotation-in-encord/`, method: 'POST', signal },
    options
  );
};

export const getApiAsyncTasksSaveEvidenceAnnotationInEncordCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksSaveEvidenceAnnotationInEncordCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiAsyncTasksSaveEvidenceAnnotationInEncordCreate>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAsyncTasksSaveEvidenceAnnotationInEncordCreate>>,
    void
  > = () => {
    return apiAsyncTasksSaveEvidenceAnnotationInEncordCreate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAsyncTasksSaveEvidenceAnnotationInEncordCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAsyncTasksSaveEvidenceAnnotationInEncordCreate>>
>;

export type ApiAsyncTasksSaveEvidenceAnnotationInEncordCreateMutationError = ErrorType<ErrorResponse>;

export const useApiAsyncTasksSaveEvidenceAnnotationInEncordCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksSaveEvidenceAnnotationInEncordCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiAsyncTasksSaveEvidenceAnnotationInEncordCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getApiAsyncTasksSaveEvidenceAnnotationInEncordCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives tasks from Google Cloud Tasks and triggers a service method to process them.

This view validates the task data, and calls the specified method in the configuration (`AsyncTaskHandlerConfig`).

See definition of Async Tasks here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiAsyncTasksSendListingNotificationsCreate = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    { url: `/api/async_tasks/send-listing-notifications/`, method: 'POST', signal },
    options
  );
};

export const getApiAsyncTasksSendListingNotificationsCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksSendListingNotificationsCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiAsyncTasksSendListingNotificationsCreate>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAsyncTasksSendListingNotificationsCreate>>,
    void
  > = () => {
    return apiAsyncTasksSendListingNotificationsCreate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAsyncTasksSendListingNotificationsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAsyncTasksSendListingNotificationsCreate>>
>;

export type ApiAsyncTasksSendListingNotificationsCreateMutationError = ErrorType<ErrorResponse>;

export const useApiAsyncTasksSendListingNotificationsCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksSendListingNotificationsCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiAsyncTasksSendListingNotificationsCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getApiAsyncTasksSendListingNotificationsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives tasks from Google Cloud Tasks and triggers a service method to process them.

This view validates the task data, and calls the specified method in the configuration (`AsyncTaskHandlerConfig`).

See definition of Async Tasks here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiAsyncTasksStartVizionTrackingCreate = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    { url: `/api/async_tasks/start-vizion-tracking/`, method: 'POST', signal },
    options
  );
};

export const getApiAsyncTasksStartVizionTrackingCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksStartVizionTrackingCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<Awaited<ReturnType<typeof apiAsyncTasksStartVizionTrackingCreate>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAsyncTasksStartVizionTrackingCreate>>, void> = () => {
    return apiAsyncTasksStartVizionTrackingCreate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAsyncTasksStartVizionTrackingCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAsyncTasksStartVizionTrackingCreate>>
>;

export type ApiAsyncTasksStartVizionTrackingCreateMutationError = ErrorType<ErrorResponse>;

export const useApiAsyncTasksStartVizionTrackingCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksStartVizionTrackingCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<Awaited<ReturnType<typeof apiAsyncTasksStartVizionTrackingCreate>>, TError, void, TContext> => {
  const mutationOptions = getApiAsyncTasksStartVizionTrackingCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives tasks from Google Cloud Tasks and triggers a service method to process them.

This view validates the task data, and calls the specified method in the configuration (`AsyncTaskHandlerConfig`).

See definition of Async Tasks here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiAsyncTasksUpdateShipmentStatusTaskHandlerCreate = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    { url: `/api/async_tasks/update-shipment-status-task-handler/`, method: 'POST', signal },
    options
  );
};

export const getApiAsyncTasksUpdateShipmentStatusTaskHandlerCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksUpdateShipmentStatusTaskHandlerCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiAsyncTasksUpdateShipmentStatusTaskHandlerCreate>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAsyncTasksUpdateShipmentStatusTaskHandlerCreate>>,
    void
  > = () => {
    return apiAsyncTasksUpdateShipmentStatusTaskHandlerCreate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAsyncTasksUpdateShipmentStatusTaskHandlerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAsyncTasksUpdateShipmentStatusTaskHandlerCreate>>
>;

export type ApiAsyncTasksUpdateShipmentStatusTaskHandlerCreateMutationError = ErrorType<ErrorResponse>;

export const useApiAsyncTasksUpdateShipmentStatusTaskHandlerCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAsyncTasksUpdateShipmentStatusTaskHandlerCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiAsyncTasksUpdateShipmentStatusTaskHandlerCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getApiAsyncTasksUpdateShipmentStatusTaskHandlerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Generate and download export files for your own company directly. Note: This endpoint does not use async tasks due to a debouncing issue that causes duplicate emails.
 * @summary Export purchaser summaries (self)
 */
export const apiDataV1ExportsPurchaserSummariesSelfCreate = (
  selfExportPurchaserSummariesRequest: BodyType<SelfExportPurchaserSummariesRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SelfExportPurchaserSummariesResponse>(
    {
      url: `/api/data/v1/exports/purchaser-summaries/self/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: selfExportPurchaserSummariesRequest,
      signal,
    },
    options
  );
};

export const getApiDataV1ExportsPurchaserSummariesSelfCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesSelfCreate>>,
    TError,
    { data: BodyType<SelfExportPurchaserSummariesRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesSelfCreate>>,
  TError,
  { data: BodyType<SelfExportPurchaserSummariesRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesSelfCreate>>,
    { data: BodyType<SelfExportPurchaserSummariesRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return apiDataV1ExportsPurchaserSummariesSelfCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiDataV1ExportsPurchaserSummariesSelfCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesSelfCreate>>
>;
export type ApiDataV1ExportsPurchaserSummariesSelfCreateMutationBody = BodyType<SelfExportPurchaserSummariesRequest>;
export type ApiDataV1ExportsPurchaserSummariesSelfCreateMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Export purchaser summaries (self)
 */
export const useApiDataV1ExportsPurchaserSummariesSelfCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesSelfCreate>>,
    TError,
    { data: BodyType<SelfExportPurchaserSummariesRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesSelfCreate>>,
  TError,
  { data: BodyType<SelfExportPurchaserSummariesRequest> },
  TContext
> => {
  const mutationOptions = getApiDataV1ExportsPurchaserSummariesSelfCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Schedule an export task for the specified purchaser.
 * @summary Export purchaser summaries (staff)
 */
export const apiDataV1ExportsPurchaserSummariesStaffCreate = (
  staffExportPurchaserSummariesRequest: BodyType<StaffExportPurchaserSummariesRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<StaffExportPurchaserSummariesResponse>(
    {
      url: `/api/data/v1/exports/purchaser-summaries/staff/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffExportPurchaserSummariesRequest,
      signal,
    },
    options
  );
};

export const getApiDataV1ExportsPurchaserSummariesStaffCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesStaffCreate>>,
    TError,
    { data: BodyType<StaffExportPurchaserSummariesRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesStaffCreate>>,
  TError,
  { data: BodyType<StaffExportPurchaserSummariesRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesStaffCreate>>,
    { data: BodyType<StaffExportPurchaserSummariesRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return apiDataV1ExportsPurchaserSummariesStaffCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiDataV1ExportsPurchaserSummariesStaffCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesStaffCreate>>
>;
export type ApiDataV1ExportsPurchaserSummariesStaffCreateMutationBody = BodyType<StaffExportPurchaserSummariesRequest>;
export type ApiDataV1ExportsPurchaserSummariesStaffCreateMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Export purchaser summaries (staff)
 */
export const useApiDataV1ExportsPurchaserSummariesStaffCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesStaffCreate>>,
    TError,
    { data: BodyType<StaffExportPurchaserSummariesRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesStaffCreate>>,
  TError,
  { data: BodyType<StaffExportPurchaserSummariesRequest> },
  TContext
> => {
  const mutationOptions = getApiDataV1ExportsPurchaserSummariesStaffCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Retrieves pipeline data for purchaser companies. Staff users can access any purchaser's data by providing purchaser_id. Non-staff users can only access their own company's data.
 * @summary Get pipeline data for purchaser companies
 */
export const apiDataV1PurchaserPipelineRetrieve = (
  params?: ApiDataV1PurchaserPipelineRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PurchaserPipelineTable>(
    { url: `/api/data/v1/purchaser-pipeline/`, method: 'GET', params, signal },
    options
  );
};

export const getApiDataV1PurchaserPipelineRetrieveQueryKey = (params?: ApiDataV1PurchaserPipelineRetrieveParams) => {
  return [`/api/data/v1/purchaser-pipeline/`, ...(params ? [params] : [])] as const;
};

export const getApiDataV1PurchaserPipelineRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1PurchaserPipelineRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDataV1PurchaserPipelineRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>> = ({ signal }) =>
    apiDataV1PurchaserPipelineRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDataV1PurchaserPipelineRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>
>;
export type ApiDataV1PurchaserPipelineRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiDataV1PurchaserPipelineRetrieve<
  TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiDataV1PurchaserPipelineRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1PurchaserPipelineRetrieve<
  TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1PurchaserPipelineRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1PurchaserPipelineRetrieve<
  TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1PurchaserPipelineRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get pipeline data for purchaser companies
 */

export function useApiDataV1PurchaserPipelineRetrieve<
  TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1PurchaserPipelineRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDataV1PurchaserPipelineRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDataV1PurchaserPipelineRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1PurchaserPipelineRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDataV1PurchaserPipelineRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>> = ({ signal }) =>
    apiDataV1PurchaserPipelineRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDataV1PurchaserPipelineRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>
>;
export type ApiDataV1PurchaserPipelineRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiDataV1PurchaserPipelineRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiDataV1PurchaserPipelineRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1PurchaserPipelineRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1PurchaserPipelineRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1PurchaserPipelineRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1PurchaserPipelineRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get pipeline data for purchaser companies
 */

export function useApiDataV1PurchaserPipelineRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1PurchaserPipelineRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDataV1PurchaserPipelineRetrieveSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiDataV1ViewsPurchaserSummariesLoadsSelfList = (
  params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedPurchaserLoadSummaryDTOList>(
    { url: `/api/data/v1/views/purchaser-summaries/loads/self/`, method: 'GET', params, signal },
    options
  );
};

export const getApiDataV1ViewsPurchaserSummariesLoadsSelfListQueryKey = (
  params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams
) => {
  return [`/api/data/v1/views/purchaser-summaries/loads/self/`, ...(params ? [params] : [])] as const;
};

export const getApiDataV1ViewsPurchaserSummariesLoadsSelfListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesLoadsSelfListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>> = ({
    signal,
  }) => apiDataV1ViewsPurchaserSummariesLoadsSelfList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDataV1ViewsPurchaserSummariesLoadsSelfListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>
>;
export type ApiDataV1ViewsPurchaserSummariesLoadsSelfListQueryError = ErrorType<ErrorResponse>;

export function useApiDataV1ViewsPurchaserSummariesLoadsSelfList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesLoadsSelfList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesLoadsSelfList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDataV1ViewsPurchaserSummariesLoadsSelfList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDataV1ViewsPurchaserSummariesLoadsSelfListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDataV1ViewsPurchaserSummariesLoadsSelfListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesLoadsSelfListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>> = ({
    signal,
  }) => apiDataV1ViewsPurchaserSummariesLoadsSelfList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDataV1ViewsPurchaserSummariesLoadsSelfListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>
>;
export type ApiDataV1ViewsPurchaserSummariesLoadsSelfListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiDataV1ViewsPurchaserSummariesLoadsSelfListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesLoadsSelfListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesLoadsSelfListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDataV1ViewsPurchaserSummariesLoadsSelfListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDataV1ViewsPurchaserSummariesLoadsSelfListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiDataV1ViewsPurchaserSummariesLoadsStaffList = (
  params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedPurchaserLoadSummaryDTOList>(
    { url: `/api/data/v1/views/purchaser-summaries/loads/staff/`, method: 'GET', params, signal },
    options
  );
};

export const getApiDataV1ViewsPurchaserSummariesLoadsStaffListQueryKey = (
  params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams
) => {
  return [`/api/data/v1/views/purchaser-summaries/loads/staff/`, ...(params ? [params] : [])] as const;
};

export const getApiDataV1ViewsPurchaserSummariesLoadsStaffListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesLoadsStaffListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>> = ({
    signal,
  }) => apiDataV1ViewsPurchaserSummariesLoadsStaffList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDataV1ViewsPurchaserSummariesLoadsStaffListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>
>;
export type ApiDataV1ViewsPurchaserSummariesLoadsStaffListQueryError = ErrorType<ErrorResponse>;

export function useApiDataV1ViewsPurchaserSummariesLoadsStaffList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesLoadsStaffList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesLoadsStaffList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDataV1ViewsPurchaserSummariesLoadsStaffList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDataV1ViewsPurchaserSummariesLoadsStaffListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDataV1ViewsPurchaserSummariesLoadsStaffListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesLoadsStaffListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>> = ({
    signal,
  }) => apiDataV1ViewsPurchaserSummariesLoadsStaffList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDataV1ViewsPurchaserSummariesLoadsStaffListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>
>;
export type ApiDataV1ViewsPurchaserSummariesLoadsStaffListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiDataV1ViewsPurchaserSummariesLoadsStaffListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesLoadsStaffListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesLoadsStaffListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDataV1ViewsPurchaserSummariesLoadsStaffListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDataV1ViewsPurchaserSummariesLoadsStaffListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList = (
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedPurchaserSalesOrderSummaryDTOList>(
    { url: `/api/data/v1/views/purchaser-summaries/sales-orders/self/`, method: 'GET', params, signal },
    options
  );
};

export const getApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListQueryKey = (
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams
) => {
  return [`/api/data/v1/views/purchaser-summaries/sales-orders/self/`, ...(params ? [params] : [])] as const;
};

export const getApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>> = ({
    signal,
  }) => apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>
>;
export type ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListQueryError = ErrorType<ErrorResponse>;

export function useApiDataV1ViewsPurchaserSummariesSalesOrdersSelfList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesSalesOrdersSelfList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesSalesOrdersSelfList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDataV1ViewsPurchaserSummariesSalesOrdersSelfList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>> = ({
    signal,
  }) => apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>
>;
export type ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList = (
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedPurchaserSalesOrderSummaryDTOList>(
    { url: `/api/data/v1/views/purchaser-summaries/sales-orders/staff/`, method: 'GET', params, signal },
    options
  );
};

export const getApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListQueryKey = (
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams
) => {
  return [`/api/data/v1/views/purchaser-summaries/sales-orders/staff/`, ...(params ? [params] : [])] as const;
};

export const getApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>> = ({
    signal,
  }) => apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>
>;
export type ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListQueryError = ErrorType<ErrorResponse>;

export function useApiDataV1ViewsPurchaserSummariesSalesOrdersStaffList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesSalesOrdersStaffList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesSalesOrdersStaffList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDataV1ViewsPurchaserSummariesSalesOrdersStaffList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>> = ({
    signal,
  }) => apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>
>;
export type ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiDataV1ViewsPurchaserSummariesShipmentsSelfList = (
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedPurchaserShipmentSummaryDTOList>(
    { url: `/api/data/v1/views/purchaser-summaries/shipments/self/`, method: 'GET', params, signal },
    options
  );
};

export const getApiDataV1ViewsPurchaserSummariesShipmentsSelfListQueryKey = (
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams
) => {
  return [`/api/data/v1/views/purchaser-summaries/shipments/self/`, ...(params ? [params] : [])] as const;
};

export const getApiDataV1ViewsPurchaserSummariesShipmentsSelfListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesShipmentsSelfListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>> = ({
    signal,
  }) => apiDataV1ViewsPurchaserSummariesShipmentsSelfList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDataV1ViewsPurchaserSummariesShipmentsSelfListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>
>;
export type ApiDataV1ViewsPurchaserSummariesShipmentsSelfListQueryError = ErrorType<ErrorResponse>;

export function useApiDataV1ViewsPurchaserSummariesShipmentsSelfList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesShipmentsSelfList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesShipmentsSelfList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDataV1ViewsPurchaserSummariesShipmentsSelfList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDataV1ViewsPurchaserSummariesShipmentsSelfListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDataV1ViewsPurchaserSummariesShipmentsSelfListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesShipmentsSelfListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>> = ({
    signal,
  }) => apiDataV1ViewsPurchaserSummariesShipmentsSelfList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDataV1ViewsPurchaserSummariesShipmentsSelfListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>
>;
export type ApiDataV1ViewsPurchaserSummariesShipmentsSelfListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiDataV1ViewsPurchaserSummariesShipmentsSelfListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesShipmentsSelfListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesShipmentsSelfListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDataV1ViewsPurchaserSummariesShipmentsSelfListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDataV1ViewsPurchaserSummariesShipmentsSelfListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiDataV1ViewsPurchaserSummariesShipmentsStaffList = (
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedPurchaserShipmentSummaryDTOList>(
    { url: `/api/data/v1/views/purchaser-summaries/shipments/staff/`, method: 'GET', params, signal },
    options
  );
};

export const getApiDataV1ViewsPurchaserSummariesShipmentsStaffListQueryKey = (
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams
) => {
  return [`/api/data/v1/views/purchaser-summaries/shipments/staff/`, ...(params ? [params] : [])] as const;
};

export const getApiDataV1ViewsPurchaserSummariesShipmentsStaffListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesShipmentsStaffListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>> = ({
    signal,
  }) => apiDataV1ViewsPurchaserSummariesShipmentsStaffList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDataV1ViewsPurchaserSummariesShipmentsStaffListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>
>;
export type ApiDataV1ViewsPurchaserSummariesShipmentsStaffListQueryError = ErrorType<ErrorResponse>;

export function useApiDataV1ViewsPurchaserSummariesShipmentsStaffList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesShipmentsStaffList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesShipmentsStaffList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDataV1ViewsPurchaserSummariesShipmentsStaffList<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDataV1ViewsPurchaserSummariesShipmentsStaffListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDataV1ViewsPurchaserSummariesShipmentsStaffListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesShipmentsStaffListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>> = ({
    signal,
  }) => apiDataV1ViewsPurchaserSummariesShipmentsStaffList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDataV1ViewsPurchaserSummariesShipmentsStaffListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>
>;
export type ApiDataV1ViewsPurchaserSummariesShipmentsStaffListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiDataV1ViewsPurchaserSummariesShipmentsStaffListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesShipmentsStaffListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDataV1ViewsPurchaserSummariesShipmentsStaffListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDataV1ViewsPurchaserSummariesShipmentsStaffListSuspense<
  TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDataV1ViewsPurchaserSummariesShipmentsStaffListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiDealsV1Create = (
  createDealDTO: BodyType<CreateDealDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<DealCreateResponse>(
    {
      url: `/api/deals/v1/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createDealDTO,
      signal,
    },
    options
  );
};

export const getApiDealsV1CreateMutationOptions = <
  TError = ErrorType<ApiDealsV1Create400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDealsV1Create>>,
    TError,
    { data: BodyType<CreateDealDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiDealsV1Create>>,
  TError,
  { data: BodyType<CreateDealDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDealsV1Create>>,
    { data: BodyType<CreateDealDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return apiDealsV1Create(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiDealsV1CreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1Create>>>;
export type ApiDealsV1CreateMutationBody = BodyType<CreateDealDTO>;
export type ApiDealsV1CreateMutationError = ErrorType<ApiDealsV1Create400 | ErrorResponse>;

export const useApiDealsV1Create = <
  TError = ErrorType<ApiDealsV1Create400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDealsV1Create>>,
    TError,
    { data: BodyType<CreateDealDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiDealsV1Create>>,
  TError,
  { data: BodyType<CreateDealDTO> },
  TContext
> => {
  const mutationOptions = getApiDealsV1CreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Helper class that provides a standard way to create an ABC using
inheritance.
 */
export const apiDealsV1ApproveCreate = (
  dealId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>({ url: `/api/deals/v1/${dealId}/approve/`, method: 'POST', signal }, options);
};

export const getApiDealsV1ApproveCreateMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDealsV1ApproveCreate>>,
    TError,
    { dealId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<Awaited<ReturnType<typeof apiDealsV1ApproveCreate>>, TError, { dealId: number }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDealsV1ApproveCreate>>, { dealId: number }> = (
    props
  ) => {
    const { dealId } = props ?? {};

    return apiDealsV1ApproveCreate(dealId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiDealsV1ApproveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1ApproveCreate>>>;

export type ApiDealsV1ApproveCreateMutationError = ErrorType<unknown>;

export const useApiDealsV1ApproveCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDealsV1ApproveCreate>>,
    TError,
    { dealId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<Awaited<ReturnType<typeof apiDealsV1ApproveCreate>>, TError, { dealId: number }, TContext> => {
  const mutationOptions = getApiDealsV1ApproveCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiDealsV1CostAposList = (
  dealId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AccountingPurchaseOrderLineItemCost[]>(
    { url: `/api/deals/v1/${dealId}/cost_apos/`, method: 'GET', signal },
    options
  );
};

export const getApiDealsV1CostAposListQueryKey = (dealId: number) => {
  return [`/api/deals/v1/${dealId}/cost_apos/`] as const;
};

export const getApiDealsV1CostAposListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDealsV1CostAposListQueryKey(dealId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1CostAposList>>> = ({ signal }) =>
    apiDealsV1CostAposList(dealId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!dealId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiDealsV1CostAposList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDealsV1CostAposListQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1CostAposList>>>;
export type ApiDealsV1CostAposListQueryError = ErrorType<unknown>;

export function useApiDealsV1CostAposList<
  TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1CostAposList<
  TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1CostAposList<
  TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDealsV1CostAposList<
  TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDealsV1CostAposListQueryOptions(dealId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDealsV1CostAposListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDealsV1CostAposListQueryKey(dealId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1CostAposList>>> = ({ signal }) =>
    apiDealsV1CostAposList(dealId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiDealsV1CostAposList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDealsV1CostAposListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1CostAposList>>>;
export type ApiDealsV1CostAposListSuspenseQueryError = ErrorType<unknown>;

export function useApiDealsV1CostAposListSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1CostAposListSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1CostAposListSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDealsV1CostAposListSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDealsV1CostAposListSuspenseQueryOptions(dealId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiDealsV1CostsList = (
  dealId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<InvoiceLineItemCost[]>({ url: `/api/deals/v1/${dealId}/costs/`, method: 'GET', signal }, options);
};

export const getApiDealsV1CostsListQueryKey = (dealId: number) => {
  return [`/api/deals/v1/${dealId}/costs/`] as const;
};

export const getApiDealsV1CostsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDealsV1CostsListQueryKey(dealId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1CostsList>>> = ({ signal }) =>
    apiDealsV1CostsList(dealId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!dealId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiDealsV1CostsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDealsV1CostsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1CostsList>>>;
export type ApiDealsV1CostsListQueryError = ErrorType<unknown>;

export function useApiDealsV1CostsList<
  TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1CostsList<
  TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1CostsList<
  TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDealsV1CostsList<
  TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDealsV1CostsListQueryOptions(dealId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDealsV1CostsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDealsV1CostsListQueryKey(dealId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1CostsList>>> = ({ signal }) =>
    apiDealsV1CostsList(dealId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiDealsV1CostsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDealsV1CostsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1CostsList>>>;
export type ApiDealsV1CostsListSuspenseQueryError = ErrorType<unknown>;

export function useApiDealsV1CostsListSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1CostsListSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1CostsListSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDealsV1CostsListSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDealsV1CostsListSuspenseQueryOptions(dealId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Helper class that provides a standard way to create an ABC using
inheritance.
 */
export const apiDealsV1HandOverCreate = (
  dealId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>({ url: `/api/deals/v1/${dealId}/hand-over/`, method: 'POST', signal }, options);
};

export const getApiDealsV1HandOverCreateMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDealsV1HandOverCreate>>,
    TError,
    { dealId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<Awaited<ReturnType<typeof apiDealsV1HandOverCreate>>, TError, { dealId: number }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDealsV1HandOverCreate>>, { dealId: number }> = (
    props
  ) => {
    const { dealId } = props ?? {};

    return apiDealsV1HandOverCreate(dealId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiDealsV1HandOverCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1HandOverCreate>>>;

export type ApiDealsV1HandOverCreateMutationError = ErrorType<unknown>;

export const useApiDealsV1HandOverCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDealsV1HandOverCreate>>,
    TError,
    { dealId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<Awaited<ReturnType<typeof apiDealsV1HandOverCreate>>, TError, { dealId: number }, TContext> => {
  const mutationOptions = getApiDealsV1HandOverCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Helper class that provides a standard way to create an ABC using
inheritance.
 */
export const apiDealsV1RejectCreate = (
  dealId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>({ url: `/api/deals/v1/${dealId}/reject/`, method: 'POST', signal }, options);
};

export const getApiDealsV1RejectCreateMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDealsV1RejectCreate>>,
    TError,
    { dealId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<Awaited<ReturnType<typeof apiDealsV1RejectCreate>>, TError, { dealId: number }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDealsV1RejectCreate>>, { dealId: number }> = (
    props
  ) => {
    const { dealId } = props ?? {};

    return apiDealsV1RejectCreate(dealId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiDealsV1RejectCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1RejectCreate>>>;

export type ApiDealsV1RejectCreateMutationError = ErrorType<unknown>;

export const useApiDealsV1RejectCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDealsV1RejectCreate>>,
    TError,
    { dealId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<Awaited<ReturnType<typeof apiDealsV1RejectCreate>>, TError, { dealId: number }, TContext> => {
  const mutationOptions = getApiDealsV1RejectCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiDealsV1RevenueList = (
  dealId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ReceivableInvoiceLineItemRevenue[]>(
    { url: `/api/deals/v1/${dealId}/revenue/`, method: 'GET', signal },
    options
  );
};

export const getApiDealsV1RevenueListQueryKey = (dealId: number) => {
  return [`/api/deals/v1/${dealId}/revenue/`] as const;
};

export const getApiDealsV1RevenueListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDealsV1RevenueListQueryKey(dealId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1RevenueList>>> = ({ signal }) =>
    apiDealsV1RevenueList(dealId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!dealId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiDealsV1RevenueList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDealsV1RevenueListQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1RevenueList>>>;
export type ApiDealsV1RevenueListQueryError = ErrorType<unknown>;

export function useApiDealsV1RevenueList<
  TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1RevenueList<
  TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1RevenueList<
  TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDealsV1RevenueList<
  TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDealsV1RevenueListQueryOptions(dealId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDealsV1RevenueListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDealsV1RevenueListQueryKey(dealId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1RevenueList>>> = ({ signal }) =>
    apiDealsV1RevenueList(dealId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiDealsV1RevenueList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDealsV1RevenueListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1RevenueList>>>;
export type ApiDealsV1RevenueListSuspenseQueryError = ErrorType<unknown>;

export function useApiDealsV1RevenueListSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1RevenueListSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1RevenueListSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDealsV1RevenueListSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>,
  TError = ErrorType<unknown>,
>(
  dealId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDealsV1RevenueListSuspenseQueryOptions(dealId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiDealsV1Retrieve = (id: number, options?: SecondParameter<typeof customAxios>, signal?: AbortSignal) => {
  return customAxios<Deal>({ url: `/api/deals/v1/${id}/`, method: 'GET', signal }, options);
};

export const getApiDealsV1RetrieveQueryKey = (id: number) => {
  return [`/api/deals/v1/${id}/`] as const;
};

export const getApiDealsV1RetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDealsV1RetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1Retrieve>>> = ({ signal }) =>
    apiDealsV1Retrieve(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiDealsV1Retrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDealsV1RetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1Retrieve>>>;
export type ApiDealsV1RetrieveQueryError = ErrorType<unknown>;

export function useApiDealsV1Retrieve<
  TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1Retrieve<
  TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1Retrieve<
  TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDealsV1Retrieve<
  TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDealsV1RetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDealsV1RetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDealsV1RetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1Retrieve>>> = ({ signal }) =>
    apiDealsV1Retrieve(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiDealsV1Retrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDealsV1RetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1Retrieve>>>;
export type ApiDealsV1RetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiDealsV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDealsV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDealsV1RetrieveSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiDealsV1PartialUpdate = (
  id: number,
  patchedDeal: BodyType<NonReadonly<PatchedDeal>>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<Deal>(
    {
      url: `/api/deals/v1/${id}/`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchedDeal,
    },
    options
  );
};

export const getApiDealsV1PartialUpdateMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDealsV1PartialUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<PatchedDeal>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiDealsV1PartialUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<PatchedDeal>> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDealsV1PartialUpdate>>,
    { id: number; data: BodyType<NonReadonly<PatchedDeal>> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiDealsV1PartialUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiDealsV1PartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1PartialUpdate>>>;
export type ApiDealsV1PartialUpdateMutationBody = BodyType<NonReadonly<PatchedDeal>>;
export type ApiDealsV1PartialUpdateMutationError = ErrorType<unknown>;

export const useApiDealsV1PartialUpdate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDealsV1PartialUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<PatchedDeal>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiDealsV1PartialUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<PatchedDeal>> },
  TContext
> => {
  const mutationOptions = getApiDealsV1PartialUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiDealsV1DealChoicesList = (
  params?: ApiDealsV1DealChoicesListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedDealChoicesList>(
    { url: `/api/deals/v1/deal-choices`, method: 'GET', params, signal },
    options
  );
};

export const getApiDealsV1DealChoicesListQueryKey = (params?: ApiDealsV1DealChoicesListParams) => {
  return [`/api/deals/v1/deal-choices`, ...(params ? [params] : [])] as const;
};

export const getApiDealsV1DealChoicesListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiDealsV1DealChoicesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDealsV1DealChoicesListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>> = ({ signal }) =>
    apiDealsV1DealChoicesList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDealsV1DealChoicesListQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>>;
export type ApiDealsV1DealChoicesListQueryError = ErrorType<unknown>;

export function useApiDealsV1DealChoicesList<
  TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiDealsV1DealChoicesListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1DealChoicesList<
  TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiDealsV1DealChoicesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1DealChoicesList<
  TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiDealsV1DealChoicesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDealsV1DealChoicesList<
  TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiDealsV1DealChoicesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDealsV1DealChoicesListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDealsV1DealChoicesListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiDealsV1DealChoicesListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDealsV1DealChoicesListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>> = ({ signal }) =>
    apiDealsV1DealChoicesList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDealsV1DealChoicesListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>
>;
export type ApiDealsV1DealChoicesListSuspenseQueryError = ErrorType<unknown>;

export function useApiDealsV1DealChoicesListSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiDealsV1DealChoicesListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1DealChoicesListSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiDealsV1DealChoicesListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1DealChoicesListSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiDealsV1DealChoicesListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDealsV1DealChoicesListSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiDealsV1DealChoicesListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDealsV1DealChoicesListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiDealsV1SellerTransactionHistoryRetrieve = (
  sellerId: number,
  params?: ApiDealsV1SellerTransactionHistoryRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<TransactionHistoryResponseDTO | void>(
    { url: `/api/deals/v1/seller-transaction-history/${sellerId}/`, method: 'GET', params, signal },
    options
  );
};

export const getApiDealsV1SellerTransactionHistoryRetrieveQueryKey = (
  sellerId: number,
  params?: ApiDealsV1SellerTransactionHistoryRetrieveParams
) => {
  return [`/api/deals/v1/seller-transaction-history/${sellerId}/`, ...(params ? [params] : [])] as const;
};

export const getApiDealsV1SellerTransactionHistoryRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>,
  TError = ErrorType<unknown>,
>(
  sellerId: number,
  params?: ApiDealsV1SellerTransactionHistoryRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDealsV1SellerTransactionHistoryRetrieveQueryKey(sellerId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>> = ({ signal }) =>
    apiDealsV1SellerTransactionHistoryRetrieve(sellerId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!sellerId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDealsV1SellerTransactionHistoryRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>
>;
export type ApiDealsV1SellerTransactionHistoryRetrieveQueryError = ErrorType<unknown>;

export function useApiDealsV1SellerTransactionHistoryRetrieve<
  TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>,
  TError = ErrorType<unknown>,
>(
  sellerId: number,
  params: undefined | ApiDealsV1SellerTransactionHistoryRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1SellerTransactionHistoryRetrieve<
  TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>,
  TError = ErrorType<unknown>,
>(
  sellerId: number,
  params?: ApiDealsV1SellerTransactionHistoryRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1SellerTransactionHistoryRetrieve<
  TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>,
  TError = ErrorType<unknown>,
>(
  sellerId: number,
  params?: ApiDealsV1SellerTransactionHistoryRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDealsV1SellerTransactionHistoryRetrieve<
  TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>,
  TError = ErrorType<unknown>,
>(
  sellerId: number,
  params?: ApiDealsV1SellerTransactionHistoryRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDealsV1SellerTransactionHistoryRetrieveQueryOptions(sellerId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDealsV1SellerTransactionHistoryRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>,
  TError = ErrorType<unknown>,
>(
  sellerId: number,
  params?: ApiDealsV1SellerTransactionHistoryRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDealsV1SellerTransactionHistoryRetrieveQueryKey(sellerId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>> = ({ signal }) =>
    apiDealsV1SellerTransactionHistoryRetrieve(sellerId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDealsV1SellerTransactionHistoryRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>
>;
export type ApiDealsV1SellerTransactionHistoryRetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiDealsV1SellerTransactionHistoryRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>,
  TError = ErrorType<unknown>,
>(
  sellerId: number,
  params: undefined | ApiDealsV1SellerTransactionHistoryRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1SellerTransactionHistoryRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>,
  TError = ErrorType<unknown>,
>(
  sellerId: number,
  params?: ApiDealsV1SellerTransactionHistoryRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDealsV1SellerTransactionHistoryRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>,
  TError = ErrorType<unknown>,
>(
  sellerId: number,
  params?: ApiDealsV1SellerTransactionHistoryRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDealsV1SellerTransactionHistoryRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>,
  TError = ErrorType<unknown>,
>(
  sellerId: number,
  params?: ApiDealsV1SellerTransactionHistoryRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDealsV1SellerTransactionHistoryRetrieveSuspenseQueryOptions(sellerId, params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiDocumentsV1DocumentsList = (
  params?: ApiDocumentsV1DocumentsListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedDocumentInfoList>(
    { url: `/api/documents/v1/documents/`, method: 'GET', params, signal },
    options
  );
};

export const getApiDocumentsV1DocumentsListQueryKey = (params?: ApiDocumentsV1DocumentsListParams) => {
  return [`/api/documents/v1/documents/`, ...(params ? [params] : [])] as const;
};

export const getApiDocumentsV1DocumentsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDocumentsV1DocumentsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDocumentsV1DocumentsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>> = ({ signal }) =>
    apiDocumentsV1DocumentsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDocumentsV1DocumentsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>
>;
export type ApiDocumentsV1DocumentsListQueryError = ErrorType<ErrorResponse>;

export function useApiDocumentsV1DocumentsList<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiDocumentsV1DocumentsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDocumentsV1DocumentsList<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDocumentsV1DocumentsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDocumentsV1DocumentsList<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDocumentsV1DocumentsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDocumentsV1DocumentsList<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDocumentsV1DocumentsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDocumentsV1DocumentsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDocumentsV1DocumentsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDocumentsV1DocumentsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDocumentsV1DocumentsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>> = ({ signal }) =>
    apiDocumentsV1DocumentsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDocumentsV1DocumentsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>
>;
export type ApiDocumentsV1DocumentsListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiDocumentsV1DocumentsListSuspense<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiDocumentsV1DocumentsListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDocumentsV1DocumentsListSuspense<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDocumentsV1DocumentsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDocumentsV1DocumentsListSuspense<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDocumentsV1DocumentsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDocumentsV1DocumentsListSuspense<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiDocumentsV1DocumentsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDocumentsV1DocumentsListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiDocumentsV1DocumentsCreate = (
  documentCreate: BodyType<DocumentCreate>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<DocumentInfo>(
    {
      url: `/api/documents/v1/documents/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: documentCreate,
      signal,
    },
    options
  );
};

export const getApiDocumentsV1DocumentsCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsCreate>>,
    TError,
    { data: BodyType<DocumentCreate> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsCreate>>,
  TError,
  { data: BodyType<DocumentCreate> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsCreate>>,
    { data: BodyType<DocumentCreate> }
  > = (props) => {
    const { data } = props ?? {};

    return apiDocumentsV1DocumentsCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiDocumentsV1DocumentsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsCreate>>
>;
export type ApiDocumentsV1DocumentsCreateMutationBody = BodyType<DocumentCreate>;
export type ApiDocumentsV1DocumentsCreateMutationError = ErrorType<ErrorResponse>;

export const useApiDocumentsV1DocumentsCreate = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsCreate>>,
    TError,
    { data: BodyType<DocumentCreate> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsCreate>>,
  TError,
  { data: BodyType<DocumentCreate> },
  TContext
> => {
  const mutationOptions = getApiDocumentsV1DocumentsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiDocumentsV1DocumentsSendSigningEmailCreate = (
  documentId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SendSigningEmailResponse>(
    { url: `/api/documents/v1/documents/${documentId}/send-signing-email/`, method: 'POST', signal },
    options
  );
};

export const getApiDocumentsV1DocumentsSendSigningEmailCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsSendSigningEmailCreate>>,
    TError,
    { documentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsSendSigningEmailCreate>>,
  TError,
  { documentId: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsSendSigningEmailCreate>>,
    { documentId: number }
  > = (props) => {
    const { documentId } = props ?? {};

    return apiDocumentsV1DocumentsSendSigningEmailCreate(documentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiDocumentsV1DocumentsSendSigningEmailCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsSendSigningEmailCreate>>
>;

export type ApiDocumentsV1DocumentsSendSigningEmailCreateMutationError = ErrorType<ErrorResponse>;

export const useApiDocumentsV1DocumentsSendSigningEmailCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsSendSigningEmailCreate>>,
    TError,
    { documentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsSendSigningEmailCreate>>,
  TError,
  { documentId: number },
  TContext
> => {
  const mutationOptions = getApiDocumentsV1DocumentsSendSigningEmailCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiDocumentsV1DocumentsSigningUrlCreate = (
  documentId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<DocumentSigningURLResponse>(
    { url: `/api/documents/v1/documents/${documentId}/signing-url/`, method: 'POST', signal },
    options
  );
};

export const getApiDocumentsV1DocumentsSigningUrlCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsSigningUrlCreate>>,
    TError,
    { documentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsSigningUrlCreate>>,
  TError,
  { documentId: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsSigningUrlCreate>>,
    { documentId: number }
  > = (props) => {
    const { documentId } = props ?? {};

    return apiDocumentsV1DocumentsSigningUrlCreate(documentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiDocumentsV1DocumentsSigningUrlCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsSigningUrlCreate>>
>;

export type ApiDocumentsV1DocumentsSigningUrlCreateMutationError = ErrorType<ErrorResponse>;

export const useApiDocumentsV1DocumentsSigningUrlCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsSigningUrlCreate>>,
    TError,
    { documentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsSigningUrlCreate>>,
  TError,
  { documentId: number },
  TContext
> => {
  const mutationOptions = getApiDocumentsV1DocumentsSigningUrlCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiDocumentsV1DocumentsUnsignCreate = (
  documentId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<DocumentInfo>(
    { url: `/api/documents/v1/documents/${documentId}/unsign/`, method: 'POST', signal },
    options
  );
};

export const getApiDocumentsV1DocumentsUnsignCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsUnsignCreate>>,
    TError,
    { documentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsUnsignCreate>>,
  TError,
  { documentId: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsUnsignCreate>>,
    { documentId: number }
  > = (props) => {
    const { documentId } = props ?? {};

    return apiDocumentsV1DocumentsUnsignCreate(documentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiDocumentsV1DocumentsUnsignCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsUnsignCreate>>
>;

export type ApiDocumentsV1DocumentsUnsignCreateMutationError = ErrorType<ErrorResponse>;

export const useApiDocumentsV1DocumentsUnsignCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsUnsignCreate>>,
    TError,
    { documentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsUnsignCreate>>,
  TError,
  { documentId: number },
  TContext
> => {
  const mutationOptions = getApiDocumentsV1DocumentsUnsignCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiDocumentsV1DocumentsRetrieve = (
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<DocumentInfo>({ url: `/api/documents/v1/documents/${id}/`, method: 'GET', signal }, options);
};

export const getApiDocumentsV1DocumentsRetrieveQueryKey = (id: number) => {
  return [`/api/documents/v1/documents/${id}/`] as const;
};

export const getApiDocumentsV1DocumentsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDocumentsV1DocumentsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>> = ({ signal }) =>
    apiDocumentsV1DocumentsRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDocumentsV1DocumentsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>
>;
export type ApiDocumentsV1DocumentsRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiDocumentsV1DocumentsRetrieve<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDocumentsV1DocumentsRetrieve<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDocumentsV1DocumentsRetrieve<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDocumentsV1DocumentsRetrieve<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDocumentsV1DocumentsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDocumentsV1DocumentsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDocumentsV1DocumentsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>> = ({ signal }) =>
    apiDocumentsV1DocumentsRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDocumentsV1DocumentsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>
>;
export type ApiDocumentsV1DocumentsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiDocumentsV1DocumentsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDocumentsV1DocumentsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDocumentsV1DocumentsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDocumentsV1DocumentsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDocumentsV1DocumentsRetrieveSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiDocumentsV1DocumentsPartialUpdate = (
  id: number,
  patchedDocumentUpdate: BodyType<PatchedDocumentUpdate>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<DocumentInfo>(
    {
      url: `/api/documents/v1/documents/${id}/`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchedDocumentUpdate,
    },
    options
  );
};

export const getApiDocumentsV1DocumentsPartialUpdateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsPartialUpdate>>,
    TError,
    { id: number; data: BodyType<PatchedDocumentUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsPartialUpdate>>,
  TError,
  { id: number; data: BodyType<PatchedDocumentUpdate> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsPartialUpdate>>,
    { id: number; data: BodyType<PatchedDocumentUpdate> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiDocumentsV1DocumentsPartialUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiDocumentsV1DocumentsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsPartialUpdate>>
>;
export type ApiDocumentsV1DocumentsPartialUpdateMutationBody = BodyType<PatchedDocumentUpdate>;
export type ApiDocumentsV1DocumentsPartialUpdateMutationError = ErrorType<ErrorResponse>;

export const useApiDocumentsV1DocumentsPartialUpdate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsPartialUpdate>>,
    TError,
    { id: number; data: BodyType<PatchedDocumentUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsPartialUpdate>>,
  TError,
  { id: number; data: BodyType<PatchedDocumentUpdate> },
  TContext
> => {
  const mutationOptions = getApiDocumentsV1DocumentsPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Get the URL for a document's context model.
 */
export const apiDocumentsV1DocumentsContextUrlRetrieve = (
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<DocumentContextURLOutput>(
    { url: `/api/documents/v1/documents/${id}/context-url/`, method: 'GET', signal },
    options
  );
};

export const getApiDocumentsV1DocumentsContextUrlRetrieveQueryKey = (id: number) => {
  return [`/api/documents/v1/documents/${id}/context-url/`] as const;
};

export const getApiDocumentsV1DocumentsContextUrlRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDocumentsV1DocumentsContextUrlRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>> = ({ signal }) =>
    apiDocumentsV1DocumentsContextUrlRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDocumentsV1DocumentsContextUrlRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>
>;
export type ApiDocumentsV1DocumentsContextUrlRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiDocumentsV1DocumentsContextUrlRetrieve<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDocumentsV1DocumentsContextUrlRetrieve<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDocumentsV1DocumentsContextUrlRetrieve<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDocumentsV1DocumentsContextUrlRetrieve<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDocumentsV1DocumentsContextUrlRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDocumentsV1DocumentsContextUrlRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDocumentsV1DocumentsContextUrlRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>> = ({ signal }) =>
    apiDocumentsV1DocumentsContextUrlRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDocumentsV1DocumentsContextUrlRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>
>;
export type ApiDocumentsV1DocumentsContextUrlRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiDocumentsV1DocumentsContextUrlRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDocumentsV1DocumentsContextUrlRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDocumentsV1DocumentsContextUrlRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDocumentsV1DocumentsContextUrlRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDocumentsV1DocumentsContextUrlRetrieveSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generate an upload URL for a document.
 */
export const apiDocumentsV1DocumentsPdfCreate = (
  id: number,
  generatePDFInput: BodyType<GeneratePDFInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GeneratePDFOutput>(
    {
      url: `/api/documents/v1/documents/${id}/pdf/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: generatePDFInput,
      signal,
    },
    options
  );
};

export const getApiDocumentsV1DocumentsPdfCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsPdfCreate>>,
    TError,
    { id: number; data: BodyType<GeneratePDFInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsPdfCreate>>,
  TError,
  { id: number; data: BodyType<GeneratePDFInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsPdfCreate>>,
    { id: number; data: BodyType<GeneratePDFInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiDocumentsV1DocumentsPdfCreate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiDocumentsV1DocumentsPdfCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsPdfCreate>>
>;
export type ApiDocumentsV1DocumentsPdfCreateMutationBody = BodyType<GeneratePDFInput>;
export type ApiDocumentsV1DocumentsPdfCreateMutationError = ErrorType<ErrorResponse>;

export const useApiDocumentsV1DocumentsPdfCreate = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsPdfCreate>>,
    TError,
    { id: number; data: BodyType<GeneratePDFInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsPdfCreate>>,
  TError,
  { id: number; data: BodyType<GeneratePDFInput> },
  TContext
> => {
  const mutationOptions = getApiDocumentsV1DocumentsPdfCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Generate an upload URL for a document.
 */
export const apiDocumentsV1DocumentsUploadCreate = (
  id: number,
  preSignedURLInput: BodyType<PreSignedURLInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PreSignedURLOutput>(
    {
      url: `/api/documents/v1/documents/${id}/upload/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: preSignedURLInput,
      signal,
    },
    options
  );
};

export const getApiDocumentsV1DocumentsUploadCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsUploadCreate>>,
    TError,
    { id: number; data: BodyType<PreSignedURLInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsUploadCreate>>,
  TError,
  { id: number; data: BodyType<PreSignedURLInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsUploadCreate>>,
    { id: number; data: BodyType<PreSignedURLInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiDocumentsV1DocumentsUploadCreate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiDocumentsV1DocumentsUploadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsUploadCreate>>
>;
export type ApiDocumentsV1DocumentsUploadCreateMutationBody = BodyType<PreSignedURLInput>;
export type ApiDocumentsV1DocumentsUploadCreateMutationError = ErrorType<ErrorResponse>;

export const useApiDocumentsV1DocumentsUploadCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsUploadCreate>>,
    TError,
    { id: number; data: BodyType<PreSignedURLInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsUploadCreate>>,
  TError,
  { id: number; data: BodyType<PreSignedURLInput> },
  TContext
> => {
  const mutationOptions = getApiDocumentsV1DocumentsUploadCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * List documents for a specific sales order, filtered by user's trade company access.
 */
export const apiV1SalesOrderDocumentListExternal = (
  salesOrderSlug: string,
  params?: ApiV1SalesOrderDocumentListExternalParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedExternalCustomerDocumentList>(
    { url: `/api/documents/v1/documents/${salesOrderSlug}/external/`, method: 'GET', params, signal },
    options
  );
};

export const getApiV1SalesOrderDocumentListExternalQueryKey = (
  salesOrderSlug: string,
  params?: ApiV1SalesOrderDocumentListExternalParams
) => {
  return [`/api/documents/v1/documents/${salesOrderSlug}/external/`, ...(params ? [params] : [])] as const;
};

export const getApiV1SalesOrderDocumentListExternalQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>,
  TError = ErrorType<ErrorResponse>,
>(
  salesOrderSlug: string,
  params?: ApiV1SalesOrderDocumentListExternalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiV1SalesOrderDocumentListExternalQueryKey(salesOrderSlug, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>> = ({ signal }) =>
    apiV1SalesOrderDocumentListExternal(salesOrderSlug, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!salesOrderSlug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiV1SalesOrderDocumentListExternalQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>
>;
export type ApiV1SalesOrderDocumentListExternalQueryError = ErrorType<ErrorResponse>;

export function useApiV1SalesOrderDocumentListExternal<
  TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>,
  TError = ErrorType<ErrorResponse>,
>(
  salesOrderSlug: string,
  params: undefined | ApiV1SalesOrderDocumentListExternalParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiV1SalesOrderDocumentListExternal<
  TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>,
  TError = ErrorType<ErrorResponse>,
>(
  salesOrderSlug: string,
  params?: ApiV1SalesOrderDocumentListExternalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiV1SalesOrderDocumentListExternal<
  TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>,
  TError = ErrorType<ErrorResponse>,
>(
  salesOrderSlug: string,
  params?: ApiV1SalesOrderDocumentListExternalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiV1SalesOrderDocumentListExternal<
  TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>,
  TError = ErrorType<ErrorResponse>,
>(
  salesOrderSlug: string,
  params?: ApiV1SalesOrderDocumentListExternalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiV1SalesOrderDocumentListExternalQueryOptions(salesOrderSlug, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiV1SalesOrderDocumentListExternalSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>,
  TError = ErrorType<ErrorResponse>,
>(
  salesOrderSlug: string,
  params?: ApiV1SalesOrderDocumentListExternalParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiV1SalesOrderDocumentListExternalQueryKey(salesOrderSlug, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>> = ({ signal }) =>
    apiV1SalesOrderDocumentListExternal(salesOrderSlug, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiV1SalesOrderDocumentListExternalSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>
>;
export type ApiV1SalesOrderDocumentListExternalSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiV1SalesOrderDocumentListExternalSuspense<
  TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>,
  TError = ErrorType<ErrorResponse>,
>(
  salesOrderSlug: string,
  params: undefined | ApiV1SalesOrderDocumentListExternalParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiV1SalesOrderDocumentListExternalSuspense<
  TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>,
  TError = ErrorType<ErrorResponse>,
>(
  salesOrderSlug: string,
  params?: ApiV1SalesOrderDocumentListExternalParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiV1SalesOrderDocumentListExternalSuspense<
  TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>,
  TError = ErrorType<ErrorResponse>,
>(
  salesOrderSlug: string,
  params?: ApiV1SalesOrderDocumentListExternalParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiV1SalesOrderDocumentListExternalSuspense<
  TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>,
  TError = ErrorType<ErrorResponse>,
>(
  salesOrderSlug: string,
  params?: ApiV1SalesOrderDocumentListExternalParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiV1SalesOrderDocumentListExternalSuspenseQueryOptions(salesOrderSlug, params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List documents for a specific shipment, filtered by user's trade company access.
 */
export const apiDocumentsV1DocumentsExternalList = (
  shipmentId: number,
  params?: ApiDocumentsV1DocumentsExternalListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedExternalCustomerDocumentList>(
    { url: `/api/documents/v1/documents/${shipmentId}/external/`, method: 'GET', params, signal },
    options
  );
};

export const getApiDocumentsV1DocumentsExternalListQueryKey = (
  shipmentId: number,
  params?: ApiDocumentsV1DocumentsExternalListParams
) => {
  return [`/api/documents/v1/documents/${shipmentId}/external/`, ...(params ? [params] : [])] as const;
};

export const getApiDocumentsV1DocumentsExternalListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>,
  TError = ErrorType<ErrorResponse>,
>(
  shipmentId: number,
  params?: ApiDocumentsV1DocumentsExternalListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDocumentsV1DocumentsExternalListQueryKey(shipmentId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>> = ({ signal }) =>
    apiDocumentsV1DocumentsExternalList(shipmentId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!shipmentId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDocumentsV1DocumentsExternalListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>
>;
export type ApiDocumentsV1DocumentsExternalListQueryError = ErrorType<ErrorResponse>;

export function useApiDocumentsV1DocumentsExternalList<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>,
  TError = ErrorType<ErrorResponse>,
>(
  shipmentId: number,
  params: undefined | ApiDocumentsV1DocumentsExternalListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDocumentsV1DocumentsExternalList<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>,
  TError = ErrorType<ErrorResponse>,
>(
  shipmentId: number,
  params?: ApiDocumentsV1DocumentsExternalListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDocumentsV1DocumentsExternalList<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>,
  TError = ErrorType<ErrorResponse>,
>(
  shipmentId: number,
  params?: ApiDocumentsV1DocumentsExternalListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDocumentsV1DocumentsExternalList<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>,
  TError = ErrorType<ErrorResponse>,
>(
  shipmentId: number,
  params?: ApiDocumentsV1DocumentsExternalListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDocumentsV1DocumentsExternalListQueryOptions(shipmentId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiDocumentsV1DocumentsExternalListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>,
  TError = ErrorType<ErrorResponse>,
>(
  shipmentId: number,
  params?: ApiDocumentsV1DocumentsExternalListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDocumentsV1DocumentsExternalListQueryKey(shipmentId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>> = ({ signal }) =>
    apiDocumentsV1DocumentsExternalList(shipmentId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiDocumentsV1DocumentsExternalListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>
>;
export type ApiDocumentsV1DocumentsExternalListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiDocumentsV1DocumentsExternalListSuspense<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>,
  TError = ErrorType<ErrorResponse>,
>(
  shipmentId: number,
  params: undefined | ApiDocumentsV1DocumentsExternalListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDocumentsV1DocumentsExternalListSuspense<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>,
  TError = ErrorType<ErrorResponse>,
>(
  shipmentId: number,
  params?: ApiDocumentsV1DocumentsExternalListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiDocumentsV1DocumentsExternalListSuspense<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>,
  TError = ErrorType<ErrorResponse>,
>(
  shipmentId: number,
  params?: ApiDocumentsV1DocumentsExternalListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiDocumentsV1DocumentsExternalListSuspense<
  TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>,
  TError = ErrorType<ErrorResponse>,
>(
  shipmentId: number,
  params?: ApiDocumentsV1DocumentsExternalListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiDocumentsV1DocumentsExternalListSuspenseQueryOptions(shipmentId, params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiDocumentsV1SigningPartiesMarkSignedCreate = (
  signingPartyId: number,
  manuallyMarkPartyAsSigned: BodyType<ManuallyMarkPartyAsSigned>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleSigningParty>(
    {
      url: `/api/documents/v1/signing-parties/${signingPartyId}/mark-signed/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: manuallyMarkPartyAsSigned,
      signal,
    },
    options
  );
};

export const getApiDocumentsV1SigningPartiesMarkSignedCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDocumentsV1SigningPartiesMarkSignedCreate>>,
    TError,
    { signingPartyId: number; data: BodyType<ManuallyMarkPartyAsSigned> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiDocumentsV1SigningPartiesMarkSignedCreate>>,
  TError,
  { signingPartyId: number; data: BodyType<ManuallyMarkPartyAsSigned> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDocumentsV1SigningPartiesMarkSignedCreate>>,
    { signingPartyId: number; data: BodyType<ManuallyMarkPartyAsSigned> }
  > = (props) => {
    const { signingPartyId, data } = props ?? {};

    return apiDocumentsV1SigningPartiesMarkSignedCreate(signingPartyId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiDocumentsV1SigningPartiesMarkSignedCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentsV1SigningPartiesMarkSignedCreate>>
>;
export type ApiDocumentsV1SigningPartiesMarkSignedCreateMutationBody = BodyType<ManuallyMarkPartyAsSigned>;
export type ApiDocumentsV1SigningPartiesMarkSignedCreateMutationError = ErrorType<ErrorResponse>;

export const useApiDocumentsV1SigningPartiesMarkSignedCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDocumentsV1SigningPartiesMarkSignedCreate>>,
    TError,
    { signingPartyId: number; data: BodyType<ManuallyMarkPartyAsSigned> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiDocumentsV1SigningPartiesMarkSignedCreate>>,
  TError,
  { signingPartyId: number; data: BodyType<ManuallyMarkPartyAsSigned> },
  TContext
> => {
  const mutationOptions = getApiDocumentsV1SigningPartiesMarkSignedCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.

This view verifies the incoming token, validates the event data, and calls the
specified method in the configuration (`PushSubscriptionConfig`) based on the event type.

See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsCreateMaterialAndTransportCostsEventHandlerCreate = (
  pushSubscriptionInput: BodyType<PushSubscriptionInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Event>(
    {
      url: `/api/events/create_material_and_transport_costs_event_handler/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pushSubscriptionInput,
      signal,
    },
    options
  );
};

export const getApiEventsCreateMaterialAndTransportCostsEventHandlerCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsCreateMaterialAndTransportCostsEventHandlerCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiEventsCreateMaterialAndTransportCostsEventHandlerCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiEventsCreateMaterialAndTransportCostsEventHandlerCreate>>,
    { data: BodyType<PushSubscriptionInput> }
  > = (props) => {
    const { data } = props ?? {};

    return apiEventsCreateMaterialAndTransportCostsEventHandlerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiEventsCreateMaterialAndTransportCostsEventHandlerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiEventsCreateMaterialAndTransportCostsEventHandlerCreate>>
>;
export type ApiEventsCreateMaterialAndTransportCostsEventHandlerCreateMutationBody = BodyType<PushSubscriptionInput>;
export type ApiEventsCreateMaterialAndTransportCostsEventHandlerCreateMutationError = ErrorType<ErrorResponse>;

export const useApiEventsCreateMaterialAndTransportCostsEventHandlerCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsCreateMaterialAndTransportCostsEventHandlerCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiEventsCreateMaterialAndTransportCostsEventHandlerCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const mutationOptions = getApiEventsCreateMaterialAndTransportCostsEventHandlerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.

This view verifies the incoming token, validates the event data, and calls the
specified method in the configuration (`PushSubscriptionConfig`) based on the event type.

See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsCreateMaterialRevenuesEventHandlerCreate = (
  pushSubscriptionInput: BodyType<PushSubscriptionInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Event>(
    {
      url: `/api/events/create_material_revenues_event_handler/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pushSubscriptionInput,
      signal,
    },
    options
  );
};

export const getApiEventsCreateMaterialRevenuesEventHandlerCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsCreateMaterialRevenuesEventHandlerCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiEventsCreateMaterialRevenuesEventHandlerCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiEventsCreateMaterialRevenuesEventHandlerCreate>>,
    { data: BodyType<PushSubscriptionInput> }
  > = (props) => {
    const { data } = props ?? {};

    return apiEventsCreateMaterialRevenuesEventHandlerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiEventsCreateMaterialRevenuesEventHandlerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiEventsCreateMaterialRevenuesEventHandlerCreate>>
>;
export type ApiEventsCreateMaterialRevenuesEventHandlerCreateMutationBody = BodyType<PushSubscriptionInput>;
export type ApiEventsCreateMaterialRevenuesEventHandlerCreateMutationError = ErrorType<ErrorResponse>;

export const useApiEventsCreateMaterialRevenuesEventHandlerCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsCreateMaterialRevenuesEventHandlerCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiEventsCreateMaterialRevenuesEventHandlerCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const mutationOptions = getApiEventsCreateMaterialRevenuesEventHandlerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.

This view verifies the incoming token, validates the event data, and calls the
specified method in the configuration (`PushSubscriptionConfig`) based on the event type.

See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsCreateNewTradeCompanyKybTicketCreate = (
  pushSubscriptionInput: BodyType<PushSubscriptionInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Event>(
    {
      url: `/api/events/create_new_trade_company_kyb_ticket/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pushSubscriptionInput,
      signal,
    },
    options
  );
};

export const getApiEventsCreateNewTradeCompanyKybTicketCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsCreateNewTradeCompanyKybTicketCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiEventsCreateNewTradeCompanyKybTicketCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiEventsCreateNewTradeCompanyKybTicketCreate>>,
    { data: BodyType<PushSubscriptionInput> }
  > = (props) => {
    const { data } = props ?? {};

    return apiEventsCreateNewTradeCompanyKybTicketCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiEventsCreateNewTradeCompanyKybTicketCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiEventsCreateNewTradeCompanyKybTicketCreate>>
>;
export type ApiEventsCreateNewTradeCompanyKybTicketCreateMutationBody = BodyType<PushSubscriptionInput>;
export type ApiEventsCreateNewTradeCompanyKybTicketCreateMutationError = ErrorType<ErrorResponse>;

export const useApiEventsCreateNewTradeCompanyKybTicketCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsCreateNewTradeCompanyKybTicketCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiEventsCreateNewTradeCompanyKybTicketCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const mutationOptions = getApiEventsCreateNewTradeCompanyKybTicketCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.

This view verifies the incoming token, validates the event data, and calls the
specified method in the configuration (`PushSubscriptionConfig`) based on the event type.

See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsEvaluatePurchaseOrderBlockingRulesCreate = (
  pushSubscriptionInput: BodyType<PushSubscriptionInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Event>(
    {
      url: `/api/events/evaluate_purchase_order_blocking_rules/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pushSubscriptionInput,
      signal,
    },
    options
  );
};

export const getApiEventsEvaluatePurchaseOrderBlockingRulesCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsEvaluatePurchaseOrderBlockingRulesCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiEventsEvaluatePurchaseOrderBlockingRulesCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiEventsEvaluatePurchaseOrderBlockingRulesCreate>>,
    { data: BodyType<PushSubscriptionInput> }
  > = (props) => {
    const { data } = props ?? {};

    return apiEventsEvaluatePurchaseOrderBlockingRulesCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiEventsEvaluatePurchaseOrderBlockingRulesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiEventsEvaluatePurchaseOrderBlockingRulesCreate>>
>;
export type ApiEventsEvaluatePurchaseOrderBlockingRulesCreateMutationBody = BodyType<PushSubscriptionInput>;
export type ApiEventsEvaluatePurchaseOrderBlockingRulesCreateMutationError = ErrorType<ErrorResponse>;

export const useApiEventsEvaluatePurchaseOrderBlockingRulesCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsEvaluatePurchaseOrderBlockingRulesCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiEventsEvaluatePurchaseOrderBlockingRulesCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const mutationOptions = getApiEventsEvaluatePurchaseOrderBlockingRulesCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.

This view verifies the incoming token, validates the event data, and calls the
specified method in the configuration (`PushSubscriptionConfig`) based on the event type.

See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsEvaluateSalesOrderBlockingRulesCreate = (
  pushSubscriptionInput: BodyType<PushSubscriptionInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Event>(
    {
      url: `/api/events/evaluate_sales_order_blocking_rules/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pushSubscriptionInput,
      signal,
    },
    options
  );
};

export const getApiEventsEvaluateSalesOrderBlockingRulesCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsEvaluateSalesOrderBlockingRulesCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiEventsEvaluateSalesOrderBlockingRulesCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiEventsEvaluateSalesOrderBlockingRulesCreate>>,
    { data: BodyType<PushSubscriptionInput> }
  > = (props) => {
    const { data } = props ?? {};

    return apiEventsEvaluateSalesOrderBlockingRulesCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiEventsEvaluateSalesOrderBlockingRulesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiEventsEvaluateSalesOrderBlockingRulesCreate>>
>;
export type ApiEventsEvaluateSalesOrderBlockingRulesCreateMutationBody = BodyType<PushSubscriptionInput>;
export type ApiEventsEvaluateSalesOrderBlockingRulesCreateMutationError = ErrorType<ErrorResponse>;

export const useApiEventsEvaluateSalesOrderBlockingRulesCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsEvaluateSalesOrderBlockingRulesCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiEventsEvaluateSalesOrderBlockingRulesCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const mutationOptions = getApiEventsEvaluateSalesOrderBlockingRulesCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.

This view verifies the incoming token, validates the event data, and calls the
specified method in the configuration (`PushSubscriptionConfig`) based on the event type.

See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate = (
  pushSubscriptionInput: BodyType<PushSubscriptionInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Event>(
    {
      url: `/api/events/mark_purchase_order_as_fulfilled_on_load_update/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pushSubscriptionInput,
      signal,
    },
    options
  );
};

export const getApiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate>>,
    { data: BodyType<PushSubscriptionInput> }
  > = (props) => {
    const { data } = props ?? {};

    return apiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate>>
>;
export type ApiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreateMutationBody = BodyType<PushSubscriptionInput>;
export type ApiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreateMutationError = ErrorType<ErrorResponse>;

export const useApiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const mutationOptions = getApiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.

This view verifies the incoming token, validates the event data, and calls the
specified method in the configuration (`PushSubscriptionConfig`) based on the event type.

See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate = (
  pushSubscriptionInput: BodyType<PushSubscriptionInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Event>(
    {
      url: `/api/events/mark_sales_order_as_fulfilled_on_load_update/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pushSubscriptionInput,
      signal,
    },
    options
  );
};

export const getApiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate>>,
    { data: BodyType<PushSubscriptionInput> }
  > = (props) => {
    const { data } = props ?? {};

    return apiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate>>
>;
export type ApiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreateMutationBody = BodyType<PushSubscriptionInput>;
export type ApiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreateMutationError = ErrorType<ErrorResponse>;

export const useApiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const mutationOptions = getApiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.

This view verifies the incoming token, validates the event data, and calls the
specified method in the configuration (`PushSubscriptionConfig`) based on the event type.

See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsRegenerateAnnexVviForShipmentLoadsCreate = (
  pushSubscriptionInput: BodyType<PushSubscriptionInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Event>(
    {
      url: `/api/events/regenerate_annex_vvi_for_shipment_loads/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pushSubscriptionInput,
      signal,
    },
    options
  );
};

export const getApiEventsRegenerateAnnexVviForShipmentLoadsCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsRegenerateAnnexVviForShipmentLoadsCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiEventsRegenerateAnnexVviForShipmentLoadsCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiEventsRegenerateAnnexVviForShipmentLoadsCreate>>,
    { data: BodyType<PushSubscriptionInput> }
  > = (props) => {
    const { data } = props ?? {};

    return apiEventsRegenerateAnnexVviForShipmentLoadsCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiEventsRegenerateAnnexVviForShipmentLoadsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiEventsRegenerateAnnexVviForShipmentLoadsCreate>>
>;
export type ApiEventsRegenerateAnnexVviForShipmentLoadsCreateMutationBody = BodyType<PushSubscriptionInput>;
export type ApiEventsRegenerateAnnexVviForShipmentLoadsCreateMutationError = ErrorType<ErrorResponse>;

export const useApiEventsRegenerateAnnexVviForShipmentLoadsCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsRegenerateAnnexVviForShipmentLoadsCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiEventsRegenerateAnnexVviForShipmentLoadsCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const mutationOptions = getApiEventsRegenerateAnnexVviForShipmentLoadsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.

This view verifies the incoming token, validates the event data, and calls the
specified method in the configuration (`PushSubscriptionConfig`) based on the event type.

See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsSendShipmentConfirmationEmailsCreate = (
  pushSubscriptionInput: BodyType<PushSubscriptionInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Event>(
    {
      url: `/api/events/send_shipment_confirmation_emails/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pushSubscriptionInput,
      signal,
    },
    options
  );
};

export const getApiEventsSendShipmentConfirmationEmailsCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsSendShipmentConfirmationEmailsCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiEventsSendShipmentConfirmationEmailsCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiEventsSendShipmentConfirmationEmailsCreate>>,
    { data: BodyType<PushSubscriptionInput> }
  > = (props) => {
    const { data } = props ?? {};

    return apiEventsSendShipmentConfirmationEmailsCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiEventsSendShipmentConfirmationEmailsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiEventsSendShipmentConfirmationEmailsCreate>>
>;
export type ApiEventsSendShipmentConfirmationEmailsCreateMutationBody = BodyType<PushSubscriptionInput>;
export type ApiEventsSendShipmentConfirmationEmailsCreateMutationError = ErrorType<ErrorResponse>;

export const useApiEventsSendShipmentConfirmationEmailsCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsSendShipmentConfirmationEmailsCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiEventsSendShipmentConfirmationEmailsCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const mutationOptions = getApiEventsSendShipmentConfirmationEmailsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.

This view verifies the incoming token, validates the event data, and calls the
specified method in the configuration (`PushSubscriptionConfig`) based on the event type.

See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsUpdateOrCreateDealApprovalTicketsCreate = (
  pushSubscriptionInput: BodyType<PushSubscriptionInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Event>(
    {
      url: `/api/events/update_or_create_deal_approval_tickets/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pushSubscriptionInput,
      signal,
    },
    options
  );
};

export const getApiEventsUpdateOrCreateDealApprovalTicketsCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsUpdateOrCreateDealApprovalTicketsCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiEventsUpdateOrCreateDealApprovalTicketsCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiEventsUpdateOrCreateDealApprovalTicketsCreate>>,
    { data: BodyType<PushSubscriptionInput> }
  > = (props) => {
    const { data } = props ?? {};

    return apiEventsUpdateOrCreateDealApprovalTicketsCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiEventsUpdateOrCreateDealApprovalTicketsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiEventsUpdateOrCreateDealApprovalTicketsCreate>>
>;
export type ApiEventsUpdateOrCreateDealApprovalTicketsCreateMutationBody = BodyType<PushSubscriptionInput>;
export type ApiEventsUpdateOrCreateDealApprovalTicketsCreateMutationError = ErrorType<ErrorResponse>;

export const useApiEventsUpdateOrCreateDealApprovalTicketsCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsUpdateOrCreateDealApprovalTicketsCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiEventsUpdateOrCreateDealApprovalTicketsCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const mutationOptions = getApiEventsUpdateOrCreateDealApprovalTicketsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.

This view verifies the incoming token, validates the event data, and calls the
specified method in the configuration (`PushSubscriptionConfig`) based on the event type.

See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsUpdateOrCreateInspectionTicketCreate = (
  pushSubscriptionInput: BodyType<PushSubscriptionInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Event>(
    {
      url: `/api/events/update_or_create_inspection_ticket/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pushSubscriptionInput,
      signal,
    },
    options
  );
};

export const getApiEventsUpdateOrCreateInspectionTicketCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsUpdateOrCreateInspectionTicketCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiEventsUpdateOrCreateInspectionTicketCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiEventsUpdateOrCreateInspectionTicketCreate>>,
    { data: BodyType<PushSubscriptionInput> }
  > = (props) => {
    const { data } = props ?? {};

    return apiEventsUpdateOrCreateInspectionTicketCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiEventsUpdateOrCreateInspectionTicketCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiEventsUpdateOrCreateInspectionTicketCreate>>
>;
export type ApiEventsUpdateOrCreateInspectionTicketCreateMutationBody = BodyType<PushSubscriptionInput>;
export type ApiEventsUpdateOrCreateInspectionTicketCreateMutationError = ErrorType<ErrorResponse>;

export const useApiEventsUpdateOrCreateInspectionTicketCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsUpdateOrCreateInspectionTicketCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiEventsUpdateOrCreateInspectionTicketCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const mutationOptions = getApiEventsUpdateOrCreateInspectionTicketCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.

This view verifies the incoming token, validates the event data, and calls the
specified method in the configuration (`PushSubscriptionConfig`) based on the event type.

See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsUpdateShipmentStatusEventHandlerCreate = (
  pushSubscriptionInput: BodyType<PushSubscriptionInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Event>(
    {
      url: `/api/events/update_shipment_status_event_handler/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pushSubscriptionInput,
      signal,
    },
    options
  );
};

export const getApiEventsUpdateShipmentStatusEventHandlerCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsUpdateShipmentStatusEventHandlerCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiEventsUpdateShipmentStatusEventHandlerCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiEventsUpdateShipmentStatusEventHandlerCreate>>,
    { data: BodyType<PushSubscriptionInput> }
  > = (props) => {
    const { data } = props ?? {};

    return apiEventsUpdateShipmentStatusEventHandlerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiEventsUpdateShipmentStatusEventHandlerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiEventsUpdateShipmentStatusEventHandlerCreate>>
>;
export type ApiEventsUpdateShipmentStatusEventHandlerCreateMutationBody = BodyType<PushSubscriptionInput>;
export type ApiEventsUpdateShipmentStatusEventHandlerCreateMutationError = ErrorType<ErrorResponse>;

export const useApiEventsUpdateShipmentStatusEventHandlerCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEventsUpdateShipmentStatusEventHandlerCreate>>,
    TError,
    { data: BodyType<PushSubscriptionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiEventsUpdateShipmentStatusEventHandlerCreate>>,
  TError,
  { data: BodyType<PushSubscriptionInput> },
  TContext
> => {
  const mutationOptions = getApiEventsUpdateShipmentStatusEventHandlerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Generate an upload URL for large files.
 */
export const apiEvidenceUploadCreate = (
  generateUploadUrlRequest: BodyType<GenerateUploadUrlRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GenerateUploadUrlResponse>(
    {
      url: `/api/evidence/upload/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: generateUploadUrlRequest,
      signal,
    },
    options
  );
};

export const getApiEvidenceUploadCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEvidenceUploadCreate>>,
    TError,
    { data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiEvidenceUploadCreate>>,
  TError,
  { data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiEvidenceUploadCreate>>,
    { data: BodyType<GenerateUploadUrlRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return apiEvidenceUploadCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiEvidenceUploadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEvidenceUploadCreate>>>;
export type ApiEvidenceUploadCreateMutationBody = BodyType<GenerateUploadUrlRequest>;
export type ApiEvidenceUploadCreateMutationError = ErrorType<ErrorResponse>;

export const useApiEvidenceUploadCreate = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEvidenceUploadCreate>>,
    TError,
    { data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiEvidenceUploadCreate>>,
  TError,
  { data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const mutationOptions = getApiEvidenceUploadCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Saves evidence as bale photo and returns inference results.
 */
export const apiEvidenceUploadUpdate = (
  processUploadRequest: BodyType<ProcessUploadRequest>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<ProcessUploadResponse>(
    {
      url: `/api/evidence/upload/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: processUploadRequest,
    },
    options
  );
};

export const getApiEvidenceUploadUpdateMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEvidenceUploadUpdate>>,
    TError,
    { data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiEvidenceUploadUpdate>>,
  TError,
  { data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiEvidenceUploadUpdate>>,
    { data: BodyType<ProcessUploadRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return apiEvidenceUploadUpdate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiEvidenceUploadUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEvidenceUploadUpdate>>>;
export type ApiEvidenceUploadUpdateMutationBody = BodyType<ProcessUploadRequest>;
export type ApiEvidenceUploadUpdateMutationError = ErrorType<unknown>;

export const useApiEvidenceUploadUpdate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEvidenceUploadUpdate>>,
    TError,
    { data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiEvidenceUploadUpdate>>,
  TError,
  { data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const mutationOptions = getApiEvidenceUploadUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiEvidenceV1Destroy = (id: number, options?: SecondParameter<typeof customAxios>) => {
  return customAxios<unknown>({ url: `/api/evidence/v1/${id}/`, method: 'DELETE' }, options);
};

export const getApiEvidenceV1DestroyMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof apiEvidenceV1Destroy>>, TError, { id: number }, TContext>;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<Awaited<ReturnType<typeof apiEvidenceV1Destroy>>, TError, { id: number }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiEvidenceV1Destroy>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return apiEvidenceV1Destroy(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiEvidenceV1DestroyMutationResult = NonNullable<Awaited<ReturnType<typeof apiEvidenceV1Destroy>>>;

export type ApiEvidenceV1DestroyMutationError = ErrorType<ErrorResponse>;

export const useApiEvidenceV1Destroy = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof apiEvidenceV1Destroy>>, TError, { id: number }, TContext>;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<Awaited<ReturnType<typeof apiEvidenceV1Destroy>>, TError, { id: number }, TContext> => {
  const mutationOptions = getApiEvidenceV1DestroyMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiEvidenceV1DataPartialUpdate = (
  id: number,
  patchedEvidenceData: BodyType<PatchedEvidenceData>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<void>(
    {
      url: `/api/evidence/v1/${id}/data`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchedEvidenceData,
    },
    options
  );
};

export const getApiEvidenceV1DataPartialUpdateMutationOptions = <
  TError = ErrorType<ApiEvidenceV1DataPartialUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEvidenceV1DataPartialUpdate>>,
    TError,
    { id: number; data: BodyType<PatchedEvidenceData> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiEvidenceV1DataPartialUpdate>>,
  TError,
  { id: number; data: BodyType<PatchedEvidenceData> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiEvidenceV1DataPartialUpdate>>,
    { id: number; data: BodyType<PatchedEvidenceData> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiEvidenceV1DataPartialUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiEvidenceV1DataPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiEvidenceV1DataPartialUpdate>>
>;
export type ApiEvidenceV1DataPartialUpdateMutationBody = BodyType<PatchedEvidenceData>;
export type ApiEvidenceV1DataPartialUpdateMutationError = ErrorType<ApiEvidenceV1DataPartialUpdate400 | ErrorResponse>;

export const useApiEvidenceV1DataPartialUpdate = <
  TError = ErrorType<ApiEvidenceV1DataPartialUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEvidenceV1DataPartialUpdate>>,
    TError,
    { id: number; data: BodyType<PatchedEvidenceData> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiEvidenceV1DataPartialUpdate>>,
  TError,
  { id: number; data: BodyType<PatchedEvidenceData> },
  TContext
> => {
  const mutationOptions = getApiEvidenceV1DataPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiEvidenceV1BulkDeleteCreate = (
  bulkDeleteRequest: BodyType<BulkDeleteRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/evidence/v1/bulk-delete/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: bulkDeleteRequest,
      signal,
    },
    options
  );
};

export const getApiEvidenceV1BulkDeleteCreateMutationOptions = <
  TError = ErrorType<ApiEvidenceV1BulkDeleteCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEvidenceV1BulkDeleteCreate>>,
    TError,
    { data: BodyType<BulkDeleteRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiEvidenceV1BulkDeleteCreate>>,
  TError,
  { data: BodyType<BulkDeleteRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiEvidenceV1BulkDeleteCreate>>,
    { data: BodyType<BulkDeleteRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return apiEvidenceV1BulkDeleteCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiEvidenceV1BulkDeleteCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiEvidenceV1BulkDeleteCreate>>
>;
export type ApiEvidenceV1BulkDeleteCreateMutationBody = BodyType<BulkDeleteRequest>;
export type ApiEvidenceV1BulkDeleteCreateMutationError = ErrorType<ApiEvidenceV1BulkDeleteCreate400 | ErrorResponse>;

export const useApiEvidenceV1BulkDeleteCreate = <
  TError = ErrorType<ApiEvidenceV1BulkDeleteCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEvidenceV1BulkDeleteCreate>>,
    TError,
    { data: BodyType<BulkDeleteRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiEvidenceV1BulkDeleteCreate>>,
  TError,
  { data: BodyType<BulkDeleteRequest> },
  TContext
> => {
  const mutationOptions = getApiEvidenceV1BulkDeleteCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Endpoint for bulk updating evidence. model passed in url determines model of a new parent obj
 */
export const apiEvidenceV1BulkUpdateSiteMaterialPartialUpdate = (
  patchedBulkUpdateData: BodyType<PatchedBulkUpdateData>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<void>(
    {
      url: `/api/evidence/v1/bulk-update/site-material/`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchedBulkUpdateData,
    },
    options
  );
};

export const getApiEvidenceV1BulkUpdateSiteMaterialPartialUpdateMutationOptions = <
  TError = ErrorType<ApiEvidenceV1BulkUpdateSiteMaterialPartialUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEvidenceV1BulkUpdateSiteMaterialPartialUpdate>>,
    TError,
    { data: BodyType<PatchedBulkUpdateData> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiEvidenceV1BulkUpdateSiteMaterialPartialUpdate>>,
  TError,
  { data: BodyType<PatchedBulkUpdateData> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiEvidenceV1BulkUpdateSiteMaterialPartialUpdate>>,
    { data: BodyType<PatchedBulkUpdateData> }
  > = (props) => {
    const { data } = props ?? {};

    return apiEvidenceV1BulkUpdateSiteMaterialPartialUpdate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiEvidenceV1BulkUpdateSiteMaterialPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiEvidenceV1BulkUpdateSiteMaterialPartialUpdate>>
>;
export type ApiEvidenceV1BulkUpdateSiteMaterialPartialUpdateMutationBody = BodyType<PatchedBulkUpdateData>;
export type ApiEvidenceV1BulkUpdateSiteMaterialPartialUpdateMutationError = ErrorType<
  ApiEvidenceV1BulkUpdateSiteMaterialPartialUpdate400 | ErrorResponse
>;

export const useApiEvidenceV1BulkUpdateSiteMaterialPartialUpdate = <
  TError = ErrorType<ApiEvidenceV1BulkUpdateSiteMaterialPartialUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEvidenceV1BulkUpdateSiteMaterialPartialUpdate>>,
    TError,
    { data: BodyType<PatchedBulkUpdateData> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiEvidenceV1BulkUpdateSiteMaterialPartialUpdate>>,
  TError,
  { data: BodyType<PatchedBulkUpdateData> },
  TContext
> => {
  const mutationOptions = getApiEvidenceV1BulkUpdateSiteMaterialPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiEvidenceV1EvidenceSessionRetrieve = (
  params: ApiEvidenceV1EvidenceSessionRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<EvidenceSessionDetails>(
    { url: `/api/evidence/v1/evidence-session`, method: 'GET', params, signal },
    options
  );
};

export const getApiEvidenceV1EvidenceSessionRetrieveQueryKey = (params: ApiEvidenceV1EvidenceSessionRetrieveParams) => {
  return [`/api/evidence/v1/evidence-session`, ...(params ? [params] : [])] as const;
};

export const getApiEvidenceV1EvidenceSessionRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>,
  TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>,
>(
  params: ApiEvidenceV1EvidenceSessionRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiEvidenceV1EvidenceSessionRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>> = ({ signal }) =>
    apiEvidenceV1EvidenceSessionRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiEvidenceV1EvidenceSessionRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>
>;
export type ApiEvidenceV1EvidenceSessionRetrieveQueryError = ErrorType<
  ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse
>;

export function useApiEvidenceV1EvidenceSessionRetrieve<
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>,
  TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>,
>(
  params: ApiEvidenceV1EvidenceSessionRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiEvidenceV1EvidenceSessionRetrieve<
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>,
  TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>,
>(
  params: ApiEvidenceV1EvidenceSessionRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiEvidenceV1EvidenceSessionRetrieve<
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>,
  TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>,
>(
  params: ApiEvidenceV1EvidenceSessionRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiEvidenceV1EvidenceSessionRetrieve<
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>,
  TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>,
>(
  params: ApiEvidenceV1EvidenceSessionRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiEvidenceV1EvidenceSessionRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiEvidenceV1EvidenceSessionRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>,
  TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>,
>(
  params: ApiEvidenceV1EvidenceSessionRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiEvidenceV1EvidenceSessionRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>> = ({ signal }) =>
    apiEvidenceV1EvidenceSessionRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiEvidenceV1EvidenceSessionRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>
>;
export type ApiEvidenceV1EvidenceSessionRetrieveSuspenseQueryError = ErrorType<
  ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse
>;

export function useApiEvidenceV1EvidenceSessionRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>,
  TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>,
>(
  params: ApiEvidenceV1EvidenceSessionRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiEvidenceV1EvidenceSessionRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>,
  TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>,
>(
  params: ApiEvidenceV1EvidenceSessionRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiEvidenceV1EvidenceSessionRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>,
  TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>,
>(
  params: ApiEvidenceV1EvidenceSessionRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiEvidenceV1EvidenceSessionRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>,
  TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>,
>(
  params: ApiEvidenceV1EvidenceSessionRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiEvidenceV1EvidenceSessionRetrieveSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiEvidenceV1EvidenceTypesRetrieve = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ApiEvidenceV1EvidenceTypesRetrieve200>(
    { url: `/api/evidence/v1/evidence-types`, method: 'GET', signal },
    options
  );
};

export const getApiEvidenceV1EvidenceTypesRetrieveQueryKey = () => {
  return [`/api/evidence/v1/evidence-types`] as const;
};

export const getApiEvidenceV1EvidenceTypesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiEvidenceV1EvidenceTypesRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>> = ({ signal }) =>
    apiEvidenceV1EvidenceTypesRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiEvidenceV1EvidenceTypesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>
>;
export type ApiEvidenceV1EvidenceTypesRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiEvidenceV1EvidenceTypesRetrieve<
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiEvidenceV1EvidenceTypesRetrieve<
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiEvidenceV1EvidenceTypesRetrieve<
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiEvidenceV1EvidenceTypesRetrieve<
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiEvidenceV1EvidenceTypesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiEvidenceV1EvidenceTypesRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiEvidenceV1EvidenceTypesRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>> = ({ signal }) =>
    apiEvidenceV1EvidenceTypesRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiEvidenceV1EvidenceTypesRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>
>;
export type ApiEvidenceV1EvidenceTypesRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiEvidenceV1EvidenceTypesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiEvidenceV1EvidenceTypesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiEvidenceV1EvidenceTypesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiEvidenceV1EvidenceTypesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiEvidenceV1EvidenceTypesRetrieveSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiEvidenceV1SiteMaterialSamplesEvidenceList = (
  siteMaterialId: string,
  params?: ApiEvidenceV1SiteMaterialSamplesEvidenceListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedEvidenceList>(
    { url: `/api/evidence/v1/site-material/${siteMaterialId}/samples-evidence/`, method: 'GET', params, signal },
    options
  );
};

export const getApiEvidenceV1SiteMaterialSamplesEvidenceListQueryKey = (
  siteMaterialId: string,
  params?: ApiEvidenceV1SiteMaterialSamplesEvidenceListParams
) => {
  return [`/api/evidence/v1/site-material/${siteMaterialId}/samples-evidence/`, ...(params ? [params] : [])] as const;
};

export const getApiEvidenceV1SiteMaterialSamplesEvidenceListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiEvidenceV1SiteMaterialSamplesEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiEvidenceV1SiteMaterialSamplesEvidenceListQueryKey(siteMaterialId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>> = ({
    signal,
  }) => apiEvidenceV1SiteMaterialSamplesEvidenceList(siteMaterialId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!siteMaterialId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiEvidenceV1SiteMaterialSamplesEvidenceListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>
>;
export type ApiEvidenceV1SiteMaterialSamplesEvidenceListQueryError = ErrorType<ErrorResponse>;

export function useApiEvidenceV1SiteMaterialSamplesEvidenceList<
  TData = Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params: undefined | ApiEvidenceV1SiteMaterialSamplesEvidenceListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiEvidenceV1SiteMaterialSamplesEvidenceList<
  TData = Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiEvidenceV1SiteMaterialSamplesEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiEvidenceV1SiteMaterialSamplesEvidenceList<
  TData = Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiEvidenceV1SiteMaterialSamplesEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiEvidenceV1SiteMaterialSamplesEvidenceList<
  TData = Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiEvidenceV1SiteMaterialSamplesEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiEvidenceV1SiteMaterialSamplesEvidenceListQueryOptions(siteMaterialId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiEvidenceV1SiteMaterialSamplesEvidenceListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiEvidenceV1SiteMaterialSamplesEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiEvidenceV1SiteMaterialSamplesEvidenceListQueryKey(siteMaterialId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>> = ({
    signal,
  }) => apiEvidenceV1SiteMaterialSamplesEvidenceList(siteMaterialId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiEvidenceV1SiteMaterialSamplesEvidenceListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>
>;
export type ApiEvidenceV1SiteMaterialSamplesEvidenceListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiEvidenceV1SiteMaterialSamplesEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params: undefined | ApiEvidenceV1SiteMaterialSamplesEvidenceListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiEvidenceV1SiteMaterialSamplesEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiEvidenceV1SiteMaterialSamplesEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiEvidenceV1SiteMaterialSamplesEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiEvidenceV1SiteMaterialSamplesEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiEvidenceV1SiteMaterialSamplesEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiEvidenceV1SiteMaterialSamplesEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1SiteMaterialSamplesEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiEvidenceV1SiteMaterialSamplesEvidenceListSuspenseQueryOptions(
    siteMaterialId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiFeatureFlagsRetrieve = (options?: SecondParameter<typeof customAxios>, signal?: AbortSignal) => {
  return customAxios<ApiFeatureFlagsRetrieve200>({ url: `/api/feature-flags/`, method: 'GET', signal }, options);
};

export const getApiFeatureFlagsRetrieveQueryKey = () => {
  return [`/api/feature-flags/`] as const;
};

export const getApiFeatureFlagsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFeatureFlagsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>> = ({ signal }) =>
    apiFeatureFlagsRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiFeatureFlagsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>>;
export type ApiFeatureFlagsRetrieveQueryError = ErrorType<unknown>;

export function useApiFeatureFlagsRetrieve<
  TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>, 'initialData'>;
  request?: SecondParameter<typeof customAxios>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiFeatureFlagsRetrieve<
  TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiFeatureFlagsRetrieve<
  TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiFeatureFlagsRetrieve<
  TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiFeatureFlagsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiFeatureFlagsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFeatureFlagsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>> = ({ signal }) =>
    apiFeatureFlagsRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiFeatureFlagsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>
>;
export type ApiFeatureFlagsRetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiFeatureFlagsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiFeatureFlagsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiFeatureFlagsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiFeatureFlagsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiFeatureFlagsRetrieveSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates payouts for all pending payment requests that have not been processed yet. Returns JSON with the results of each payout, including success or error messages.
 * @summary Creates payouts for pending payment requests
 */
export const createPendingRequestsPayouts = (options?: SecondParameter<typeof customAxios>, signal?: AbortSignal) => {
  return customAxios<PayoutCreationResponse>(
    { url: `/api/finances/v1/payment-requests/create-payouts/`, method: 'POST', signal },
    options
  );
};

export const getCreatePendingRequestsPayoutsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof createPendingRequestsPayouts>>, TError, void, TContext>;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<Awaited<ReturnType<typeof createPendingRequestsPayouts>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPendingRequestsPayouts>>, void> = () => {
    return createPendingRequestsPayouts(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePendingRequestsPayoutsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPendingRequestsPayouts>>
>;

export type CreatePendingRequestsPayoutsMutationError = ErrorType<unknown>;

/**
 * @summary Creates payouts for pending payment requests
 */
export const useCreatePendingRequestsPayouts = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof createPendingRequestsPayouts>>, TError, void, TContext>;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<Awaited<ReturnType<typeof createPendingRequestsPayouts>>, TError, void, TContext> => {
  const mutationOptions = getCreatePendingRequestsPayoutsMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Accepts JSON data containing payment request information, validates it, and processes each payment request. Returns a JSON object with the results of each payment request, including success or error messages.
 * @summary Uploads JSON data of buyer payment requests and submits them if applicable
 */
export const uploadPaymentRequestsJSON = (
  singlePaymentRequest: BodyType<SinglePaymentRequest[]>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaymentRequestsCreationResponse>(
    {
      url: `/api/finances/v1/payment-requests/submit/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: singlePaymentRequest,
      signal,
    },
    options
  );
};

export const getUploadPaymentRequestsJSONMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadPaymentRequestsJSON>>,
    TError,
    { data: BodyType<SinglePaymentRequest[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadPaymentRequestsJSON>>,
  TError,
  { data: BodyType<SinglePaymentRequest[]> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadPaymentRequestsJSON>>,
    { data: BodyType<SinglePaymentRequest[]> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadPaymentRequestsJSON(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadPaymentRequestsJSONMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadPaymentRequestsJSON>>
>;
export type UploadPaymentRequestsJSONMutationBody = BodyType<SinglePaymentRequest[]>;
export type UploadPaymentRequestsJSONMutationError = ErrorType<unknown>;

/**
 * @summary Uploads JSON data of buyer payment requests and submits them if applicable
 */
export const useUploadPaymentRequestsJSON = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadPaymentRequestsJSON>>,
    TError,
    { data: BodyType<SinglePaymentRequest[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadPaymentRequestsJSON>>,
  TError,
  { data: BodyType<SinglePaymentRequest[]> },
  TContext
> => {
  const mutationOptions = getUploadPaymentRequestsJSONMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiGradesV1Retrieve = (options?: SecondParameter<typeof customAxios>, signal?: AbortSignal) => {
  return customAxios<GradeList>({ url: `/api/grades/v1/`, method: 'GET', signal }, options);
};

export const getApiGradesV1RetrieveQueryKey = () => {
  return [`/api/grades/v1/`] as const;
};

export const getApiGradesV1RetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiGradesV1Retrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGradesV1Retrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiGradesV1RetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGradesV1Retrieve>>> = ({ signal }) =>
    apiGradesV1Retrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiGradesV1Retrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiGradesV1RetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiGradesV1Retrieve>>>;
export type ApiGradesV1RetrieveQueryError = ErrorType<unknown>;

export function useApiGradesV1Retrieve<
  TData = Awaited<ReturnType<typeof apiGradesV1Retrieve>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGradesV1Retrieve>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof apiGradesV1Retrieve>>, TError, TData>, 'initialData'>;
  request?: SecondParameter<typeof customAxios>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiGradesV1Retrieve<
  TData = Awaited<ReturnType<typeof apiGradesV1Retrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGradesV1Retrieve>>, TError, TData>> &
    Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiGradesV1Retrieve>>, TError, TData>, 'initialData'>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiGradesV1Retrieve<
  TData = Awaited<ReturnType<typeof apiGradesV1Retrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGradesV1Retrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiGradesV1Retrieve<
  TData = Awaited<ReturnType<typeof apiGradesV1Retrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGradesV1Retrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiGradesV1RetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiGradesV1RetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiGradesV1Retrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiGradesV1Retrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiGradesV1RetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGradesV1Retrieve>>> = ({ signal }) =>
    apiGradesV1Retrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiGradesV1Retrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiGradesV1RetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiGradesV1Retrieve>>>;
export type ApiGradesV1RetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiGradesV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiGradesV1Retrieve>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiGradesV1Retrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiGradesV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiGradesV1Retrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiGradesV1Retrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiGradesV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiGradesV1Retrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiGradesV1Retrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiGradesV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiGradesV1Retrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiGradesV1Retrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiGradesV1RetrieveSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Redirect the user to download a quality report.
 */
export const apiGradesV1ReportRetrieve = (
  params: ApiGradesV1ReportRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<unknown>({ url: `/api/grades/v1/report`, method: 'GET', params, signal }, options);
};

export const getApiGradesV1ReportRetrieveQueryKey = (params: ApiGradesV1ReportRetrieveParams) => {
  return [`/api/grades/v1/report`, ...(params ? [params] : [])] as const;
};

export const getApiGradesV1ReportRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>,
  TError = ErrorType<void | ErrorResponse>,
>(
  params: ApiGradesV1ReportRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiGradesV1ReportRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>> = ({ signal }) =>
    apiGradesV1ReportRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiGradesV1ReportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>>;
export type ApiGradesV1ReportRetrieveQueryError = ErrorType<void | ErrorResponse>;

export function useApiGradesV1ReportRetrieve<
  TData = Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>,
  TError = ErrorType<void | ErrorResponse>,
>(
  params: ApiGradesV1ReportRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiGradesV1ReportRetrieve<
  TData = Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>,
  TError = ErrorType<void | ErrorResponse>,
>(
  params: ApiGradesV1ReportRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiGradesV1ReportRetrieve<
  TData = Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>,
  TError = ErrorType<void | ErrorResponse>,
>(
  params: ApiGradesV1ReportRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiGradesV1ReportRetrieve<
  TData = Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>,
  TError = ErrorType<void | ErrorResponse>,
>(
  params: ApiGradesV1ReportRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiGradesV1ReportRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiGradesV1ReportRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>,
  TError = ErrorType<void | ErrorResponse>,
>(
  params: ApiGradesV1ReportRetrieveParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiGradesV1ReportRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>> = ({ signal }) =>
    apiGradesV1ReportRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiGradesV1ReportRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>
>;
export type ApiGradesV1ReportRetrieveSuspenseQueryError = ErrorType<void | ErrorResponse>;

export function useApiGradesV1ReportRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>,
  TError = ErrorType<void | ErrorResponse>,
>(
  params: ApiGradesV1ReportRetrieveParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiGradesV1ReportRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>,
  TError = ErrorType<void | ErrorResponse>,
>(
  params: ApiGradesV1ReportRetrieveParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiGradesV1ReportRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>,
  TError = ErrorType<void | ErrorResponse>,
>(
  params: ApiGradesV1ReportRetrieveParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiGradesV1ReportRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>,
  TError = ErrorType<void | ErrorResponse>,
>(
  params: ApiGradesV1ReportRetrieveParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiGradesV1ReportRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiGradesV1ReportRetrieveSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiGroundControlSettingsRetrieve = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GroundControlConfigApi>({ url: `/api/ground-control/settings`, method: 'GET', signal }, options);
};

export const getApiGroundControlSettingsRetrieveQueryKey = () => {
  return [`/api/ground-control/settings`] as const;
};

export const getApiGroundControlSettingsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiGroundControlSettingsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>> = ({ signal }) =>
    apiGroundControlSettingsRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiGroundControlSettingsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>
>;
export type ApiGroundControlSettingsRetrieveQueryError = ErrorType<unknown>;

export function useApiGroundControlSettingsRetrieve<
  TData = Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiGroundControlSettingsRetrieve<
  TData = Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiGroundControlSettingsRetrieve<
  TData = Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiGroundControlSettingsRetrieve<
  TData = Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiGroundControlSettingsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiGroundControlSettingsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiGroundControlSettingsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>> = ({ signal }) =>
    apiGroundControlSettingsRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiGroundControlSettingsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>
>;
export type ApiGroundControlSettingsRetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiGroundControlSettingsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiGroundControlSettingsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiGroundControlSettingsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiGroundControlSettingsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiGroundControlSettingsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiGroundControlSettingsRetrieveSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiInspectionsBaleLoadedUpdate = (
  id: number,
  baleLoadedRequestBody: BodyType<BaleLoadedRequestBody>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<void>(
    {
      url: `/api/inspections/${id}/bale_loaded/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: baleLoadedRequestBody,
    },
    options
  );
};

export const getApiInspectionsBaleLoadedUpdateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsBaleLoadedUpdate>>,
    TError,
    { id: number; data: BodyType<BaleLoadedRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsBaleLoadedUpdate>>,
  TError,
  { id: number; data: BodyType<BaleLoadedRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsBaleLoadedUpdate>>,
    { id: number; data: BodyType<BaleLoadedRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiInspectionsBaleLoadedUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsBaleLoadedUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsBaleLoadedUpdate>>
>;
export type ApiInspectionsBaleLoadedUpdateMutationBody = BodyType<BaleLoadedRequestBody>;
export type ApiInspectionsBaleLoadedUpdateMutationError = ErrorType<ErrorResponse>;

export const useApiInspectionsBaleLoadedUpdate = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsBaleLoadedUpdate>>,
    TError,
    { id: number; data: BodyType<BaleLoadedRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsBaleLoadedUpdate>>,
  TError,
  { id: number; data: BodyType<BaleLoadedRequestBody> },
  TContext
> => {
  const mutationOptions = getApiInspectionsBaleLoadedUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsExternalV1Retrieve = (
  slug: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ExternalInspection>(
    { url: `/api/inspections/external/v1/${slug}/`, method: 'GET', signal },
    options
  );
};

export const getApiInspectionsExternalV1RetrieveQueryKey = (slug: string) => {
  return [`/api/inspections/external/v1/${slug}/`] as const;
};

export const getApiInspectionsExternalV1RetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsExternalV1RetrieveQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>> = ({ signal }) =>
    apiInspectionsExternalV1Retrieve(slug, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsExternalV1RetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>
>;
export type ApiInspectionsExternalV1RetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiInspectionsExternalV1Retrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsExternalV1Retrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsExternalV1Retrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsExternalV1Retrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsExternalV1RetrieveQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiInspectionsExternalV1RetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsExternalV1RetrieveQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>> = ({ signal }) =>
    apiInspectionsExternalV1Retrieve(slug, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsExternalV1RetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>
>;
export type ApiInspectionsExternalV1RetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiInspectionsExternalV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsExternalV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsExternalV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsExternalV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsExternalV1RetrieveSuspenseQueryOptions(slug, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiInspectionsExternalV1MarkAsCompleteUpdate = (
  slug: string,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<ExternalInspection>(
    { url: `/api/inspections/external/v1/${slug}/mark_as_complete/`, method: 'PUT' },
    options
  );
};

export const getApiInspectionsExternalV1MarkAsCompleteUpdateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsExternalV1MarkAsCompleteUpdate>>,
    TError,
    { slug: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsExternalV1MarkAsCompleteUpdate>>,
  TError,
  { slug: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsExternalV1MarkAsCompleteUpdate>>,
    { slug: string }
  > = (props) => {
    const { slug } = props ?? {};

    return apiInspectionsExternalV1MarkAsCompleteUpdate(slug, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsExternalV1MarkAsCompleteUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsExternalV1MarkAsCompleteUpdate>>
>;

export type ApiInspectionsExternalV1MarkAsCompleteUpdateMutationError = ErrorType<ErrorResponse>;

export const useApiInspectionsExternalV1MarkAsCompleteUpdate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsExternalV1MarkAsCompleteUpdate>>,
    TError,
    { slug: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsExternalV1MarkAsCompleteUpdate>>,
  TError,
  { slug: string },
  TContext
> => {
  const mutationOptions = getApiInspectionsExternalV1MarkAsCompleteUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @deprecated
 */
export const apiInspectionsV1List = (
  params?: ApiInspectionsV1ListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedListInspectionList>(
    { url: `/api/inspections/v1/`, method: 'GET', params, signal },
    options
  );
};

export const getApiInspectionsV1ListQueryKey = (params?: ApiInspectionsV1ListParams) => {
  return [`/api/inspections/v1/`, ...(params ? [params] : [])] as const;
};

export const getApiInspectionsV1ListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1List>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1ListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1ListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1List>>> = ({ signal }) =>
    apiInspectionsV1List(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1List>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1ListQueryResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1List>>>;
export type ApiInspectionsV1ListQueryError = ErrorType<unknown>;

export function useApiInspectionsV1List<
  TData = Awaited<ReturnType<typeof apiInspectionsV1List>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiInspectionsV1ListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1List<
  TData = Awaited<ReturnType<typeof apiInspectionsV1List>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1ListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1List<
  TData = Awaited<ReturnType<typeof apiInspectionsV1List>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1ListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @deprecated
 */

export function useApiInspectionsV1List<
  TData = Awaited<ReturnType<typeof apiInspectionsV1List>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1ListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1ListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiInspectionsV1ListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1List>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1ListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1ListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1List>>> = ({ signal }) =>
    apiInspectionsV1List(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1List>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1ListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1List>>>;
export type ApiInspectionsV1ListSuspenseQueryError = ErrorType<unknown>;

export function useApiInspectionsV1ListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1List>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiInspectionsV1ListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1ListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1List>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1ListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1ListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1List>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1ListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @deprecated
 */

export function useApiInspectionsV1ListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1List>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1ListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1ListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiInspectionsV1Create = (
  createInspection: BodyType<NonReadonly<CreateInspection>>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CreateInspection>(
    {
      url: `/api/inspections/v1/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createInspection,
      signal,
    },
    options
  );
};

export const getApiInspectionsV1CreateMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1Create>>,
    TError,
    { data: BodyType<NonReadonly<CreateInspection>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1Create>>,
  TError,
  { data: BodyType<NonReadonly<CreateInspection>> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1Create>>,
    { data: BodyType<NonReadonly<CreateInspection>> }
  > = (props) => {
    const { data } = props ?? {};

    return apiInspectionsV1Create(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1CreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1Create>>>;
export type ApiInspectionsV1CreateMutationBody = BodyType<NonReadonly<CreateInspection>>;
export type ApiInspectionsV1CreateMutationError = ErrorType<unknown>;

export const useApiInspectionsV1Create = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1Create>>,
    TError,
    { data: BodyType<NonReadonly<CreateInspection>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1Create>>,
  TError,
  { data: BodyType<NonReadonly<CreateInspection>> },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1CreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsV1Retrieve = (
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Inspection>({ url: `/api/inspections/v1/${id}/`, method: 'GET', signal }, options);
};

export const getApiInspectionsV1RetrieveQueryKey = (id: number) => {
  return [`/api/inspections/v1/${id}/`] as const;
};

export const getApiInspectionsV1RetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1RetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>> = ({ signal }) =>
    apiInspectionsV1Retrieve(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1RetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>>;
export type ApiInspectionsV1RetrieveQueryError = ErrorType<unknown>;

export function useApiInspectionsV1Retrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1Retrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1Retrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1Retrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1RetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiInspectionsV1RetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1RetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>> = ({ signal }) =>
    apiInspectionsV1Retrieve(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1RetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>
>;
export type ApiInspectionsV1RetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiInspectionsV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1RetrieveSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiInspectionsV1Update = (
  id: number,
  inspection: BodyType<NonReadonly<Inspection>>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<Inspection>(
    {
      url: `/api/inspections/v1/${id}/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: inspection,
    },
    options
  );
};

export const getApiInspectionsV1UpdateMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1Update>>,
    TError,
    { id: number; data: BodyType<NonReadonly<Inspection>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1Update>>,
  TError,
  { id: number; data: BodyType<NonReadonly<Inspection>> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1Update>>,
    { id: number; data: BodyType<NonReadonly<Inspection>> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiInspectionsV1Update(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1UpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1Update>>>;
export type ApiInspectionsV1UpdateMutationBody = BodyType<NonReadonly<Inspection>>;
export type ApiInspectionsV1UpdateMutationError = ErrorType<unknown>;

export const useApiInspectionsV1Update = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1Update>>,
    TError,
    { id: number; data: BodyType<NonReadonly<Inspection>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1Update>>,
  TError,
  { id: number; data: BodyType<NonReadonly<Inspection>> },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1UpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsV1PartialUpdate = (
  id: number,
  patchedInspection: BodyType<NonReadonly<PatchedInspection>>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<Inspection>(
    {
      url: `/api/inspections/v1/${id}/`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchedInspection,
    },
    options
  );
};

export const getApiInspectionsV1PartialUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1PartialUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<PatchedInspection>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1PartialUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<PatchedInspection>> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1PartialUpdate>>,
    { id: number; data: BodyType<NonReadonly<PatchedInspection>> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiInspectionsV1PartialUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1PartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1PartialUpdate>>
>;
export type ApiInspectionsV1PartialUpdateMutationBody = BodyType<NonReadonly<PatchedInspection>>;
export type ApiInspectionsV1PartialUpdateMutationError = ErrorType<unknown>;

export const useApiInspectionsV1PartialUpdate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1PartialUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<PatchedInspection>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1PartialUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<PatchedInspection>> },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1PartialUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsV1Destroy = (id: number, options?: SecondParameter<typeof customAxios>) => {
  return customAxios<void>({ url: `/api/inspections/v1/${id}/`, method: 'DELETE' }, options);
};

export const getApiInspectionsV1DestroyMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1Destroy>>, TError, { id: number }, TContext>;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1Destroy>>, TError, { id: number }, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiInspectionsV1Destroy>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return apiInspectionsV1Destroy(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1DestroyMutationResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1Destroy>>>;

export type ApiInspectionsV1DestroyMutationError = ErrorType<unknown>;

export const useApiInspectionsV1Destroy = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1Destroy>>, TError, { id: number }, TContext>;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<Awaited<ReturnType<typeof apiInspectionsV1Destroy>>, TError, { id: number }, TContext> => {
  const mutationOptions = getApiInspectionsV1DestroyMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsV1GenerateInspectionLinkUpdate = (
  id: number,
  inspection: BodyType<NonReadonly<Inspection>>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<InspectionLink>(
    {
      url: `/api/inspections/v1/${id}/generate_inspection_link/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: inspection,
    },
    options
  );
};

export const getApiInspectionsV1GenerateInspectionLinkUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1GenerateInspectionLinkUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<Inspection>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1GenerateInspectionLinkUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<Inspection>> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1GenerateInspectionLinkUpdate>>,
    { id: number; data: BodyType<NonReadonly<Inspection>> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiInspectionsV1GenerateInspectionLinkUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1GenerateInspectionLinkUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1GenerateInspectionLinkUpdate>>
>;
export type ApiInspectionsV1GenerateInspectionLinkUpdateMutationBody = BodyType<NonReadonly<Inspection>>;
export type ApiInspectionsV1GenerateInspectionLinkUpdateMutationError = ErrorType<unknown>;

export const useApiInspectionsV1GenerateInspectionLinkUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1GenerateInspectionLinkUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<Inspection>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1GenerateInspectionLinkUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<Inspection>> },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1GenerateInspectionLinkUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsV1EvidenceList = (
  slug: string,
  params?: ApiInspectionsV1EvidenceListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedEvidenceList>(
    { url: `/api/inspections/v1/${slug}/evidence/`, method: 'GET', params, signal },
    options
  );
};

export const getApiInspectionsV1EvidenceListQueryKey = (slug: string, params?: ApiInspectionsV1EvidenceListParams) => {
  return [`/api/inspections/v1/${slug}/evidence/`, ...(params ? [params] : [])] as const;
};

export const getApiInspectionsV1EvidenceListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  params?: ApiInspectionsV1EvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1EvidenceListQueryKey(slug, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>> = ({ signal }) =>
    apiInspectionsV1EvidenceList(slug, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1EvidenceListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>
>;
export type ApiInspectionsV1EvidenceListQueryError = ErrorType<ErrorResponse>;

export function useApiInspectionsV1EvidenceList<
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  params: undefined | ApiInspectionsV1EvidenceListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1EvidenceList<
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  params?: ApiInspectionsV1EvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1EvidenceList<
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  params?: ApiInspectionsV1EvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1EvidenceList<
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  params?: ApiInspectionsV1EvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1EvidenceListQueryOptions(slug, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiInspectionsV1EvidenceListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  params?: ApiInspectionsV1EvidenceListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1EvidenceListQueryKey(slug, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>> = ({ signal }) =>
    apiInspectionsV1EvidenceList(slug, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1EvidenceListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>
>;
export type ApiInspectionsV1EvidenceListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiInspectionsV1EvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  params: undefined | ApiInspectionsV1EvidenceListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1EvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  params?: ApiInspectionsV1EvidenceListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1EvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  params?: ApiInspectionsV1EvidenceListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1EvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  params?: ApiInspectionsV1EvidenceListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1EvidenceListSuspenseQueryOptions(slug, params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiInspectionsV1EvidenceRetrieve = (
  slug: string,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Evidence>({ url: `/api/inspections/v1/${slug}/evidence/${id}/`, method: 'GET', signal }, options);
};

export const getApiInspectionsV1EvidenceRetrieveQueryKey = (slug: string, id: number) => {
  return [`/api/inspections/v1/${slug}/evidence/${id}/`] as const;
};

export const getApiInspectionsV1EvidenceRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1EvidenceRetrieveQueryKey(slug, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>> = ({ signal }) =>
    apiInspectionsV1EvidenceRetrieve(slug, id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(slug && id), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1EvidenceRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>
>;
export type ApiInspectionsV1EvidenceRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiInspectionsV1EvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1EvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1EvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1EvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1EvidenceRetrieveQueryOptions(slug, id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiInspectionsV1EvidenceRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1EvidenceRetrieveQueryKey(slug, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>> = ({ signal }) =>
    apiInspectionsV1EvidenceRetrieve(slug, id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1EvidenceRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>
>;
export type ApiInspectionsV1EvidenceRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiInspectionsV1EvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1EvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1EvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1EvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1EvidenceRetrieveSuspenseQueryOptions(slug, id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generate an upload URL for large files.
 */
export const apiInspectionsV1EvidenceUploadCreate = (
  slug: string,
  generateUploadUrlRequest: BodyType<GenerateUploadUrlRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GenerateUploadUrlResponse>(
    {
      url: `/api/inspections/v1/${slug}/evidence/upload`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: generateUploadUrlRequest,
      signal,
    },
    options
  );
};

export const getApiInspectionsV1EvidenceUploadCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadCreate>>,
    TError,
    { slug: string; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadCreate>>,
  TError,
  { slug: string; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadCreate>>,
    { slug: string; data: BodyType<GenerateUploadUrlRequest> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return apiInspectionsV1EvidenceUploadCreate(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1EvidenceUploadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadCreate>>
>;
export type ApiInspectionsV1EvidenceUploadCreateMutationBody = BodyType<GenerateUploadUrlRequest>;
export type ApiInspectionsV1EvidenceUploadCreateMutationError = ErrorType<ErrorResponse>;

export const useApiInspectionsV1EvidenceUploadCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadCreate>>,
    TError,
    { slug: string; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadCreate>>,
  TError,
  { slug: string; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1EvidenceUploadCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Saves evidence as bale photo and returns inference results.
 */
export const apiInspectionsV1EvidenceUploadUpdate = (
  slug: string,
  processUploadRequest: BodyType<ProcessUploadRequest>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<ProcessUploadResponse>(
    {
      url: `/api/inspections/v1/${slug}/evidence/upload`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: processUploadRequest,
    },
    options
  );
};

export const getApiInspectionsV1EvidenceUploadUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadUpdate>>,
    TError,
    { slug: string; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadUpdate>>,
  TError,
  { slug: string; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadUpdate>>,
    { slug: string; data: BodyType<ProcessUploadRequest> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return apiInspectionsV1EvidenceUploadUpdate(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1EvidenceUploadUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadUpdate>>
>;
export type ApiInspectionsV1EvidenceUploadUpdateMutationBody = BodyType<ProcessUploadRequest>;
export type ApiInspectionsV1EvidenceUploadUpdateMutationError = ErrorType<unknown>;

export const useApiInspectionsV1EvidenceUploadUpdate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadUpdate>>,
    TError,
    { slug: string; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadUpdate>>,
  TError,
  { slug: string; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1EvidenceUploadUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsV1CompaniesList = (
  params?: ApiInspectionsV1CompaniesListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedInspectionCompanyList>(
    { url: `/api/inspections/v1/companies/`, method: 'GET', params, signal },
    options
  );
};

export const getApiInspectionsV1CompaniesListQueryKey = (params?: ApiInspectionsV1CompaniesListParams) => {
  return [`/api/inspections/v1/companies/`, ...(params ? [params] : [])] as const;
};

export const getApiInspectionsV1CompaniesListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1CompaniesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1CompaniesListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>> = ({ signal }) =>
    apiInspectionsV1CompaniesList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1CompaniesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>
>;
export type ApiInspectionsV1CompaniesListQueryError = ErrorType<unknown>;

export function useApiInspectionsV1CompaniesList<
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiInspectionsV1CompaniesListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1CompaniesList<
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1CompaniesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1CompaniesList<
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1CompaniesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1CompaniesList<
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1CompaniesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1CompaniesListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiInspectionsV1CompaniesListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1CompaniesListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1CompaniesListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>> = ({ signal }) =>
    apiInspectionsV1CompaniesList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1CompaniesListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>
>;
export type ApiInspectionsV1CompaniesListSuspenseQueryError = ErrorType<unknown>;

export function useApiInspectionsV1CompaniesListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiInspectionsV1CompaniesListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1CompaniesListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1CompaniesListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1CompaniesListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1CompaniesListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1CompaniesListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1CompaniesListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1CompaniesListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiInspectionsV1CompaniesCreate = (
  createInspectionCompany: BodyType<CreateInspectionCompany>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<InspectionCompany>(
    {
      url: `/api/inspections/v1/companies/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createInspectionCompany,
      signal,
    },
    options
  );
};

export const getApiInspectionsV1CompaniesCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1CompaniesCreate>>,
    TError,
    { data: BodyType<CreateInspectionCompany> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1CompaniesCreate>>,
  TError,
  { data: BodyType<CreateInspectionCompany> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1CompaniesCreate>>,
    { data: BodyType<CreateInspectionCompany> }
  > = (props) => {
    const { data } = props ?? {};

    return apiInspectionsV1CompaniesCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1CompaniesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1CompaniesCreate>>
>;
export type ApiInspectionsV1CompaniesCreateMutationBody = BodyType<CreateInspectionCompany>;
export type ApiInspectionsV1CompaniesCreateMutationError = ErrorType<unknown>;

export const useApiInspectionsV1CompaniesCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1CompaniesCreate>>,
    TError,
    { data: BodyType<CreateInspectionCompany> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1CompaniesCreate>>,
  TError,
  { data: BodyType<CreateInspectionCompany> },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1CompaniesCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsV1CompaniesRetrieve = (
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<InspectionCompany>(
    { url: `/api/inspections/v1/companies/${id}/`, method: 'GET', signal },
    options
  );
};

export const getApiInspectionsV1CompaniesRetrieveQueryKey = (id: number) => {
  return [`/api/inspections/v1/companies/${id}/`] as const;
};

export const getApiInspectionsV1CompaniesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1CompaniesRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>> = ({ signal }) =>
    apiInspectionsV1CompaniesRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1CompaniesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>
>;
export type ApiInspectionsV1CompaniesRetrieveQueryError = ErrorType<unknown>;

export function useApiInspectionsV1CompaniesRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1CompaniesRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1CompaniesRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1CompaniesRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1CompaniesRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiInspectionsV1CompaniesRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1CompaniesRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>> = ({ signal }) =>
    apiInspectionsV1CompaniesRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1CompaniesRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>
>;
export type ApiInspectionsV1CompaniesRetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiInspectionsV1CompaniesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1CompaniesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1CompaniesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1CompaniesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1CompaniesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1CompaniesRetrieveSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiInspectionsV1CompaniesUpdate = (
  id: number,
  inspectionCompany: BodyType<NonReadonly<InspectionCompany>>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<InspectionCompany>(
    {
      url: `/api/inspections/v1/companies/${id}/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: inspectionCompany,
    },
    options
  );
};

export const getApiInspectionsV1CompaniesUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1CompaniesUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<InspectionCompany>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1CompaniesUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<InspectionCompany>> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1CompaniesUpdate>>,
    { id: number; data: BodyType<NonReadonly<InspectionCompany>> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiInspectionsV1CompaniesUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1CompaniesUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1CompaniesUpdate>>
>;
export type ApiInspectionsV1CompaniesUpdateMutationBody = BodyType<NonReadonly<InspectionCompany>>;
export type ApiInspectionsV1CompaniesUpdateMutationError = ErrorType<unknown>;

export const useApiInspectionsV1CompaniesUpdate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1CompaniesUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<InspectionCompany>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1CompaniesUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<InspectionCompany>> },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1CompaniesUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsV1CompaniesPartialUpdate = (
  id: number,
  patchedInspectionCompany: BodyType<NonReadonly<PatchedInspectionCompany>>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<InspectionCompany>(
    {
      url: `/api/inspections/v1/companies/${id}/`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchedInspectionCompany,
    },
    options
  );
};

export const getApiInspectionsV1CompaniesPartialUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1CompaniesPartialUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<PatchedInspectionCompany>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1CompaniesPartialUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<PatchedInspectionCompany>> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1CompaniesPartialUpdate>>,
    { id: number; data: BodyType<NonReadonly<PatchedInspectionCompany>> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiInspectionsV1CompaniesPartialUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1CompaniesPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1CompaniesPartialUpdate>>
>;
export type ApiInspectionsV1CompaniesPartialUpdateMutationBody = BodyType<NonReadonly<PatchedInspectionCompany>>;
export type ApiInspectionsV1CompaniesPartialUpdateMutationError = ErrorType<unknown>;

export const useApiInspectionsV1CompaniesPartialUpdate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1CompaniesPartialUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<PatchedInspectionCompany>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1CompaniesPartialUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<PatchedInspectionCompany>> },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1CompaniesPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsV1CompaniesAddInspectorCreate = (
  id: number,
  inspector: BodyType<NonReadonly<Inspector>>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Inspector>(
    {
      url: `/api/inspections/v1/companies/${id}/add_inspector/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: inspector,
      signal,
    },
    options
  );
};

export const getApiInspectionsV1CompaniesAddInspectorCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1CompaniesAddInspectorCreate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<Inspector>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1CompaniesAddInspectorCreate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<Inspector>> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1CompaniesAddInspectorCreate>>,
    { id: number; data: BodyType<NonReadonly<Inspector>> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiInspectionsV1CompaniesAddInspectorCreate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1CompaniesAddInspectorCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1CompaniesAddInspectorCreate>>
>;
export type ApiInspectionsV1CompaniesAddInspectorCreateMutationBody = BodyType<NonReadonly<Inspector>>;
export type ApiInspectionsV1CompaniesAddInspectorCreateMutationError = ErrorType<unknown>;

export const useApiInspectionsV1CompaniesAddInspectorCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1CompaniesAddInspectorCreate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<Inspector>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1CompaniesAddInspectorCreate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<Inspector>> },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1CompaniesAddInspectorCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsV1InspectionLoadsList = (
  params?: ApiInspectionsV1InspectionLoadsListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedInspectionLoadList>(
    { url: `/api/inspections/v1/inspection-loads/`, method: 'GET', params, signal },
    options
  );
};

export const getApiInspectionsV1InspectionLoadsListQueryKey = (params?: ApiInspectionsV1InspectionLoadsListParams) => {
  return [`/api/inspections/v1/inspection-loads/`, ...(params ? [params] : [])] as const;
};

export const getApiInspectionsV1InspectionLoadsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1InspectionLoadsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1InspectionLoadsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>> = ({ signal }) =>
    apiInspectionsV1InspectionLoadsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1InspectionLoadsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>
>;
export type ApiInspectionsV1InspectionLoadsListQueryError = ErrorType<unknown>;

export function useApiInspectionsV1InspectionLoadsList<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiInspectionsV1InspectionLoadsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1InspectionLoadsList<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1InspectionLoadsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1InspectionLoadsList<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1InspectionLoadsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1InspectionLoadsList<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1InspectionLoadsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1InspectionLoadsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiInspectionsV1InspectionLoadsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1InspectionLoadsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1InspectionLoadsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>> = ({ signal }) =>
    apiInspectionsV1InspectionLoadsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1InspectionLoadsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>
>;
export type ApiInspectionsV1InspectionLoadsListSuspenseQueryError = ErrorType<unknown>;

export function useApiInspectionsV1InspectionLoadsListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiInspectionsV1InspectionLoadsListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1InspectionLoadsListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1InspectionLoadsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1InspectionLoadsListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1InspectionLoadsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1InspectionLoadsListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1InspectionLoadsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1InspectionLoadsListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiInspectionsV1InspectionLoadsCreate = (
  inspectionLoad: BodyType<NonReadonly<InspectionLoad>>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<InspectionLoad>(
    {
      url: `/api/inspections/v1/inspection-loads/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: inspectionLoad,
      signal,
    },
    options
  );
};

export const getApiInspectionsV1InspectionLoadsCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsCreate>>,
    TError,
    { data: BodyType<NonReadonly<InspectionLoad>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsCreate>>,
  TError,
  { data: BodyType<NonReadonly<InspectionLoad>> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsCreate>>,
    { data: BodyType<NonReadonly<InspectionLoad>> }
  > = (props) => {
    const { data } = props ?? {};

    return apiInspectionsV1InspectionLoadsCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1InspectionLoadsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsCreate>>
>;
export type ApiInspectionsV1InspectionLoadsCreateMutationBody = BodyType<NonReadonly<InspectionLoad>>;
export type ApiInspectionsV1InspectionLoadsCreateMutationError = ErrorType<unknown>;

export const useApiInspectionsV1InspectionLoadsCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsCreate>>,
    TError,
    { data: BodyType<NonReadonly<InspectionLoad>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsCreate>>,
  TError,
  { data: BodyType<NonReadonly<InspectionLoad>> },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1InspectionLoadsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsV1InspectionLoadsRetrieve = (
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<InspectionLoad>(
    { url: `/api/inspections/v1/inspection-loads/${id}/`, method: 'GET', signal },
    options
  );
};

export const getApiInspectionsV1InspectionLoadsRetrieveQueryKey = (id: number) => {
  return [`/api/inspections/v1/inspection-loads/${id}/`] as const;
};

export const getApiInspectionsV1InspectionLoadsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1InspectionLoadsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>> = ({ signal }) =>
    apiInspectionsV1InspectionLoadsRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1InspectionLoadsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>
>;
export type ApiInspectionsV1InspectionLoadsRetrieveQueryError = ErrorType<unknown>;

export function useApiInspectionsV1InspectionLoadsRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1InspectionLoadsRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1InspectionLoadsRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1InspectionLoadsRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1InspectionLoadsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiInspectionsV1InspectionLoadsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1InspectionLoadsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>> = ({ signal }) =>
    apiInspectionsV1InspectionLoadsRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1InspectionLoadsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>
>;
export type ApiInspectionsV1InspectionLoadsRetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiInspectionsV1InspectionLoadsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1InspectionLoadsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1InspectionLoadsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1InspectionLoadsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1InspectionLoadsRetrieveSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiInspectionsV1InspectionLoadsUpdate = (
  id: number,
  inspectionLoad: BodyType<NonReadonly<InspectionLoad>>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<InspectionLoad>(
    {
      url: `/api/inspections/v1/inspection-loads/${id}/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: inspectionLoad,
    },
    options
  );
};

export const getApiInspectionsV1InspectionLoadsUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<InspectionLoad>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<InspectionLoad>> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsUpdate>>,
    { id: number; data: BodyType<NonReadonly<InspectionLoad>> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiInspectionsV1InspectionLoadsUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1InspectionLoadsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsUpdate>>
>;
export type ApiInspectionsV1InspectionLoadsUpdateMutationBody = BodyType<NonReadonly<InspectionLoad>>;
export type ApiInspectionsV1InspectionLoadsUpdateMutationError = ErrorType<unknown>;

export const useApiInspectionsV1InspectionLoadsUpdate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<InspectionLoad>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<InspectionLoad>> },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1InspectionLoadsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsV1InspectionLoadsPartialUpdate = (
  id: number,
  patchedInspectionLoad: BodyType<NonReadonly<PatchedInspectionLoad>>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<InspectionLoad>(
    {
      url: `/api/inspections/v1/inspection-loads/${id}/`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchedInspectionLoad,
    },
    options
  );
};

export const getApiInspectionsV1InspectionLoadsPartialUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsPartialUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<PatchedInspectionLoad>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsPartialUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<PatchedInspectionLoad>> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsPartialUpdate>>,
    { id: number; data: BodyType<NonReadonly<PatchedInspectionLoad>> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiInspectionsV1InspectionLoadsPartialUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1InspectionLoadsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsPartialUpdate>>
>;
export type ApiInspectionsV1InspectionLoadsPartialUpdateMutationBody = BodyType<NonReadonly<PatchedInspectionLoad>>;
export type ApiInspectionsV1InspectionLoadsPartialUpdateMutationError = ErrorType<unknown>;

export const useApiInspectionsV1InspectionLoadsPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsPartialUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<PatchedInspectionLoad>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsPartialUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<PatchedInspectionLoad>> },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1InspectionLoadsPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsV1InspectionLoadsDestroy = (id: number, options?: SecondParameter<typeof customAxios>) => {
  return customAxios<void>({ url: `/api/inspections/v1/inspection-loads/${id}/`, method: 'DELETE' }, options);
};

export const getApiInspectionsV1InspectionLoadsDestroyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsDestroy>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsDestroy>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsDestroy>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return apiInspectionsV1InspectionLoadsDestroy(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1InspectionLoadsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsDestroy>>
>;

export type ApiInspectionsV1InspectionLoadsDestroyMutationError = ErrorType<unknown>;

export const useApiInspectionsV1InspectionLoadsDestroy = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsDestroy>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsDestroy>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1InspectionLoadsDestroyMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsV1InspectionLoadsBulkCreateCreate = (
  inspectionLoad: BodyType<NonReadonly<InspectionLoad[]>>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<InspectionLoad[]>(
    {
      url: `/api/inspections/v1/inspection-loads/bulk_create/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: inspectionLoad,
      signal,
    },
    options
  );
};

export const getApiInspectionsV1InspectionLoadsBulkCreateCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsBulkCreateCreate>>,
    TError,
    { data: BodyType<NonReadonly<InspectionLoad[]>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsBulkCreateCreate>>,
  TError,
  { data: BodyType<NonReadonly<InspectionLoad[]>> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsBulkCreateCreate>>,
    { data: BodyType<NonReadonly<InspectionLoad[]>> }
  > = (props) => {
    const { data } = props ?? {};

    return apiInspectionsV1InspectionLoadsBulkCreateCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1InspectionLoadsBulkCreateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsBulkCreateCreate>>
>;
export type ApiInspectionsV1InspectionLoadsBulkCreateCreateMutationBody = BodyType<NonReadonly<InspectionLoad[]>>;
export type ApiInspectionsV1InspectionLoadsBulkCreateCreateMutationError = ErrorType<unknown>;

export const useApiInspectionsV1InspectionLoadsBulkCreateCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsBulkCreateCreate>>,
    TError,
    { data: BodyType<NonReadonly<InspectionLoad[]>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1InspectionLoadsBulkCreateCreate>>,
  TError,
  { data: BodyType<NonReadonly<InspectionLoad[]>> },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1InspectionLoadsBulkCreateCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsV1InspectorsCreate = (
  inspector: BodyType<NonReadonly<Inspector>>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Inspector>(
    {
      url: `/api/inspections/v1/inspectors/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: inspector,
      signal,
    },
    options
  );
};

export const getApiInspectionsV1InspectorsCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectorsCreate>>,
    TError,
    { data: BodyType<NonReadonly<Inspector>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1InspectorsCreate>>,
  TError,
  { data: BodyType<NonReadonly<Inspector>> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1InspectorsCreate>>,
    { data: BodyType<NonReadonly<Inspector>> }
  > = (props) => {
    const { data } = props ?? {};

    return apiInspectionsV1InspectorsCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1InspectorsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1InspectorsCreate>>
>;
export type ApiInspectionsV1InspectorsCreateMutationBody = BodyType<NonReadonly<Inspector>>;
export type ApiInspectionsV1InspectorsCreateMutationError = ErrorType<unknown>;

export const useApiInspectionsV1InspectorsCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectorsCreate>>,
    TError,
    { data: BodyType<NonReadonly<Inspector>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1InspectorsCreate>>,
  TError,
  { data: BodyType<NonReadonly<Inspector>> },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1InspectorsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsV1InspectorsRetrieve = (
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Inspector>({ url: `/api/inspections/v1/inspectors/${id}/`, method: 'GET', signal }, options);
};

export const getApiInspectionsV1InspectorsRetrieveQueryKey = (id: number) => {
  return [`/api/inspections/v1/inspectors/${id}/`] as const;
};

export const getApiInspectionsV1InspectorsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1InspectorsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>> = ({ signal }) =>
    apiInspectionsV1InspectorsRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1InspectorsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>
>;
export type ApiInspectionsV1InspectorsRetrieveQueryError = ErrorType<unknown>;

export function useApiInspectionsV1InspectorsRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1InspectorsRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1InspectorsRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1InspectorsRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1InspectorsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiInspectionsV1InspectorsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1InspectorsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>> = ({ signal }) =>
    apiInspectionsV1InspectorsRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1InspectorsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>
>;
export type ApiInspectionsV1InspectorsRetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiInspectionsV1InspectorsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1InspectorsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1InspectorsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1InspectorsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1InspectorsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1InspectorsRetrieveSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiInspectionsV1InspectorsUpdate = (
  id: number,
  inspector: BodyType<NonReadonly<Inspector>>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<Inspector>(
    {
      url: `/api/inspections/v1/inspectors/${id}/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: inspector,
    },
    options
  );
};

export const getApiInspectionsV1InspectorsUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectorsUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<Inspector>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1InspectorsUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<Inspector>> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1InspectorsUpdate>>,
    { id: number; data: BodyType<NonReadonly<Inspector>> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiInspectionsV1InspectorsUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1InspectorsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1InspectorsUpdate>>
>;
export type ApiInspectionsV1InspectorsUpdateMutationBody = BodyType<NonReadonly<Inspector>>;
export type ApiInspectionsV1InspectorsUpdateMutationError = ErrorType<unknown>;

export const useApiInspectionsV1InspectorsUpdate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectorsUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<Inspector>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1InspectorsUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<Inspector>> },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1InspectorsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsV1InspectorsPartialUpdate = (
  id: number,
  patchedInspector: BodyType<NonReadonly<PatchedInspector>>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<Inspector>(
    {
      url: `/api/inspections/v1/inspectors/${id}/`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchedInspector,
    },
    options
  );
};

export const getApiInspectionsV1InspectorsPartialUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectorsPartialUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<PatchedInspector>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1InspectorsPartialUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<PatchedInspector>> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1InspectorsPartialUpdate>>,
    { id: number; data: BodyType<NonReadonly<PatchedInspector>> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiInspectionsV1InspectorsPartialUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1InspectorsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1InspectorsPartialUpdate>>
>;
export type ApiInspectionsV1InspectorsPartialUpdateMutationBody = BodyType<NonReadonly<PatchedInspector>>;
export type ApiInspectionsV1InspectorsPartialUpdateMutationError = ErrorType<unknown>;

export const useApiInspectionsV1InspectorsPartialUpdate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1InspectorsPartialUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<PatchedInspector>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1InspectorsPartialUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<PatchedInspector>> },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1InspectorsPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiInspectionsV1LoadsList = (
  params?: ApiInspectionsV1LoadsListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedLoadList>({ url: `/api/inspections/v1/loads/`, method: 'GET', params, signal }, options);
};

export const getApiInspectionsV1LoadsListQueryKey = (params?: ApiInspectionsV1LoadsListParams) => {
  return [`/api/inspections/v1/loads/`, ...(params ? [params] : [])] as const;
};

export const getApiInspectionsV1LoadsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1LoadsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1LoadsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>> = ({ signal }) =>
    apiInspectionsV1LoadsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1LoadsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>>;
export type ApiInspectionsV1LoadsListQueryError = ErrorType<unknown>;

export function useApiInspectionsV1LoadsList<
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiInspectionsV1LoadsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1LoadsList<
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1LoadsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1LoadsList<
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1LoadsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1LoadsList<
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1LoadsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1LoadsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiInspectionsV1LoadsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1LoadsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1LoadsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>> = ({ signal }) =>
    apiInspectionsV1LoadsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1LoadsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>
>;
export type ApiInspectionsV1LoadsListSuspenseQueryError = ErrorType<unknown>;

export function useApiInspectionsV1LoadsListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiInspectionsV1LoadsListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1LoadsListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1LoadsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1LoadsListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1LoadsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1LoadsListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiInspectionsV1LoadsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1LoadsListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiInspectionsV1LoadsRetrieve = (
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Load>({ url: `/api/inspections/v1/loads/${id}/`, method: 'GET', signal }, options);
};

export const getApiInspectionsV1LoadsRetrieveQueryKey = (id: number) => {
  return [`/api/inspections/v1/loads/${id}/`] as const;
};

export const getApiInspectionsV1LoadsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1LoadsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>> = ({ signal }) =>
    apiInspectionsV1LoadsRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1LoadsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>
>;
export type ApiInspectionsV1LoadsRetrieveQueryError = ErrorType<unknown>;

export function useApiInspectionsV1LoadsRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1LoadsRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1LoadsRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1LoadsRetrieve<
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1LoadsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiInspectionsV1LoadsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV1LoadsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>> = ({ signal }) =>
    apiInspectionsV1LoadsRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV1LoadsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>
>;
export type ApiInspectionsV1LoadsRetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiInspectionsV1LoadsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1LoadsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV1LoadsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV1LoadsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1LoadsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV1LoadsRetrieveSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiInspectionsV1LoadsMarkInspectionNotNeededPartialUpdate = (
  id: number,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<Load>(
    { url: `/api/inspections/v1/loads/${id}/mark_inspection_not_needed/`, method: 'PATCH' },
    options
  );
};

export const getApiInspectionsV1LoadsMarkInspectionNotNeededPartialUpdateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1LoadsMarkInspectionNotNeededPartialUpdate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiInspectionsV1LoadsMarkInspectionNotNeededPartialUpdate>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInspectionsV1LoadsMarkInspectionNotNeededPartialUpdate>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return apiInspectionsV1LoadsMarkInspectionNotNeededPartialUpdate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiInspectionsV1LoadsMarkInspectionNotNeededPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInspectionsV1LoadsMarkInspectionNotNeededPartialUpdate>>
>;

export type ApiInspectionsV1LoadsMarkInspectionNotNeededPartialUpdateMutationError = ErrorType<ErrorResponse>;

export const useApiInspectionsV1LoadsMarkInspectionNotNeededPartialUpdate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInspectionsV1LoadsMarkInspectionNotNeededPartialUpdate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiInspectionsV1LoadsMarkInspectionNotNeededPartialUpdate>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getApiInspectionsV1LoadsMarkInspectionNotNeededPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiInspectionsV2List = (
  params?: ApiInspectionsV2ListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedInspectionDTOList>(
    { url: `/api/inspections/v2/`, method: 'GET', params, signal },
    options
  );
};

export const getApiInspectionsV2ListQueryKey = (params?: ApiInspectionsV2ListParams) => {
  return [`/api/inspections/v2/`, ...(params ? [params] : [])] as const;
};

export const getApiInspectionsV2ListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV2List>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiInspectionsV2ListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV2List>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV2ListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV2List>>> = ({ signal }) =>
    apiInspectionsV2List(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV2List>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV2ListQueryResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV2List>>>;
export type ApiInspectionsV2ListQueryError = ErrorType<ErrorResponse>;

export function useApiInspectionsV2List<
  TData = Awaited<ReturnType<typeof apiInspectionsV2List>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiInspectionsV2ListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV2List>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV2List>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV2List<
  TData = Awaited<ReturnType<typeof apiInspectionsV2List>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiInspectionsV2ListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV2List>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiInspectionsV2List>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV2List<
  TData = Awaited<ReturnType<typeof apiInspectionsV2List>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiInspectionsV2ListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV2List>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV2List<
  TData = Awaited<ReturnType<typeof apiInspectionsV2List>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiInspectionsV2ListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV2List>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV2ListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiInspectionsV2ListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiInspectionsV2List>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiInspectionsV2ListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV2List>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInspectionsV2ListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV2List>>> = ({ signal }) =>
    apiInspectionsV2List(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiInspectionsV2List>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiInspectionsV2ListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV2List>>>;
export type ApiInspectionsV2ListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiInspectionsV2ListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV2List>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiInspectionsV2ListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV2List>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV2ListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV2List>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiInspectionsV2ListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV2List>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiInspectionsV2ListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV2List>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiInspectionsV2ListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV2List>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiInspectionsV2ListSuspense<
  TData = Awaited<ReturnType<typeof apiInspectionsV2List>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiInspectionsV2ListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV2List>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiInspectionsV2ListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiLogisticsShipmentsCreate = (
  shipmentCreate: BodyType<ShipmentCreate>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ShipmentInfo>(
    {
      url: `/api/logistics/shipments/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: shipmentCreate,
      signal,
    },
    options
  );
};

export const getApiLogisticsShipmentsCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiLogisticsShipmentsCreate>>,
    TError,
    { data: BodyType<ShipmentCreate> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiLogisticsShipmentsCreate>>,
  TError,
  { data: BodyType<ShipmentCreate> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiLogisticsShipmentsCreate>>,
    { data: BodyType<ShipmentCreate> }
  > = (props) => {
    const { data } = props ?? {};

    return apiLogisticsShipmentsCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiLogisticsShipmentsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiLogisticsShipmentsCreate>>
>;
export type ApiLogisticsShipmentsCreateMutationBody = BodyType<ShipmentCreate>;
export type ApiLogisticsShipmentsCreateMutationError = ErrorType<ErrorResponse>;

export const useApiLogisticsShipmentsCreate = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiLogisticsShipmentsCreate>>,
    TError,
    { data: BodyType<ShipmentCreate> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiLogisticsShipmentsCreate>>,
  TError,
  { data: BodyType<ShipmentCreate> },
  TContext
> => {
  const mutationOptions = getApiLogisticsShipmentsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiLogisticsShipmentsRetrieve = (
  name: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ShipmentInfo>({ url: `/api/logistics/shipments/${name}/`, method: 'GET', signal }, options);
};

export const getApiLogisticsShipmentsRetrieveQueryKey = (name: string) => {
  return [`/api/logistics/shipments/${name}/`] as const;
};

export const getApiLogisticsShipmentsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  name: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiLogisticsShipmentsRetrieveQueryKey(name);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>> = ({ signal }) =>
    apiLogisticsShipmentsRetrieve(name, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!name, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiLogisticsShipmentsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>
>;
export type ApiLogisticsShipmentsRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiLogisticsShipmentsRetrieve<
  TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  name: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsShipmentsRetrieve<
  TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  name: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsShipmentsRetrieve<
  TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  name: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiLogisticsShipmentsRetrieve<
  TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  name: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiLogisticsShipmentsRetrieveQueryOptions(name, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiLogisticsShipmentsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  name: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiLogisticsShipmentsRetrieveQueryKey(name);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>> = ({ signal }) =>
    apiLogisticsShipmentsRetrieve(name, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiLogisticsShipmentsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>
>;
export type ApiLogisticsShipmentsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiLogisticsShipmentsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  name: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsShipmentsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  name: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsShipmentsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  name: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiLogisticsShipmentsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  name: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiLogisticsShipmentsRetrieveSuspenseQueryOptions(name, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiLogisticsShipmentsPartialUpdate = (
  name: string,
  patchedShipmentUpdate: BodyType<PatchedShipmentUpdate>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<ShipmentInfo>(
    {
      url: `/api/logistics/shipments/${name}/`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchedShipmentUpdate,
    },
    options
  );
};

export const getApiLogisticsShipmentsPartialUpdateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiLogisticsShipmentsPartialUpdate>>,
    TError,
    { name: string; data: BodyType<PatchedShipmentUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiLogisticsShipmentsPartialUpdate>>,
  TError,
  { name: string; data: BodyType<PatchedShipmentUpdate> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiLogisticsShipmentsPartialUpdate>>,
    { name: string; data: BodyType<PatchedShipmentUpdate> }
  > = (props) => {
    const { name, data } = props ?? {};

    return apiLogisticsShipmentsPartialUpdate(name, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiLogisticsShipmentsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiLogisticsShipmentsPartialUpdate>>
>;
export type ApiLogisticsShipmentsPartialUpdateMutationBody = BodyType<PatchedShipmentUpdate>;
export type ApiLogisticsShipmentsPartialUpdateMutationError = ErrorType<ErrorResponse>;

export const useApiLogisticsShipmentsPartialUpdate = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiLogisticsShipmentsPartialUpdate>>,
    TError,
    { name: string; data: BodyType<PatchedShipmentUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiLogisticsShipmentsPartialUpdate>>,
  TError,
  { name: string; data: BodyType<PatchedShipmentUpdate> },
  TContext
> => {
  const mutationOptions = getApiLogisticsShipmentsPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiLogisticsV1LoadsList = (
  params?: ApiLogisticsV1LoadsListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedSimpleLoadList>(
    { url: `/api/logistics/v1/loads/`, method: 'GET', params, signal },
    options
  );
};

export const getApiLogisticsV1LoadsListQueryKey = (params?: ApiLogisticsV1LoadsListParams) => {
  return [`/api/logistics/v1/loads/`, ...(params ? [params] : [])] as const;
};

export const getApiLogisticsV1LoadsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiLogisticsV1LoadsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiLogisticsV1LoadsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>> = ({ signal }) =>
    apiLogisticsV1LoadsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiLogisticsV1LoadsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>>;
export type ApiLogisticsV1LoadsListQueryError = ErrorType<ErrorResponse>;

export function useApiLogisticsV1LoadsList<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiLogisticsV1LoadsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsV1LoadsList<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiLogisticsV1LoadsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsV1LoadsList<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiLogisticsV1LoadsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiLogisticsV1LoadsList<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiLogisticsV1LoadsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiLogisticsV1LoadsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiLogisticsV1LoadsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiLogisticsV1LoadsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiLogisticsV1LoadsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>> = ({ signal }) =>
    apiLogisticsV1LoadsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiLogisticsV1LoadsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>
>;
export type ApiLogisticsV1LoadsListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiLogisticsV1LoadsListSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiLogisticsV1LoadsListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsV1LoadsListSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiLogisticsV1LoadsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsV1LoadsListSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiLogisticsV1LoadsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiLogisticsV1LoadsListSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiLogisticsV1LoadsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiLogisticsV1LoadsListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiLogisticsV1LoadsEvidenceList = (
  loadId: string,
  params?: ApiLogisticsV1LoadsEvidenceListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedEvidenceList>(
    { url: `/api/logistics/v1/loads/${loadId}/evidence/`, method: 'GET', params, signal },
    options
  );
};

export const getApiLogisticsV1LoadsEvidenceListQueryKey = (
  loadId: string,
  params?: ApiLogisticsV1LoadsEvidenceListParams
) => {
  return [`/api/logistics/v1/loads/${loadId}/evidence/`, ...(params ? [params] : [])] as const;
};

export const getApiLogisticsV1LoadsEvidenceListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  params?: ApiLogisticsV1LoadsEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiLogisticsV1LoadsEvidenceListQueryKey(loadId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>> = ({ signal }) =>
    apiLogisticsV1LoadsEvidenceList(loadId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!loadId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiLogisticsV1LoadsEvidenceListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>
>;
export type ApiLogisticsV1LoadsEvidenceListQueryError = ErrorType<ErrorResponse>;

export function useApiLogisticsV1LoadsEvidenceList<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  params: undefined | ApiLogisticsV1LoadsEvidenceListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsV1LoadsEvidenceList<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  params?: ApiLogisticsV1LoadsEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsV1LoadsEvidenceList<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  params?: ApiLogisticsV1LoadsEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiLogisticsV1LoadsEvidenceList<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  params?: ApiLogisticsV1LoadsEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiLogisticsV1LoadsEvidenceListQueryOptions(loadId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiLogisticsV1LoadsEvidenceListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  params?: ApiLogisticsV1LoadsEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiLogisticsV1LoadsEvidenceListQueryKey(loadId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>> = ({ signal }) =>
    apiLogisticsV1LoadsEvidenceList(loadId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiLogisticsV1LoadsEvidenceListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>
>;
export type ApiLogisticsV1LoadsEvidenceListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiLogisticsV1LoadsEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  params: undefined | ApiLogisticsV1LoadsEvidenceListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsV1LoadsEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  params?: ApiLogisticsV1LoadsEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsV1LoadsEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  params?: ApiLogisticsV1LoadsEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiLogisticsV1LoadsEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  params?: ApiLogisticsV1LoadsEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiLogisticsV1LoadsEvidenceListSuspenseQueryOptions(loadId, params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiLogisticsV1LoadsEvidenceRetrieve = (
  loadId: string,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Evidence>(
    { url: `/api/logistics/v1/loads/${loadId}/evidence/${id}/`, method: 'GET', signal },
    options
  );
};

export const getApiLogisticsV1LoadsEvidenceRetrieveQueryKey = (loadId: string, id: number) => {
  return [`/api/logistics/v1/loads/${loadId}/evidence/${id}/`] as const;
};

export const getApiLogisticsV1LoadsEvidenceRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiLogisticsV1LoadsEvidenceRetrieveQueryKey(loadId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>> = ({ signal }) =>
    apiLogisticsV1LoadsEvidenceRetrieve(loadId, id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(loadId && id), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiLogisticsV1LoadsEvidenceRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>
>;
export type ApiLogisticsV1LoadsEvidenceRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiLogisticsV1LoadsEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsV1LoadsEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsV1LoadsEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiLogisticsV1LoadsEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiLogisticsV1LoadsEvidenceRetrieveQueryOptions(loadId, id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiLogisticsV1LoadsEvidenceRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiLogisticsV1LoadsEvidenceRetrieveQueryKey(loadId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>> = ({ signal }) =>
    apiLogisticsV1LoadsEvidenceRetrieve(loadId, id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiLogisticsV1LoadsEvidenceRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>
>;
export type ApiLogisticsV1LoadsEvidenceRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiLogisticsV1LoadsEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsV1LoadsEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsV1LoadsEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiLogisticsV1LoadsEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiLogisticsV1LoadsEvidenceRetrieveSuspenseQueryOptions(loadId, id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generate an upload URL for large files.
 */
export const apiLogisticsV1LoadsEvidenceUploadCreate = (
  loadId: number,
  generateUploadUrlRequest: BodyType<GenerateUploadUrlRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GenerateUploadUrlResponse>(
    {
      url: `/api/logistics/v1/loads/${loadId}/evidence/upload/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: generateUploadUrlRequest,
      signal,
    },
    options
  );
};

export const getApiLogisticsV1LoadsEvidenceUploadCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadCreate>>,
    TError,
    { loadId: number; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadCreate>>,
  TError,
  { loadId: number; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadCreate>>,
    { loadId: number; data: BodyType<GenerateUploadUrlRequest> }
  > = (props) => {
    const { loadId, data } = props ?? {};

    return apiLogisticsV1LoadsEvidenceUploadCreate(loadId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiLogisticsV1LoadsEvidenceUploadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadCreate>>
>;
export type ApiLogisticsV1LoadsEvidenceUploadCreateMutationBody = BodyType<GenerateUploadUrlRequest>;
export type ApiLogisticsV1LoadsEvidenceUploadCreateMutationError = ErrorType<ErrorResponse>;

export const useApiLogisticsV1LoadsEvidenceUploadCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadCreate>>,
    TError,
    { loadId: number; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadCreate>>,
  TError,
  { loadId: number; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const mutationOptions = getApiLogisticsV1LoadsEvidenceUploadCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Saves evidence as bale photo and returns inference results.
 */
export const apiLogisticsV1LoadsEvidenceUploadUpdate = (
  loadId: number,
  processUploadRequest: BodyType<ProcessUploadRequest>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<ProcessUploadResponse>(
    {
      url: `/api/logistics/v1/loads/${loadId}/evidence/upload/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: processUploadRequest,
    },
    options
  );
};

export const getApiLogisticsV1LoadsEvidenceUploadUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadUpdate>>,
    TError,
    { loadId: number; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadUpdate>>,
  TError,
  { loadId: number; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadUpdate>>,
    { loadId: number; data: BodyType<ProcessUploadRequest> }
  > = (props) => {
    const { loadId, data } = props ?? {};

    return apiLogisticsV1LoadsEvidenceUploadUpdate(loadId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiLogisticsV1LoadsEvidenceUploadUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadUpdate>>
>;
export type ApiLogisticsV1LoadsEvidenceUploadUpdateMutationBody = BodyType<ProcessUploadRequest>;
export type ApiLogisticsV1LoadsEvidenceUploadUpdateMutationError = ErrorType<unknown>;

export const useApiLogisticsV1LoadsEvidenceUploadUpdate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadUpdate>>,
    TError,
    { loadId: number; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadUpdate>>,
  TError,
  { loadId: number; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const mutationOptions = getApiLogisticsV1LoadsEvidenceUploadUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiLogisticsV1ShipmentsList = (
  params?: ApiLogisticsV1ShipmentsListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedShipmentInfoList>(
    { url: `/api/logistics/v1/shipments/`, method: 'GET', params, signal },
    options
  );
};

export const getApiLogisticsV1ShipmentsListQueryKey = (params?: ApiLogisticsV1ShipmentsListParams) => {
  return [`/api/logistics/v1/shipments/`, ...(params ? [params] : [])] as const;
};

export const getApiLogisticsV1ShipmentsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiLogisticsV1ShipmentsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiLogisticsV1ShipmentsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>> = ({ signal }) =>
    apiLogisticsV1ShipmentsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiLogisticsV1ShipmentsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>
>;
export type ApiLogisticsV1ShipmentsListQueryError = ErrorType<ErrorResponse>;

export function useApiLogisticsV1ShipmentsList<
  TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiLogisticsV1ShipmentsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsV1ShipmentsList<
  TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiLogisticsV1ShipmentsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsV1ShipmentsList<
  TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiLogisticsV1ShipmentsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiLogisticsV1ShipmentsList<
  TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiLogisticsV1ShipmentsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiLogisticsV1ShipmentsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiLogisticsV1ShipmentsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiLogisticsV1ShipmentsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiLogisticsV1ShipmentsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>> = ({ signal }) =>
    apiLogisticsV1ShipmentsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiLogisticsV1ShipmentsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>
>;
export type ApiLogisticsV1ShipmentsListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiLogisticsV1ShipmentsListSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiLogisticsV1ShipmentsListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsV1ShipmentsListSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiLogisticsV1ShipmentsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiLogisticsV1ShipmentsListSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiLogisticsV1ShipmentsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiLogisticsV1ShipmentsListSuspense<
  TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiLogisticsV1ShipmentsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiLogisticsV1ShipmentsListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generate an upload URL for documents.
 */
export const apiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate = (
  name: string,
  documentPreSignedURLInput: BodyType<DocumentPreSignedURLInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<DocumentPreSignedURLOutput>(
    {
      url: `/api/logistics/v1/shipments/${name}/documents/pre-signed-url/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: documentPreSignedURLInput,
      signal,
    },
    options
  );
};

export const getApiLogisticsV1ShipmentsDocumentsPreSignedUrlCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate>>,
    TError,
    { name: string; data: BodyType<DocumentPreSignedURLInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate>>,
  TError,
  { name: string; data: BodyType<DocumentPreSignedURLInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate>>,
    { name: string; data: BodyType<DocumentPreSignedURLInput> }
  > = (props) => {
    const { name, data } = props ?? {};

    return apiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate(name, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiLogisticsV1ShipmentsDocumentsPreSignedUrlCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate>>
>;
export type ApiLogisticsV1ShipmentsDocumentsPreSignedUrlCreateMutationBody = BodyType<DocumentPreSignedURLInput>;
export type ApiLogisticsV1ShipmentsDocumentsPreSignedUrlCreateMutationError = ErrorType<ErrorResponse>;

export const useApiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate>>,
    TError,
    { name: string; data: BodyType<DocumentPreSignedURLInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate>>,
  TError,
  { name: string; data: BodyType<DocumentPreSignedURLInput> },
  TContext
> => {
  const mutationOptions = getApiLogisticsV1ShipmentsDocumentsPreSignedUrlCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiLogisticsV1ShipmentsDocumentsUploadCreate = (
  name: string,
  documentUpload: BodyType<DocumentUpload>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/logistics/v1/shipments/${name}/documents/upload/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: documentUpload,
      signal,
    },
    options
  );
};

export const getApiLogisticsV1ShipmentsDocumentsUploadCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsUploadCreate>>,
    TError,
    { name: string; data: BodyType<DocumentUpload> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsUploadCreate>>,
  TError,
  { name: string; data: BodyType<DocumentUpload> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsUploadCreate>>,
    { name: string; data: BodyType<DocumentUpload> }
  > = (props) => {
    const { name, data } = props ?? {};

    return apiLogisticsV1ShipmentsDocumentsUploadCreate(name, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiLogisticsV1ShipmentsDocumentsUploadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsUploadCreate>>
>;
export type ApiLogisticsV1ShipmentsDocumentsUploadCreateMutationBody = BodyType<DocumentUpload>;
export type ApiLogisticsV1ShipmentsDocumentsUploadCreateMutationError = ErrorType<ErrorResponse>;

export const useApiLogisticsV1ShipmentsDocumentsUploadCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsUploadCreate>>,
    TError,
    { name: string; data: BodyType<DocumentUpload> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsUploadCreate>>,
  TError,
  { name: string; data: BodyType<DocumentUpload> },
  TContext
> => {
  const mutationOptions = getApiLogisticsV1ShipmentsDocumentsUploadCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiMarketingMediaV1SiteMaterialBulkCreateCreate = (
  siteMaterialId: number,
  marketingMediaBulkCreateRequest: BodyType<MarketingMediaBulkCreateRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    {
      url: `/api/marketing-media/v1/site-material/${siteMaterialId}/bulk-create/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: marketingMediaBulkCreateRequest,
      signal,
    },
    options
  );
};

export const getApiMarketingMediaV1SiteMaterialBulkCreateCreateMutationOptions = <
  TError = ErrorType<ApiMarketingMediaV1SiteMaterialBulkCreateCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMarketingMediaV1SiteMaterialBulkCreateCreate>>,
    TError,
    { siteMaterialId: number; data: BodyType<MarketingMediaBulkCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiMarketingMediaV1SiteMaterialBulkCreateCreate>>,
  TError,
  { siteMaterialId: number; data: BodyType<MarketingMediaBulkCreateRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiMarketingMediaV1SiteMaterialBulkCreateCreate>>,
    { siteMaterialId: number; data: BodyType<MarketingMediaBulkCreateRequest> }
  > = (props) => {
    const { siteMaterialId, data } = props ?? {};

    return apiMarketingMediaV1SiteMaterialBulkCreateCreate(siteMaterialId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiMarketingMediaV1SiteMaterialBulkCreateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiMarketingMediaV1SiteMaterialBulkCreateCreate>>
>;
export type ApiMarketingMediaV1SiteMaterialBulkCreateCreateMutationBody = BodyType<MarketingMediaBulkCreateRequest>;
export type ApiMarketingMediaV1SiteMaterialBulkCreateCreateMutationError = ErrorType<
  ApiMarketingMediaV1SiteMaterialBulkCreateCreate400 | ErrorResponse
>;

export const useApiMarketingMediaV1SiteMaterialBulkCreateCreate = <
  TError = ErrorType<ApiMarketingMediaV1SiteMaterialBulkCreateCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMarketingMediaV1SiteMaterialBulkCreateCreate>>,
    TError,
    { siteMaterialId: number; data: BodyType<MarketingMediaBulkCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiMarketingMediaV1SiteMaterialBulkCreateCreate>>,
  TError,
  { siteMaterialId: number; data: BodyType<MarketingMediaBulkCreateRequest> },
  TContext
> => {
  const mutationOptions = getApiMarketingMediaV1SiteMaterialBulkCreateCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiMaterialsV1AllowedMaterialSpecsList = (
  params?: ApiMaterialsV1AllowedMaterialSpecsListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedAllowedMaterialSpecList>(
    { url: `/api/materials/v1/allowed-material-specs/`, method: 'GET', params, signal },
    options
  );
};

export const getApiMaterialsV1AllowedMaterialSpecsListQueryKey = (
  params?: ApiMaterialsV1AllowedMaterialSpecsListParams
) => {
  return [`/api/materials/v1/allowed-material-specs/`, ...(params ? [params] : [])] as const;
};

export const getApiMaterialsV1AllowedMaterialSpecsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1AllowedMaterialSpecsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1AllowedMaterialSpecsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>> = ({ signal }) =>
    apiMaterialsV1AllowedMaterialSpecsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1AllowedMaterialSpecsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>
>;
export type ApiMaterialsV1AllowedMaterialSpecsListQueryError = ErrorType<unknown>;

export function useApiMaterialsV1AllowedMaterialSpecsList<
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiMaterialsV1AllowedMaterialSpecsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1AllowedMaterialSpecsList<
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1AllowedMaterialSpecsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1AllowedMaterialSpecsList<
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1AllowedMaterialSpecsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1AllowedMaterialSpecsList<
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1AllowedMaterialSpecsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1AllowedMaterialSpecsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiMaterialsV1AllowedMaterialSpecsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1AllowedMaterialSpecsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1AllowedMaterialSpecsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>> = ({ signal }) =>
    apiMaterialsV1AllowedMaterialSpecsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1AllowedMaterialSpecsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>
>;
export type ApiMaterialsV1AllowedMaterialSpecsListSuspenseQueryError = ErrorType<unknown>;

export function useApiMaterialsV1AllowedMaterialSpecsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiMaterialsV1AllowedMaterialSpecsListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1AllowedMaterialSpecsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1AllowedMaterialSpecsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1AllowedMaterialSpecsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1AllowedMaterialSpecsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1AllowedMaterialSpecsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1AllowedMaterialSpecsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1AllowedMaterialSpecsListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiMaterialsV1AllowedMaterialSpecsRetrieve = (
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AllowedMaterialSpec>(
    { url: `/api/materials/v1/allowed-material-specs/${id}/`, method: 'GET', signal },
    options
  );
};

export const getApiMaterialsV1AllowedMaterialSpecsRetrieveQueryKey = (id: number) => {
  return [`/api/materials/v1/allowed-material-specs/${id}/`] as const;
};

export const getApiMaterialsV1AllowedMaterialSpecsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1AllowedMaterialSpecsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>> = ({ signal }) =>
    apiMaterialsV1AllowedMaterialSpecsRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1AllowedMaterialSpecsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>
>;
export type ApiMaterialsV1AllowedMaterialSpecsRetrieveQueryError = ErrorType<unknown>;

export function useApiMaterialsV1AllowedMaterialSpecsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1AllowedMaterialSpecsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1AllowedMaterialSpecsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1AllowedMaterialSpecsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1AllowedMaterialSpecsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiMaterialsV1AllowedMaterialSpecsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1AllowedMaterialSpecsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>> = ({ signal }) =>
    apiMaterialsV1AllowedMaterialSpecsRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1AllowedMaterialSpecsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>
>;
export type ApiMaterialsV1AllowedMaterialSpecsRetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiMaterialsV1AllowedMaterialSpecsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1AllowedMaterialSpecsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1AllowedMaterialSpecsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1AllowedMaterialSpecsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1AllowedMaterialSpecsRetrieveSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiMaterialsV1MaterialColoursRetrieve = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<MaterialColourList>(
    { url: `/api/materials/v1/material-colours/`, method: 'GET', signal },
    options
  );
};

export const getApiMaterialsV1MaterialColoursRetrieveQueryKey = () => {
  return [`/api/materials/v1/material-colours/`] as const;
};

export const getApiMaterialsV1MaterialColoursRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1MaterialColoursRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>> = ({ signal }) =>
    apiMaterialsV1MaterialColoursRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1MaterialColoursRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>
>;
export type ApiMaterialsV1MaterialColoursRetrieveQueryError = ErrorType<unknown>;

export function useApiMaterialsV1MaterialColoursRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialColoursRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialColoursRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1MaterialColoursRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1MaterialColoursRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiMaterialsV1MaterialColoursRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1MaterialColoursRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>> = ({ signal }) =>
    apiMaterialsV1MaterialColoursRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1MaterialColoursRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>
>;
export type ApiMaterialsV1MaterialColoursRetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiMaterialsV1MaterialColoursRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialColoursRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialColoursRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1MaterialColoursRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1MaterialColoursRetrieveSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiMaterialsV1MaterialComponentsList = (
  params?: ApiMaterialsV1MaterialComponentsListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleMaterialComponent[]>(
    { url: `/api/materials/v1/material-components/`, method: 'GET', params, signal },
    options
  );
};

export const getApiMaterialsV1MaterialComponentsListQueryKey = (
  params?: ApiMaterialsV1MaterialComponentsListParams
) => {
  return [`/api/materials/v1/material-components/`, ...(params ? [params] : [])] as const;
};

export const getApiMaterialsV1MaterialComponentsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialComponentsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1MaterialComponentsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>> = ({ signal }) =>
    apiMaterialsV1MaterialComponentsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1MaterialComponentsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>
>;
export type ApiMaterialsV1MaterialComponentsListQueryError = ErrorType<unknown>;

export function useApiMaterialsV1MaterialComponentsList<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiMaterialsV1MaterialComponentsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialComponentsList<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialComponentsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialComponentsList<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialComponentsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1MaterialComponentsList<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialComponentsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1MaterialComponentsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiMaterialsV1MaterialComponentsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialComponentsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1MaterialComponentsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>> = ({ signal }) =>
    apiMaterialsV1MaterialComponentsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1MaterialComponentsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>
>;
export type ApiMaterialsV1MaterialComponentsListSuspenseQueryError = ErrorType<unknown>;

export function useApiMaterialsV1MaterialComponentsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiMaterialsV1MaterialComponentsListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialComponentsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialComponentsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialComponentsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialComponentsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1MaterialComponentsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialComponentsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1MaterialComponentsListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiMaterialsV1MaterialFormsRetrieve = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<MaterialFormList>({ url: `/api/materials/v1/material-forms/`, method: 'GET', signal }, options);
};

export const getApiMaterialsV1MaterialFormsRetrieveQueryKey = () => {
  return [`/api/materials/v1/material-forms/`] as const;
};

export const getApiMaterialsV1MaterialFormsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1MaterialFormsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>> = ({ signal }) =>
    apiMaterialsV1MaterialFormsRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1MaterialFormsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>
>;
export type ApiMaterialsV1MaterialFormsRetrieveQueryError = ErrorType<unknown>;

export function useApiMaterialsV1MaterialFormsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialFormsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialFormsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1MaterialFormsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1MaterialFormsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiMaterialsV1MaterialFormsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1MaterialFormsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>> = ({ signal }) =>
    apiMaterialsV1MaterialFormsRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1MaterialFormsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>
>;
export type ApiMaterialsV1MaterialFormsRetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiMaterialsV1MaterialFormsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialFormsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialFormsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1MaterialFormsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1MaterialFormsRetrieveSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiMaterialsV1MaterialGradesRetrieve = (
  params?: ApiMaterialsV1MaterialGradesRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<MaterialGradeList>(
    { url: `/api/materials/v1/material-grades/`, method: 'GET', params, signal },
    options
  );
};

export const getApiMaterialsV1MaterialGradesRetrieveQueryKey = (
  params?: ApiMaterialsV1MaterialGradesRetrieveParams
) => {
  return [`/api/materials/v1/material-grades/`, ...(params ? [params] : [])] as const;
};

export const getApiMaterialsV1MaterialGradesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialGradesRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1MaterialGradesRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>> = ({ signal }) =>
    apiMaterialsV1MaterialGradesRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1MaterialGradesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>
>;
export type ApiMaterialsV1MaterialGradesRetrieveQueryError = ErrorType<unknown>;

export function useApiMaterialsV1MaterialGradesRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiMaterialsV1MaterialGradesRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialGradesRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialGradesRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialGradesRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialGradesRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1MaterialGradesRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialGradesRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1MaterialGradesRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiMaterialsV1MaterialGradesRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialGradesRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1MaterialGradesRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>> = ({ signal }) =>
    apiMaterialsV1MaterialGradesRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1MaterialGradesRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>
>;
export type ApiMaterialsV1MaterialGradesRetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiMaterialsV1MaterialGradesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiMaterialsV1MaterialGradesRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialGradesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialGradesRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialGradesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialGradesRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1MaterialGradesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialGradesRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1MaterialGradesRetrieveSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiMaterialsV1MaterialOriginsRetrieve = (
  params?: ApiMaterialsV1MaterialOriginsRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<MaterialOriginList>(
    { url: `/api/materials/v1/material-origins/`, method: 'GET', params, signal },
    options
  );
};

export const getApiMaterialsV1MaterialOriginsRetrieveQueryKey = (
  params?: ApiMaterialsV1MaterialOriginsRetrieveParams
) => {
  return [`/api/materials/v1/material-origins/`, ...(params ? [params] : [])] as const;
};

export const getApiMaterialsV1MaterialOriginsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiMaterialsV1MaterialOriginsRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1MaterialOriginsRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>> = ({ signal }) =>
    apiMaterialsV1MaterialOriginsRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1MaterialOriginsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>
>;
export type ApiMaterialsV1MaterialOriginsRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiMaterialsV1MaterialOriginsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiMaterialsV1MaterialOriginsRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialOriginsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiMaterialsV1MaterialOriginsRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialOriginsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiMaterialsV1MaterialOriginsRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1MaterialOriginsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiMaterialsV1MaterialOriginsRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1MaterialOriginsRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiMaterialsV1MaterialOriginsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiMaterialsV1MaterialOriginsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1MaterialOriginsRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>> = ({ signal }) =>
    apiMaterialsV1MaterialOriginsRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1MaterialOriginsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>
>;
export type ApiMaterialsV1MaterialOriginsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiMaterialsV1MaterialOriginsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiMaterialsV1MaterialOriginsRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialOriginsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiMaterialsV1MaterialOriginsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialOriginsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiMaterialsV1MaterialOriginsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1MaterialOriginsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiMaterialsV1MaterialOriginsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1MaterialOriginsRetrieveSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiMaterialV1MaterialProductsList = (
  params?: ApiMaterialV1MaterialProductsListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedMaterialProductInfoListItemList>(
    { url: `/api/materials/v1/material-products/`, method: 'GET', params, signal },
    options
  );
};

export const getApiMaterialV1MaterialProductsListQueryKey = (params?: ApiMaterialV1MaterialProductsListParams) => {
  return [`/api/materials/v1/material-products/`, ...(params ? [params] : [])] as const;
};

export const getApiMaterialV1MaterialProductsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiMaterialV1MaterialProductsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialV1MaterialProductsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>> = ({ signal }) =>
    apiMaterialV1MaterialProductsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialV1MaterialProductsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>
>;
export type ApiMaterialV1MaterialProductsListQueryError = ErrorType<ErrorResponse>;

export function useApiMaterialV1MaterialProductsList<
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiMaterialV1MaterialProductsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialV1MaterialProductsList<
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiMaterialV1MaterialProductsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialV1MaterialProductsList<
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiMaterialV1MaterialProductsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialV1MaterialProductsList<
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiMaterialV1MaterialProductsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialV1MaterialProductsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiMaterialV1MaterialProductsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiMaterialV1MaterialProductsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialV1MaterialProductsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>> = ({ signal }) =>
    apiMaterialV1MaterialProductsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialV1MaterialProductsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>
>;
export type ApiMaterialV1MaterialProductsListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiMaterialV1MaterialProductsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiMaterialV1MaterialProductsListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialV1MaterialProductsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiMaterialV1MaterialProductsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialV1MaterialProductsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiMaterialV1MaterialProductsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialV1MaterialProductsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiMaterialV1MaterialProductsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialV1MaterialProductsListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiMaterialsV1MaterialProductsCreate = (
  createMaterialProductDTO: BodyType<CreateMaterialProductDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CreateMaterialProductOutput>(
    {
      url: `/api/materials/v1/material-products/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createMaterialProductDTO,
      signal,
    },
    options
  );
};

export const getApiMaterialsV1MaterialProductsCreateMutationOptions = <
  TError = ErrorType<ApiMaterialsV1MaterialProductsCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsCreate>>,
    TError,
    { data: BodyType<CreateMaterialProductDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsCreate>>,
  TError,
  { data: BodyType<CreateMaterialProductDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsCreate>>,
    { data: BodyType<CreateMaterialProductDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return apiMaterialsV1MaterialProductsCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiMaterialsV1MaterialProductsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsCreate>>
>;
export type ApiMaterialsV1MaterialProductsCreateMutationBody = BodyType<CreateMaterialProductDTO>;
export type ApiMaterialsV1MaterialProductsCreateMutationError = ErrorType<
  ApiMaterialsV1MaterialProductsCreate400 | ErrorResponse
>;

export const useApiMaterialsV1MaterialProductsCreate = <
  TError = ErrorType<ApiMaterialsV1MaterialProductsCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsCreate>>,
    TError,
    { data: BodyType<CreateMaterialProductDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsCreate>>,
  TError,
  { data: BodyType<CreateMaterialProductDTO> },
  TContext
> => {
  const mutationOptions = getApiMaterialsV1MaterialProductsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiMaterialV1MaterialProductsDetail = (
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<MaterialProductInfoDetails>(
    { url: `/api/materials/v1/material-products/${id}/`, method: 'GET', signal },
    options
  );
};

export const getApiMaterialV1MaterialProductsDetailQueryKey = (id: number) => {
  return [`/api/materials/v1/material-products/${id}/`] as const;
};

export const getApiMaterialV1MaterialProductsDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialV1MaterialProductsDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>> = ({ signal }) =>
    apiMaterialV1MaterialProductsDetail(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialV1MaterialProductsDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>
>;
export type ApiMaterialV1MaterialProductsDetailQueryError = ErrorType<ErrorResponse>;

export function useApiMaterialV1MaterialProductsDetail<
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialV1MaterialProductsDetail<
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialV1MaterialProductsDetail<
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialV1MaterialProductsDetail<
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialV1MaterialProductsDetailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiMaterialV1MaterialProductsDetailSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialV1MaterialProductsDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>> = ({ signal }) =>
    apiMaterialV1MaterialProductsDetail(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialV1MaterialProductsDetailSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>
>;
export type ApiMaterialV1MaterialProductsDetailSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiMaterialV1MaterialProductsDetailSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialV1MaterialProductsDetailSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialV1MaterialProductsDetailSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialV1MaterialProductsDetailSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialV1MaterialProductsDetailSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiMaterialsV1MaterialProductsUpdate = (
  id: number,
  updateMaterialProductDTO: BodyType<UpdateMaterialProductDTO>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<UpdateMaterialProductOutput>(
    {
      url: `/api/materials/v1/material-products/${id}/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateMaterialProductDTO,
    },
    options
  );
};

export const getApiMaterialsV1MaterialProductsUpdateMutationOptions = <
  TError = ErrorType<ApiMaterialsV1MaterialProductsUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsUpdate>>,
    TError,
    { id: number; data: BodyType<UpdateMaterialProductDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsUpdate>>,
  TError,
  { id: number; data: BodyType<UpdateMaterialProductDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsUpdate>>,
    { id: number; data: BodyType<UpdateMaterialProductDTO> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiMaterialsV1MaterialProductsUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiMaterialsV1MaterialProductsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsUpdate>>
>;
export type ApiMaterialsV1MaterialProductsUpdateMutationBody = BodyType<UpdateMaterialProductDTO>;
export type ApiMaterialsV1MaterialProductsUpdateMutationError = ErrorType<
  ApiMaterialsV1MaterialProductsUpdate400 | ErrorResponse
>;

export const useApiMaterialsV1MaterialProductsUpdate = <
  TError = ErrorType<ApiMaterialsV1MaterialProductsUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsUpdate>>,
    TError,
    { id: number; data: BodyType<UpdateMaterialProductDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsUpdate>>,
  TError,
  { id: number; data: BodyType<UpdateMaterialProductDTO> },
  TContext
> => {
  const mutationOptions = getApiMaterialsV1MaterialProductsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiMaterialV1MaterialProductsDelete = (id: number, options?: SecondParameter<typeof customAxios>) => {
  return customAxios<void>({ url: `/api/materials/v1/material-products/${id}/`, method: 'DELETE' }, options);
};

export const getApiMaterialV1MaterialProductsDeleteMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDelete>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDelete>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDelete>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return apiMaterialV1MaterialProductsDelete(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiMaterialV1MaterialProductsDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDelete>>
>;

export type ApiMaterialV1MaterialProductsDeleteMutationError = ErrorType<ErrorResponse>;

export const useApiMaterialV1MaterialProductsDelete = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDelete>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDelete>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getApiMaterialV1MaterialProductsDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiMaterialsV1MaterialRegionsRetrieve = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<MaterialRegionList>(
    { url: `/api/materials/v1/material-regions/`, method: 'GET', signal },
    options
  );
};

export const getApiMaterialsV1MaterialRegionsRetrieveQueryKey = () => {
  return [`/api/materials/v1/material-regions/`] as const;
};

export const getApiMaterialsV1MaterialRegionsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1MaterialRegionsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>> = ({ signal }) =>
    apiMaterialsV1MaterialRegionsRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1MaterialRegionsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>
>;
export type ApiMaterialsV1MaterialRegionsRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiMaterialsV1MaterialRegionsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialRegionsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialRegionsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1MaterialRegionsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1MaterialRegionsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiMaterialsV1MaterialRegionsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1MaterialRegionsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>> = ({ signal }) =>
    apiMaterialsV1MaterialRegionsRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1MaterialRegionsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>
>;
export type ApiMaterialsV1MaterialRegionsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiMaterialsV1MaterialRegionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialRegionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialRegionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1MaterialRegionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1MaterialRegionsRetrieveSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiMaterialsV1MaterialsList = (
  params?: ApiMaterialsV1MaterialsListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedMaterialList>(
    { url: `/api/materials/v1/materials/`, method: 'GET', params, signal },
    options
  );
};

export const getApiMaterialsV1MaterialsListQueryKey = (params?: ApiMaterialsV1MaterialsListParams) => {
  return [`/api/materials/v1/materials/`, ...(params ? [params] : [])] as const;
};

export const getApiMaterialsV1MaterialsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1MaterialsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>> = ({ signal }) =>
    apiMaterialsV1MaterialsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1MaterialsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>
>;
export type ApiMaterialsV1MaterialsListQueryError = ErrorType<unknown>;

export function useApiMaterialsV1MaterialsList<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiMaterialsV1MaterialsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialsList<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialsList<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1MaterialsList<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1MaterialsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiMaterialsV1MaterialsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1MaterialsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>> = ({ signal }) =>
    apiMaterialsV1MaterialsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1MaterialsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>
>;
export type ApiMaterialsV1MaterialsListSuspenseQueryError = ErrorType<unknown>;

export function useApiMaterialsV1MaterialsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiMaterialsV1MaterialsListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1MaterialsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiMaterialsV1MaterialsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1MaterialsListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiMaterialsV1MaterialsSupportedComponentsList = (
  materialId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<FullMaterialSupportedComponent[]>(
    { url: `/api/materials/v1/materials/${materialId}/supported-components/`, method: 'GET', signal },
    options
  );
};

export const getApiMaterialsV1MaterialsSupportedComponentsListQueryKey = (materialId: number) => {
  return [`/api/materials/v1/materials/${materialId}/supported-components/`] as const;
};

export const getApiMaterialsV1MaterialsSupportedComponentsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>,
  TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsList400 | ErrorResponse>,
>(
  materialId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1MaterialsSupportedComponentsListQueryKey(materialId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>> = ({
    signal,
  }) => apiMaterialsV1MaterialsSupportedComponentsList(materialId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!materialId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1MaterialsSupportedComponentsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>
>;
export type ApiMaterialsV1MaterialsSupportedComponentsListQueryError = ErrorType<
  ApiMaterialsV1MaterialsSupportedComponentsList400 | ErrorResponse
>;

export function useApiMaterialsV1MaterialsSupportedComponentsList<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>,
  TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsList400 | ErrorResponse>,
>(
  materialId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialsSupportedComponentsList<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>,
  TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsList400 | ErrorResponse>,
>(
  materialId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialsSupportedComponentsList<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>,
  TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsList400 | ErrorResponse>,
>(
  materialId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1MaterialsSupportedComponentsList<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>,
  TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsList400 | ErrorResponse>,
>(
  materialId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1MaterialsSupportedComponentsListQueryOptions(materialId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiMaterialsV1MaterialsSupportedComponentsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>,
  TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsList400 | ErrorResponse>,
>(
  materialId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1MaterialsSupportedComponentsListQueryKey(materialId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>> = ({
    signal,
  }) => apiMaterialsV1MaterialsSupportedComponentsList(materialId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1MaterialsSupportedComponentsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>
>;
export type ApiMaterialsV1MaterialsSupportedComponentsListSuspenseQueryError = ErrorType<
  ApiMaterialsV1MaterialsSupportedComponentsList400 | ErrorResponse
>;

export function useApiMaterialsV1MaterialsSupportedComponentsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>,
  TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsList400 | ErrorResponse>,
>(
  materialId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialsSupportedComponentsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>,
  TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsList400 | ErrorResponse>,
>(
  materialId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialsSupportedComponentsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>,
  TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsList400 | ErrorResponse>,
>(
  materialId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1MaterialsSupportedComponentsListSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>,
  TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsList400 | ErrorResponse>,
>(
  materialId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1MaterialsSupportedComponentsListSuspenseQueryOptions(materialId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiMaterialsV1MaterialsRetrieve = (
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Material>({ url: `/api/materials/v1/materials/${id}/`, method: 'GET', signal }, options);
};

export const getApiMaterialsV1MaterialsRetrieveQueryKey = (id: number) => {
  return [`/api/materials/v1/materials/${id}/`] as const;
};

export const getApiMaterialsV1MaterialsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1MaterialsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>> = ({ signal }) =>
    apiMaterialsV1MaterialsRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1MaterialsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>
>;
export type ApiMaterialsV1MaterialsRetrieveQueryError = ErrorType<unknown>;

export function useApiMaterialsV1MaterialsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1MaterialsRetrieve<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1MaterialsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiMaterialsV1MaterialsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMaterialsV1MaterialsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>> = ({ signal }) =>
    apiMaterialsV1MaterialsRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiMaterialsV1MaterialsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>
>;
export type ApiMaterialsV1MaterialsRetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiMaterialsV1MaterialsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiMaterialsV1MaterialsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiMaterialsV1MaterialsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiMaterialsV1MaterialsRetrieveSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiV1Omnisearch = (
  params: ApiV1OmnisearchParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<OmnisearchResponse>({ url: `/api/omnisearch/v1/`, method: 'GET', params, signal }, options);
};

export const getApiV1OmnisearchQueryKey = (params: ApiV1OmnisearchParams) => {
  return [`/api/omnisearch/v1/`, ...(params ? [params] : [])] as const;
};

export const getApiV1OmnisearchQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV1Omnisearch>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: ApiV1OmnisearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiV1OmnisearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiV1Omnisearch>>> = ({ signal }) =>
    apiV1Omnisearch(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV1Omnisearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiV1OmnisearchQueryResult = NonNullable<Awaited<ReturnType<typeof apiV1Omnisearch>>>;
export type ApiV1OmnisearchQueryError = ErrorType<ErrorResponse>;

export function useApiV1Omnisearch<
  TData = Awaited<ReturnType<typeof apiV1Omnisearch>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: ApiV1OmnisearchParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiV1Omnisearch<
  TData = Awaited<ReturnType<typeof apiV1Omnisearch>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: ApiV1OmnisearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiV1Omnisearch<
  TData = Awaited<ReturnType<typeof apiV1Omnisearch>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: ApiV1OmnisearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiV1Omnisearch<
  TData = Awaited<ReturnType<typeof apiV1Omnisearch>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: ApiV1OmnisearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiV1OmnisearchQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiV1OmnisearchSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV1Omnisearch>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: ApiV1OmnisearchParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiV1OmnisearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiV1Omnisearch>>> = ({ signal }) =>
    apiV1Omnisearch(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiV1Omnisearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiV1OmnisearchSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiV1Omnisearch>>>;
export type ApiV1OmnisearchSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiV1OmnisearchSuspense<
  TData = Awaited<ReturnType<typeof apiV1Omnisearch>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: ApiV1OmnisearchParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiV1OmnisearchSuspense<
  TData = Awaited<ReturnType<typeof apiV1Omnisearch>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: ApiV1OmnisearchParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiV1OmnisearchSuspense<
  TData = Awaited<ReturnType<typeof apiV1Omnisearch>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: ApiV1OmnisearchParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiV1OmnisearchSuspense<
  TData = Awaited<ReturnType<typeof apiV1Omnisearch>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: ApiV1OmnisearchParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiV1OmnisearchSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const purchaseOrdersList = (
  params?: PurchaseOrdersListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<FullPurchaseOrderInfo>(
    { url: `/api/orders/v1/purchase-orders/`, method: 'GET', params, signal },
    options
  );
};

export const getPurchaseOrdersListQueryKey = (params?: PurchaseOrdersListParams) => {
  return [`/api/orders/v1/purchase-orders/`, ...(params ? [params] : [])] as const;
};

export const getPurchaseOrdersListQueryOptions = <
  TData = Awaited<ReturnType<typeof purchaseOrdersList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: PurchaseOrdersListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPurchaseOrdersListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersList>>> = ({ signal }) =>
    purchaseOrdersList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof purchaseOrdersList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PurchaseOrdersListQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersList>>>;
export type PurchaseOrdersListQueryError = ErrorType<ErrorResponse>;

export function usePurchaseOrdersList<
  TData = Awaited<ReturnType<typeof purchaseOrdersList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | PurchaseOrdersListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePurchaseOrdersList<
  TData = Awaited<ReturnType<typeof purchaseOrdersList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: PurchaseOrdersListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePurchaseOrdersList<
  TData = Awaited<ReturnType<typeof purchaseOrdersList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: PurchaseOrdersListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function usePurchaseOrdersList<
  TData = Awaited<ReturnType<typeof purchaseOrdersList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: PurchaseOrdersListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPurchaseOrdersListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPurchaseOrdersListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof purchaseOrdersList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: PurchaseOrdersListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPurchaseOrdersListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersList>>> = ({ signal }) =>
    purchaseOrdersList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof purchaseOrdersList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PurchaseOrdersListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersList>>>;
export type PurchaseOrdersListSuspenseQueryError = ErrorType<ErrorResponse>;

export function usePurchaseOrdersListSuspense<
  TData = Awaited<ReturnType<typeof purchaseOrdersList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | PurchaseOrdersListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePurchaseOrdersListSuspense<
  TData = Awaited<ReturnType<typeof purchaseOrdersList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: PurchaseOrdersListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePurchaseOrdersListSuspense<
  TData = Awaited<ReturnType<typeof purchaseOrdersList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: PurchaseOrdersListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function usePurchaseOrdersListSuspense<
  TData = Awaited<ReturnType<typeof purchaseOrdersList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: PurchaseOrdersListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPurchaseOrdersListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiOrdersV1PurchaseOrdersCreate = (
  createPurchaseOrderDTO: BodyType<CreatePurchaseOrderDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<FullPurchaseOrderInfo>(
    {
      url: `/api/orders/v1/purchase-orders/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createPurchaseOrderDTO,
      signal,
    },
    options
  );
};

export const getApiOrdersV1PurchaseOrdersCreateMutationOptions = <
  TError = ErrorType<ApiOrdersV1PurchaseOrdersCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersCreate>>,
    TError,
    { data: BodyType<CreatePurchaseOrderDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersCreate>>,
  TError,
  { data: BodyType<CreatePurchaseOrderDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersCreate>>,
    { data: BodyType<CreatePurchaseOrderDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return apiOrdersV1PurchaseOrdersCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiOrdersV1PurchaseOrdersCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersCreate>>
>;
export type ApiOrdersV1PurchaseOrdersCreateMutationBody = BodyType<CreatePurchaseOrderDTO>;
export type ApiOrdersV1PurchaseOrdersCreateMutationError = ErrorType<
  ApiOrdersV1PurchaseOrdersCreate400 | ErrorResponse
>;

export const useApiOrdersV1PurchaseOrdersCreate = <
  TError = ErrorType<ApiOrdersV1PurchaseOrdersCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersCreate>>,
    TError,
    { data: BodyType<CreatePurchaseOrderDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersCreate>>,
  TError,
  { data: BodyType<CreatePurchaseOrderDTO> },
  TContext
> => {
  const mutationOptions = getApiOrdersV1PurchaseOrdersCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiOrdersV1PurchaseOrdersRetrieve = (
  slug: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<FullPurchaseOrderInfo>(
    { url: `/api/orders/v1/purchase-orders/${slug}/`, method: 'GET', signal },
    options
  );
};

export const getApiOrdersV1PurchaseOrdersRetrieveQueryKey = (slug: string) => {
  return [`/api/orders/v1/purchase-orders/${slug}/`] as const;
};

export const getApiOrdersV1PurchaseOrdersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiOrdersV1PurchaseOrdersRetrieveQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>> = ({ signal }) =>
    apiOrdersV1PurchaseOrdersRetrieve(slug, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiOrdersV1PurchaseOrdersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>
>;
export type ApiOrdersV1PurchaseOrdersRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiOrdersV1PurchaseOrdersRetrieve<
  TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiOrdersV1PurchaseOrdersRetrieve<
  TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiOrdersV1PurchaseOrdersRetrieve<
  TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiOrdersV1PurchaseOrdersRetrieve<
  TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiOrdersV1PurchaseOrdersRetrieveQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiOrdersV1PurchaseOrdersRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiOrdersV1PurchaseOrdersRetrieveQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>> = ({ signal }) =>
    apiOrdersV1PurchaseOrdersRetrieve(slug, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiOrdersV1PurchaseOrdersRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>
>;
export type ApiOrdersV1PurchaseOrdersRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiOrdersV1PurchaseOrdersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiOrdersV1PurchaseOrdersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiOrdersV1PurchaseOrdersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiOrdersV1PurchaseOrdersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiOrdersV1PurchaseOrdersRetrieveSuspenseQueryOptions(slug, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiOrdersV1PurchaseOrdersApproveCreate = (
  slug: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    { url: `/api/orders/v1/purchase-orders/${slug}/approve/`, method: 'POST', signal },
    options
  );
};

export const getApiOrdersV1PurchaseOrdersApproveCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersApproveCreate>>,
    TError,
    { slug: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersApproveCreate>>,
  TError,
  { slug: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersApproveCreate>>,
    { slug: string }
  > = (props) => {
    const { slug } = props ?? {};

    return apiOrdersV1PurchaseOrdersApproveCreate(slug, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiOrdersV1PurchaseOrdersApproveCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersApproveCreate>>
>;

export type ApiOrdersV1PurchaseOrdersApproveCreateMutationError = ErrorType<unknown>;

export const useApiOrdersV1PurchaseOrdersApproveCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersApproveCreate>>,
    TError,
    { slug: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersApproveCreate>>,
  TError,
  { slug: string },
  TContext
> => {
  const mutationOptions = getApiOrdersV1PurchaseOrdersApproveCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Generate an upload URL for documents.
 */
export const apiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate = (
  slug: string,
  documentPreSignedURLInput: BodyType<DocumentPreSignedURLInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<DocumentPreSignedURLOutput>(
    {
      url: `/api/orders/v1/purchase-orders/${slug}/documents/pre-signed-url/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: documentPreSignedURLInput,
      signal,
    },
    options
  );
};

export const getApiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate>>,
    TError,
    { slug: string; data: BodyType<DocumentPreSignedURLInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate>>,
  TError,
  { slug: string; data: BodyType<DocumentPreSignedURLInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate>>,
    { slug: string; data: BodyType<DocumentPreSignedURLInput> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return apiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate>>
>;
export type ApiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreateMutationBody = BodyType<DocumentPreSignedURLInput>;
export type ApiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreateMutationError = ErrorType<ErrorResponse>;

export const useApiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate>>,
    TError,
    { slug: string; data: BodyType<DocumentPreSignedURLInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate>>,
  TError,
  { slug: string; data: BodyType<DocumentPreSignedURLInput> },
  TContext
> => {
  const mutationOptions = getApiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiOrdersV1PurchaseOrdersDocumentsUploadCreate = (
  slug: string,
  documentUpload: BodyType<DocumentUpload>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/orders/v1/purchase-orders/${slug}/documents/upload/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: documentUpload,
      signal,
    },
    options
  );
};

export const getApiOrdersV1PurchaseOrdersDocumentsUploadCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsUploadCreate>>,
    TError,
    { slug: string; data: BodyType<DocumentUpload> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsUploadCreate>>,
  TError,
  { slug: string; data: BodyType<DocumentUpload> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsUploadCreate>>,
    { slug: string; data: BodyType<DocumentUpload> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return apiOrdersV1PurchaseOrdersDocumentsUploadCreate(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiOrdersV1PurchaseOrdersDocumentsUploadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsUploadCreate>>
>;
export type ApiOrdersV1PurchaseOrdersDocumentsUploadCreateMutationBody = BodyType<DocumentUpload>;
export type ApiOrdersV1PurchaseOrdersDocumentsUploadCreateMutationError = ErrorType<ErrorResponse>;

export const useApiOrdersV1PurchaseOrdersDocumentsUploadCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsUploadCreate>>,
    TError,
    { slug: string; data: BodyType<DocumentUpload> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsUploadCreate>>,
  TError,
  { slug: string; data: BodyType<DocumentUpload> },
  TContext
> => {
  const mutationOptions = getApiOrdersV1PurchaseOrdersDocumentsUploadCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiOrdersV1PurchaseOrdersRejectCreate = (
  slug: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    { url: `/api/orders/v1/purchase-orders/${slug}/reject/`, method: 'POST', signal },
    options
  );
};

export const getApiOrdersV1PurchaseOrdersRejectCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRejectCreate>>,
    TError,
    { slug: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRejectCreate>>,
  TError,
  { slug: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRejectCreate>>,
    { slug: string }
  > = (props) => {
    const { slug } = props ?? {};

    return apiOrdersV1PurchaseOrdersRejectCreate(slug, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiOrdersV1PurchaseOrdersRejectCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRejectCreate>>
>;

export type ApiOrdersV1PurchaseOrdersRejectCreateMutationError = ErrorType<unknown>;

export const useApiOrdersV1PurchaseOrdersRejectCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRejectCreate>>,
    TError,
    { slug: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRejectCreate>>,
  TError,
  { slug: string },
  TContext
> => {
  const mutationOptions = getApiOrdersV1PurchaseOrdersRejectCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiOrdersV1PurchaseOrdersUpdatePartialUpdate = (
  slug: string,
  patchedUpdatePurchaseOrderDTO: BodyType<PatchedUpdatePurchaseOrderDTO>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<FullPurchaseOrderInfo>(
    {
      url: `/api/orders/v1/purchase-orders/${slug}/update/`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchedUpdatePurchaseOrderDTO,
    },
    options
  );
};

export const getApiOrdersV1PurchaseOrdersUpdatePartialUpdateMutationOptions = <
  TError = ErrorType<ApiOrdersV1PurchaseOrdersUpdatePartialUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersUpdatePartialUpdate>>,
    TError,
    { slug: string; data: BodyType<PatchedUpdatePurchaseOrderDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersUpdatePartialUpdate>>,
  TError,
  { slug: string; data: BodyType<PatchedUpdatePurchaseOrderDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersUpdatePartialUpdate>>,
    { slug: string; data: BodyType<PatchedUpdatePurchaseOrderDTO> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return apiOrdersV1PurchaseOrdersUpdatePartialUpdate(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiOrdersV1PurchaseOrdersUpdatePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersUpdatePartialUpdate>>
>;
export type ApiOrdersV1PurchaseOrdersUpdatePartialUpdateMutationBody = BodyType<PatchedUpdatePurchaseOrderDTO>;
export type ApiOrdersV1PurchaseOrdersUpdatePartialUpdateMutationError = ErrorType<
  ApiOrdersV1PurchaseOrdersUpdatePartialUpdate400 | ErrorResponse
>;

export const useApiOrdersV1PurchaseOrdersUpdatePartialUpdate = <
  TError = ErrorType<ApiOrdersV1PurchaseOrdersUpdatePartialUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersUpdatePartialUpdate>>,
    TError,
    { slug: string; data: BodyType<PatchedUpdatePurchaseOrderDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersUpdatePartialUpdate>>,
  TError,
  { slug: string; data: BodyType<PatchedUpdatePurchaseOrderDTO> },
  TContext
> => {
  const mutationOptions = getApiOrdersV1PurchaseOrdersUpdatePartialUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const salesOrderList = (
  params?: SalesOrderListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<FullSalesOrderInfo>(
    { url: `/api/orders/v1/sales-orders/`, method: 'GET', params, signal },
    options
  );
};

export const getSalesOrderListQueryKey = (params?: SalesOrderListParams) => {
  return [`/api/orders/v1/sales-orders/`, ...(params ? [params] : [])] as const;
};

export const getSalesOrderListQueryOptions = <
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: SalesOrderListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSalesOrderListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderList>>> = ({ signal }) =>
    salesOrderList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof salesOrderList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SalesOrderListQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderList>>>;
export type SalesOrderListQueryError = ErrorType<ErrorResponse>;

export function useSalesOrderList<
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | SalesOrderListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSalesOrderList<
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: SalesOrderListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSalesOrderList<
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: SalesOrderListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useSalesOrderList<
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: SalesOrderListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSalesOrderListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSalesOrderListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: SalesOrderListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSalesOrderListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderList>>> = ({ signal }) =>
    salesOrderList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof salesOrderList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SalesOrderListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderList>>>;
export type SalesOrderListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useSalesOrderListSuspense<
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | SalesOrderListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSalesOrderListSuspense<
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: SalesOrderListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSalesOrderListSuspense<
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: SalesOrderListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useSalesOrderListSuspense<
  TData = Awaited<ReturnType<typeof salesOrderList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: SalesOrderListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSalesOrderListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiOrdersV1SalesOrdersCreate = (
  createSalesOrderDTO: BodyType<CreateSalesOrderDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<FullSalesOrderInfo>(
    {
      url: `/api/orders/v1/sales-orders/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createSalesOrderDTO,
      signal,
    },
    options
  );
};

export const getApiOrdersV1SalesOrdersCreateMutationOptions = <
  TError = ErrorType<ApiOrdersV1SalesOrdersCreate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCreate>>,
    TError,
    { data: BodyType<CreateSalesOrderDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCreate>>,
  TError,
  { data: BodyType<CreateSalesOrderDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCreate>>,
    { data: BodyType<CreateSalesOrderDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return apiOrdersV1SalesOrdersCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiOrdersV1SalesOrdersCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCreate>>
>;
export type ApiOrdersV1SalesOrdersCreateMutationBody = BodyType<CreateSalesOrderDTO>;
export type ApiOrdersV1SalesOrdersCreateMutationError = ErrorType<ApiOrdersV1SalesOrdersCreate400>;

export const useApiOrdersV1SalesOrdersCreate = <
  TError = ErrorType<ApiOrdersV1SalesOrdersCreate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCreate>>,
    TError,
    { data: BodyType<CreateSalesOrderDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCreate>>,
  TError,
  { data: BodyType<CreateSalesOrderDTO> },
  TContext
> => {
  const mutationOptions = getApiOrdersV1SalesOrdersCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiOrdersV1SalesOrdersRetrieve = (
  slug: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<FullSalesOrderInfo>(
    { url: `/api/orders/v1/sales-orders/${slug}/`, method: 'GET', signal },
    options
  );
};

export const getApiOrdersV1SalesOrdersRetrieveQueryKey = (slug: string) => {
  return [`/api/orders/v1/sales-orders/${slug}/`] as const;
};

export const getApiOrdersV1SalesOrdersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>,
  TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiOrdersV1SalesOrdersRetrieveQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>> = ({ signal }) =>
    apiOrdersV1SalesOrdersRetrieve(slug, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiOrdersV1SalesOrdersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>
>;
export type ApiOrdersV1SalesOrdersRetrieveQueryError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>;

export function useApiOrdersV1SalesOrdersRetrieve<
  TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>,
  TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>,
>(
  slug: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiOrdersV1SalesOrdersRetrieve<
  TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>,
  TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiOrdersV1SalesOrdersRetrieve<
  TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>,
  TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiOrdersV1SalesOrdersRetrieve<
  TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>,
  TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiOrdersV1SalesOrdersRetrieveQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiOrdersV1SalesOrdersRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>,
  TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiOrdersV1SalesOrdersRetrieveQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>> = ({ signal }) =>
    apiOrdersV1SalesOrdersRetrieve(slug, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiOrdersV1SalesOrdersRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>
>;
export type ApiOrdersV1SalesOrdersRetrieveSuspenseQueryError = ErrorType<
  ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse
>;

export function useApiOrdersV1SalesOrdersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>,
  TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>,
>(
  slug: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiOrdersV1SalesOrdersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>,
  TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiOrdersV1SalesOrdersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>,
  TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiOrdersV1SalesOrdersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>,
  TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiOrdersV1SalesOrdersRetrieveSuspenseQueryOptions(slug, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiOrdersV1SalesOrdersApproveCreate = (
  slug: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    { url: `/api/orders/v1/sales-orders/${slug}/approve/`, method: 'POST', signal },
    options
  );
};

export const getApiOrdersV1SalesOrdersApproveCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersApproveCreate>>,
    TError,
    { slug: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersApproveCreate>>,
  TError,
  { slug: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersApproveCreate>>,
    { slug: string }
  > = (props) => {
    const { slug } = props ?? {};

    return apiOrdersV1SalesOrdersApproveCreate(slug, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiOrdersV1SalesOrdersApproveCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersApproveCreate>>
>;

export type ApiOrdersV1SalesOrdersApproveCreateMutationError = ErrorType<unknown>;

export const useApiOrdersV1SalesOrdersApproveCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersApproveCreate>>,
    TError,
    { slug: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersApproveCreate>>,
  TError,
  { slug: string },
  TContext
> => {
  const mutationOptions = getApiOrdersV1SalesOrdersApproveCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiOrdersV1SalesOrdersCustomerUpdatePartialUpdate = (
  slug: string,
  patchedCustomerUpdateSalesOrderDTO: BodyType<PatchedCustomerUpdateSalesOrderDTO>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<SimpleSalesOrder>(
    {
      url: `/api/orders/v1/sales-orders/${slug}/customer-update/`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchedCustomerUpdateSalesOrderDTO,
    },
    options
  );
};

export const getApiOrdersV1SalesOrdersCustomerUpdatePartialUpdateMutationOptions = <
  TError = ErrorType<ApiOrdersV1SalesOrdersCustomerUpdatePartialUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCustomerUpdatePartialUpdate>>,
    TError,
    { slug: string; data: BodyType<PatchedCustomerUpdateSalesOrderDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCustomerUpdatePartialUpdate>>,
  TError,
  { slug: string; data: BodyType<PatchedCustomerUpdateSalesOrderDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCustomerUpdatePartialUpdate>>,
    { slug: string; data: BodyType<PatchedCustomerUpdateSalesOrderDTO> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return apiOrdersV1SalesOrdersCustomerUpdatePartialUpdate(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiOrdersV1SalesOrdersCustomerUpdatePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCustomerUpdatePartialUpdate>>
>;
export type ApiOrdersV1SalesOrdersCustomerUpdatePartialUpdateMutationBody =
  BodyType<PatchedCustomerUpdateSalesOrderDTO>;
export type ApiOrdersV1SalesOrdersCustomerUpdatePartialUpdateMutationError = ErrorType<
  ApiOrdersV1SalesOrdersCustomerUpdatePartialUpdate400 | ErrorResponse
>;

export const useApiOrdersV1SalesOrdersCustomerUpdatePartialUpdate = <
  TError = ErrorType<ApiOrdersV1SalesOrdersCustomerUpdatePartialUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCustomerUpdatePartialUpdate>>,
    TError,
    { slug: string; data: BodyType<PatchedCustomerUpdateSalesOrderDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCustomerUpdatePartialUpdate>>,
  TError,
  { slug: string; data: BodyType<PatchedCustomerUpdateSalesOrderDTO> },
  TContext
> => {
  const mutationOptions = getApiOrdersV1SalesOrdersCustomerUpdatePartialUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Generate an upload URL for documents.
 */
export const apiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate = (
  slug: string,
  documentPreSignedURLInput: BodyType<DocumentPreSignedURLInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<DocumentPreSignedURLOutput>(
    {
      url: `/api/orders/v1/sales-orders/${slug}/documents/pre-signed-url/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: documentPreSignedURLInput,
      signal,
    },
    options
  );
};

export const getApiOrdersV1SalesOrdersDocumentsPreSignedUrlCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate>>,
    TError,
    { slug: string; data: BodyType<DocumentPreSignedURLInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate>>,
  TError,
  { slug: string; data: BodyType<DocumentPreSignedURLInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate>>,
    { slug: string; data: BodyType<DocumentPreSignedURLInput> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return apiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiOrdersV1SalesOrdersDocumentsPreSignedUrlCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate>>
>;
export type ApiOrdersV1SalesOrdersDocumentsPreSignedUrlCreateMutationBody = BodyType<DocumentPreSignedURLInput>;
export type ApiOrdersV1SalesOrdersDocumentsPreSignedUrlCreateMutationError = ErrorType<ErrorResponse>;

export const useApiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate>>,
    TError,
    { slug: string; data: BodyType<DocumentPreSignedURLInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate>>,
  TError,
  { slug: string; data: BodyType<DocumentPreSignedURLInput> },
  TContext
> => {
  const mutationOptions = getApiOrdersV1SalesOrdersDocumentsPreSignedUrlCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiOrdersV1SalesOrdersDocumentsUploadCreate = (
  slug: string,
  documentUpload: BodyType<DocumentUpload>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/orders/v1/sales-orders/${slug}/documents/upload/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: documentUpload,
      signal,
    },
    options
  );
};

export const getApiOrdersV1SalesOrdersDocumentsUploadCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsUploadCreate>>,
    TError,
    { slug: string; data: BodyType<DocumentUpload> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsUploadCreate>>,
  TError,
  { slug: string; data: BodyType<DocumentUpload> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsUploadCreate>>,
    { slug: string; data: BodyType<DocumentUpload> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return apiOrdersV1SalesOrdersDocumentsUploadCreate(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiOrdersV1SalesOrdersDocumentsUploadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsUploadCreate>>
>;
export type ApiOrdersV1SalesOrdersDocumentsUploadCreateMutationBody = BodyType<DocumentUpload>;
export type ApiOrdersV1SalesOrdersDocumentsUploadCreateMutationError = ErrorType<ErrorResponse>;

export const useApiOrdersV1SalesOrdersDocumentsUploadCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsUploadCreate>>,
    TError,
    { slug: string; data: BodyType<DocumentUpload> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsUploadCreate>>,
  TError,
  { slug: string; data: BodyType<DocumentUpload> },
  TContext
> => {
  const mutationOptions = getApiOrdersV1SalesOrdersDocumentsUploadCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiOrdersV1SalesOrdersRejectCreate = (
  slug: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    { url: `/api/orders/v1/sales-orders/${slug}/reject/`, method: 'POST', signal },
    options
  );
};

export const getApiOrdersV1SalesOrdersRejectCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRejectCreate>>,
    TError,
    { slug: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRejectCreate>>,
  TError,
  { slug: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRejectCreate>>,
    { slug: string }
  > = (props) => {
    const { slug } = props ?? {};

    return apiOrdersV1SalesOrdersRejectCreate(slug, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiOrdersV1SalesOrdersRejectCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRejectCreate>>
>;

export type ApiOrdersV1SalesOrdersRejectCreateMutationError = ErrorType<unknown>;

export const useApiOrdersV1SalesOrdersRejectCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRejectCreate>>,
    TError,
    { slug: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRejectCreate>>,
  TError,
  { slug: string },
  TContext
> => {
  const mutationOptions = getApiOrdersV1SalesOrdersRejectCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiOrdersV1SalesOrdersUpdatePartialUpdate = (
  slug: string,
  patchedUpdateSalesOrderDTO: BodyType<PatchedUpdateSalesOrderDTO>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<FullSalesOrderInfo>(
    {
      url: `/api/orders/v1/sales-orders/${slug}/update/`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchedUpdateSalesOrderDTO,
    },
    options
  );
};

export const getApiOrdersV1SalesOrdersUpdatePartialUpdateMutationOptions = <
  TError = ErrorType<ApiOrdersV1SalesOrdersUpdatePartialUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersUpdatePartialUpdate>>,
    TError,
    { slug: string; data: BodyType<PatchedUpdateSalesOrderDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersUpdatePartialUpdate>>,
  TError,
  { slug: string; data: BodyType<PatchedUpdateSalesOrderDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersUpdatePartialUpdate>>,
    { slug: string; data: BodyType<PatchedUpdateSalesOrderDTO> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return apiOrdersV1SalesOrdersUpdatePartialUpdate(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiOrdersV1SalesOrdersUpdatePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersUpdatePartialUpdate>>
>;
export type ApiOrdersV1SalesOrdersUpdatePartialUpdateMutationBody = BodyType<PatchedUpdateSalesOrderDTO>;
export type ApiOrdersV1SalesOrdersUpdatePartialUpdateMutationError = ErrorType<
  ApiOrdersV1SalesOrdersUpdatePartialUpdate400 | ErrorResponse
>;

export const useApiOrdersV1SalesOrdersUpdatePartialUpdate = <
  TError = ErrorType<ApiOrdersV1SalesOrdersUpdatePartialUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrdersV1SalesOrdersUpdatePartialUpdate>>,
    TError,
    { slug: string; data: BodyType<PatchedUpdateSalesOrderDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiOrdersV1SalesOrdersUpdatePartialUpdate>>,
  TError,
  { slug: string; data: BodyType<PatchedUpdateSalesOrderDTO> },
  TContext
> => {
  const mutationOptions = getApiOrdersV1SalesOrdersUpdatePartialUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Calculate the profitability of a deal based on the input data.
 * @summary Calculate the profitability parameters of a given deal
 */
export const apiPostDealFinanceV1ProfitabilityCalculatorCreate = (
  profitabilityCalculationRequest: BodyType<ProfitabilityCalculationRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ProfitabilityEstimateDTO>(
    {
      url: `/api/post-deal/finance/v1/profitability-calculator/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: profitabilityCalculationRequest,
      signal,
    },
    options
  );
};

export const getApiPostDealFinanceV1ProfitabilityCalculatorCreateMutationOptions = <
  TError = ErrorType<ApiPostDealFinanceV1ProfitabilityCalculatorCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPostDealFinanceV1ProfitabilityCalculatorCreate>>,
    TError,
    { data: BodyType<ProfitabilityCalculationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiPostDealFinanceV1ProfitabilityCalculatorCreate>>,
  TError,
  { data: BodyType<ProfitabilityCalculationRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPostDealFinanceV1ProfitabilityCalculatorCreate>>,
    { data: BodyType<ProfitabilityCalculationRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return apiPostDealFinanceV1ProfitabilityCalculatorCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiPostDealFinanceV1ProfitabilityCalculatorCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPostDealFinanceV1ProfitabilityCalculatorCreate>>
>;
export type ApiPostDealFinanceV1ProfitabilityCalculatorCreateMutationBody = BodyType<ProfitabilityCalculationRequest>;
export type ApiPostDealFinanceV1ProfitabilityCalculatorCreateMutationError = ErrorType<
  ApiPostDealFinanceV1ProfitabilityCalculatorCreate400 | ErrorResponse
>;

/**
 * @summary Calculate the profitability parameters of a given deal
 */
export const useApiPostDealFinanceV1ProfitabilityCalculatorCreate = <
  TError = ErrorType<ApiPostDealFinanceV1ProfitabilityCalculatorCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPostDealFinanceV1ProfitabilityCalculatorCreate>>,
    TError,
    { data: BodyType<ProfitabilityCalculationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiPostDealFinanceV1ProfitabilityCalculatorCreate>>,
  TError,
  { data: BodyType<ProfitabilityCalculationRequest> },
  TContext
> => {
  const mutationOptions = getApiPostDealFinanceV1ProfitabilityCalculatorCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiPostDealTrackerV1CarriersRetrieve = (
  params?: ApiPostDealTrackerV1CarriersRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CarrierList>(
    { url: `/api/post-deal/tracker/v1/carriers/`, method: 'GET', params, signal },
    options
  );
};

export const getApiPostDealTrackerV1CarriersRetrieveQueryKey = (
  params?: ApiPostDealTrackerV1CarriersRetrieveParams
) => {
  return [`/api/post-deal/tracker/v1/carriers/`, ...(params ? [params] : [])] as const;
};

export const getApiPostDealTrackerV1CarriersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiPostDealTrackerV1CarriersRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPostDealTrackerV1CarriersRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>> = ({ signal }) =>
    apiPostDealTrackerV1CarriersRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiPostDealTrackerV1CarriersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>
>;
export type ApiPostDealTrackerV1CarriersRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiPostDealTrackerV1CarriersRetrieve<
  TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiPostDealTrackerV1CarriersRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiPostDealTrackerV1CarriersRetrieve<
  TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiPostDealTrackerV1CarriersRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiPostDealTrackerV1CarriersRetrieve<
  TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiPostDealTrackerV1CarriersRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiPostDealTrackerV1CarriersRetrieve<
  TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiPostDealTrackerV1CarriersRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiPostDealTrackerV1CarriersRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiPostDealTrackerV1CarriersRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiPostDealTrackerV1CarriersRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPostDealTrackerV1CarriersRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>> = ({ signal }) =>
    apiPostDealTrackerV1CarriersRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiPostDealTrackerV1CarriersRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>
>;
export type ApiPostDealTrackerV1CarriersRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiPostDealTrackerV1CarriersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiPostDealTrackerV1CarriersRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiPostDealTrackerV1CarriersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiPostDealTrackerV1CarriersRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiPostDealTrackerV1CarriersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiPostDealTrackerV1CarriersRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiPostDealTrackerV1CarriersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiPostDealTrackerV1CarriersRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiPostDealTrackerV1CarriersRetrieveSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiQualityReportV1SiteMaterialExistsRetrieve = (
  siteMaterialPublicId: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    { url: `/api/quality-report/v1/site-material/${siteMaterialPublicId}/exists/`, method: 'GET', signal },
    options
  );
};

export const getApiQualityReportV1SiteMaterialExistsRetrieveQueryKey = (siteMaterialPublicId: string) => {
  return [`/api/quality-report/v1/site-material/${siteMaterialPublicId}/exists/`] as const;
};

export const getApiQualityReportV1SiteMaterialExistsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialPublicId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiQualityReportV1SiteMaterialExistsRetrieveQueryKey(siteMaterialPublicId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>> = ({
    signal,
  }) => apiQualityReportV1SiteMaterialExistsRetrieve(siteMaterialPublicId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!siteMaterialPublicId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualityReportV1SiteMaterialExistsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>
>;
export type ApiQualityReportV1SiteMaterialExistsRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiQualityReportV1SiteMaterialExistsRetrieve<
  TData = Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialPublicId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityReportV1SiteMaterialExistsRetrieve<
  TData = Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialPublicId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityReportV1SiteMaterialExistsRetrieve<
  TData = Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialPublicId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualityReportV1SiteMaterialExistsRetrieve<
  TData = Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialPublicId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualityReportV1SiteMaterialExistsRetrieveQueryOptions(siteMaterialPublicId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiQualityReportV1SiteMaterialExistsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialPublicId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiQualityReportV1SiteMaterialExistsRetrieveQueryKey(siteMaterialPublicId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>> = ({
    signal,
  }) => apiQualityReportV1SiteMaterialExistsRetrieve(siteMaterialPublicId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualityReportV1SiteMaterialExistsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>
>;
export type ApiQualityReportV1SiteMaterialExistsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiQualityReportV1SiteMaterialExistsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialPublicId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityReportV1SiteMaterialExistsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialPublicId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityReportV1SiteMaterialExistsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialPublicId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualityReportV1SiteMaterialExistsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialPublicId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityReportV1SiteMaterialExistsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualityReportV1SiteMaterialExistsRetrieveSuspenseQueryOptions(
    siteMaterialPublicId,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiQualityBuyerV1LoadsRetrieve = (options?: SecondParameter<typeof customAxios>, signal?: AbortSignal) => {
  return customAxios<BuyerLoadsList>({ url: `/api/quality/buyer/v1/loads/`, method: 'GET', signal }, options);
};

export const getApiQualityBuyerV1LoadsRetrieveQueryKey = () => {
  return [`/api/quality/buyer/v1/loads/`] as const;
};

export const getApiQualityBuyerV1LoadsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiQualityBuyerV1LoadsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>> = ({ signal }) =>
    apiQualityBuyerV1LoadsRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualityBuyerV1LoadsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>
>;
export type ApiQualityBuyerV1LoadsRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiQualityBuyerV1LoadsRetrieve<
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityBuyerV1LoadsRetrieve<
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityBuyerV1LoadsRetrieve<
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualityBuyerV1LoadsRetrieve<
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualityBuyerV1LoadsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiQualityBuyerV1LoadsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiQualityBuyerV1LoadsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>> = ({ signal }) =>
    apiQualityBuyerV1LoadsRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualityBuyerV1LoadsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>
>;
export type ApiQualityBuyerV1LoadsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiQualityBuyerV1LoadsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options: {
  query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityBuyerV1LoadsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityBuyerV1LoadsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualityBuyerV1LoadsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualityBuyerV1LoadsRetrieveSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get detailed information about a specific load including its associated sample and evidence.
 */
export const apiQualityBuyerV1LoadsDetail = (
  loadId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<BuyerLoadDetail>(
    { url: `/api/quality/buyer/v1/loads/${loadId}/`, method: 'GET', signal },
    options
  );
};

export const getApiQualityBuyerV1LoadsDetailQueryKey = (loadId: number) => {
  return [`/api/quality/buyer/v1/loads/${loadId}/`] as const;
};

export const getApiQualityBuyerV1LoadsDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiQualityBuyerV1LoadsDetailQueryKey(loadId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>> = ({ signal }) =>
    apiQualityBuyerV1LoadsDetail(loadId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!loadId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualityBuyerV1LoadsDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>
>;
export type ApiQualityBuyerV1LoadsDetailQueryError = ErrorType<ErrorResponse>;

export function useApiQualityBuyerV1LoadsDetail<
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityBuyerV1LoadsDetail<
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityBuyerV1LoadsDetail<
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualityBuyerV1LoadsDetail<
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualityBuyerV1LoadsDetailQueryOptions(loadId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiQualityBuyerV1LoadsDetailSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiQualityBuyerV1LoadsDetailQueryKey(loadId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>> = ({ signal }) =>
    apiQualityBuyerV1LoadsDetail(loadId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualityBuyerV1LoadsDetailSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>
>;
export type ApiQualityBuyerV1LoadsDetailSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiQualityBuyerV1LoadsDetailSuspense<
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: number,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityBuyerV1LoadsDetailSuspense<
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityBuyerV1LoadsDetailSuspense<
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualityBuyerV1LoadsDetailSuspense<
  TData = Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>,
  TError = ErrorType<ErrorResponse>,
>(
  loadId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerV1LoadsDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualityBuyerV1LoadsDetailSuspenseQueryOptions(loadId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiQualityExternalUploadV1Create = (
  createExternalUpload: BodyType<CreateExternalUpload>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleExternalUploadDTO>(
    {
      url: `/api/quality/external-upload/v1/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createExternalUpload,
      signal,
    },
    options
  );
};

export const getApiQualityExternalUploadV1CreateMutationOptions = <
  TError = ErrorType<ApiQualityExternalUploadV1Create400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualityExternalUploadV1Create>>,
    TError,
    { data: BodyType<CreateExternalUpload> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiQualityExternalUploadV1Create>>,
  TError,
  { data: BodyType<CreateExternalUpload> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiQualityExternalUploadV1Create>>,
    { data: BodyType<CreateExternalUpload> }
  > = (props) => {
    const { data } = props ?? {};

    return apiQualityExternalUploadV1Create(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiQualityExternalUploadV1CreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiQualityExternalUploadV1Create>>
>;
export type ApiQualityExternalUploadV1CreateMutationBody = BodyType<CreateExternalUpload>;
export type ApiQualityExternalUploadV1CreateMutationError = ErrorType<
  ApiQualityExternalUploadV1Create400 | ErrorResponse
>;

export const useApiQualityExternalUploadV1Create = <
  TError = ErrorType<ApiQualityExternalUploadV1Create400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualityExternalUploadV1Create>>,
    TError,
    { data: BodyType<CreateExternalUpload> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiQualityExternalUploadV1Create>>,
  TError,
  { data: BodyType<CreateExternalUpload> },
  TContext
> => {
  const mutationOptions = getApiQualityExternalUploadV1CreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiQualityExternalUploadV1Retrieve = (
  externalUploadUuid: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ExternalUploadWithUser>(
    { url: `/api/quality/external-upload/v1/${externalUploadUuid}/`, method: 'GET', signal },
    options
  );
};

export const getApiQualityExternalUploadV1RetrieveQueryKey = (externalUploadUuid: string) => {
  return [`/api/quality/external-upload/v1/${externalUploadUuid}/`] as const;
};

export const getApiQualityExternalUploadV1RetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  externalUploadUuid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiQualityExternalUploadV1RetrieveQueryKey(externalUploadUuid);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>> = ({ signal }) =>
    apiQualityExternalUploadV1Retrieve(externalUploadUuid, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!externalUploadUuid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualityExternalUploadV1RetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>
>;
export type ApiQualityExternalUploadV1RetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiQualityExternalUploadV1Retrieve<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  externalUploadUuid: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityExternalUploadV1Retrieve<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  externalUploadUuid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityExternalUploadV1Retrieve<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  externalUploadUuid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualityExternalUploadV1Retrieve<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  externalUploadUuid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualityExternalUploadV1RetrieveQueryOptions(externalUploadUuid, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiQualityExternalUploadV1RetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  externalUploadUuid: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiQualityExternalUploadV1RetrieveQueryKey(externalUploadUuid);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>> = ({ signal }) =>
    apiQualityExternalUploadV1Retrieve(externalUploadUuid, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualityExternalUploadV1RetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>
>;
export type ApiQualityExternalUploadV1RetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiQualityExternalUploadV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  externalUploadUuid: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityExternalUploadV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  externalUploadUuid: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityExternalUploadV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  externalUploadUuid: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualityExternalUploadV1RetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  externalUploadUuid: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualityExternalUploadV1RetrieveSuspenseQueryOptions(externalUploadUuid, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiQualityExternalUploadV1EvidenceList = (
  uuid: string,
  params?: ApiQualityExternalUploadV1EvidenceListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedEvidenceList>(
    { url: `/api/quality/external-upload/v1/${uuid}/evidence/`, method: 'GET', params, signal },
    options
  );
};

export const getApiQualityExternalUploadV1EvidenceListQueryKey = (
  uuid: string,
  params?: ApiQualityExternalUploadV1EvidenceListParams
) => {
  return [`/api/quality/external-upload/v1/${uuid}/evidence/`, ...(params ? [params] : [])] as const;
};

export const getApiQualityExternalUploadV1EvidenceListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  params?: ApiQualityExternalUploadV1EvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiQualityExternalUploadV1EvidenceListQueryKey(uuid, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>> = ({ signal }) =>
    apiQualityExternalUploadV1EvidenceList(uuid, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!uuid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualityExternalUploadV1EvidenceListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>
>;
export type ApiQualityExternalUploadV1EvidenceListQueryError = ErrorType<ErrorResponse>;

export function useApiQualityExternalUploadV1EvidenceList<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  params: undefined | ApiQualityExternalUploadV1EvidenceListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityExternalUploadV1EvidenceList<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  params?: ApiQualityExternalUploadV1EvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityExternalUploadV1EvidenceList<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  params?: ApiQualityExternalUploadV1EvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualityExternalUploadV1EvidenceList<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  params?: ApiQualityExternalUploadV1EvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualityExternalUploadV1EvidenceListQueryOptions(uuid, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiQualityExternalUploadV1EvidenceListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  params?: ApiQualityExternalUploadV1EvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiQualityExternalUploadV1EvidenceListQueryKey(uuid, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>> = ({ signal }) =>
    apiQualityExternalUploadV1EvidenceList(uuid, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualityExternalUploadV1EvidenceListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>
>;
export type ApiQualityExternalUploadV1EvidenceListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiQualityExternalUploadV1EvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  params: undefined | ApiQualityExternalUploadV1EvidenceListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityExternalUploadV1EvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  params?: ApiQualityExternalUploadV1EvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityExternalUploadV1EvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  params?: ApiQualityExternalUploadV1EvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualityExternalUploadV1EvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  params?: ApiQualityExternalUploadV1EvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualityExternalUploadV1EvidenceListSuspenseQueryOptions(uuid, params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiQualityExternalUploadV1EvidenceRetrieve = (
  uuid: string,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Evidence>(
    { url: `/api/quality/external-upload/v1/${uuid}/evidence/${id}/`, method: 'GET', signal },
    options
  );
};

export const getApiQualityExternalUploadV1EvidenceRetrieveQueryKey = (uuid: string, id: number) => {
  return [`/api/quality/external-upload/v1/${uuid}/evidence/${id}/`] as const;
};

export const getApiQualityExternalUploadV1EvidenceRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiQualityExternalUploadV1EvidenceRetrieveQueryKey(uuid, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>> = ({ signal }) =>
    apiQualityExternalUploadV1EvidenceRetrieve(uuid, id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(uuid && id), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualityExternalUploadV1EvidenceRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>
>;
export type ApiQualityExternalUploadV1EvidenceRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiQualityExternalUploadV1EvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityExternalUploadV1EvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityExternalUploadV1EvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualityExternalUploadV1EvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualityExternalUploadV1EvidenceRetrieveQueryOptions(uuid, id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiQualityExternalUploadV1EvidenceRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiQualityExternalUploadV1EvidenceRetrieveQueryKey(uuid, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>> = ({ signal }) =>
    apiQualityExternalUploadV1EvidenceRetrieve(uuid, id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualityExternalUploadV1EvidenceRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>
>;
export type ApiQualityExternalUploadV1EvidenceRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiQualityExternalUploadV1EvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityExternalUploadV1EvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualityExternalUploadV1EvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualityExternalUploadV1EvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  uuid: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualityExternalUploadV1EvidenceRetrieveSuspenseQueryOptions(uuid, id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generate an upload URL for large files.
 */
export const apiQualityExternalUploadV1EvidenceUploadCreate = (
  uuid: string,
  generateUploadUrlRequest: BodyType<GenerateUploadUrlRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GenerateUploadUrlResponse>(
    {
      url: `/api/quality/external-upload/v1/${uuid}/evidence/upload/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: generateUploadUrlRequest,
      signal,
    },
    options
  );
};

export const getApiQualityExternalUploadV1EvidenceUploadCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadCreate>>,
    TError,
    { uuid: string; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadCreate>>,
  TError,
  { uuid: string; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadCreate>>,
    { uuid: string; data: BodyType<GenerateUploadUrlRequest> }
  > = (props) => {
    const { uuid, data } = props ?? {};

    return apiQualityExternalUploadV1EvidenceUploadCreate(uuid, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiQualityExternalUploadV1EvidenceUploadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadCreate>>
>;
export type ApiQualityExternalUploadV1EvidenceUploadCreateMutationBody = BodyType<GenerateUploadUrlRequest>;
export type ApiQualityExternalUploadV1EvidenceUploadCreateMutationError = ErrorType<ErrorResponse>;

export const useApiQualityExternalUploadV1EvidenceUploadCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadCreate>>,
    TError,
    { uuid: string; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadCreate>>,
  TError,
  { uuid: string; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const mutationOptions = getApiQualityExternalUploadV1EvidenceUploadCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Saves evidence as bale photo and returns inference results.
 */
export const apiQualityExternalUploadV1EvidenceUploadUpdate = (
  uuid: string,
  processUploadRequest: BodyType<ProcessUploadRequest>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<ProcessUploadResponse>(
    {
      url: `/api/quality/external-upload/v1/${uuid}/evidence/upload/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: processUploadRequest,
    },
    options
  );
};

export const getApiQualityExternalUploadV1EvidenceUploadUpdateMutationOptions = <
  TError = ErrorType<unknown | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadUpdate>>,
    TError,
    { uuid: string; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadUpdate>>,
  TError,
  { uuid: string; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadUpdate>>,
    { uuid: string; data: BodyType<ProcessUploadRequest> }
  > = (props) => {
    const { uuid, data } = props ?? {};

    return apiQualityExternalUploadV1EvidenceUploadUpdate(uuid, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiQualityExternalUploadV1EvidenceUploadUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadUpdate>>
>;
export type ApiQualityExternalUploadV1EvidenceUploadUpdateMutationBody = BodyType<ProcessUploadRequest>;
export type ApiQualityExternalUploadV1EvidenceUploadUpdateMutationError = ErrorType<unknown | ErrorResponse>;

export const useApiQualityExternalUploadV1EvidenceUploadUpdate = <
  TError = ErrorType<unknown | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadUpdate>>,
    TError,
    { uuid: string; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadUpdate>>,
  TError,
  { uuid: string; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const mutationOptions = getApiQualityExternalUploadV1EvidenceUploadUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiQualitySessionsV1SiteMaterialSessionSampleRetrieve = (
  siteMaterialSessionId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SiteMaterialSessionSampleWithAverageFeatures>(
    { url: `/api/quality/sessions/v1/site-material-session/${siteMaterialSessionId}/sample/`, method: 'GET', signal },
    options
  );
};

export const getApiQualitySessionsV1SiteMaterialSessionSampleRetrieveQueryKey = (siteMaterialSessionId: number) => {
  return [`/api/quality/sessions/v1/site-material-session/${siteMaterialSessionId}/sample/`] as const;
};

export const getApiQualitySessionsV1SiteMaterialSessionSampleRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiQualitySessionsV1SiteMaterialSessionSampleRetrieveQueryKey(siteMaterialSessionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>> = ({
    signal,
  }) => apiQualitySessionsV1SiteMaterialSessionSampleRetrieve(siteMaterialSessionId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!siteMaterialSessionId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualitySessionsV1SiteMaterialSessionSampleRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>
>;
export type ApiQualitySessionsV1SiteMaterialSessionSampleRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiQualitySessionsV1SiteMaterialSessionSampleRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1SiteMaterialSessionSampleRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1SiteMaterialSessionSampleRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualitySessionsV1SiteMaterialSessionSampleRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualitySessionsV1SiteMaterialSessionSampleRetrieveQueryOptions(
    siteMaterialSessionId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiQualitySessionsV1SiteMaterialSessionSampleRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiQualitySessionsV1SiteMaterialSessionSampleRetrieveQueryKey(siteMaterialSessionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>> = ({
    signal,
  }) => apiQualitySessionsV1SiteMaterialSessionSampleRetrieve(siteMaterialSessionId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualitySessionsV1SiteMaterialSessionSampleRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>
>;
export type ApiQualitySessionsV1SiteMaterialSessionSampleRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiQualitySessionsV1SiteMaterialSessionSampleRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1SiteMaterialSessionSampleRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1SiteMaterialSessionSampleRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualitySessionsV1SiteMaterialSessionSampleRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualitySessionsV1SiteMaterialSessionSampleRetrieveSuspenseQueryOptions(
    siteMaterialSessionId,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiQualitySessionsV1SiteMaterialSessionSampleCreate = (
  siteMaterialSessionId: number,
  createSiteMaterialSessionSample: BodyType<CreateSiteMaterialSessionSample>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleSiteMaterialSessionSample>(
    {
      url: `/api/quality/sessions/v1/site-material-session/${siteMaterialSessionId}/sample/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createSiteMaterialSessionSample,
      signal,
    },
    options
  );
};

export const getApiQualitySessionsV1SiteMaterialSessionSampleCreateMutationOptions = <
  TError = ErrorType<ApiQualitySessionsV1SiteMaterialSessionSampleCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleCreate>>,
    TError,
    { siteMaterialSessionId: number; data: BodyType<CreateSiteMaterialSessionSample> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleCreate>>,
  TError,
  { siteMaterialSessionId: number; data: BodyType<CreateSiteMaterialSessionSample> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleCreate>>,
    { siteMaterialSessionId: number; data: BodyType<CreateSiteMaterialSessionSample> }
  > = (props) => {
    const { siteMaterialSessionId, data } = props ?? {};

    return apiQualitySessionsV1SiteMaterialSessionSampleCreate(siteMaterialSessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiQualitySessionsV1SiteMaterialSessionSampleCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleCreate>>
>;
export type ApiQualitySessionsV1SiteMaterialSessionSampleCreateMutationBody = BodyType<CreateSiteMaterialSessionSample>;
export type ApiQualitySessionsV1SiteMaterialSessionSampleCreateMutationError = ErrorType<
  ApiQualitySessionsV1SiteMaterialSessionSampleCreate400 | ErrorResponse
>;

export const useApiQualitySessionsV1SiteMaterialSessionSampleCreate = <
  TError = ErrorType<ApiQualitySessionsV1SiteMaterialSessionSampleCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleCreate>>,
    TError,
    { siteMaterialSessionId: number; data: BodyType<CreateSiteMaterialSessionSample> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionSampleCreate>>,
  TError,
  { siteMaterialSessionId: number; data: BodyType<CreateSiteMaterialSessionSample> },
  TContext
> => {
  const mutationOptions = getApiQualitySessionsV1SiteMaterialSessionSampleCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * View for accessing/updating/deleting site material sessions
by external users (e.g. sellers).
 */
export const apiQualitySessionsV1SiteMaterialSessionsRetrieve = (
  siteMaterialSessionId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<FullSiteMaterialSession>(
    { url: `/api/quality/sessions/v1/site-material-sessions/${siteMaterialSessionId}/`, method: 'GET', signal },
    options
  );
};

export const getApiQualitySessionsV1SiteMaterialSessionsRetrieveQueryKey = (siteMaterialSessionId: number) => {
  return [`/api/quality/sessions/v1/site-material-sessions/${siteMaterialSessionId}/`] as const;
};

export const getApiQualitySessionsV1SiteMaterialSessionsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiQualitySessionsV1SiteMaterialSessionsRetrieveQueryKey(siteMaterialSessionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>> = ({
    signal,
  }) => apiQualitySessionsV1SiteMaterialSessionsRetrieve(siteMaterialSessionId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!siteMaterialSessionId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualitySessionsV1SiteMaterialSessionsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>
>;
export type ApiQualitySessionsV1SiteMaterialSessionsRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiQualitySessionsV1SiteMaterialSessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1SiteMaterialSessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1SiteMaterialSessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualitySessionsV1SiteMaterialSessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualitySessionsV1SiteMaterialSessionsRetrieveQueryOptions(siteMaterialSessionId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiQualitySessionsV1SiteMaterialSessionsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiQualitySessionsV1SiteMaterialSessionsRetrieveQueryKey(siteMaterialSessionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>> = ({
    signal,
  }) => apiQualitySessionsV1SiteMaterialSessionsRetrieve(siteMaterialSessionId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualitySessionsV1SiteMaterialSessionsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>
>;
export type ApiQualitySessionsV1SiteMaterialSessionsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiQualitySessionsV1SiteMaterialSessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1SiteMaterialSessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1SiteMaterialSessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualitySessionsV1SiteMaterialSessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualitySessionsV1SiteMaterialSessionsRetrieveSuspenseQueryOptions(
    siteMaterialSessionId,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * View for accessing/updating/deleting site material sessions
by external users (e.g. sellers).
 */
export const apiQualitySessionsV1SiteMaterialSessionsPartialUpdate = (
  siteMaterialSessionId: number,
  patchedSiteMaterialSessionUpdateDTO: BodyType<PatchedSiteMaterialSessionUpdateDTO>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<void>(
    {
      url: `/api/quality/sessions/v1/site-material-sessions/${siteMaterialSessionId}/`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchedSiteMaterialSessionUpdateDTO,
    },
    options
  );
};

export const getApiQualitySessionsV1SiteMaterialSessionsPartialUpdateMutationOptions = <
  TError = ErrorType<ApiQualitySessionsV1SiteMaterialSessionsPartialUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsPartialUpdate>>,
    TError,
    { siteMaterialSessionId: number; data: BodyType<PatchedSiteMaterialSessionUpdateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsPartialUpdate>>,
  TError,
  { siteMaterialSessionId: number; data: BodyType<PatchedSiteMaterialSessionUpdateDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsPartialUpdate>>,
    { siteMaterialSessionId: number; data: BodyType<PatchedSiteMaterialSessionUpdateDTO> }
  > = (props) => {
    const { siteMaterialSessionId, data } = props ?? {};

    return apiQualitySessionsV1SiteMaterialSessionsPartialUpdate(siteMaterialSessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiQualitySessionsV1SiteMaterialSessionsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsPartialUpdate>>
>;
export type ApiQualitySessionsV1SiteMaterialSessionsPartialUpdateMutationBody =
  BodyType<PatchedSiteMaterialSessionUpdateDTO>;
export type ApiQualitySessionsV1SiteMaterialSessionsPartialUpdateMutationError = ErrorType<
  ApiQualitySessionsV1SiteMaterialSessionsPartialUpdate400 | ErrorResponse
>;

export const useApiQualitySessionsV1SiteMaterialSessionsPartialUpdate = <
  TError = ErrorType<ApiQualitySessionsV1SiteMaterialSessionsPartialUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsPartialUpdate>>,
    TError,
    { siteMaterialSessionId: number; data: BodyType<PatchedSiteMaterialSessionUpdateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsPartialUpdate>>,
  TError,
  { siteMaterialSessionId: number; data: BodyType<PatchedSiteMaterialSessionUpdateDTO> },
  TContext
> => {
  const mutationOptions = getApiQualitySessionsV1SiteMaterialSessionsPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * View for accessing/updating/deleting site material sessions
by external users (e.g. sellers).
 */
export const apiQualitySessionsV1SiteMaterialSessionsDestroy = (
  siteMaterialSessionId: number,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<void>(
    { url: `/api/quality/sessions/v1/site-material-sessions/${siteMaterialSessionId}/`, method: 'DELETE' },
    options
  );
};

export const getApiQualitySessionsV1SiteMaterialSessionsDestroyMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsDestroy>>,
    TError,
    { siteMaterialSessionId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsDestroy>>,
  TError,
  { siteMaterialSessionId: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsDestroy>>,
    { siteMaterialSessionId: number }
  > = (props) => {
    const { siteMaterialSessionId } = props ?? {};

    return apiQualitySessionsV1SiteMaterialSessionsDestroy(siteMaterialSessionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiQualitySessionsV1SiteMaterialSessionsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsDestroy>>
>;

export type ApiQualitySessionsV1SiteMaterialSessionsDestroyMutationError = ErrorType<ErrorResponse>;

export const useApiQualitySessionsV1SiteMaterialSessionsDestroy = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsDestroy>>,
    TError,
    { siteMaterialSessionId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsDestroy>>,
  TError,
  { siteMaterialSessionId: number },
  TContext
> => {
  const mutationOptions = getApiQualitySessionsV1SiteMaterialSessionsDestroyMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiQualitySessionsV1SiteMaterialSessionsEvidenceList = (
  siteMaterialSessionId: number,
  params?: ApiQualitySessionsV1SiteMaterialSessionsEvidenceListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedEvidenceList>(
    {
      url: `/api/quality/sessions/v1/site-material-sessions/${siteMaterialSessionId}/evidence/`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getApiQualitySessionsV1SiteMaterialSessionsEvidenceListQueryKey = (
  siteMaterialSessionId: number,
  params?: ApiQualitySessionsV1SiteMaterialSessionsEvidenceListParams
) => {
  return [
    `/api/quality/sessions/v1/site-material-sessions/${siteMaterialSessionId}/evidence/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApiQualitySessionsV1SiteMaterialSessionsEvidenceListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  params?: ApiQualitySessionsV1SiteMaterialSessionsEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiQualitySessionsV1SiteMaterialSessionsEvidenceListQueryKey(siteMaterialSessionId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>> = ({
    signal,
  }) => apiQualitySessionsV1SiteMaterialSessionsEvidenceList(siteMaterialSessionId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!siteMaterialSessionId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualitySessionsV1SiteMaterialSessionsEvidenceListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>
>;
export type ApiQualitySessionsV1SiteMaterialSessionsEvidenceListQueryError = ErrorType<ErrorResponse>;

export function useApiQualitySessionsV1SiteMaterialSessionsEvidenceList<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  params: undefined | ApiQualitySessionsV1SiteMaterialSessionsEvidenceListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1SiteMaterialSessionsEvidenceList<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  params?: ApiQualitySessionsV1SiteMaterialSessionsEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1SiteMaterialSessionsEvidenceList<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  params?: ApiQualitySessionsV1SiteMaterialSessionsEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualitySessionsV1SiteMaterialSessionsEvidenceList<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  params?: ApiQualitySessionsV1SiteMaterialSessionsEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualitySessionsV1SiteMaterialSessionsEvidenceListQueryOptions(
    siteMaterialSessionId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiQualitySessionsV1SiteMaterialSessionsEvidenceListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  params?: ApiQualitySessionsV1SiteMaterialSessionsEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiQualitySessionsV1SiteMaterialSessionsEvidenceListQueryKey(siteMaterialSessionId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>> = ({
    signal,
  }) => apiQualitySessionsV1SiteMaterialSessionsEvidenceList(siteMaterialSessionId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualitySessionsV1SiteMaterialSessionsEvidenceListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>
>;
export type ApiQualitySessionsV1SiteMaterialSessionsEvidenceListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiQualitySessionsV1SiteMaterialSessionsEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  params: undefined | ApiQualitySessionsV1SiteMaterialSessionsEvidenceListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1SiteMaterialSessionsEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  params?: ApiQualitySessionsV1SiteMaterialSessionsEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1SiteMaterialSessionsEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  params?: ApiQualitySessionsV1SiteMaterialSessionsEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualitySessionsV1SiteMaterialSessionsEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  params?: ApiQualitySessionsV1SiteMaterialSessionsEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualitySessionsV1SiteMaterialSessionsEvidenceListSuspenseQueryOptions(
    siteMaterialSessionId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve = (
  siteMaterialSessionId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Evidence>(
    {
      url: `/api/quality/sessions/v1/site-material-sessions/${siteMaterialSessionId}/evidence/${id}/`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieveQueryKey = (
  siteMaterialSessionId: number,
  id: number
) => {
  return [`/api/quality/sessions/v1/site-material-sessions/${siteMaterialSessionId}/evidence/${id}/`] as const;
};

export const getApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieveQueryKey(siteMaterialSessionId, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>
  > = ({ signal }) =>
    apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve(siteMaterialSessionId, id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(siteMaterialSessionId && id), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>
>;
export type ApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieveQueryOptions(
    siteMaterialSessionId,
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieveQueryKey(siteMaterialSessionId, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>
  > = ({ signal }) =>
    apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve(siteMaterialSessionId, id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>
>;
export type ApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialSessionId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualitySessionsV1SiteMaterialSessionsEvidenceRetrieveSuspenseQueryOptions(
    siteMaterialSessionId,
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generate an upload URL for large files.
 */
export const apiQualitySessionsV1SiteMaterialSessionsEvidenceUploadCreate = (
  siteMaterialSessionId: number,
  generateUploadUrlRequest: BodyType<GenerateUploadUrlRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GenerateUploadUrlResponse>(
    {
      url: `/api/quality/sessions/v1/site-material-sessions/${siteMaterialSessionId}/evidence/upload`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: generateUploadUrlRequest,
      signal,
    },
    options
  );
};

export const getApiQualitySessionsV1SiteMaterialSessionsEvidenceUploadCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceUploadCreate>>,
    TError,
    { siteMaterialSessionId: number; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceUploadCreate>>,
  TError,
  { siteMaterialSessionId: number; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceUploadCreate>>,
    { siteMaterialSessionId: number; data: BodyType<GenerateUploadUrlRequest> }
  > = (props) => {
    const { siteMaterialSessionId, data } = props ?? {};

    return apiQualitySessionsV1SiteMaterialSessionsEvidenceUploadCreate(siteMaterialSessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiQualitySessionsV1SiteMaterialSessionsEvidenceUploadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceUploadCreate>>
>;
export type ApiQualitySessionsV1SiteMaterialSessionsEvidenceUploadCreateMutationBody =
  BodyType<GenerateUploadUrlRequest>;
export type ApiQualitySessionsV1SiteMaterialSessionsEvidenceUploadCreateMutationError = ErrorType<ErrorResponse>;

export const useApiQualitySessionsV1SiteMaterialSessionsEvidenceUploadCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceUploadCreate>>,
    TError,
    { siteMaterialSessionId: number; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceUploadCreate>>,
  TError,
  { siteMaterialSessionId: number; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const mutationOptions = getApiQualitySessionsV1SiteMaterialSessionsEvidenceUploadCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Saves evidence as bale photo and returns inference results.
 */
export const apiQualitySessionsV1SiteMaterialSessionsEvidenceUploadUpdate = (
  siteMaterialSessionId: number,
  processUploadRequest: BodyType<ProcessUploadRequest>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<ProcessUploadResponse>(
    {
      url: `/api/quality/sessions/v1/site-material-sessions/${siteMaterialSessionId}/evidence/upload`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: processUploadRequest,
    },
    options
  );
};

export const getApiQualitySessionsV1SiteMaterialSessionsEvidenceUploadUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceUploadUpdate>>,
    TError,
    { siteMaterialSessionId: number; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceUploadUpdate>>,
  TError,
  { siteMaterialSessionId: number; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceUploadUpdate>>,
    { siteMaterialSessionId: number; data: BodyType<ProcessUploadRequest> }
  > = (props) => {
    const { siteMaterialSessionId, data } = props ?? {};

    return apiQualitySessionsV1SiteMaterialSessionsEvidenceUploadUpdate(siteMaterialSessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiQualitySessionsV1SiteMaterialSessionsEvidenceUploadUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceUploadUpdate>>
>;
export type ApiQualitySessionsV1SiteMaterialSessionsEvidenceUploadUpdateMutationBody = BodyType<ProcessUploadRequest>;
export type ApiQualitySessionsV1SiteMaterialSessionsEvidenceUploadUpdateMutationError = ErrorType<unknown>;

export const useApiQualitySessionsV1SiteMaterialSessionsEvidenceUploadUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceUploadUpdate>>,
    TError,
    { siteMaterialSessionId: number; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsEvidenceUploadUpdate>>,
  TError,
  { siteMaterialSessionId: number; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const mutationOptions = getApiQualitySessionsV1SiteMaterialSessionsEvidenceUploadUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiQualitySessionsV1SiteMaterialSessionsGeneratePdfCreate = (
  siteMaterialSessionId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SiteMaterialSessionGeneratePDFResponse>(
    {
      url: `/api/quality/sessions/v1/site-material-sessions/${siteMaterialSessionId}/generate-pdf/`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getApiQualitySessionsV1SiteMaterialSessionsGeneratePdfCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsGeneratePdfCreate>>,
    TError,
    { siteMaterialSessionId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsGeneratePdfCreate>>,
  TError,
  { siteMaterialSessionId: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsGeneratePdfCreate>>,
    { siteMaterialSessionId: number }
  > = (props) => {
    const { siteMaterialSessionId } = props ?? {};

    return apiQualitySessionsV1SiteMaterialSessionsGeneratePdfCreate(siteMaterialSessionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiQualitySessionsV1SiteMaterialSessionsGeneratePdfCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsGeneratePdfCreate>>
>;

export type ApiQualitySessionsV1SiteMaterialSessionsGeneratePdfCreateMutationError = ErrorType<ErrorResponse>;

export const useApiQualitySessionsV1SiteMaterialSessionsGeneratePdfCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsGeneratePdfCreate>>,
    TError,
    { siteMaterialSessionId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiQualitySessionsV1SiteMaterialSessionsGeneratePdfCreate>>,
  TError,
  { siteMaterialSessionId: number },
  TContext
> => {
  const mutationOptions = getApiQualitySessionsV1SiteMaterialSessionsGeneratePdfCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiQualitySessionsV1TradeCompanySessionEvidenceList = (
  tradeCompanySessionId: number,
  params?: ApiQualitySessionsV1TradeCompanySessionEvidenceListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedEvidenceList>(
    {
      url: `/api/quality/sessions/v1/trade-company-session/${tradeCompanySessionId}/evidence/`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getApiQualitySessionsV1TradeCompanySessionEvidenceListQueryKey = (
  tradeCompanySessionId: number,
  params?: ApiQualitySessionsV1TradeCompanySessionEvidenceListParams
) => {
  return [
    `/api/quality/sessions/v1/trade-company-session/${tradeCompanySessionId}/evidence/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApiQualitySessionsV1TradeCompanySessionEvidenceListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  params?: ApiQualitySessionsV1TradeCompanySessionEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiQualitySessionsV1TradeCompanySessionEvidenceListQueryKey(tradeCompanySessionId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>> = ({
    signal,
  }) => apiQualitySessionsV1TradeCompanySessionEvidenceList(tradeCompanySessionId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!tradeCompanySessionId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualitySessionsV1TradeCompanySessionEvidenceListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>
>;
export type ApiQualitySessionsV1TradeCompanySessionEvidenceListQueryError = ErrorType<ErrorResponse>;

export function useApiQualitySessionsV1TradeCompanySessionEvidenceList<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  params: undefined | ApiQualitySessionsV1TradeCompanySessionEvidenceListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1TradeCompanySessionEvidenceList<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  params?: ApiQualitySessionsV1TradeCompanySessionEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1TradeCompanySessionEvidenceList<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  params?: ApiQualitySessionsV1TradeCompanySessionEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualitySessionsV1TradeCompanySessionEvidenceList<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  params?: ApiQualitySessionsV1TradeCompanySessionEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualitySessionsV1TradeCompanySessionEvidenceListQueryOptions(
    tradeCompanySessionId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiQualitySessionsV1TradeCompanySessionEvidenceListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  params?: ApiQualitySessionsV1TradeCompanySessionEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiQualitySessionsV1TradeCompanySessionEvidenceListQueryKey(tradeCompanySessionId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>> = ({
    signal,
  }) => apiQualitySessionsV1TradeCompanySessionEvidenceList(tradeCompanySessionId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualitySessionsV1TradeCompanySessionEvidenceListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>
>;
export type ApiQualitySessionsV1TradeCompanySessionEvidenceListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiQualitySessionsV1TradeCompanySessionEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  params: undefined | ApiQualitySessionsV1TradeCompanySessionEvidenceListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1TradeCompanySessionEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  params?: ApiQualitySessionsV1TradeCompanySessionEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1TradeCompanySessionEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  params?: ApiQualitySessionsV1TradeCompanySessionEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualitySessionsV1TradeCompanySessionEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  params?: ApiQualitySessionsV1TradeCompanySessionEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualitySessionsV1TradeCompanySessionEvidenceListSuspenseQueryOptions(
    tradeCompanySessionId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve = (
  tradeCompanySessionId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Evidence>(
    {
      url: `/api/quality/sessions/v1/trade-company-session/${tradeCompanySessionId}/evidence/${id}/`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getApiQualitySessionsV1TradeCompanySessionEvidenceRetrieveQueryKey = (
  tradeCompanySessionId: number,
  id: number
) => {
  return [`/api/quality/sessions/v1/trade-company-session/${tradeCompanySessionId}/evidence/${id}/`] as const;
};

export const getApiQualitySessionsV1TradeCompanySessionEvidenceRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiQualitySessionsV1TradeCompanySessionEvidenceRetrieveQueryKey(tradeCompanySessionId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>> = ({
    signal,
  }) => apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve(tradeCompanySessionId, id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(tradeCompanySessionId && id), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualitySessionsV1TradeCompanySessionEvidenceRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>
>;
export type ApiQualitySessionsV1TradeCompanySessionEvidenceRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiQualitySessionsV1TradeCompanySessionEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1TradeCompanySessionEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1TradeCompanySessionEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualitySessionsV1TradeCompanySessionEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualitySessionsV1TradeCompanySessionEvidenceRetrieveQueryOptions(
    tradeCompanySessionId,
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiQualitySessionsV1TradeCompanySessionEvidenceRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiQualitySessionsV1TradeCompanySessionEvidenceRetrieveQueryKey(tradeCompanySessionId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>> = ({
    signal,
  }) => apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve(tradeCompanySessionId, id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualitySessionsV1TradeCompanySessionEvidenceRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>
>;
export type ApiQualitySessionsV1TradeCompanySessionEvidenceRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiQualitySessionsV1TradeCompanySessionEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1TradeCompanySessionEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1TradeCompanySessionEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualitySessionsV1TradeCompanySessionEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualitySessionsV1TradeCompanySessionEvidenceRetrieveSuspenseQueryOptions(
    tradeCompanySessionId,
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiQualitySessionsV1TradeCompanySessionSampleRetrieve = (
  tradeCompanySessionId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<TradeCompanySessionSampleWithAverageFeatures>(
    { url: `/api/quality/sessions/v1/trade-company-session/${tradeCompanySessionId}/sample/`, method: 'GET', signal },
    options
  );
};

export const getApiQualitySessionsV1TradeCompanySessionSampleRetrieveQueryKey = (tradeCompanySessionId: number) => {
  return [`/api/quality/sessions/v1/trade-company-session/${tradeCompanySessionId}/sample/`] as const;
};

export const getApiQualitySessionsV1TradeCompanySessionSampleRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiQualitySessionsV1TradeCompanySessionSampleRetrieveQueryKey(tradeCompanySessionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>> = ({
    signal,
  }) => apiQualitySessionsV1TradeCompanySessionSampleRetrieve(tradeCompanySessionId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!tradeCompanySessionId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualitySessionsV1TradeCompanySessionSampleRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>
>;
export type ApiQualitySessionsV1TradeCompanySessionSampleRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiQualitySessionsV1TradeCompanySessionSampleRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1TradeCompanySessionSampleRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1TradeCompanySessionSampleRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualitySessionsV1TradeCompanySessionSampleRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualitySessionsV1TradeCompanySessionSampleRetrieveQueryOptions(
    tradeCompanySessionId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiQualitySessionsV1TradeCompanySessionSampleRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiQualitySessionsV1TradeCompanySessionSampleRetrieveQueryKey(tradeCompanySessionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>> = ({
    signal,
  }) => apiQualitySessionsV1TradeCompanySessionSampleRetrieve(tradeCompanySessionId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualitySessionsV1TradeCompanySessionSampleRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>
>;
export type ApiQualitySessionsV1TradeCompanySessionSampleRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiQualitySessionsV1TradeCompanySessionSampleRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1TradeCompanySessionSampleRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1TradeCompanySessionSampleRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualitySessionsV1TradeCompanySessionSampleRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualitySessionsV1TradeCompanySessionSampleRetrieveSuspenseQueryOptions(
    tradeCompanySessionId,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiQualitySessionsV1TradeCompanySessionSampleCreate = (
  tradeCompanySessionId: number,
  createTradeCompanySessionSample: BodyType<CreateTradeCompanySessionSample>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleTradeCompanySessionSample>(
    {
      url: `/api/quality/sessions/v1/trade-company-session/${tradeCompanySessionId}/sample/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createTradeCompanySessionSample,
      signal,
    },
    options
  );
};

export const getApiQualitySessionsV1TradeCompanySessionSampleCreateMutationOptions = <
  TError = ErrorType<ApiQualitySessionsV1TradeCompanySessionSampleCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleCreate>>,
    TError,
    { tradeCompanySessionId: number; data: BodyType<CreateTradeCompanySessionSample> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleCreate>>,
  TError,
  { tradeCompanySessionId: number; data: BodyType<CreateTradeCompanySessionSample> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleCreate>>,
    { tradeCompanySessionId: number; data: BodyType<CreateTradeCompanySessionSample> }
  > = (props) => {
    const { tradeCompanySessionId, data } = props ?? {};

    return apiQualitySessionsV1TradeCompanySessionSampleCreate(tradeCompanySessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiQualitySessionsV1TradeCompanySessionSampleCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleCreate>>
>;
export type ApiQualitySessionsV1TradeCompanySessionSampleCreateMutationBody = BodyType<CreateTradeCompanySessionSample>;
export type ApiQualitySessionsV1TradeCompanySessionSampleCreateMutationError = ErrorType<
  ApiQualitySessionsV1TradeCompanySessionSampleCreate400 | ErrorResponse
>;

export const useApiQualitySessionsV1TradeCompanySessionSampleCreate = <
  TError = ErrorType<ApiQualitySessionsV1TradeCompanySessionSampleCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleCreate>>,
    TError,
    { tradeCompanySessionId: number; data: BodyType<CreateTradeCompanySessionSample> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionSampleCreate>>,
  TError,
  { tradeCompanySessionId: number; data: BodyType<CreateTradeCompanySessionSample> },
  TContext
> => {
  const mutationOptions = getApiQualitySessionsV1TradeCompanySessionSampleCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiQualitySessionsV1TradeCompanySessionsRetrieve = (
  tradeCompanySessionId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<FullTradeCompanySession>(
    { url: `/api/quality/sessions/v1/trade-company-sessions/${tradeCompanySessionId}/`, method: 'GET', signal },
    options
  );
};

export const getApiQualitySessionsV1TradeCompanySessionsRetrieveQueryKey = (tradeCompanySessionId: number) => {
  return [`/api/quality/sessions/v1/trade-company-sessions/${tradeCompanySessionId}/`] as const;
};

export const getApiQualitySessionsV1TradeCompanySessionsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiQualitySessionsV1TradeCompanySessionsRetrieveQueryKey(tradeCompanySessionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>> = ({
    signal,
  }) => apiQualitySessionsV1TradeCompanySessionsRetrieve(tradeCompanySessionId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!tradeCompanySessionId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualitySessionsV1TradeCompanySessionsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>
>;
export type ApiQualitySessionsV1TradeCompanySessionsRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiQualitySessionsV1TradeCompanySessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1TradeCompanySessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1TradeCompanySessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualitySessionsV1TradeCompanySessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualitySessionsV1TradeCompanySessionsRetrieveQueryOptions(tradeCompanySessionId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiQualitySessionsV1TradeCompanySessionsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiQualitySessionsV1TradeCompanySessionsRetrieveQueryKey(tradeCompanySessionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>> = ({
    signal,
  }) => apiQualitySessionsV1TradeCompanySessionsRetrieve(tradeCompanySessionId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiQualitySessionsV1TradeCompanySessionsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>
>;
export type ApiQualitySessionsV1TradeCompanySessionsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiQualitySessionsV1TradeCompanySessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1TradeCompanySessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiQualitySessionsV1TradeCompanySessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiQualitySessionsV1TradeCompanySessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanySessionId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiQualitySessionsV1TradeCompanySessionsRetrieveSuspenseQueryOptions(
    tradeCompanySessionId,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiQualitySessionsV1TradeCompanySessionsPartialUpdate = (
  tradeCompanySessionId: number,
  patchedTradeCompanySessionUpdateDTO: BodyType<PatchedTradeCompanySessionUpdateDTO>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<void>(
    {
      url: `/api/quality/sessions/v1/trade-company-sessions/${tradeCompanySessionId}/`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchedTradeCompanySessionUpdateDTO,
    },
    options
  );
};

export const getApiQualitySessionsV1TradeCompanySessionsPartialUpdateMutationOptions = <
  TError = ErrorType<ApiQualitySessionsV1TradeCompanySessionsPartialUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsPartialUpdate>>,
    TError,
    { tradeCompanySessionId: number; data: BodyType<PatchedTradeCompanySessionUpdateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsPartialUpdate>>,
  TError,
  { tradeCompanySessionId: number; data: BodyType<PatchedTradeCompanySessionUpdateDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsPartialUpdate>>,
    { tradeCompanySessionId: number; data: BodyType<PatchedTradeCompanySessionUpdateDTO> }
  > = (props) => {
    const { tradeCompanySessionId, data } = props ?? {};

    return apiQualitySessionsV1TradeCompanySessionsPartialUpdate(tradeCompanySessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiQualitySessionsV1TradeCompanySessionsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsPartialUpdate>>
>;
export type ApiQualitySessionsV1TradeCompanySessionsPartialUpdateMutationBody =
  BodyType<PatchedTradeCompanySessionUpdateDTO>;
export type ApiQualitySessionsV1TradeCompanySessionsPartialUpdateMutationError = ErrorType<
  ApiQualitySessionsV1TradeCompanySessionsPartialUpdate400 | ErrorResponse
>;

export const useApiQualitySessionsV1TradeCompanySessionsPartialUpdate = <
  TError = ErrorType<ApiQualitySessionsV1TradeCompanySessionsPartialUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsPartialUpdate>>,
    TError,
    { tradeCompanySessionId: number; data: BodyType<PatchedTradeCompanySessionUpdateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsPartialUpdate>>,
  TError,
  { tradeCompanySessionId: number; data: BodyType<PatchedTradeCompanySessionUpdateDTO> },
  TContext
> => {
  const mutationOptions = getApiQualitySessionsV1TradeCompanySessionsPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiQualitySessionsV1TradeCompanySessionsDestroy = (
  tradeCompanySessionId: number,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<void>(
    { url: `/api/quality/sessions/v1/trade-company-sessions/${tradeCompanySessionId}/`, method: 'DELETE' },
    options
  );
};

export const getApiQualitySessionsV1TradeCompanySessionsDestroyMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsDestroy>>,
    TError,
    { tradeCompanySessionId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsDestroy>>,
  TError,
  { tradeCompanySessionId: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsDestroy>>,
    { tradeCompanySessionId: number }
  > = (props) => {
    const { tradeCompanySessionId } = props ?? {};

    return apiQualitySessionsV1TradeCompanySessionsDestroy(tradeCompanySessionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiQualitySessionsV1TradeCompanySessionsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsDestroy>>
>;

export type ApiQualitySessionsV1TradeCompanySessionsDestroyMutationError = ErrorType<ErrorResponse>;

export const useApiQualitySessionsV1TradeCompanySessionsDestroy = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsDestroy>>,
    TError,
    { tradeCompanySessionId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsDestroy>>,
  TError,
  { tradeCompanySessionId: number },
  TContext
> => {
  const mutationOptions = getApiQualitySessionsV1TradeCompanySessionsDestroyMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Generate an upload URL for large files.
 */
export const apiQualitySessionsV1TradeCompanySessionsEvidenceUploadCreate = (
  tradeCompanySessionId: number,
  generateUploadUrlRequest: BodyType<GenerateUploadUrlRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GenerateUploadUrlResponse>(
    {
      url: `/api/quality/sessions/v1/trade-company-sessions/${tradeCompanySessionId}/evidence/upload`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: generateUploadUrlRequest,
      signal,
    },
    options
  );
};

export const getApiQualitySessionsV1TradeCompanySessionsEvidenceUploadCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsEvidenceUploadCreate>>,
    TError,
    { tradeCompanySessionId: number; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsEvidenceUploadCreate>>,
  TError,
  { tradeCompanySessionId: number; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsEvidenceUploadCreate>>,
    { tradeCompanySessionId: number; data: BodyType<GenerateUploadUrlRequest> }
  > = (props) => {
    const { tradeCompanySessionId, data } = props ?? {};

    return apiQualitySessionsV1TradeCompanySessionsEvidenceUploadCreate(tradeCompanySessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiQualitySessionsV1TradeCompanySessionsEvidenceUploadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsEvidenceUploadCreate>>
>;
export type ApiQualitySessionsV1TradeCompanySessionsEvidenceUploadCreateMutationBody =
  BodyType<GenerateUploadUrlRequest>;
export type ApiQualitySessionsV1TradeCompanySessionsEvidenceUploadCreateMutationError = ErrorType<ErrorResponse>;

export const useApiQualitySessionsV1TradeCompanySessionsEvidenceUploadCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsEvidenceUploadCreate>>,
    TError,
    { tradeCompanySessionId: number; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsEvidenceUploadCreate>>,
  TError,
  { tradeCompanySessionId: number; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const mutationOptions = getApiQualitySessionsV1TradeCompanySessionsEvidenceUploadCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Saves evidence as bale photo and returns inference results.
 */
export const apiQualitySessionsV1TradeCompanySessionsEvidenceUploadUpdate = (
  tradeCompanySessionId: number,
  processUploadRequest: BodyType<ProcessUploadRequest>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<ProcessUploadResponse>(
    {
      url: `/api/quality/sessions/v1/trade-company-sessions/${tradeCompanySessionId}/evidence/upload`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: processUploadRequest,
    },
    options
  );
};

export const getApiQualitySessionsV1TradeCompanySessionsEvidenceUploadUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsEvidenceUploadUpdate>>,
    TError,
    { tradeCompanySessionId: number; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsEvidenceUploadUpdate>>,
  TError,
  { tradeCompanySessionId: number; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsEvidenceUploadUpdate>>,
    { tradeCompanySessionId: number; data: BodyType<ProcessUploadRequest> }
  > = (props) => {
    const { tradeCompanySessionId, data } = props ?? {};

    return apiQualitySessionsV1TradeCompanySessionsEvidenceUploadUpdate(tradeCompanySessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiQualitySessionsV1TradeCompanySessionsEvidenceUploadUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsEvidenceUploadUpdate>>
>;
export type ApiQualitySessionsV1TradeCompanySessionsEvidenceUploadUpdateMutationBody = BodyType<ProcessUploadRequest>;
export type ApiQualitySessionsV1TradeCompanySessionsEvidenceUploadUpdateMutationError = ErrorType<unknown>;

export const useApiQualitySessionsV1TradeCompanySessionsEvidenceUploadUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsEvidenceUploadUpdate>>,
    TError,
    { tradeCompanySessionId: number; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsEvidenceUploadUpdate>>,
  TError,
  { tradeCompanySessionId: number; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const mutationOptions = getApiQualitySessionsV1TradeCompanySessionsEvidenceUploadUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate = (
  tradeCompanySessionId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GeneratePDFResponse>(
    {
      url: `/api/quality/sessions/v1/trade-company-sessions/${tradeCompanySessionId}/generate-pdf/`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getApiQualitySessionsV1TradeCompanySessionsGeneratePdfCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate>>,
    TError,
    { tradeCompanySessionId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate>>,
  TError,
  { tradeCompanySessionId: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate>>,
    { tradeCompanySessionId: number }
  > = (props) => {
    const { tradeCompanySessionId } = props ?? {};

    return apiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate(tradeCompanySessionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiQualitySessionsV1TradeCompanySessionsGeneratePdfCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate>>
>;

export type ApiQualitySessionsV1TradeCompanySessionsGeneratePdfCreateMutationError = ErrorType<ErrorResponse>;

export const useApiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate>>,
    TError,
    { tradeCompanySessionId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate>>,
  TError,
  { tradeCompanySessionId: number },
  TContext
> => {
  const mutationOptions = getApiQualitySessionsV1TradeCompanySessionsGeneratePdfCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiSamplesV1SamplesCreate = (
  createSampleDTO: BodyType<CreateSampleDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SiteMaterialSampleWithBreakdown>(
    {
      url: `/api/samples/v1/samples/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createSampleDTO,
      signal,
    },
    options
  );
};

export const getApiSamplesV1SamplesCreateMutationOptions = <
  TError = ErrorType<ApiSamplesV1SamplesCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesCreate>>,
    TError,
    { data: BodyType<CreateSampleDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSamplesV1SamplesCreate>>,
  TError,
  { data: BodyType<CreateSampleDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSamplesV1SamplesCreate>>,
    { data: BodyType<CreateSampleDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return apiSamplesV1SamplesCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSamplesV1SamplesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesCreate>>
>;
export type ApiSamplesV1SamplesCreateMutationBody = BodyType<CreateSampleDTO>;
export type ApiSamplesV1SamplesCreateMutationError = ErrorType<ApiSamplesV1SamplesCreate400 | ErrorResponse>;

export const useApiSamplesV1SamplesCreate = <
  TError = ErrorType<ApiSamplesV1SamplesCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesCreate>>,
    TError,
    { data: BodyType<CreateSampleDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSamplesV1SamplesCreate>>,
  TError,
  { data: BodyType<CreateSampleDTO> },
  TContext
> => {
  const mutationOptions = getApiSamplesV1SamplesCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiSamplesV1SamplesEvidenceList = (
  objectId: number,
  params?: ApiSamplesV1SamplesEvidenceListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedEvidenceList>(
    { url: `/api/samples/v1/samples/${objectId}/evidence/`, method: 'GET', params, signal },
    options
  );
};

export const getApiSamplesV1SamplesEvidenceListQueryKey = (
  objectId: number,
  params?: ApiSamplesV1SamplesEvidenceListParams
) => {
  return [`/api/samples/v1/samples/${objectId}/evidence/`, ...(params ? [params] : [])] as const;
};

export const getApiSamplesV1SamplesEvidenceListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params?: ApiSamplesV1SamplesEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSamplesV1SamplesEvidenceListQueryKey(objectId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>> = ({ signal }) =>
    apiSamplesV1SamplesEvidenceList(objectId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!objectId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SamplesEvidenceListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>
>;
export type ApiSamplesV1SamplesEvidenceListQueryError = ErrorType<ErrorResponse>;

export function useApiSamplesV1SamplesEvidenceList<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params: undefined | ApiSamplesV1SamplesEvidenceListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesEvidenceList<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params?: ApiSamplesV1SamplesEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesEvidenceList<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params?: ApiSamplesV1SamplesEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SamplesEvidenceList<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params?: ApiSamplesV1SamplesEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SamplesEvidenceListQueryOptions(objectId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSamplesV1SamplesEvidenceListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params?: ApiSamplesV1SamplesEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSamplesV1SamplesEvidenceListQueryKey(objectId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>> = ({ signal }) =>
    apiSamplesV1SamplesEvidenceList(objectId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SamplesEvidenceListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>
>;
export type ApiSamplesV1SamplesEvidenceListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiSamplesV1SamplesEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params: undefined | ApiSamplesV1SamplesEvidenceListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params?: ApiSamplesV1SamplesEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params?: ApiSamplesV1SamplesEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SamplesEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params?: ApiSamplesV1SamplesEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SamplesEvidenceListSuspenseQueryOptions(objectId, params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiSamplesV1SamplesEvidenceRetrieve = (
  objectId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Evidence>(
    { url: `/api/samples/v1/samples/${objectId}/evidence/${id}/`, method: 'GET', signal },
    options
  );
};

export const getApiSamplesV1SamplesEvidenceRetrieveQueryKey = (objectId: number, id: number) => {
  return [`/api/samples/v1/samples/${objectId}/evidence/${id}/`] as const;
};

export const getApiSamplesV1SamplesEvidenceRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSamplesV1SamplesEvidenceRetrieveQueryKey(objectId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>> = ({ signal }) =>
    apiSamplesV1SamplesEvidenceRetrieve(objectId, id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(objectId && id), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SamplesEvidenceRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>
>;
export type ApiSamplesV1SamplesEvidenceRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiSamplesV1SamplesEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SamplesEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SamplesEvidenceRetrieveQueryOptions(objectId, id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSamplesV1SamplesEvidenceRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSamplesV1SamplesEvidenceRetrieveQueryKey(objectId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>> = ({ signal }) =>
    apiSamplesV1SamplesEvidenceRetrieve(objectId, id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SamplesEvidenceRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>
>;
export type ApiSamplesV1SamplesEvidenceRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiSamplesV1SamplesEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SamplesEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SamplesEvidenceRetrieveSuspenseQueryOptions(objectId, id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generate an upload URL for large files.
 */
export const apiSamplesV1SamplesUploadCreate = (
  id: number,
  generateUploadUrlRequest: BodyType<GenerateUploadUrlRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GenerateUploadUrlResponse>(
    {
      url: `/api/samples/v1/samples/${id}/upload`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: generateUploadUrlRequest,
      signal,
    },
    options
  );
};

export const getApiSamplesV1SamplesUploadCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesUploadCreate>>,
    TError,
    { id: number; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSamplesV1SamplesUploadCreate>>,
  TError,
  { id: number; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSamplesV1SamplesUploadCreate>>,
    { id: number; data: BodyType<GenerateUploadUrlRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiSamplesV1SamplesUploadCreate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSamplesV1SamplesUploadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesUploadCreate>>
>;
export type ApiSamplesV1SamplesUploadCreateMutationBody = BodyType<GenerateUploadUrlRequest>;
export type ApiSamplesV1SamplesUploadCreateMutationError = ErrorType<ErrorResponse>;

export const useApiSamplesV1SamplesUploadCreate = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesUploadCreate>>,
    TError,
    { id: number; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSamplesV1SamplesUploadCreate>>,
  TError,
  { id: number; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const mutationOptions = getApiSamplesV1SamplesUploadCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Saves evidence as bale photo and returns inference results.
 */
export const apiSamplesV1SamplesUploadUpdate = (
  id: number,
  processUploadRequest: BodyType<ProcessUploadRequest>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<ProcessUploadResponse>(
    {
      url: `/api/samples/v1/samples/${id}/upload`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: processUploadRequest,
    },
    options
  );
};

export const getApiSamplesV1SamplesUploadUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesUploadUpdate>>,
    TError,
    { id: number; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSamplesV1SamplesUploadUpdate>>,
  TError,
  { id: number; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSamplesV1SamplesUploadUpdate>>,
    { id: number; data: BodyType<ProcessUploadRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiSamplesV1SamplesUploadUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSamplesV1SamplesUploadUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesUploadUpdate>>
>;
export type ApiSamplesV1SamplesUploadUpdateMutationBody = BodyType<ProcessUploadRequest>;
export type ApiSamplesV1SamplesUploadUpdateMutationError = ErrorType<unknown>;

export const useApiSamplesV1SamplesUploadUpdate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesUploadUpdate>>,
    TError,
    { id: number; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSamplesV1SamplesUploadUpdate>>,
  TError,
  { id: number; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const mutationOptions = getApiSamplesV1SamplesUploadUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiSamplesV1SamplesRetrieve = (
  sampleId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SampleDetails>({ url: `/api/samples/v1/samples/${sampleId}/`, method: 'GET', signal }, options);
};

export const getApiSamplesV1SamplesRetrieveQueryKey = (sampleId: number) => {
  return [`/api/samples/v1/samples/${sampleId}/`] as const;
};

export const getApiSamplesV1SamplesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSamplesV1SamplesRetrieveQueryKey(sampleId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>> = ({ signal }) =>
    apiSamplesV1SamplesRetrieve(sampleId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!sampleId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SamplesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>
>;
export type ApiSamplesV1SamplesRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiSamplesV1SamplesRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SamplesRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SamplesRetrieveQueryOptions(sampleId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSamplesV1SamplesRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSamplesV1SamplesRetrieveQueryKey(sampleId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>> = ({ signal }) =>
    apiSamplesV1SamplesRetrieve(sampleId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SamplesRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>
>;
export type ApiSamplesV1SamplesRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiSamplesV1SamplesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SamplesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SamplesRetrieveSuspenseQueryOptions(sampleId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiSamplesV1SamplesUpdate = (
  sampleId: number,
  updateSampleDTO: BodyType<UpdateSampleDTO>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<SiteMaterialSampleWithBreakdown>(
    {
      url: `/api/samples/v1/samples/${sampleId}/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateSampleDTO,
    },
    options
  );
};

export const getApiSamplesV1SamplesUpdateMutationOptions = <
  TError = ErrorType<ApiSamplesV1SamplesUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesUpdate>>,
    TError,
    { sampleId: number; data: BodyType<UpdateSampleDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSamplesV1SamplesUpdate>>,
  TError,
  { sampleId: number; data: BodyType<UpdateSampleDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSamplesV1SamplesUpdate>>,
    { sampleId: number; data: BodyType<UpdateSampleDTO> }
  > = (props) => {
    const { sampleId, data } = props ?? {};

    return apiSamplesV1SamplesUpdate(sampleId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSamplesV1SamplesUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesUpdate>>
>;
export type ApiSamplesV1SamplesUpdateMutationBody = BodyType<UpdateSampleDTO>;
export type ApiSamplesV1SamplesUpdateMutationError = ErrorType<ApiSamplesV1SamplesUpdate400 | ErrorResponse>;

export const useApiSamplesV1SamplesUpdate = <
  TError = ErrorType<ApiSamplesV1SamplesUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesUpdate>>,
    TError,
    { sampleId: number; data: BodyType<UpdateSampleDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSamplesV1SamplesUpdate>>,
  TError,
  { sampleId: number; data: BodyType<UpdateSampleDTO> },
  TContext
> => {
  const mutationOptions = getApiSamplesV1SamplesUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiSamplesV1SamplesDestroy = (sampleId: number, options?: SecondParameter<typeof customAxios>) => {
  return customAxios<void>({ url: `/api/samples/v1/samples/${sampleId}/`, method: 'DELETE' }, options);
};

export const getApiSamplesV1SamplesDestroyMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesDestroy>>,
    TError,
    { sampleId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSamplesV1SamplesDestroy>>,
  TError,
  { sampleId: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiSamplesV1SamplesDestroy>>, { sampleId: number }> = (
    props
  ) => {
    const { sampleId } = props ?? {};

    return apiSamplesV1SamplesDestroy(sampleId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSamplesV1SamplesDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesDestroy>>
>;

export type ApiSamplesV1SamplesDestroyMutationError = ErrorType<ErrorResponse>;

export const useApiSamplesV1SamplesDestroy = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesDestroy>>,
    TError,
    { sampleId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSamplesV1SamplesDestroy>>,
  TError,
  { sampleId: number },
  TContext
> => {
  const mutationOptions = getApiSamplesV1SamplesDestroyMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiSamplesV1SamplesListRetrieve = (
  siteMaterialId: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SampleList>(
    { url: `/api/samples/v1/samples/${siteMaterialId}/list`, method: 'GET', signal },
    options
  );
};

export const getApiSamplesV1SamplesListRetrieveQueryKey = (siteMaterialId: string) => {
  return [`/api/samples/v1/samples/${siteMaterialId}/list`] as const;
};

export const getApiSamplesV1SamplesListRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesListRetrieve400 | ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSamplesV1SamplesListRetrieveQueryKey(siteMaterialId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>> = ({ signal }) =>
    apiSamplesV1SamplesListRetrieve(siteMaterialId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!siteMaterialId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SamplesListRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>
>;
export type ApiSamplesV1SamplesListRetrieveQueryError = ErrorType<ApiSamplesV1SamplesListRetrieve400 | ErrorResponse>;

export function useApiSamplesV1SamplesListRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesListRetrieve400 | ErrorResponse>,
>(
  siteMaterialId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesListRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesListRetrieve400 | ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesListRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesListRetrieve400 | ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SamplesListRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesListRetrieve400 | ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SamplesListRetrieveQueryOptions(siteMaterialId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSamplesV1SamplesListRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesListRetrieve400 | ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSamplesV1SamplesListRetrieveQueryKey(siteMaterialId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>> = ({ signal }) =>
    apiSamplesV1SamplesListRetrieve(siteMaterialId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SamplesListRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>
>;
export type ApiSamplesV1SamplesListRetrieveSuspenseQueryError = ErrorType<
  ApiSamplesV1SamplesListRetrieve400 | ErrorResponse
>;

export function useApiSamplesV1SamplesListRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesListRetrieve400 | ErrorResponse>,
>(
  siteMaterialId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesListRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesListRetrieve400 | ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesListRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesListRetrieve400 | ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SamplesListRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesListRetrieve400 | ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesListRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SamplesListRetrieveSuspenseQueryOptions(siteMaterialId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiSamplesV1SamplesBuyerCreate = (
  createBuyerSampleDTO: BodyType<CreateBuyerSampleDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<BuyerLoadSampleWithBreakdown>(
    {
      url: `/api/samples/v1/samples/buyer/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createBuyerSampleDTO,
      signal,
    },
    options
  );
};

export const getApiSamplesV1SamplesBuyerCreateMutationOptions = <
  TError = ErrorType<ApiSamplesV1SamplesBuyerCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerCreate>>,
    TError,
    { data: BodyType<CreateBuyerSampleDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerCreate>>,
  TError,
  { data: BodyType<CreateBuyerSampleDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerCreate>>,
    { data: BodyType<CreateBuyerSampleDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return apiSamplesV1SamplesBuyerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSamplesV1SamplesBuyerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerCreate>>
>;
export type ApiSamplesV1SamplesBuyerCreateMutationBody = BodyType<CreateBuyerSampleDTO>;
export type ApiSamplesV1SamplesBuyerCreateMutationError = ErrorType<ApiSamplesV1SamplesBuyerCreate400 | ErrorResponse>;

export const useApiSamplesV1SamplesBuyerCreate = <
  TError = ErrorType<ApiSamplesV1SamplesBuyerCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerCreate>>,
    TError,
    { data: BodyType<CreateBuyerSampleDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerCreate>>,
  TError,
  { data: BodyType<CreateBuyerSampleDTO> },
  TContext
> => {
  const mutationOptions = getApiSamplesV1SamplesBuyerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiSamplesV1SamplesBuyerEvidenceList = (
  objectId: number,
  params?: ApiSamplesV1SamplesBuyerEvidenceListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedEvidenceList>(
    { url: `/api/samples/v1/samples/buyer/${objectId}/evidence/`, method: 'GET', params, signal },
    options
  );
};

export const getApiSamplesV1SamplesBuyerEvidenceListQueryKey = (
  objectId: number,
  params?: ApiSamplesV1SamplesBuyerEvidenceListParams
) => {
  return [`/api/samples/v1/samples/buyer/${objectId}/evidence/`, ...(params ? [params] : [])] as const;
};

export const getApiSamplesV1SamplesBuyerEvidenceListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  params?: ApiSamplesV1SamplesBuyerEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSamplesV1SamplesBuyerEvidenceListQueryKey(objectId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>> = ({ signal }) =>
    apiSamplesV1SamplesBuyerEvidenceList(objectId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!objectId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SamplesBuyerEvidenceListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>
>;
export type ApiSamplesV1SamplesBuyerEvidenceListQueryError = ErrorType<unknown>;

export function useApiSamplesV1SamplesBuyerEvidenceList<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  params: undefined | ApiSamplesV1SamplesBuyerEvidenceListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesBuyerEvidenceList<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  params?: ApiSamplesV1SamplesBuyerEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesBuyerEvidenceList<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  params?: ApiSamplesV1SamplesBuyerEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SamplesBuyerEvidenceList<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  params?: ApiSamplesV1SamplesBuyerEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SamplesBuyerEvidenceListQueryOptions(objectId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSamplesV1SamplesBuyerEvidenceListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  params?: ApiSamplesV1SamplesBuyerEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSamplesV1SamplesBuyerEvidenceListQueryKey(objectId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>> = ({ signal }) =>
    apiSamplesV1SamplesBuyerEvidenceList(objectId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SamplesBuyerEvidenceListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>
>;
export type ApiSamplesV1SamplesBuyerEvidenceListSuspenseQueryError = ErrorType<unknown>;

export function useApiSamplesV1SamplesBuyerEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  params: undefined | ApiSamplesV1SamplesBuyerEvidenceListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesBuyerEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  params?: ApiSamplesV1SamplesBuyerEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesBuyerEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  params?: ApiSamplesV1SamplesBuyerEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SamplesBuyerEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  params?: ApiSamplesV1SamplesBuyerEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SamplesBuyerEvidenceListSuspenseQueryOptions(objectId, params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiSamplesV1SamplesBuyerEvidenceRetrieve = (
  objectId: number,
  id: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Evidence>(
    { url: `/api/samples/v1/samples/buyer/${objectId}/evidence/${id}/`, method: 'GET', signal },
    options
  );
};

export const getApiSamplesV1SamplesBuyerEvidenceRetrieveQueryKey = (objectId: number, id: string) => {
  return [`/api/samples/v1/samples/buyer/${objectId}/evidence/${id}/`] as const;
};

export const getApiSamplesV1SamplesBuyerEvidenceRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSamplesV1SamplesBuyerEvidenceRetrieveQueryKey(objectId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>> = ({ signal }) =>
    apiSamplesV1SamplesBuyerEvidenceRetrieve(objectId, id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(objectId && id), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SamplesBuyerEvidenceRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>
>;
export type ApiSamplesV1SamplesBuyerEvidenceRetrieveQueryError = ErrorType<unknown>;

export function useApiSamplesV1SamplesBuyerEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesBuyerEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesBuyerEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SamplesBuyerEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SamplesBuyerEvidenceRetrieveQueryOptions(objectId, id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSamplesV1SamplesBuyerEvidenceRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSamplesV1SamplesBuyerEvidenceRetrieveQueryKey(objectId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>> = ({ signal }) =>
    apiSamplesV1SamplesBuyerEvidenceRetrieve(objectId, id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SamplesBuyerEvidenceRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>
>;
export type ApiSamplesV1SamplesBuyerEvidenceRetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiSamplesV1SamplesBuyerEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesBuyerEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesBuyerEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SamplesBuyerEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>,
  TError = ErrorType<unknown>,
>(
  objectId: number,
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SamplesBuyerEvidenceRetrieveSuspenseQueryOptions(objectId, id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generate an upload URL for large files.
 */
export const apiSamplesV1SamplesBuyerUploadCreate = (
  id: number,
  generateUploadUrlRequest: BodyType<GenerateUploadUrlRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GenerateUploadUrlResponse>(
    {
      url: `/api/samples/v1/samples/buyer/${id}/upload/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: generateUploadUrlRequest,
      signal,
    },
    options
  );
};

export const getApiSamplesV1SamplesBuyerUploadCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerUploadCreate>>,
    TError,
    { id: number; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerUploadCreate>>,
  TError,
  { id: number; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerUploadCreate>>,
    { id: number; data: BodyType<GenerateUploadUrlRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiSamplesV1SamplesBuyerUploadCreate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSamplesV1SamplesBuyerUploadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerUploadCreate>>
>;
export type ApiSamplesV1SamplesBuyerUploadCreateMutationBody = BodyType<GenerateUploadUrlRequest>;
export type ApiSamplesV1SamplesBuyerUploadCreateMutationError = ErrorType<ErrorResponse>;

export const useApiSamplesV1SamplesBuyerUploadCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerUploadCreate>>,
    TError,
    { id: number; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerUploadCreate>>,
  TError,
  { id: number; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const mutationOptions = getApiSamplesV1SamplesBuyerUploadCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Saves evidence as bale photo and returns inference results.
 */
export const apiSamplesV1SamplesBuyerUploadUpdate = (
  id: number,
  processUploadRequest: BodyType<ProcessUploadRequest>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<ProcessUploadResponse>(
    {
      url: `/api/samples/v1/samples/buyer/${id}/upload/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: processUploadRequest,
    },
    options
  );
};

export const getApiSamplesV1SamplesBuyerUploadUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerUploadUpdate>>,
    TError,
    { id: number; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerUploadUpdate>>,
  TError,
  { id: number; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerUploadUpdate>>,
    { id: number; data: BodyType<ProcessUploadRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiSamplesV1SamplesBuyerUploadUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSamplesV1SamplesBuyerUploadUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerUploadUpdate>>
>;
export type ApiSamplesV1SamplesBuyerUploadUpdateMutationBody = BodyType<ProcessUploadRequest>;
export type ApiSamplesV1SamplesBuyerUploadUpdateMutationError = ErrorType<unknown>;

export const useApiSamplesV1SamplesBuyerUploadUpdate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerUploadUpdate>>,
    TError,
    { id: number; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerUploadUpdate>>,
  TError,
  { id: number; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const mutationOptions = getApiSamplesV1SamplesBuyerUploadUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiSamplesV1SamplesBuyerRetrieve = (
  sampleId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<BuyerSampleDetails>(
    { url: `/api/samples/v1/samples/buyer/${sampleId}/`, method: 'GET', signal },
    options
  );
};

export const getApiSamplesV1SamplesBuyerRetrieveQueryKey = (sampleId: number) => {
  return [`/api/samples/v1/samples/buyer/${sampleId}/`] as const;
};

export const getApiSamplesV1SamplesBuyerRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSamplesV1SamplesBuyerRetrieveQueryKey(sampleId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>> = ({ signal }) =>
    apiSamplesV1SamplesBuyerRetrieve(sampleId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!sampleId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SamplesBuyerRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>
>;
export type ApiSamplesV1SamplesBuyerRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiSamplesV1SamplesBuyerRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesBuyerRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesBuyerRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SamplesBuyerRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SamplesBuyerRetrieveQueryOptions(sampleId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSamplesV1SamplesBuyerRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSamplesV1SamplesBuyerRetrieveQueryKey(sampleId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>> = ({ signal }) =>
    apiSamplesV1SamplesBuyerRetrieve(sampleId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SamplesBuyerRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>
>;
export type ApiSamplesV1SamplesBuyerRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiSamplesV1SamplesBuyerRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesBuyerRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesBuyerRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SamplesBuyerRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SamplesBuyerRetrieveSuspenseQueryOptions(sampleId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiSamplesV1SamplesBuyerUpdate = (
  sampleId: number,
  updateBuyerSampleDTO: BodyType<UpdateBuyerSampleDTO>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<BuyerLoadSampleWithBreakdown>(
    {
      url: `/api/samples/v1/samples/buyer/${sampleId}/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateBuyerSampleDTO,
    },
    options
  );
};

export const getApiSamplesV1SamplesBuyerUpdateMutationOptions = <
  TError = ErrorType<ApiSamplesV1SamplesBuyerUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerUpdate>>,
    TError,
    { sampleId: number; data: BodyType<UpdateBuyerSampleDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerUpdate>>,
  TError,
  { sampleId: number; data: BodyType<UpdateBuyerSampleDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerUpdate>>,
    { sampleId: number; data: BodyType<UpdateBuyerSampleDTO> }
  > = (props) => {
    const { sampleId, data } = props ?? {};

    return apiSamplesV1SamplesBuyerUpdate(sampleId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSamplesV1SamplesBuyerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerUpdate>>
>;
export type ApiSamplesV1SamplesBuyerUpdateMutationBody = BodyType<UpdateBuyerSampleDTO>;
export type ApiSamplesV1SamplesBuyerUpdateMutationError = ErrorType<ApiSamplesV1SamplesBuyerUpdate400 | ErrorResponse>;

export const useApiSamplesV1SamplesBuyerUpdate = <
  TError = ErrorType<ApiSamplesV1SamplesBuyerUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerUpdate>>,
    TError,
    { sampleId: number; data: BodyType<UpdateBuyerSampleDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerUpdate>>,
  TError,
  { sampleId: number; data: BodyType<UpdateBuyerSampleDTO> },
  TContext
> => {
  const mutationOptions = getApiSamplesV1SamplesBuyerUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiSamplesV1SamplesBuyerDestroy = (sampleId: number, options?: SecondParameter<typeof customAxios>) => {
  return customAxios<void>({ url: `/api/samples/v1/samples/buyer/${sampleId}/`, method: 'DELETE' }, options);
};

export const getApiSamplesV1SamplesBuyerDestroyMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerDestroy>>,
    TError,
    { sampleId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerDestroy>>,
  TError,
  { sampleId: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerDestroy>>,
    { sampleId: number }
  > = (props) => {
    const { sampleId } = props ?? {};

    return apiSamplesV1SamplesBuyerDestroy(sampleId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSamplesV1SamplesBuyerDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerDestroy>>
>;

export type ApiSamplesV1SamplesBuyerDestroyMutationError = ErrorType<ErrorResponse>;

export const useApiSamplesV1SamplesBuyerDestroy = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerDestroy>>,
    TError,
    { sampleId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerDestroy>>,
  TError,
  { sampleId: number },
  TContext
> => {
  const mutationOptions = getApiSamplesV1SamplesBuyerDestroyMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiSamplesV1SamplesBuyerLoadListRetrieve = (
  loadId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<BuyerSampleList>(
    { url: `/api/samples/v1/samples/buyer/load/${loadId}/list/`, method: 'GET', signal },
    options
  );
};

export const getApiSamplesV1SamplesBuyerLoadListRetrieveQueryKey = (loadId: number) => {
  return [`/api/samples/v1/samples/buyer/load/${loadId}/list/`] as const;
};

export const getApiSamplesV1SamplesBuyerLoadListRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesBuyerLoadListRetrieve400 | ErrorResponse>,
>(
  loadId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSamplesV1SamplesBuyerLoadListRetrieveQueryKey(loadId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>> = ({ signal }) =>
    apiSamplesV1SamplesBuyerLoadListRetrieve(loadId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!loadId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SamplesBuyerLoadListRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>
>;
export type ApiSamplesV1SamplesBuyerLoadListRetrieveQueryError = ErrorType<
  ApiSamplesV1SamplesBuyerLoadListRetrieve400 | ErrorResponse
>;

export function useApiSamplesV1SamplesBuyerLoadListRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesBuyerLoadListRetrieve400 | ErrorResponse>,
>(
  loadId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesBuyerLoadListRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesBuyerLoadListRetrieve400 | ErrorResponse>,
>(
  loadId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesBuyerLoadListRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesBuyerLoadListRetrieve400 | ErrorResponse>,
>(
  loadId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SamplesBuyerLoadListRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesBuyerLoadListRetrieve400 | ErrorResponse>,
>(
  loadId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SamplesBuyerLoadListRetrieveQueryOptions(loadId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSamplesV1SamplesBuyerLoadListRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesBuyerLoadListRetrieve400 | ErrorResponse>,
>(
  loadId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSamplesV1SamplesBuyerLoadListRetrieveQueryKey(loadId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>> = ({ signal }) =>
    apiSamplesV1SamplesBuyerLoadListRetrieve(loadId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SamplesBuyerLoadListRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>
>;
export type ApiSamplesV1SamplesBuyerLoadListRetrieveSuspenseQueryError = ErrorType<
  ApiSamplesV1SamplesBuyerLoadListRetrieve400 | ErrorResponse
>;

export function useApiSamplesV1SamplesBuyerLoadListRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesBuyerLoadListRetrieve400 | ErrorResponse>,
>(
  loadId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesBuyerLoadListRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesBuyerLoadListRetrieve400 | ErrorResponse>,
>(
  loadId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SamplesBuyerLoadListRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesBuyerLoadListRetrieve400 | ErrorResponse>,
>(
  loadId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SamplesBuyerLoadListRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>,
  TError = ErrorType<ApiSamplesV1SamplesBuyerLoadListRetrieve400 | ErrorResponse>,
>(
  loadId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SamplesBuyerLoadListRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SamplesBuyerLoadListRetrieveSuspenseQueryOptions(loadId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generate an upload URL for large files.
 */
export const apiSamplesV1SiteMaterialSessionSampleEvidenceUploadCreate = (
  id: number,
  generateUploadUrlRequest: BodyType<GenerateUploadUrlRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GenerateUploadUrlResponse>(
    {
      url: `/api/samples/v1/site-material-session-sample/${id}/evidence/upload/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: generateUploadUrlRequest,
      signal,
    },
    options
  );
};

export const getApiSamplesV1SiteMaterialSessionSampleEvidenceUploadCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceUploadCreate>>,
    TError,
    { id: number; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceUploadCreate>>,
  TError,
  { id: number; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceUploadCreate>>,
    { id: number; data: BodyType<GenerateUploadUrlRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiSamplesV1SiteMaterialSessionSampleEvidenceUploadCreate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSamplesV1SiteMaterialSessionSampleEvidenceUploadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceUploadCreate>>
>;
export type ApiSamplesV1SiteMaterialSessionSampleEvidenceUploadCreateMutationBody = BodyType<GenerateUploadUrlRequest>;
export type ApiSamplesV1SiteMaterialSessionSampleEvidenceUploadCreateMutationError = ErrorType<ErrorResponse>;

export const useApiSamplesV1SiteMaterialSessionSampleEvidenceUploadCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceUploadCreate>>,
    TError,
    { id: number; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceUploadCreate>>,
  TError,
  { id: number; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const mutationOptions = getApiSamplesV1SiteMaterialSessionSampleEvidenceUploadCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Saves evidence as bale photo and returns inference results.
 */
export const apiSamplesV1SiteMaterialSessionSampleEvidenceUploadUpdate = (
  id: number,
  processUploadRequest: BodyType<ProcessUploadRequest>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<ProcessUploadResponse>(
    {
      url: `/api/samples/v1/site-material-session-sample/${id}/evidence/upload/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: processUploadRequest,
    },
    options
  );
};

export const getApiSamplesV1SiteMaterialSessionSampleEvidenceUploadUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceUploadUpdate>>,
    TError,
    { id: number; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceUploadUpdate>>,
  TError,
  { id: number; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceUploadUpdate>>,
    { id: number; data: BodyType<ProcessUploadRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiSamplesV1SiteMaterialSessionSampleEvidenceUploadUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSamplesV1SiteMaterialSessionSampleEvidenceUploadUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceUploadUpdate>>
>;
export type ApiSamplesV1SiteMaterialSessionSampleEvidenceUploadUpdateMutationBody = BodyType<ProcessUploadRequest>;
export type ApiSamplesV1SiteMaterialSessionSampleEvidenceUploadUpdateMutationError = ErrorType<unknown>;

export const useApiSamplesV1SiteMaterialSessionSampleEvidenceUploadUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceUploadUpdate>>,
    TError,
    { id: number; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceUploadUpdate>>,
  TError,
  { id: number; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const mutationOptions = getApiSamplesV1SiteMaterialSessionSampleEvidenceUploadUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiSamplesV1SiteMaterialSessionSampleEvidenceList = (
  sampleId: number,
  params?: ApiSamplesV1SiteMaterialSessionSampleEvidenceListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedEvidenceList>(
    { url: `/api/samples/v1/site-material-session-sample/${sampleId}/evidence/`, method: 'GET', params, signal },
    options
  );
};

export const getApiSamplesV1SiteMaterialSessionSampleEvidenceListQueryKey = (
  sampleId: number,
  params?: ApiSamplesV1SiteMaterialSessionSampleEvidenceListParams
) => {
  return [`/api/samples/v1/site-material-session-sample/${sampleId}/evidence/`, ...(params ? [params] : [])] as const;
};

export const getApiSamplesV1SiteMaterialSessionSampleEvidenceListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params?: ApiSamplesV1SiteMaterialSessionSampleEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiSamplesV1SiteMaterialSessionSampleEvidenceListQueryKey(sampleId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>> = ({
    signal,
  }) => apiSamplesV1SiteMaterialSessionSampleEvidenceList(sampleId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!sampleId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SiteMaterialSessionSampleEvidenceListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>
>;
export type ApiSamplesV1SiteMaterialSessionSampleEvidenceListQueryError = ErrorType<ErrorResponse>;

export function useApiSamplesV1SiteMaterialSessionSampleEvidenceList<
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params: undefined | ApiSamplesV1SiteMaterialSessionSampleEvidenceListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SiteMaterialSessionSampleEvidenceList<
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params?: ApiSamplesV1SiteMaterialSessionSampleEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SiteMaterialSessionSampleEvidenceList<
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params?: ApiSamplesV1SiteMaterialSessionSampleEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SiteMaterialSessionSampleEvidenceList<
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params?: ApiSamplesV1SiteMaterialSessionSampleEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SiteMaterialSessionSampleEvidenceListQueryOptions(sampleId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSamplesV1SiteMaterialSessionSampleEvidenceListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params?: ApiSamplesV1SiteMaterialSessionSampleEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiSamplesV1SiteMaterialSessionSampleEvidenceListQueryKey(sampleId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>> = ({
    signal,
  }) => apiSamplesV1SiteMaterialSessionSampleEvidenceList(sampleId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SiteMaterialSessionSampleEvidenceListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>
>;
export type ApiSamplesV1SiteMaterialSessionSampleEvidenceListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiSamplesV1SiteMaterialSessionSampleEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params: undefined | ApiSamplesV1SiteMaterialSessionSampleEvidenceListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SiteMaterialSessionSampleEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params?: ApiSamplesV1SiteMaterialSessionSampleEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SiteMaterialSessionSampleEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params?: ApiSamplesV1SiteMaterialSessionSampleEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SiteMaterialSessionSampleEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params?: ApiSamplesV1SiteMaterialSessionSampleEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SiteMaterialSessionSampleEvidenceListSuspenseQueryOptions(
    sampleId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve = (
  sampleId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Evidence>(
    { url: `/api/samples/v1/site-material-session-sample/${sampleId}/evidence/${id}/`, method: 'GET', signal },
    options
  );
};

export const getApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieveQueryKey = (sampleId: number, id: number) => {
  return [`/api/samples/v1/site-material-session-sample/${sampleId}/evidence/${id}/`] as const;
};

export const getApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieveQueryKey(sampleId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>> = ({
    signal,
  }) => apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve(sampleId, id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(sampleId && id), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>
>;
export type ApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieveQueryOptions(sampleId, id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieveQueryKey(sampleId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>> = ({
    signal,
  }) => apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve(sampleId, id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>
>;
export type ApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1SiteMaterialSessionSampleEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1SiteMaterialSessionSampleEvidenceRetrieveSuspenseQueryOptions(
    sampleId,
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generate an upload URL for large files.
 */
export const apiSamplesV1TradeCompanySessionSampleEvidenceUploadCreate = (
  id: number,
  generateUploadUrlRequest: BodyType<GenerateUploadUrlRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GenerateUploadUrlResponse>(
    {
      url: `/api/samples/v1/trade-company-session-sample/${id}/evidence/upload/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: generateUploadUrlRequest,
      signal,
    },
    options
  );
};

export const getApiSamplesV1TradeCompanySessionSampleEvidenceUploadCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceUploadCreate>>,
    TError,
    { id: number; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceUploadCreate>>,
  TError,
  { id: number; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceUploadCreate>>,
    { id: number; data: BodyType<GenerateUploadUrlRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiSamplesV1TradeCompanySessionSampleEvidenceUploadCreate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSamplesV1TradeCompanySessionSampleEvidenceUploadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceUploadCreate>>
>;
export type ApiSamplesV1TradeCompanySessionSampleEvidenceUploadCreateMutationBody = BodyType<GenerateUploadUrlRequest>;
export type ApiSamplesV1TradeCompanySessionSampleEvidenceUploadCreateMutationError = ErrorType<ErrorResponse>;

export const useApiSamplesV1TradeCompanySessionSampleEvidenceUploadCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceUploadCreate>>,
    TError,
    { id: number; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceUploadCreate>>,
  TError,
  { id: number; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const mutationOptions = getApiSamplesV1TradeCompanySessionSampleEvidenceUploadCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Saves evidence as bale photo and returns inference results.
 */
export const apiSamplesV1TradeCompanySessionSampleEvidenceUploadUpdate = (
  id: number,
  processUploadRequest: BodyType<ProcessUploadRequest>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<ProcessUploadResponse>(
    {
      url: `/api/samples/v1/trade-company-session-sample/${id}/evidence/upload/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: processUploadRequest,
    },
    options
  );
};

export const getApiSamplesV1TradeCompanySessionSampleEvidenceUploadUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceUploadUpdate>>,
    TError,
    { id: number; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceUploadUpdate>>,
  TError,
  { id: number; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceUploadUpdate>>,
    { id: number; data: BodyType<ProcessUploadRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiSamplesV1TradeCompanySessionSampleEvidenceUploadUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSamplesV1TradeCompanySessionSampleEvidenceUploadUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceUploadUpdate>>
>;
export type ApiSamplesV1TradeCompanySessionSampleEvidenceUploadUpdateMutationBody = BodyType<ProcessUploadRequest>;
export type ApiSamplesV1TradeCompanySessionSampleEvidenceUploadUpdateMutationError = ErrorType<unknown>;

export const useApiSamplesV1TradeCompanySessionSampleEvidenceUploadUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceUploadUpdate>>,
    TError,
    { id: number; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceUploadUpdate>>,
  TError,
  { id: number; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const mutationOptions = getApiSamplesV1TradeCompanySessionSampleEvidenceUploadUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiSamplesV1TradeCompanySessionSampleEvidenceList = (
  sampleId: number,
  params?: ApiSamplesV1TradeCompanySessionSampleEvidenceListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedEvidenceList>(
    { url: `/api/samples/v1/trade-company-session-sample/${sampleId}/evidence/`, method: 'GET', params, signal },
    options
  );
};

export const getApiSamplesV1TradeCompanySessionSampleEvidenceListQueryKey = (
  sampleId: number,
  params?: ApiSamplesV1TradeCompanySessionSampleEvidenceListParams
) => {
  return [`/api/samples/v1/trade-company-session-sample/${sampleId}/evidence/`, ...(params ? [params] : [])] as const;
};

export const getApiSamplesV1TradeCompanySessionSampleEvidenceListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params?: ApiSamplesV1TradeCompanySessionSampleEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiSamplesV1TradeCompanySessionSampleEvidenceListQueryKey(sampleId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>> = ({
    signal,
  }) => apiSamplesV1TradeCompanySessionSampleEvidenceList(sampleId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!sampleId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1TradeCompanySessionSampleEvidenceListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>
>;
export type ApiSamplesV1TradeCompanySessionSampleEvidenceListQueryError = ErrorType<ErrorResponse>;

export function useApiSamplesV1TradeCompanySessionSampleEvidenceList<
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params: undefined | ApiSamplesV1TradeCompanySessionSampleEvidenceListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1TradeCompanySessionSampleEvidenceList<
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params?: ApiSamplesV1TradeCompanySessionSampleEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1TradeCompanySessionSampleEvidenceList<
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params?: ApiSamplesV1TradeCompanySessionSampleEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1TradeCompanySessionSampleEvidenceList<
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params?: ApiSamplesV1TradeCompanySessionSampleEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1TradeCompanySessionSampleEvidenceListQueryOptions(sampleId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSamplesV1TradeCompanySessionSampleEvidenceListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params?: ApiSamplesV1TradeCompanySessionSampleEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiSamplesV1TradeCompanySessionSampleEvidenceListQueryKey(sampleId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>> = ({
    signal,
  }) => apiSamplesV1TradeCompanySessionSampleEvidenceList(sampleId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1TradeCompanySessionSampleEvidenceListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>
>;
export type ApiSamplesV1TradeCompanySessionSampleEvidenceListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiSamplesV1TradeCompanySessionSampleEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params: undefined | ApiSamplesV1TradeCompanySessionSampleEvidenceListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1TradeCompanySessionSampleEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params?: ApiSamplesV1TradeCompanySessionSampleEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1TradeCompanySessionSampleEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params?: ApiSamplesV1TradeCompanySessionSampleEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1TradeCompanySessionSampleEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  params?: ApiSamplesV1TradeCompanySessionSampleEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1TradeCompanySessionSampleEvidenceListSuspenseQueryOptions(
    sampleId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve = (
  sampleId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Evidence>(
    { url: `/api/samples/v1/trade-company-session-sample/${sampleId}/evidence/${id}/`, method: 'GET', signal },
    options
  );
};

export const getApiSamplesV1TradeCompanySessionSampleEvidenceRetrieveQueryKey = (sampleId: number, id: number) => {
  return [`/api/samples/v1/trade-company-session-sample/${sampleId}/evidence/${id}/`] as const;
};

export const getApiSamplesV1TradeCompanySessionSampleEvidenceRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiSamplesV1TradeCompanySessionSampleEvidenceRetrieveQueryKey(sampleId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>> = ({
    signal,
  }) => apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve(sampleId, id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(sampleId && id), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1TradeCompanySessionSampleEvidenceRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>
>;
export type ApiSamplesV1TradeCompanySessionSampleEvidenceRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiSamplesV1TradeCompanySessionSampleEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1TradeCompanySessionSampleEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1TradeCompanySessionSampleEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1TradeCompanySessionSampleEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1TradeCompanySessionSampleEvidenceRetrieveQueryOptions(sampleId, id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSamplesV1TradeCompanySessionSampleEvidenceRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiSamplesV1TradeCompanySessionSampleEvidenceRetrieveQueryKey(sampleId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>> = ({
    signal,
  }) => apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve(sampleId, id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSamplesV1TradeCompanySessionSampleEvidenceRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>
>;
export type ApiSamplesV1TradeCompanySessionSampleEvidenceRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiSamplesV1TradeCompanySessionSampleEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1TradeCompanySessionSampleEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSamplesV1TradeCompanySessionSampleEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSamplesV1TradeCompanySessionSampleEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  sampleId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSamplesV1TradeCompanySessionSampleEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSamplesV1TradeCompanySessionSampleEvidenceRetrieveSuspenseQueryOptions(
    sampleId,
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List all material specs enabled within self serve
 */
export const apiSelfserveV1EnabledMaterialSpecsRetrieve = (
  params?: ApiSelfserveV1EnabledMaterialSpecsRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ListResponseEnabledMaterialSpecs>(
    { url: `/api/selfserve/v1/enabled-material-specs/`, method: 'GET', params, signal },
    options
  );
};

export const getApiSelfserveV1EnabledMaterialSpecsRetrieveQueryKey = (
  params?: ApiSelfserveV1EnabledMaterialSpecsRetrieveParams
) => {
  return [`/api/selfserve/v1/enabled-material-specs/`, ...(params ? [params] : [])] as const;
};

export const getApiSelfserveV1EnabledMaterialSpecsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiSelfserveV1EnabledMaterialSpecsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSelfserveV1EnabledMaterialSpecsRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>> = ({ signal }) =>
    apiSelfserveV1EnabledMaterialSpecsRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSelfserveV1EnabledMaterialSpecsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>
>;
export type ApiSelfserveV1EnabledMaterialSpecsRetrieveQueryError = ErrorType<unknown>;

export function useApiSelfserveV1EnabledMaterialSpecsRetrieve<
  TData = Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiSelfserveV1EnabledMaterialSpecsRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV1EnabledMaterialSpecsRetrieve<
  TData = Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiSelfserveV1EnabledMaterialSpecsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV1EnabledMaterialSpecsRetrieve<
  TData = Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiSelfserveV1EnabledMaterialSpecsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSelfserveV1EnabledMaterialSpecsRetrieve<
  TData = Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiSelfserveV1EnabledMaterialSpecsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSelfserveV1EnabledMaterialSpecsRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSelfserveV1EnabledMaterialSpecsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiSelfserveV1EnabledMaterialSpecsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSelfserveV1EnabledMaterialSpecsRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>> = ({ signal }) =>
    apiSelfserveV1EnabledMaterialSpecsRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSelfserveV1EnabledMaterialSpecsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>
>;
export type ApiSelfserveV1EnabledMaterialSpecsRetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiSelfserveV1EnabledMaterialSpecsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiSelfserveV1EnabledMaterialSpecsRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV1EnabledMaterialSpecsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiSelfserveV1EnabledMaterialSpecsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV1EnabledMaterialSpecsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiSelfserveV1EnabledMaterialSpecsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSelfserveV1EnabledMaterialSpecsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiSelfserveV1EnabledMaterialSpecsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1EnabledMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSelfserveV1EnabledMaterialSpecsRetrieveSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiSelfserveV1MaterialDemandCreateCreate = (
  createMaterialDemandRequestDTO: BodyType<CreateMaterialDemandRequestDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    {
      url: `/api/selfserve/v1/material-demand/create/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createMaterialDemandRequestDTO,
      signal,
    },
    options
  );
};

export const getApiSelfserveV1MaterialDemandCreateCreateMutationOptions = <
  TError = ErrorType<ApiSelfserveV1MaterialDemandCreateCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSelfserveV1MaterialDemandCreateCreate>>,
    TError,
    { data: BodyType<CreateMaterialDemandRequestDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSelfserveV1MaterialDemandCreateCreate>>,
  TError,
  { data: BodyType<CreateMaterialDemandRequestDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSelfserveV1MaterialDemandCreateCreate>>,
    { data: BodyType<CreateMaterialDemandRequestDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return apiSelfserveV1MaterialDemandCreateCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSelfserveV1MaterialDemandCreateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSelfserveV1MaterialDemandCreateCreate>>
>;
export type ApiSelfserveV1MaterialDemandCreateCreateMutationBody = BodyType<CreateMaterialDemandRequestDTO>;
export type ApiSelfserveV1MaterialDemandCreateCreateMutationError = ErrorType<
  ApiSelfserveV1MaterialDemandCreateCreate400 | ErrorResponse
>;

export const useApiSelfserveV1MaterialDemandCreateCreate = <
  TError = ErrorType<ApiSelfserveV1MaterialDemandCreateCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSelfserveV1MaterialDemandCreateCreate>>,
    TError,
    { data: BodyType<CreateMaterialDemandRequestDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSelfserveV1MaterialDemandCreateCreate>>,
  TError,
  { data: BodyType<CreateMaterialDemandRequestDTO> },
  TContext
> => {
  const mutationOptions = getApiSelfserveV1MaterialDemandCreateCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiSelfserveV1MaterialSupplyList = (
  params?: ApiSelfserveV1MaterialSupplyListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AvailableMaterialSupplyResponseDTO>(
    { url: `/api/selfserve/v1/material-supply/`, method: 'GET', params, signal },
    options
  );
};

export const getApiSelfserveV1MaterialSupplyListQueryKey = (params?: ApiSelfserveV1MaterialSupplyListParams) => {
  return [`/api/selfserve/v1/material-supply/`, ...(params ? [params] : [])] as const;
};

export const getApiSelfserveV1MaterialSupplyListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>,
  TError = ErrorType<ApiSelfserveV1MaterialSupplyList400 | ErrorResponse>,
>(
  params?: ApiSelfserveV1MaterialSupplyListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSelfserveV1MaterialSupplyListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>> = ({ signal }) =>
    apiSelfserveV1MaterialSupplyList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSelfserveV1MaterialSupplyListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>
>;
export type ApiSelfserveV1MaterialSupplyListQueryError = ErrorType<ApiSelfserveV1MaterialSupplyList400 | ErrorResponse>;

export function useApiSelfserveV1MaterialSupplyList<
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>,
  TError = ErrorType<ApiSelfserveV1MaterialSupplyList400 | ErrorResponse>,
>(
  params: undefined | ApiSelfserveV1MaterialSupplyListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV1MaterialSupplyList<
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>,
  TError = ErrorType<ApiSelfserveV1MaterialSupplyList400 | ErrorResponse>,
>(
  params?: ApiSelfserveV1MaterialSupplyListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV1MaterialSupplyList<
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>,
  TError = ErrorType<ApiSelfserveV1MaterialSupplyList400 | ErrorResponse>,
>(
  params?: ApiSelfserveV1MaterialSupplyListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSelfserveV1MaterialSupplyList<
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>,
  TError = ErrorType<ApiSelfserveV1MaterialSupplyList400 | ErrorResponse>,
>(
  params?: ApiSelfserveV1MaterialSupplyListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSelfserveV1MaterialSupplyListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSelfserveV1MaterialSupplyListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>,
  TError = ErrorType<ApiSelfserveV1MaterialSupplyList400 | ErrorResponse>,
>(
  params?: ApiSelfserveV1MaterialSupplyListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSelfserveV1MaterialSupplyListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>> = ({ signal }) =>
    apiSelfserveV1MaterialSupplyList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSelfserveV1MaterialSupplyListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>
>;
export type ApiSelfserveV1MaterialSupplyListSuspenseQueryError = ErrorType<
  ApiSelfserveV1MaterialSupplyList400 | ErrorResponse
>;

export function useApiSelfserveV1MaterialSupplyListSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>,
  TError = ErrorType<ApiSelfserveV1MaterialSupplyList400 | ErrorResponse>,
>(
  params: undefined | ApiSelfserveV1MaterialSupplyListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV1MaterialSupplyListSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>,
  TError = ErrorType<ApiSelfserveV1MaterialSupplyList400 | ErrorResponse>,
>(
  params?: ApiSelfserveV1MaterialSupplyListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV1MaterialSupplyListSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>,
  TError = ErrorType<ApiSelfserveV1MaterialSupplyList400 | ErrorResponse>,
>(
  params?: ApiSelfserveV1MaterialSupplyListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSelfserveV1MaterialSupplyListSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>,
  TError = ErrorType<ApiSelfserveV1MaterialSupplyList400 | ErrorResponse>,
>(
  params?: ApiSelfserveV1MaterialSupplyListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSelfserveV1MaterialSupplyListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiSelfserveV1MaterialSupplyRetrieve = (
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AvailableMaterialSupplyItem>(
    { url: `/api/selfserve/v1/material-supply/${id}/`, method: 'GET', signal },
    options
  );
};

export const getApiSelfserveV1MaterialSupplyRetrieveQueryKey = (id: number) => {
  return [`/api/selfserve/v1/material-supply/${id}/`] as const;
};

export const getApiSelfserveV1MaterialSupplyRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSelfserveV1MaterialSupplyRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>> = ({ signal }) =>
    apiSelfserveV1MaterialSupplyRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSelfserveV1MaterialSupplyRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>
>;
export type ApiSelfserveV1MaterialSupplyRetrieveQueryError = ErrorType<unknown>;

export function useApiSelfserveV1MaterialSupplyRetrieve<
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV1MaterialSupplyRetrieve<
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV1MaterialSupplyRetrieve<
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSelfserveV1MaterialSupplyRetrieve<
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSelfserveV1MaterialSupplyRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSelfserveV1MaterialSupplyRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSelfserveV1MaterialSupplyRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>> = ({ signal }) =>
    apiSelfserveV1MaterialSupplyRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSelfserveV1MaterialSupplyRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>
>;
export type ApiSelfserveV1MaterialSupplyRetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiSelfserveV1MaterialSupplyRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV1MaterialSupplyRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV1MaterialSupplyRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSelfserveV1MaterialSupplyRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1MaterialSupplyRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSelfserveV1MaterialSupplyRetrieveSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve the latest prices for a SiteMaterial with evidence.
 */
export const apiSelfserveV1PriceList = (
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaymentTermPrice[]>({ url: `/api/selfserve/v1/price/${id}/`, method: 'GET', signal }, options);
};

export const getApiSelfserveV1PriceListQueryKey = (id: number) => {
  return [`/api/selfserve/v1/price/${id}/`] as const;
};

export const getApiSelfserveV1PriceListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSelfserveV1PriceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1PriceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSelfserveV1PriceListQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSelfserveV1PriceList>>> = ({ signal }) =>
    apiSelfserveV1PriceList(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSelfserveV1PriceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSelfserveV1PriceListQueryResult = NonNullable<Awaited<ReturnType<typeof apiSelfserveV1PriceList>>>;
export type ApiSelfserveV1PriceListQueryError = ErrorType<ErrorResponse>;

export function useApiSelfserveV1PriceList<
  TData = Awaited<ReturnType<typeof apiSelfserveV1PriceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1PriceList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiSelfserveV1PriceList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV1PriceList<
  TData = Awaited<ReturnType<typeof apiSelfserveV1PriceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1PriceList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiSelfserveV1PriceList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV1PriceList<
  TData = Awaited<ReturnType<typeof apiSelfserveV1PriceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1PriceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSelfserveV1PriceList<
  TData = Awaited<ReturnType<typeof apiSelfserveV1PriceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1PriceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSelfserveV1PriceListQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSelfserveV1PriceListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSelfserveV1PriceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1PriceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSelfserveV1PriceListQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSelfserveV1PriceList>>> = ({ signal }) =>
    apiSelfserveV1PriceList(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSelfserveV1PriceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSelfserveV1PriceListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSelfserveV1PriceList>>
>;
export type ApiSelfserveV1PriceListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiSelfserveV1PriceListSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV1PriceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1PriceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV1PriceListSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV1PriceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1PriceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV1PriceListSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV1PriceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1PriceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSelfserveV1PriceListSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV1PriceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV1PriceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSelfserveV1PriceListSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new DummyPO with the selected price.
 */
export const apiSelfserveV2NewCreate = (
  dummyPOCreateRequest: BodyType<DummyPOCreateRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<DummyPODetailV2>(
    {
      url: `/api/selfserve/v2/new/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dummyPOCreateRequest,
      signal,
    },
    options
  );
};

export const getApiSelfserveV2NewCreateMutationOptions = <
  TError = ErrorType<ErrorResponse | ApiSelfserveV2NewCreate422>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSelfserveV2NewCreate>>,
    TError,
    { data: BodyType<DummyPOCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSelfserveV2NewCreate>>,
  TError,
  { data: BodyType<DummyPOCreateRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSelfserveV2NewCreate>>,
    { data: BodyType<DummyPOCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return apiSelfserveV2NewCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSelfserveV2NewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiSelfserveV2NewCreate>>>;
export type ApiSelfserveV2NewCreateMutationBody = BodyType<DummyPOCreateRequest>;
export type ApiSelfserveV2NewCreateMutationError = ErrorType<ErrorResponse | ApiSelfserveV2NewCreate422>;

export const useApiSelfserveV2NewCreate = <
  TError = ErrorType<ErrorResponse | ApiSelfserveV2NewCreate422>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSelfserveV2NewCreate>>,
    TError,
    { data: BodyType<DummyPOCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSelfserveV2NewCreate>>,
  TError,
  { data: BodyType<DummyPOCreateRequest> },
  TContext
> => {
  const mutationOptions = getApiSelfserveV2NewCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Gets the full details for all DummyPOs
 */
export const apiSelfserveV2OrdersList = (
  params?: ApiSelfserveV2OrdersListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedDummyPODetailV2List>(
    { url: `/api/selfserve/v2/orders/`, method: 'GET', params, signal },
    options
  );
};

export const getApiSelfserveV2OrdersListQueryKey = (params?: ApiSelfserveV2OrdersListParams) => {
  return [`/api/selfserve/v2/orders/`, ...(params ? [params] : [])] as const;
};

export const getApiSelfserveV2OrdersListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiSelfserveV2OrdersListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSelfserveV2OrdersListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>> = ({ signal }) =>
    apiSelfserveV2OrdersList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSelfserveV2OrdersListQueryResult = NonNullable<Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>>;
export type ApiSelfserveV2OrdersListQueryError = ErrorType<unknown>;

export function useApiSelfserveV2OrdersList<
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiSelfserveV2OrdersListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV2OrdersList<
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiSelfserveV2OrdersListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV2OrdersList<
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiSelfserveV2OrdersListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSelfserveV2OrdersList<
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiSelfserveV2OrdersListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSelfserveV2OrdersListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSelfserveV2OrdersListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiSelfserveV2OrdersListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSelfserveV2OrdersListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>> = ({ signal }) =>
    apiSelfserveV2OrdersList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSelfserveV2OrdersListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>
>;
export type ApiSelfserveV2OrdersListSuspenseQueryError = ErrorType<unknown>;

export function useApiSelfserveV2OrdersListSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiSelfserveV2OrdersListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV2OrdersListSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiSelfserveV2OrdersListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV2OrdersListSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiSelfserveV2OrdersListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSelfserveV2OrdersListSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiSelfserveV2OrdersListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSelfserveV2OrdersListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets the full details for a single DummyPO by id
 */
export const apiSelfserveV2OrdersRetrieve = (
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<DummyPODetailV2>({ url: `/api/selfserve/v2/orders/${id}`, method: 'GET', signal }, options);
};

export const getApiSelfserveV2OrdersRetrieveQueryKey = (id: number) => {
  return [`/api/selfserve/v2/orders/${id}`] as const;
};

export const getApiSelfserveV2OrdersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSelfserveV2OrdersRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>> = ({ signal }) =>
    apiSelfserveV2OrdersRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSelfserveV2OrdersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>
>;
export type ApiSelfserveV2OrdersRetrieveQueryError = ErrorType<unknown>;

export function useApiSelfserveV2OrdersRetrieve<
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV2OrdersRetrieve<
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV2OrdersRetrieve<
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSelfserveV2OrdersRetrieve<
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSelfserveV2OrdersRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSelfserveV2OrdersRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSelfserveV2OrdersRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>> = ({ signal }) =>
    apiSelfserveV2OrdersRetrieve(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSelfserveV2OrdersRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>
>;
export type ApiSelfserveV2OrdersRetrieveSuspenseQueryError = ErrorType<unknown>;

export function useApiSelfserveV2OrdersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV2OrdersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSelfserveV2OrdersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSelfserveV2OrdersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSelfserveV2OrdersRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSelfserveV2OrdersRetrieveSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Endpoints to update editable fields after a DummyPO has been created
 */
export const apiSelfserveV2OrdersUpdate = (
  id: number,
  dummyPODetailV2: BodyType<NonReadonly<DummyPODetailV2>>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<DummyPODetailV2>(
    {
      url: `/api/selfserve/v2/orders/${id}/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: dummyPODetailV2,
    },
    options
  );
};

export const getApiSelfserveV2OrdersUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSelfserveV2OrdersUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<DummyPODetailV2>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSelfserveV2OrdersUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<DummyPODetailV2>> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSelfserveV2OrdersUpdate>>,
    { id: number; data: BodyType<NonReadonly<DummyPODetailV2>> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiSelfserveV2OrdersUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSelfserveV2OrdersUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSelfserveV2OrdersUpdate>>
>;
export type ApiSelfserveV2OrdersUpdateMutationBody = BodyType<NonReadonly<DummyPODetailV2>>;
export type ApiSelfserveV2OrdersUpdateMutationError = ErrorType<unknown>;

export const useApiSelfserveV2OrdersUpdate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSelfserveV2OrdersUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<DummyPODetailV2>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSelfserveV2OrdersUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<DummyPODetailV2>> },
  TContext
> => {
  const mutationOptions = getApiSelfserveV2OrdersUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Endpoints to update editable fields after a DummyPO has been created
 */
export const apiSelfserveV2OrdersPartialUpdate = (
  id: number,
  patchedDummyPODetailV2: BodyType<NonReadonly<PatchedDummyPODetailV2>>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<DummyPODetailV2>(
    {
      url: `/api/selfserve/v2/orders/${id}/`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchedDummyPODetailV2,
    },
    options
  );
};

export const getApiSelfserveV2OrdersPartialUpdateMutationOptions = <
  TError = ErrorType<ApiSelfserveV2OrdersPartialUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSelfserveV2OrdersPartialUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<PatchedDummyPODetailV2>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSelfserveV2OrdersPartialUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<PatchedDummyPODetailV2>> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSelfserveV2OrdersPartialUpdate>>,
    { id: number; data: BodyType<NonReadonly<PatchedDummyPODetailV2>> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiSelfserveV2OrdersPartialUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSelfserveV2OrdersPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSelfserveV2OrdersPartialUpdate>>
>;
export type ApiSelfserveV2OrdersPartialUpdateMutationBody = BodyType<NonReadonly<PatchedDummyPODetailV2>>;
export type ApiSelfserveV2OrdersPartialUpdateMutationError = ErrorType<
  ApiSelfserveV2OrdersPartialUpdate400 | ErrorResponse
>;

export const useApiSelfserveV2OrdersPartialUpdate = <
  TError = ErrorType<ApiSelfserveV2OrdersPartialUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSelfserveV2OrdersPartialUpdate>>,
    TError,
    { id: number; data: BodyType<NonReadonly<PatchedDummyPODetailV2>> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSelfserveV2OrdersPartialUpdate>>,
  TError,
  { id: number; data: BodyType<NonReadonly<PatchedDummyPODetailV2>> },
  TContext
> => {
  const mutationOptions = getApiSelfserveV2OrdersPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiSpecificationsV1SiteMaterialSpecificationsEvidenceList = (
  objectId: number,
  params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedEvidenceList>(
    { url: `/api/specifications/v1/site-material-specifications/${objectId}/evidence/`, method: 'GET', params, signal },
    options
  );
};

export const getApiSpecificationsV1SiteMaterialSpecificationsEvidenceListQueryKey = (
  objectId: number,
  params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams
) => {
  return [
    `/api/specifications/v1/site-material-specifications/${objectId}/evidence/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApiSpecificationsV1SiteMaterialSpecificationsEvidenceListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiSpecificationsV1SiteMaterialSpecificationsEvidenceListQueryKey(objectId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>
  > = ({ signal }) =>
    apiSpecificationsV1SiteMaterialSpecificationsEvidenceList(objectId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!objectId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>
>;
export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListQueryError = ErrorType<ErrorResponse>;

export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceList<
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params: undefined | ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceList<
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceList<
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceList<
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSpecificationsV1SiteMaterialSpecificationsEvidenceListQueryOptions(
    objectId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSpecificationsV1SiteMaterialSpecificationsEvidenceListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiSpecificationsV1SiteMaterialSpecificationsEvidenceListQueryKey(objectId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>
  > = ({ signal }) =>
    apiSpecificationsV1SiteMaterialSpecificationsEvidenceList(objectId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>
>;
export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params: undefined | ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSpecificationsV1SiteMaterialSpecificationsEvidenceListSuspenseQueryOptions(
    objectId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve = (
  objectId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Evidence>(
    { url: `/api/specifications/v1/site-material-specifications/${objectId}/evidence/${id}/`, method: 'GET', signal },
    options
  );
};

export const getApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveQueryKey = (
  objectId: number,
  id: number
) => {
  return [`/api/specifications/v1/site-material-specifications/${objectId}/evidence/${id}/`] as const;
};

export const getApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveQueryKey(objectId, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>
  > = ({ signal }) =>
    apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve(objectId, id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(objectId && id), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>
>;
export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveQueryOptions(
    objectId,
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveQueryKey(objectId, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>
  > = ({ signal }) =>
    apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve(objectId, id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>
>;
export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectId: number,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveSuspenseQueryOptions(
    objectId,
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Verify that the current user is authenticated.
 */
export const apiSupportV1TicketCreate = (
  createSupportTicket: BodyType<CreateSupportTicket>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Ticket>(
    {
      url: `/api/support/v1/ticket/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createSupportTicket,
      signal,
    },
    options
  );
};

export const getApiSupportV1TicketCreateMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSupportV1TicketCreate>>,
    TError,
    { data: BodyType<CreateSupportTicket> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiSupportV1TicketCreate>>,
  TError,
  { data: BodyType<CreateSupportTicket> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSupportV1TicketCreate>>,
    { data: BodyType<CreateSupportTicket> }
  > = (props) => {
    const { data } = props ?? {};

    return apiSupportV1TicketCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiSupportV1TicketCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiSupportV1TicketCreate>>>;
export type ApiSupportV1TicketCreateMutationBody = BodyType<CreateSupportTicket>;
export type ApiSupportV1TicketCreateMutationError = ErrorType<unknown>;

export const useApiSupportV1TicketCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSupportV1TicketCreate>>,
    TError,
    { data: BodyType<CreateSupportTicket> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiSupportV1TicketCreate>>,
  TError,
  { data: BodyType<CreateSupportTicket> },
  TContext
> => {
  const mutationOptions = getApiSupportV1TicketCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Verify that the current user is authenticated.
 */
export const apiTicketsV1FindList = (
  params?: ApiTicketsV1FindListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedGetTicketsOutputList>(
    { url: `/api/tickets/v1/find/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTicketsV1FindListQueryKey = (params?: ApiTicketsV1FindListParams) => {
  return [`/api/tickets/v1/find/`, ...(params ? [params] : [])] as const;
};

export const getApiTicketsV1FindListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTicketsV1FindListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTicketsV1FindListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTicketsV1FindList>>> = ({ signal }) =>
    apiTicketsV1FindList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTicketsV1FindList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTicketsV1FindListQueryResult = NonNullable<Awaited<ReturnType<typeof apiTicketsV1FindList>>>;
export type ApiTicketsV1FindListQueryError = ErrorType<ErrorResponse>;

export function useApiTicketsV1FindList<
  TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiTicketsV1FindListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTicketsV1FindList<
  TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTicketsV1FindListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTicketsV1FindList<
  TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTicketsV1FindListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTicketsV1FindList<
  TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTicketsV1FindListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTicketsV1FindListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTicketsV1FindListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTicketsV1FindListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTicketsV1FindListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTicketsV1FindList>>> = ({ signal }) =>
    apiTicketsV1FindList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTicketsV1FindList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTicketsV1FindListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiTicketsV1FindList>>>;
export type ApiTicketsV1FindListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTicketsV1FindListSuspense<
  TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiTicketsV1FindListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTicketsV1FindListSuspense<
  TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTicketsV1FindListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTicketsV1FindListSuspense<
  TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTicketsV1FindListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTicketsV1FindListSuspense<
  TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTicketsV1FindListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTicketsV1FindListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1AvailableTonnesForBuyer = (
  params?: ApiTradeV1AvailableTonnesForBuyerParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<MaterialListingSumTonnesResponse>(
    { url: `/api/trade/v1/available-tonnes-for-buyer/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1AvailableTonnesForBuyerQueryKey = (params?: ApiTradeV1AvailableTonnesForBuyerParams) => {
  return [`/api/trade/v1/available-tonnes-for-buyer/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1AvailableTonnesForBuyerQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>,
  TError = ErrorType<ApiTradeV1AvailableTonnesForBuyer400 | ErrorResponse>,
>(
  params?: ApiTradeV1AvailableTonnesForBuyerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1AvailableTonnesForBuyerQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>> = ({ signal }) =>
    apiTradeV1AvailableTonnesForBuyer(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1AvailableTonnesForBuyerQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>
>;
export type ApiTradeV1AvailableTonnesForBuyerQueryError = ErrorType<
  ApiTradeV1AvailableTonnesForBuyer400 | ErrorResponse
>;

export function useApiTradeV1AvailableTonnesForBuyer<
  TData = Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>,
  TError = ErrorType<ApiTradeV1AvailableTonnesForBuyer400 | ErrorResponse>,
>(
  params: undefined | ApiTradeV1AvailableTonnesForBuyerParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1AvailableTonnesForBuyer<
  TData = Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>,
  TError = ErrorType<ApiTradeV1AvailableTonnesForBuyer400 | ErrorResponse>,
>(
  params?: ApiTradeV1AvailableTonnesForBuyerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1AvailableTonnesForBuyer<
  TData = Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>,
  TError = ErrorType<ApiTradeV1AvailableTonnesForBuyer400 | ErrorResponse>,
>(
  params?: ApiTradeV1AvailableTonnesForBuyerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1AvailableTonnesForBuyer<
  TData = Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>,
  TError = ErrorType<ApiTradeV1AvailableTonnesForBuyer400 | ErrorResponse>,
>(
  params?: ApiTradeV1AvailableTonnesForBuyerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1AvailableTonnesForBuyerQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1AvailableTonnesForBuyerSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>,
  TError = ErrorType<ApiTradeV1AvailableTonnesForBuyer400 | ErrorResponse>,
>(
  params?: ApiTradeV1AvailableTonnesForBuyerParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1AvailableTonnesForBuyerQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>> = ({ signal }) =>
    apiTradeV1AvailableTonnesForBuyer(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1AvailableTonnesForBuyerSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>
>;
export type ApiTradeV1AvailableTonnesForBuyerSuspenseQueryError = ErrorType<
  ApiTradeV1AvailableTonnesForBuyer400 | ErrorResponse
>;

export function useApiTradeV1AvailableTonnesForBuyerSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>,
  TError = ErrorType<ApiTradeV1AvailableTonnesForBuyer400 | ErrorResponse>,
>(
  params: undefined | ApiTradeV1AvailableTonnesForBuyerParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1AvailableTonnesForBuyerSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>,
  TError = ErrorType<ApiTradeV1AvailableTonnesForBuyer400 | ErrorResponse>,
>(
  params?: ApiTradeV1AvailableTonnesForBuyerParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1AvailableTonnesForBuyerSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>,
  TError = ErrorType<ApiTradeV1AvailableTonnesForBuyer400 | ErrorResponse>,
>(
  params?: ApiTradeV1AvailableTonnesForBuyerParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1AvailableTonnesForBuyerSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>,
  TError = ErrorType<ApiTradeV1AvailableTonnesForBuyer400 | ErrorResponse>,
>(
  params?: ApiTradeV1AvailableTonnesForBuyerParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1AvailableTonnesForBuyer>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1AvailableTonnesForBuyerSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1BuySignalsList = (
  params?: ApiTradeV1BuySignalsListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<FullDemandSignalDTO[]>(
    { url: `/api/trade/v1/buy-signals/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1BuySignalsListQueryKey = (params?: ApiTradeV1BuySignalsListParams) => {
  return [`/api/trade/v1/buy-signals/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1BuySignalsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>,
  TError = ErrorType<ApiTradeV1BuySignalsList400>,
>(
  params?: ApiTradeV1BuySignalsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1BuySignalsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>> = ({ signal }) =>
    apiTradeV1BuySignalsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1BuySignalsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>>;
export type ApiTradeV1BuySignalsListQueryError = ErrorType<ApiTradeV1BuySignalsList400>;

export function useApiTradeV1BuySignalsList<
  TData = Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>,
  TError = ErrorType<ApiTradeV1BuySignalsList400>,
>(
  params: undefined | ApiTradeV1BuySignalsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1BuySignalsList<
  TData = Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>,
  TError = ErrorType<ApiTradeV1BuySignalsList400>,
>(
  params?: ApiTradeV1BuySignalsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1BuySignalsList<
  TData = Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>,
  TError = ErrorType<ApiTradeV1BuySignalsList400>,
>(
  params?: ApiTradeV1BuySignalsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1BuySignalsList<
  TData = Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>,
  TError = ErrorType<ApiTradeV1BuySignalsList400>,
>(
  params?: ApiTradeV1BuySignalsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1BuySignalsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1BuySignalsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>,
  TError = ErrorType<ApiTradeV1BuySignalsList400>,
>(
  params?: ApiTradeV1BuySignalsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1BuySignalsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>> = ({ signal }) =>
    apiTradeV1BuySignalsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1BuySignalsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>
>;
export type ApiTradeV1BuySignalsListSuspenseQueryError = ErrorType<ApiTradeV1BuySignalsList400>;

export function useApiTradeV1BuySignalsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>,
  TError = ErrorType<ApiTradeV1BuySignalsList400>,
>(
  params: undefined | ApiTradeV1BuySignalsListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1BuySignalsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>,
  TError = ErrorType<ApiTradeV1BuySignalsList400>,
>(
  params?: ApiTradeV1BuySignalsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1BuySignalsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>,
  TError = ErrorType<ApiTradeV1BuySignalsList400>,
>(
  params?: ApiTradeV1BuySignalsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1BuySignalsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>,
  TError = ErrorType<ApiTradeV1BuySignalsList400>,
>(
  params?: ApiTradeV1BuySignalsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuySignalsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1BuySignalsListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1BuySignalsCreate = (
  demandSignalCreateDTO: BodyType<DemandSignalCreateDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<FullDemandSignalDTO>(
    {
      url: `/api/trade/v1/buy-signals/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: demandSignalCreateDTO,
      signal,
    },
    options
  );
};

export const getApiTradeV1BuySignalsCreateMutationOptions = <
  TError = ErrorType<ApiTradeV1BuySignalsCreate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1BuySignalsCreate>>,
    TError,
    { data: BodyType<DemandSignalCreateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1BuySignalsCreate>>,
  TError,
  { data: BodyType<DemandSignalCreateDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1BuySignalsCreate>>,
    { data: BodyType<DemandSignalCreateDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return apiTradeV1BuySignalsCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1BuySignalsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1BuySignalsCreate>>
>;
export type ApiTradeV1BuySignalsCreateMutationBody = BodyType<DemandSignalCreateDTO>;
export type ApiTradeV1BuySignalsCreateMutationError = ErrorType<ApiTradeV1BuySignalsCreate400>;

export const useApiTradeV1BuySignalsCreate = <
  TError = ErrorType<ApiTradeV1BuySignalsCreate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1BuySignalsCreate>>,
    TError,
    { data: BodyType<DemandSignalCreateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1BuySignalsCreate>>,
  TError,
  { data: BodyType<DemandSignalCreateDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1BuySignalsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1BuySignalsUpdate = (
  id: number,
  demandSignalUpdateDTO: BodyType<DemandSignalUpdateDTO>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<FullDemandSignalDTO>(
    {
      url: `/api/trade/v1/buy-signals/${id}/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: demandSignalUpdateDTO,
    },
    options
  );
};

export const getApiTradeV1BuySignalsUpdateMutationOptions = <
  TError = ErrorType<ApiTradeV1BuySignalsUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1BuySignalsUpdate>>,
    TError,
    { id: number; data: BodyType<DemandSignalUpdateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1BuySignalsUpdate>>,
  TError,
  { id: number; data: BodyType<DemandSignalUpdateDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1BuySignalsUpdate>>,
    { id: number; data: BodyType<DemandSignalUpdateDTO> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiTradeV1BuySignalsUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1BuySignalsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1BuySignalsUpdate>>
>;
export type ApiTradeV1BuySignalsUpdateMutationBody = BodyType<DemandSignalUpdateDTO>;
export type ApiTradeV1BuySignalsUpdateMutationError = ErrorType<ApiTradeV1BuySignalsUpdate400 | ErrorResponse>;

export const useApiTradeV1BuySignalsUpdate = <
  TError = ErrorType<ApiTradeV1BuySignalsUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1BuySignalsUpdate>>,
    TError,
    { id: number; data: BodyType<DemandSignalUpdateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1BuySignalsUpdate>>,
  TError,
  { id: number; data: BodyType<DemandSignalUpdateDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1BuySignalsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1BuyerMaterialSpecificationsCreate = (
  upsertBuyerMaterialSpecification: BodyType<UpsertBuyerMaterialSpecification>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CreateBuyerMaterialSpecificationResponse>(
    {
      url: `/api/trade/v1/buyer-material-specifications/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: upsertBuyerMaterialSpecification,
      signal,
    },
    options
  );
};

export const getApiTradeV1BuyerMaterialSpecificationsCreateMutationOptions = <
  TError = ErrorType<ApiTradeV1BuyerMaterialSpecificationsCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsCreate>>,
    TError,
    { data: BodyType<UpsertBuyerMaterialSpecification> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsCreate>>,
  TError,
  { data: BodyType<UpsertBuyerMaterialSpecification> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsCreate>>,
    { data: BodyType<UpsertBuyerMaterialSpecification> }
  > = (props) => {
    const { data } = props ?? {};

    return apiTradeV1BuyerMaterialSpecificationsCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1BuyerMaterialSpecificationsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsCreate>>
>;
export type ApiTradeV1BuyerMaterialSpecificationsCreateMutationBody = BodyType<UpsertBuyerMaterialSpecification>;
export type ApiTradeV1BuyerMaterialSpecificationsCreateMutationError = ErrorType<
  ApiTradeV1BuyerMaterialSpecificationsCreate400 | ErrorResponse
>;

export const useApiTradeV1BuyerMaterialSpecificationsCreate = <
  TError = ErrorType<ApiTradeV1BuyerMaterialSpecificationsCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsCreate>>,
    TError,
    { data: BodyType<UpsertBuyerMaterialSpecification> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsCreate>>,
  TError,
  { data: BodyType<UpsertBuyerMaterialSpecification> },
  TContext
> => {
  const mutationOptions = getApiTradeV1BuyerMaterialSpecificationsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1BuyerMaterialSpecificationsRetrieve = (
  buyerMaterialSpecificationId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<FullBuyerMaterialSpecification>(
    { url: `/api/trade/v1/buyer-material-specifications/${buyerMaterialSpecificationId}/`, method: 'GET', signal },
    options
  );
};

export const getApiTradeV1BuyerMaterialSpecificationsRetrieveQueryKey = (buyerMaterialSpecificationId: number) => {
  return [`/api/trade/v1/buyer-material-specifications/${buyerMaterialSpecificationId}/`] as const;
};

export const getApiTradeV1BuyerMaterialSpecificationsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  buyerMaterialSpecificationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiTradeV1BuyerMaterialSpecificationsRetrieveQueryKey(buyerMaterialSpecificationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>> = ({
    signal,
  }) => apiTradeV1BuyerMaterialSpecificationsRetrieve(buyerMaterialSpecificationId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!buyerMaterialSpecificationId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1BuyerMaterialSpecificationsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>
>;
export type ApiTradeV1BuyerMaterialSpecificationsRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1BuyerMaterialSpecificationsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  buyerMaterialSpecificationId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1BuyerMaterialSpecificationsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  buyerMaterialSpecificationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1BuyerMaterialSpecificationsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  buyerMaterialSpecificationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1BuyerMaterialSpecificationsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  buyerMaterialSpecificationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1BuyerMaterialSpecificationsRetrieveQueryOptions(
    buyerMaterialSpecificationId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1BuyerMaterialSpecificationsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  buyerMaterialSpecificationId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiTradeV1BuyerMaterialSpecificationsRetrieveQueryKey(buyerMaterialSpecificationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>> = ({
    signal,
  }) => apiTradeV1BuyerMaterialSpecificationsRetrieve(buyerMaterialSpecificationId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1BuyerMaterialSpecificationsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>
>;
export type ApiTradeV1BuyerMaterialSpecificationsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1BuyerMaterialSpecificationsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  buyerMaterialSpecificationId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1BuyerMaterialSpecificationsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  buyerMaterialSpecificationId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1BuyerMaterialSpecificationsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  buyerMaterialSpecificationId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1BuyerMaterialSpecificationsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  buyerMaterialSpecificationId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1BuyerMaterialSpecificationsRetrieveSuspenseQueryOptions(
    buyerMaterialSpecificationId,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1BuyerMaterialSpecificationsUpdate = (
  buyerMaterialSpecificationId: number,
  upsertBuyerMaterialSpecification: BodyType<UpsertBuyerMaterialSpecification>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<void>(
    {
      url: `/api/trade/v1/buyer-material-specifications/${buyerMaterialSpecificationId}/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: upsertBuyerMaterialSpecification,
    },
    options
  );
};

export const getApiTradeV1BuyerMaterialSpecificationsUpdateMutationOptions = <
  TError = ErrorType<ApiTradeV1BuyerMaterialSpecificationsUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsUpdate>>,
    TError,
    { buyerMaterialSpecificationId: number; data: BodyType<UpsertBuyerMaterialSpecification> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsUpdate>>,
  TError,
  { buyerMaterialSpecificationId: number; data: BodyType<UpsertBuyerMaterialSpecification> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsUpdate>>,
    { buyerMaterialSpecificationId: number; data: BodyType<UpsertBuyerMaterialSpecification> }
  > = (props) => {
    const { buyerMaterialSpecificationId, data } = props ?? {};

    return apiTradeV1BuyerMaterialSpecificationsUpdate(buyerMaterialSpecificationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1BuyerMaterialSpecificationsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsUpdate>>
>;
export type ApiTradeV1BuyerMaterialSpecificationsUpdateMutationBody = BodyType<UpsertBuyerMaterialSpecification>;
export type ApiTradeV1BuyerMaterialSpecificationsUpdateMutationError = ErrorType<
  ApiTradeV1BuyerMaterialSpecificationsUpdate400 | ErrorResponse
>;

export const useApiTradeV1BuyerMaterialSpecificationsUpdate = <
  TError = ErrorType<ApiTradeV1BuyerMaterialSpecificationsUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsUpdate>>,
    TError,
    { buyerMaterialSpecificationId: number; data: BodyType<UpsertBuyerMaterialSpecification> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsUpdate>>,
  TError,
  { buyerMaterialSpecificationId: number; data: BodyType<UpsertBuyerMaterialSpecification> },
  TContext
> => {
  const mutationOptions = getApiTradeV1BuyerMaterialSpecificationsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1BuyerMaterialSpecificationsDestroy = (
  buyerMaterialSpecificationId: number,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<void>(
    { url: `/api/trade/v1/buyer-material-specifications/${buyerMaterialSpecificationId}/`, method: 'DELETE' },
    options
  );
};

export const getApiTradeV1BuyerMaterialSpecificationsDestroyMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDestroy>>,
    TError,
    { buyerMaterialSpecificationId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDestroy>>,
  TError,
  { buyerMaterialSpecificationId: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDestroy>>,
    { buyerMaterialSpecificationId: number }
  > = (props) => {
    const { buyerMaterialSpecificationId } = props ?? {};

    return apiTradeV1BuyerMaterialSpecificationsDestroy(buyerMaterialSpecificationId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1BuyerMaterialSpecificationsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDestroy>>
>;

export type ApiTradeV1BuyerMaterialSpecificationsDestroyMutationError = ErrorType<ErrorResponse>;

export const useApiTradeV1BuyerMaterialSpecificationsDestroy = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDestroy>>,
    TError,
    { buyerMaterialSpecificationId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDestroy>>,
  TError,
  { buyerMaterialSpecificationId: number },
  TContext
> => {
  const mutationOptions = getApiTradeV1BuyerMaterialSpecificationsDestroyMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Generate an upload URL for documents.
 */
export const apiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate = (
  buyerMaterialSpecificationId: number,
  documentPreSignedURLInput: BodyType<DocumentPreSignedURLInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<DocumentPreSignedURLOutput>(
    {
      url: `/api/trade/v1/buyer-material-specifications/${buyerMaterialSpecificationId}/documents/pre-signed-url/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: documentPreSignedURLInput,
      signal,
    },
    options
  );
};

export const getApiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate>>,
    TError,
    { buyerMaterialSpecificationId: number; data: BodyType<DocumentPreSignedURLInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate>>,
  TError,
  { buyerMaterialSpecificationId: number; data: BodyType<DocumentPreSignedURLInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate>>,
    { buyerMaterialSpecificationId: number; data: BodyType<DocumentPreSignedURLInput> }
  > = (props) => {
    const { buyerMaterialSpecificationId, data } = props ?? {};

    return apiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate(
      buyerMaterialSpecificationId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate>>
>;
export type ApiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreateMutationBody =
  BodyType<DocumentPreSignedURLInput>;
export type ApiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreateMutationError = ErrorType<ErrorResponse>;

export const useApiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate>>,
    TError,
    { buyerMaterialSpecificationId: number; data: BodyType<DocumentPreSignedURLInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate>>,
  TError,
  { buyerMaterialSpecificationId: number; data: BodyType<DocumentPreSignedURLInput> },
  TContext
> => {
  const mutationOptions = getApiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate = (
  buyerMaterialSpecificationId: number,
  input: BodyType<Input>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/trade/v1/buyer-material-specifications/${buyerMaterialSpecificationId}/documents/upload/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: input,
      signal,
    },
    options
  );
};

export const getApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreateMutationOptions = <
  TError = ErrorType<ApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate>>,
    TError,
    { buyerMaterialSpecificationId: number; data: BodyType<Input> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate>>,
  TError,
  { buyerMaterialSpecificationId: number; data: BodyType<Input> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate>>,
    { buyerMaterialSpecificationId: number; data: BodyType<Input> }
  > = (props) => {
    const { buyerMaterialSpecificationId, data } = props ?? {};

    return apiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate(
      buyerMaterialSpecificationId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate>>
>;
export type ApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreateMutationBody = BodyType<Input>;
export type ApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreateMutationError = ErrorType<
  ApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate400 | ErrorResponse
>;

export const useApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate = <
  TError = ErrorType<ApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate>>,
    TError,
    { buyerMaterialSpecificationId: number; data: BodyType<Input> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate>>,
  TError,
  { buyerMaterialSpecificationId: number; data: BodyType<Input> },
  TContext
> => {
  const mutationOptions = getApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Convert a market index percentage to absolute price based on material type
 */
export const apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve = (
  params: ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ConvertMarketIndexPercentageToPriceResponse>(
    { url: `/api/trade/v1/convert-market-index-percentage-to-price/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveQueryKey = (
  params: ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveParams
) => {
  return [`/api/trade/v1/convert-market-index-percentage-to-price/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>> = ({
    signal,
  }) => apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>
>;
export type ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveQueryError = ErrorType<
  ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieve400 | ErrorResponse
>;

export function useApiTradeV1ConvertMarketIndexPercentageToPriceRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1ConvertMarketIndexPercentageToPriceRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1ConvertMarketIndexPercentageToPriceRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1ConvertMarketIndexPercentageToPriceRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>> = ({
    signal,
  }) => apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>
>;
export type ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveSuspenseQueryError = ErrorType<
  ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieve400 | ErrorResponse
>;

export function useApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1ConvertMarketIndexPercentageToPriceRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1ConvertMarketIndexPercentageToPriceRetrieveSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Convert a price to market index percentage based on material type
 */
export const apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve = (
  params: ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ConvertPriceToMarketIndexPercentageResponse>(
    { url: `/api/trade/v1/convert-price-to-market-index-percentage/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveQueryKey = (
  params: ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveParams
) => {
  return [`/api/trade/v1/convert-price-to-market-index-percentage/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>> = ({
    signal,
  }) => apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>
>;
export type ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveQueryError = ErrorType<
  ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieve400 | ErrorResponse
>;

export function useApiTradeV1ConvertPriceToMarketIndexPercentageRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1ConvertPriceToMarketIndexPercentageRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1ConvertPriceToMarketIndexPercentageRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1ConvertPriceToMarketIndexPercentageRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>> = ({
    signal,
  }) => apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>
>;
export type ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveSuspenseQueryError = ErrorType<
  ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieve400 | ErrorResponse
>;

export function useApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
  TError = ErrorType<ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieve400 | ErrorResponse>,
>(
  params: ApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1ConvertPriceToMarketIndexPercentageRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1ConvertPriceToMarketIndexPercentageRetrieveSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1DemandSignalsList = (
  params?: ApiTradeV1DemandSignalsListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<FullDemandSignalDTO[]>(
    { url: `/api/trade/v1/demand-signals/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1DemandSignalsListQueryKey = (params?: ApiTradeV1DemandSignalsListParams) => {
  return [`/api/trade/v1/demand-signals/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1DemandSignalsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>,
  TError = ErrorType<ApiTradeV1DemandSignalsList400>,
>(
  params?: ApiTradeV1DemandSignalsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1DemandSignalsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>> = ({ signal }) =>
    apiTradeV1DemandSignalsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1DemandSignalsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>
>;
export type ApiTradeV1DemandSignalsListQueryError = ErrorType<ApiTradeV1DemandSignalsList400>;

export function useApiTradeV1DemandSignalsList<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>,
  TError = ErrorType<ApiTradeV1DemandSignalsList400>,
>(
  params: undefined | ApiTradeV1DemandSignalsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1DemandSignalsList<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>,
  TError = ErrorType<ApiTradeV1DemandSignalsList400>,
>(
  params?: ApiTradeV1DemandSignalsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1DemandSignalsList<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>,
  TError = ErrorType<ApiTradeV1DemandSignalsList400>,
>(
  params?: ApiTradeV1DemandSignalsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1DemandSignalsList<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>,
  TError = ErrorType<ApiTradeV1DemandSignalsList400>,
>(
  params?: ApiTradeV1DemandSignalsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1DemandSignalsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1DemandSignalsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>,
  TError = ErrorType<ApiTradeV1DemandSignalsList400>,
>(
  params?: ApiTradeV1DemandSignalsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1DemandSignalsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>> = ({ signal }) =>
    apiTradeV1DemandSignalsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1DemandSignalsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>
>;
export type ApiTradeV1DemandSignalsListSuspenseQueryError = ErrorType<ApiTradeV1DemandSignalsList400>;

export function useApiTradeV1DemandSignalsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>,
  TError = ErrorType<ApiTradeV1DemandSignalsList400>,
>(
  params: undefined | ApiTradeV1DemandSignalsListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1DemandSignalsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>,
  TError = ErrorType<ApiTradeV1DemandSignalsList400>,
>(
  params?: ApiTradeV1DemandSignalsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1DemandSignalsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>,
  TError = ErrorType<ApiTradeV1DemandSignalsList400>,
>(
  params?: ApiTradeV1DemandSignalsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1DemandSignalsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>,
  TError = ErrorType<ApiTradeV1DemandSignalsList400>,
>(
  params?: ApiTradeV1DemandSignalsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1DemandSignalsListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1DemandSignalsCreate = (
  demandSignalCreateDTO: BodyType<DemandSignalCreateDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<FullDemandSignalDTO>(
    {
      url: `/api/trade/v1/demand-signals/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: demandSignalCreateDTO,
      signal,
    },
    options
  );
};

export const getApiTradeV1DemandSignalsCreateMutationOptions = <
  TError = ErrorType<ApiTradeV1DemandSignalsCreate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1DemandSignalsCreate>>,
    TError,
    { data: BodyType<DemandSignalCreateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1DemandSignalsCreate>>,
  TError,
  { data: BodyType<DemandSignalCreateDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1DemandSignalsCreate>>,
    { data: BodyType<DemandSignalCreateDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return apiTradeV1DemandSignalsCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1DemandSignalsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1DemandSignalsCreate>>
>;
export type ApiTradeV1DemandSignalsCreateMutationBody = BodyType<DemandSignalCreateDTO>;
export type ApiTradeV1DemandSignalsCreateMutationError = ErrorType<ApiTradeV1DemandSignalsCreate400>;

export const useApiTradeV1DemandSignalsCreate = <
  TError = ErrorType<ApiTradeV1DemandSignalsCreate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1DemandSignalsCreate>>,
    TError,
    { data: BodyType<DemandSignalCreateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1DemandSignalsCreate>>,
  TError,
  { data: BodyType<DemandSignalCreateDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1DemandSignalsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1DemandSignalsUpdate = (
  id: number,
  demandSignalUpdateDTO: BodyType<DemandSignalUpdateDTO>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<FullDemandSignalDTO>(
    {
      url: `/api/trade/v1/demand-signals/${id}/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: demandSignalUpdateDTO,
    },
    options
  );
};

export const getApiTradeV1DemandSignalsUpdateMutationOptions = <
  TError = ErrorType<ApiTradeV1DemandSignalsUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1DemandSignalsUpdate>>,
    TError,
    { id: number; data: BodyType<DemandSignalUpdateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1DemandSignalsUpdate>>,
  TError,
  { id: number; data: BodyType<DemandSignalUpdateDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1DemandSignalsUpdate>>,
    { id: number; data: BodyType<DemandSignalUpdateDTO> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiTradeV1DemandSignalsUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1DemandSignalsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1DemandSignalsUpdate>>
>;
export type ApiTradeV1DemandSignalsUpdateMutationBody = BodyType<DemandSignalUpdateDTO>;
export type ApiTradeV1DemandSignalsUpdateMutationError = ErrorType<ApiTradeV1DemandSignalsUpdate400 | ErrorResponse>;

export const useApiTradeV1DemandSignalsUpdate = <
  TError = ErrorType<ApiTradeV1DemandSignalsUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1DemandSignalsUpdate>>,
    TError,
    { id: number; data: BodyType<DemandSignalUpdateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1DemandSignalsUpdate>>,
  TError,
  { id: number; data: BodyType<DemandSignalUpdateDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1DemandSignalsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1DemandSignalsCalculateOptimalPriceCreate = (
  calculateOptimalPricesForSiteMaterialsAndDemandSignalsRequestDTO: BodyType<CalculateOptimalPricesForSiteMaterialsAndDemandSignalsRequestDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PricedDemandSignalDTO[]>(
    {
      url: `/api/trade/v1/demand-signals/calculate-optimal-price/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: calculateOptimalPricesForSiteMaterialsAndDemandSignalsRequestDTO,
      signal,
    },
    options
  );
};

export const getApiTradeV1DemandSignalsCalculateOptimalPriceCreateMutationOptions = <
  TError = ErrorType<ApiTradeV1DemandSignalsCalculateOptimalPriceCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1DemandSignalsCalculateOptimalPriceCreate>>,
    TError,
    { data: BodyType<CalculateOptimalPricesForSiteMaterialsAndDemandSignalsRequestDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1DemandSignalsCalculateOptimalPriceCreate>>,
  TError,
  { data: BodyType<CalculateOptimalPricesForSiteMaterialsAndDemandSignalsRequestDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1DemandSignalsCalculateOptimalPriceCreate>>,
    { data: BodyType<CalculateOptimalPricesForSiteMaterialsAndDemandSignalsRequestDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return apiTradeV1DemandSignalsCalculateOptimalPriceCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1DemandSignalsCalculateOptimalPriceCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1DemandSignalsCalculateOptimalPriceCreate>>
>;
export type ApiTradeV1DemandSignalsCalculateOptimalPriceCreateMutationBody =
  BodyType<CalculateOptimalPricesForSiteMaterialsAndDemandSignalsRequestDTO>;
export type ApiTradeV1DemandSignalsCalculateOptimalPriceCreateMutationError = ErrorType<
  ApiTradeV1DemandSignalsCalculateOptimalPriceCreate400 | ErrorResponse
>;

export const useApiTradeV1DemandSignalsCalculateOptimalPriceCreate = <
  TError = ErrorType<ApiTradeV1DemandSignalsCalculateOptimalPriceCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1DemandSignalsCalculateOptimalPriceCreate>>,
    TError,
    { data: BodyType<CalculateOptimalPricesForSiteMaterialsAndDemandSignalsRequestDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1DemandSignalsCalculateOptimalPriceCreate>>,
  TError,
  { data: BodyType<CalculateOptimalPricesForSiteMaterialsAndDemandSignalsRequestDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1DemandSignalsCalculateOptimalPriceCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1DemandSignalsCalculateSellPriceCreate = (
  calculateSellPriceForDemandSignalsRequestDTO: BodyType<CalculateSellPriceForDemandSignalsRequestDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PricedDemandSignalDTO[]>(
    {
      url: `/api/trade/v1/demand-signals/calculate-sell-price/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: calculateSellPriceForDemandSignalsRequestDTO,
      signal,
    },
    options
  );
};

export const getApiTradeV1DemandSignalsCalculateSellPriceCreateMutationOptions = <
  TError = ErrorType<ApiTradeV1DemandSignalsCalculateSellPriceCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1DemandSignalsCalculateSellPriceCreate>>,
    TError,
    { data: BodyType<CalculateSellPriceForDemandSignalsRequestDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1DemandSignalsCalculateSellPriceCreate>>,
  TError,
  { data: BodyType<CalculateSellPriceForDemandSignalsRequestDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1DemandSignalsCalculateSellPriceCreate>>,
    { data: BodyType<CalculateSellPriceForDemandSignalsRequestDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return apiTradeV1DemandSignalsCalculateSellPriceCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1DemandSignalsCalculateSellPriceCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1DemandSignalsCalculateSellPriceCreate>>
>;
export type ApiTradeV1DemandSignalsCalculateSellPriceCreateMutationBody =
  BodyType<CalculateSellPriceForDemandSignalsRequestDTO>;
export type ApiTradeV1DemandSignalsCalculateSellPriceCreateMutationError = ErrorType<
  ApiTradeV1DemandSignalsCalculateSellPriceCreate400 | ErrorResponse
>;

export const useApiTradeV1DemandSignalsCalculateSellPriceCreate = <
  TError = ErrorType<ApiTradeV1DemandSignalsCalculateSellPriceCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1DemandSignalsCalculateSellPriceCreate>>,
    TError,
    { data: BodyType<CalculateSellPriceForDemandSignalsRequestDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1DemandSignalsCalculateSellPriceCreate>>,
  TError,
  { data: BodyType<CalculateSellPriceForDemandSignalsRequestDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1DemandSignalsCalculateSellPriceCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1DemandSignalsMaterialSpecsRetrieve = (
  params?: ApiTradeV1DemandSignalsMaterialSpecsRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<DemandSignalMaterialsSpecsList>(
    { url: `/api/trade/v1/demand-signals/material-specs/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1DemandSignalsMaterialSpecsRetrieveQueryKey = (
  params?: ApiTradeV1DemandSignalsMaterialSpecsRetrieveParams
) => {
  return [`/api/trade/v1/demand-signals/material-specs/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1DemandSignalsMaterialSpecsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialSpecsRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1DemandSignalsMaterialSpecsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1DemandSignalsMaterialSpecsRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>> = ({
    signal,
  }) => apiTradeV1DemandSignalsMaterialSpecsRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1DemandSignalsMaterialSpecsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>
>;
export type ApiTradeV1DemandSignalsMaterialSpecsRetrieveQueryError = ErrorType<
  ApiTradeV1DemandSignalsMaterialSpecsRetrieve400 | ErrorResponse
>;

export function useApiTradeV1DemandSignalsMaterialSpecsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialSpecsRetrieve400 | ErrorResponse>,
>(
  params: undefined | ApiTradeV1DemandSignalsMaterialSpecsRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1DemandSignalsMaterialSpecsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialSpecsRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1DemandSignalsMaterialSpecsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1DemandSignalsMaterialSpecsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialSpecsRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1DemandSignalsMaterialSpecsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1DemandSignalsMaterialSpecsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialSpecsRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1DemandSignalsMaterialSpecsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1DemandSignalsMaterialSpecsRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1DemandSignalsMaterialSpecsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialSpecsRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1DemandSignalsMaterialSpecsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1DemandSignalsMaterialSpecsRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>> = ({
    signal,
  }) => apiTradeV1DemandSignalsMaterialSpecsRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1DemandSignalsMaterialSpecsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>
>;
export type ApiTradeV1DemandSignalsMaterialSpecsRetrieveSuspenseQueryError = ErrorType<
  ApiTradeV1DemandSignalsMaterialSpecsRetrieve400 | ErrorResponse
>;

export function useApiTradeV1DemandSignalsMaterialSpecsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialSpecsRetrieve400 | ErrorResponse>,
>(
  params: undefined | ApiTradeV1DemandSignalsMaterialSpecsRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1DemandSignalsMaterialSpecsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialSpecsRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1DemandSignalsMaterialSpecsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1DemandSignalsMaterialSpecsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialSpecsRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1DemandSignalsMaterialSpecsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1DemandSignalsMaterialSpecsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialSpecsRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1DemandSignalsMaterialSpecsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialSpecsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1DemandSignalsMaterialSpecsRetrieveSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1DemandSignalsMaterialsRetrieve = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<DemandSignalMaterialsList>(
    { url: `/api/trade/v1/demand-signals/materials/`, method: 'GET', signal },
    options
  );
};

export const getApiTradeV1DemandSignalsMaterialsRetrieveQueryKey = () => {
  return [`/api/trade/v1/demand-signals/materials/`] as const;
};

export const getApiTradeV1DemandSignalsMaterialsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialsRetrieve400 | ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1DemandSignalsMaterialsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>> = ({ signal }) =>
    apiTradeV1DemandSignalsMaterialsRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1DemandSignalsMaterialsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>
>;
export type ApiTradeV1DemandSignalsMaterialsRetrieveQueryError = ErrorType<
  ApiTradeV1DemandSignalsMaterialsRetrieve400 | ErrorResponse
>;

export function useApiTradeV1DemandSignalsMaterialsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialsRetrieve400 | ErrorResponse>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1DemandSignalsMaterialsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialsRetrieve400 | ErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1DemandSignalsMaterialsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialsRetrieve400 | ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1DemandSignalsMaterialsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialsRetrieve400 | ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1DemandSignalsMaterialsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1DemandSignalsMaterialsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialsRetrieve400 | ErrorResponse>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1DemandSignalsMaterialsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>> = ({ signal }) =>
    apiTradeV1DemandSignalsMaterialsRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1DemandSignalsMaterialsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>
>;
export type ApiTradeV1DemandSignalsMaterialsRetrieveSuspenseQueryError = ErrorType<
  ApiTradeV1DemandSignalsMaterialsRetrieve400 | ErrorResponse
>;

export function useApiTradeV1DemandSignalsMaterialsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialsRetrieve400 | ErrorResponse>,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1DemandSignalsMaterialsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialsRetrieve400 | ErrorResponse>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1DemandSignalsMaterialsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialsRetrieve400 | ErrorResponse>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1DemandSignalsMaterialsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>,
  TError = ErrorType<ApiTradeV1DemandSignalsMaterialsRetrieve400 | ErrorResponse>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1DemandSignalsMaterialsRetrieve>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1DemandSignalsMaterialsRetrieveSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get historical market index prices for a specific material type.
 */
export const apiTradeV1MarketIndexPricesRetrieve = (
  params?: ApiTradeV1MarketIndexPricesRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<HistoricalPricesPerMarketIndex>(
    { url: `/api/trade/v1/market-index-prices/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1MarketIndexPricesRetrieveQueryKey = (params?: ApiTradeV1MarketIndexPricesRetrieveParams) => {
  return [`/api/trade/v1/market-index-prices/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1MarketIndexPricesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1MarketIndexPricesRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1MarketIndexPricesRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>> = ({ signal }) =>
    apiTradeV1MarketIndexPricesRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1MarketIndexPricesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>
>;
export type ApiTradeV1MarketIndexPricesRetrieveQueryError = ErrorType<
  ApiTradeV1MarketIndexPricesRetrieve400 | ErrorResponse
>;

export function useApiTradeV1MarketIndexPricesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesRetrieve400 | ErrorResponse>,
>(
  params: undefined | ApiTradeV1MarketIndexPricesRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MarketIndexPricesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1MarketIndexPricesRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MarketIndexPricesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1MarketIndexPricesRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1MarketIndexPricesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1MarketIndexPricesRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1MarketIndexPricesRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1MarketIndexPricesRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1MarketIndexPricesRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1MarketIndexPricesRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>> = ({ signal }) =>
    apiTradeV1MarketIndexPricesRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1MarketIndexPricesRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>
>;
export type ApiTradeV1MarketIndexPricesRetrieveSuspenseQueryError = ErrorType<
  ApiTradeV1MarketIndexPricesRetrieve400 | ErrorResponse
>;

export function useApiTradeV1MarketIndexPricesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesRetrieve400 | ErrorResponse>,
>(
  params: undefined | ApiTradeV1MarketIndexPricesRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MarketIndexPricesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1MarketIndexPricesRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MarketIndexPricesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1MarketIndexPricesRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1MarketIndexPricesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1MarketIndexPricesRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1MarketIndexPricesRetrieveSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get latest market index prices for a specific material type.
 */
export const apiTradeV1MarketIndexPricesLatestRetrieve = (
  params?: ApiTradeV1MarketIndexPricesLatestRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<LatestPricesDTO>(
    { url: `/api/trade/v1/market-index-prices/latest/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1MarketIndexPricesLatestRetrieveQueryKey = (
  params?: ApiTradeV1MarketIndexPricesLatestRetrieveParams
) => {
  return [`/api/trade/v1/market-index-prices/latest/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1MarketIndexPricesLatestRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesLatestRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1MarketIndexPricesLatestRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1MarketIndexPricesLatestRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>> = ({ signal }) =>
    apiTradeV1MarketIndexPricesLatestRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1MarketIndexPricesLatestRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>
>;
export type ApiTradeV1MarketIndexPricesLatestRetrieveQueryError = ErrorType<
  ApiTradeV1MarketIndexPricesLatestRetrieve400 | ErrorResponse
>;

export function useApiTradeV1MarketIndexPricesLatestRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesLatestRetrieve400 | ErrorResponse>,
>(
  params: undefined | ApiTradeV1MarketIndexPricesLatestRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MarketIndexPricesLatestRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesLatestRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1MarketIndexPricesLatestRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MarketIndexPricesLatestRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesLatestRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1MarketIndexPricesLatestRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1MarketIndexPricesLatestRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesLatestRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1MarketIndexPricesLatestRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1MarketIndexPricesLatestRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1MarketIndexPricesLatestRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesLatestRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1MarketIndexPricesLatestRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1MarketIndexPricesLatestRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>> = ({ signal }) =>
    apiTradeV1MarketIndexPricesLatestRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1MarketIndexPricesLatestRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>
>;
export type ApiTradeV1MarketIndexPricesLatestRetrieveSuspenseQueryError = ErrorType<
  ApiTradeV1MarketIndexPricesLatestRetrieve400 | ErrorResponse
>;

export function useApiTradeV1MarketIndexPricesLatestRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesLatestRetrieve400 | ErrorResponse>,
>(
  params: undefined | ApiTradeV1MarketIndexPricesLatestRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MarketIndexPricesLatestRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesLatestRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1MarketIndexPricesLatestRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MarketIndexPricesLatestRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesLatestRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1MarketIndexPricesLatestRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1MarketIndexPricesLatestRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>,
  TError = ErrorType<ApiTradeV1MarketIndexPricesLatestRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1MarketIndexPricesLatestRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MarketIndexPricesLatestRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1MarketIndexPricesLatestRetrieveSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1MaterialListingOffersSendCreate = (
  offerId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    { url: `/api/trade/v1/material-listing-offers/${offerId}/send/`, method: 'POST', signal },
    options
  );
};

export const getApiTradeV1MaterialListingOffersSendCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1MaterialListingOffersSendCreate>>,
    TError,
    { offerId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1MaterialListingOffersSendCreate>>,
  TError,
  { offerId: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1MaterialListingOffersSendCreate>>,
    { offerId: number }
  > = (props) => {
    const { offerId } = props ?? {};

    return apiTradeV1MaterialListingOffersSendCreate(offerId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1MaterialListingOffersSendCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1MaterialListingOffersSendCreate>>
>;

export type ApiTradeV1MaterialListingOffersSendCreateMutationError = ErrorType<ErrorResponse>;

export const useApiTradeV1MaterialListingOffersSendCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1MaterialListingOffersSendCreate>>,
    TError,
    { offerId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1MaterialListingOffersSendCreate>>,
  TError,
  { offerId: number },
  TContext
> => {
  const mutationOptions = getApiTradeV1MaterialListingOffersSendCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1MaterialListingsList = (
  params?: ApiTradeV1MaterialListingsListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<MaterialListingListResponse>(
    { url: `/api/trade/v1/material-listings/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1MaterialListingsListQueryKey = (params?: ApiTradeV1MaterialListingsListParams) => {
  return [`/api/trade/v1/material-listings/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1MaterialListingsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>,
  TError = ErrorType<ApiTradeV1MaterialListingsList400 | ErrorResponse>,
>(
  params?: ApiTradeV1MaterialListingsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1MaterialListingsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>> = ({ signal }) =>
    apiTradeV1MaterialListingsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1MaterialListingsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>
>;
export type ApiTradeV1MaterialListingsListQueryError = ErrorType<ApiTradeV1MaterialListingsList400 | ErrorResponse>;

export function useApiTradeV1MaterialListingsList<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>,
  TError = ErrorType<ApiTradeV1MaterialListingsList400 | ErrorResponse>,
>(
  params: undefined | ApiTradeV1MaterialListingsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MaterialListingsList<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>,
  TError = ErrorType<ApiTradeV1MaterialListingsList400 | ErrorResponse>,
>(
  params?: ApiTradeV1MaterialListingsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MaterialListingsList<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>,
  TError = ErrorType<ApiTradeV1MaterialListingsList400 | ErrorResponse>,
>(
  params?: ApiTradeV1MaterialListingsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1MaterialListingsList<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>,
  TError = ErrorType<ApiTradeV1MaterialListingsList400 | ErrorResponse>,
>(
  params?: ApiTradeV1MaterialListingsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1MaterialListingsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1MaterialListingsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>,
  TError = ErrorType<ApiTradeV1MaterialListingsList400 | ErrorResponse>,
>(
  params?: ApiTradeV1MaterialListingsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1MaterialListingsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>> = ({ signal }) =>
    apiTradeV1MaterialListingsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1MaterialListingsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>
>;
export type ApiTradeV1MaterialListingsListSuspenseQueryError = ErrorType<
  ApiTradeV1MaterialListingsList400 | ErrorResponse
>;

export function useApiTradeV1MaterialListingsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>,
  TError = ErrorType<ApiTradeV1MaterialListingsList400 | ErrorResponse>,
>(
  params: undefined | ApiTradeV1MaterialListingsListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MaterialListingsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>,
  TError = ErrorType<ApiTradeV1MaterialListingsList400 | ErrorResponse>,
>(
  params?: ApiTradeV1MaterialListingsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MaterialListingsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>,
  TError = ErrorType<ApiTradeV1MaterialListingsList400 | ErrorResponse>,
>(
  params?: ApiTradeV1MaterialListingsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1MaterialListingsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>,
  TError = ErrorType<ApiTradeV1MaterialListingsList400 | ErrorResponse>,
>(
  params?: ApiTradeV1MaterialListingsListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1MaterialListingsListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1MaterialListingsForBuyerCreate = (
  materialListingsForBuyerRequestDTO: BodyType<MaterialListingsForBuyerRequestDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<MaterialListingsForBuyerResponseDTO>(
    {
      url: `/api/trade/v1/material-listings-for-buyer/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: materialListingsForBuyerRequestDTO,
      signal,
    },
    options
  );
};

export const getApiTradeV1MaterialListingsForBuyerCreateMutationOptions = <
  TError = ErrorType<ApiTradeV1MaterialListingsForBuyerCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1MaterialListingsForBuyerCreate>>,
    TError,
    { data: BodyType<MaterialListingsForBuyerRequestDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1MaterialListingsForBuyerCreate>>,
  TError,
  { data: BodyType<MaterialListingsForBuyerRequestDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1MaterialListingsForBuyerCreate>>,
    { data: BodyType<MaterialListingsForBuyerRequestDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return apiTradeV1MaterialListingsForBuyerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1MaterialListingsForBuyerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1MaterialListingsForBuyerCreate>>
>;
export type ApiTradeV1MaterialListingsForBuyerCreateMutationBody = BodyType<MaterialListingsForBuyerRequestDTO>;
export type ApiTradeV1MaterialListingsForBuyerCreateMutationError = ErrorType<
  ApiTradeV1MaterialListingsForBuyerCreate400 | ErrorResponse
>;

export const useApiTradeV1MaterialListingsForBuyerCreate = <
  TError = ErrorType<ApiTradeV1MaterialListingsForBuyerCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1MaterialListingsForBuyerCreate>>,
    TError,
    { data: BodyType<MaterialListingsForBuyerRequestDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1MaterialListingsForBuyerCreate>>,
  TError,
  { data: BodyType<MaterialListingsForBuyerRequestDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1MaterialListingsForBuyerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1MaterialListingsRetrieve = (
  publicId: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<MaterialListingDetailResponseDTO>(
    { url: `/api/trade/v1/material-listings/${publicId}/`, method: 'GET', signal },
    options
  );
};

export const getApiTradeV1MaterialListingsRetrieveQueryKey = (publicId: string) => {
  return [`/api/trade/v1/material-listings/${publicId}/`] as const;
};

export const getApiTradeV1MaterialListingsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1MaterialListingsRetrieveQueryKey(publicId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>> = ({ signal }) =>
    apiTradeV1MaterialListingsRetrieve(publicId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!publicId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1MaterialListingsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>
>;
export type ApiTradeV1MaterialListingsRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1MaterialListingsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MaterialListingsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MaterialListingsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1MaterialListingsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1MaterialListingsRetrieveQueryOptions(publicId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1MaterialListingsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1MaterialListingsRetrieveQueryKey(publicId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>> = ({ signal }) =>
    apiTradeV1MaterialListingsRetrieve(publicId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1MaterialListingsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>
>;
export type ApiTradeV1MaterialListingsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1MaterialListingsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MaterialListingsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MaterialListingsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1MaterialListingsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1MaterialListingsRetrieveSuspenseQueryOptions(publicId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1MaterialListingsBidCreate = (
  publicId: string,
  createMaterialListingBidRequestDTO: BodyType<CreateMaterialListingBidRequestDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    {
      url: `/api/trade/v1/material-listings/${publicId}/bid/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createMaterialListingBidRequestDTO,
      signal,
    },
    options
  );
};

export const getApiTradeV1MaterialListingsBidCreateMutationOptions = <
  TError = ErrorType<ApiTradeV1MaterialListingsBidCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1MaterialListingsBidCreate>>,
    TError,
    { publicId: string; data: BodyType<CreateMaterialListingBidRequestDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1MaterialListingsBidCreate>>,
  TError,
  { publicId: string; data: BodyType<CreateMaterialListingBidRequestDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1MaterialListingsBidCreate>>,
    { publicId: string; data: BodyType<CreateMaterialListingBidRequestDTO> }
  > = (props) => {
    const { publicId, data } = props ?? {};

    return apiTradeV1MaterialListingsBidCreate(publicId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1MaterialListingsBidCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1MaterialListingsBidCreate>>
>;
export type ApiTradeV1MaterialListingsBidCreateMutationBody = BodyType<CreateMaterialListingBidRequestDTO>;
export type ApiTradeV1MaterialListingsBidCreateMutationError = ErrorType<
  ApiTradeV1MaterialListingsBidCreate400 | ErrorResponse
>;

export const useApiTradeV1MaterialListingsBidCreate = <
  TError = ErrorType<ApiTradeV1MaterialListingsBidCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1MaterialListingsBidCreate>>,
    TError,
    { publicId: string; data: BodyType<CreateMaterialListingBidRequestDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1MaterialListingsBidCreate>>,
  TError,
  { publicId: string; data: BodyType<CreateMaterialListingBidRequestDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1MaterialListingsBidCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1MaterialListingsLatestOfferRetrieve = (
  publicId: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<MaterialOfferDTO>(
    { url: `/api/trade/v1/material-listings/${publicId}/latest-offer/`, method: 'GET', signal },
    options
  );
};

export const getApiTradeV1MaterialListingsLatestOfferRetrieveQueryKey = (publicId: string) => {
  return [`/api/trade/v1/material-listings/${publicId}/latest-offer/`] as const;
};

export const getApiTradeV1MaterialListingsLatestOfferRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1MaterialListingsLatestOfferRetrieveQueryKey(publicId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>> = ({
    signal,
  }) => apiTradeV1MaterialListingsLatestOfferRetrieve(publicId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!publicId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1MaterialListingsLatestOfferRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>
>;
export type ApiTradeV1MaterialListingsLatestOfferRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1MaterialListingsLatestOfferRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MaterialListingsLatestOfferRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MaterialListingsLatestOfferRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1MaterialListingsLatestOfferRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1MaterialListingsLatestOfferRetrieveQueryOptions(publicId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1MaterialListingsLatestOfferRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1MaterialListingsLatestOfferRetrieveQueryKey(publicId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>> = ({
    signal,
  }) => apiTradeV1MaterialListingsLatestOfferRetrieve(publicId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1MaterialListingsLatestOfferRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>
>;
export type ApiTradeV1MaterialListingsLatestOfferRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1MaterialListingsLatestOfferRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MaterialListingsLatestOfferRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1MaterialListingsLatestOfferRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1MaterialListingsLatestOfferRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  publicId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1MaterialListingsLatestOfferRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1MaterialListingsLatestOfferRetrieveSuspenseQueryOptions(publicId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1MaterialListingsOffersCreate = (
  createMaterialListingOfferRequestDTO: BodyType<CreateMaterialListingOfferRequestDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<MaterialOfferDTO>(
    {
      url: `/api/trade/v1/material-listings/offers/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createMaterialListingOfferRequestDTO,
      signal,
    },
    options
  );
};

export const getApiTradeV1MaterialListingsOffersCreateMutationOptions = <
  TError = ErrorType<ApiTradeV1MaterialListingsOffersCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1MaterialListingsOffersCreate>>,
    TError,
    { data: BodyType<CreateMaterialListingOfferRequestDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1MaterialListingsOffersCreate>>,
  TError,
  { data: BodyType<CreateMaterialListingOfferRequestDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1MaterialListingsOffersCreate>>,
    { data: BodyType<CreateMaterialListingOfferRequestDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return apiTradeV1MaterialListingsOffersCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1MaterialListingsOffersCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1MaterialListingsOffersCreate>>
>;
export type ApiTradeV1MaterialListingsOffersCreateMutationBody = BodyType<CreateMaterialListingOfferRequestDTO>;
export type ApiTradeV1MaterialListingsOffersCreateMutationError = ErrorType<
  ApiTradeV1MaterialListingsOffersCreate400 | ErrorResponse
>;

export const useApiTradeV1MaterialListingsOffersCreate = <
  TError = ErrorType<ApiTradeV1MaterialListingsOffersCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1MaterialListingsOffersCreate>>,
    TError,
    { data: BodyType<CreateMaterialListingOfferRequestDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1MaterialListingsOffersCreate>>,
  TError,
  { data: BodyType<CreateMaterialListingOfferRequestDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1MaterialListingsOffersCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1PackagingSpecificationsUpdate = (
  packagingSpecificationId: number,
  updatePackagingSpecificationDTO: BodyType<UpdatePackagingSpecificationDTO>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<void>(
    {
      url: `/api/trade/v1/packaging-specifications/${packagingSpecificationId}/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updatePackagingSpecificationDTO,
    },
    options
  );
};

export const getApiTradeV1PackagingSpecificationsUpdateMutationOptions = <
  TError = ErrorType<ApiTradeV1PackagingSpecificationsUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsUpdate>>,
    TError,
    { packagingSpecificationId: number; data: BodyType<UpdatePackagingSpecificationDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsUpdate>>,
  TError,
  { packagingSpecificationId: number; data: BodyType<UpdatePackagingSpecificationDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsUpdate>>,
    { packagingSpecificationId: number; data: BodyType<UpdatePackagingSpecificationDTO> }
  > = (props) => {
    const { packagingSpecificationId, data } = props ?? {};

    return apiTradeV1PackagingSpecificationsUpdate(packagingSpecificationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1PackagingSpecificationsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsUpdate>>
>;
export type ApiTradeV1PackagingSpecificationsUpdateMutationBody = BodyType<UpdatePackagingSpecificationDTO>;
export type ApiTradeV1PackagingSpecificationsUpdateMutationError = ErrorType<
  ApiTradeV1PackagingSpecificationsUpdate400 | ErrorResponse
>;

export const useApiTradeV1PackagingSpecificationsUpdate = <
  TError = ErrorType<ApiTradeV1PackagingSpecificationsUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsUpdate>>,
    TError,
    { packagingSpecificationId: number; data: BodyType<UpdatePackagingSpecificationDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsUpdate>>,
  TError,
  { packagingSpecificationId: number; data: BodyType<UpdatePackagingSpecificationDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1PackagingSpecificationsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1PackagingSpecificationsDestroy = (
  packagingSpecificationId: number,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<void>(
    { url: `/api/trade/v1/packaging-specifications/${packagingSpecificationId}/`, method: 'DELETE' },
    options
  );
};

export const getApiTradeV1PackagingSpecificationsDestroyMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsDestroy>>,
    TError,
    { packagingSpecificationId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsDestroy>>,
  TError,
  { packagingSpecificationId: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsDestroy>>,
    { packagingSpecificationId: number }
  > = (props) => {
    const { packagingSpecificationId } = props ?? {};

    return apiTradeV1PackagingSpecificationsDestroy(packagingSpecificationId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1PackagingSpecificationsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsDestroy>>
>;

export type ApiTradeV1PackagingSpecificationsDestroyMutationError = ErrorType<ErrorResponse>;

export const useApiTradeV1PackagingSpecificationsDestroy = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsDestroy>>,
    TError,
    { packagingSpecificationId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsDestroy>>,
  TError,
  { packagingSpecificationId: number },
  TContext
> => {
  const mutationOptions = getApiTradeV1PackagingSpecificationsDestroyMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Get tailored price details per material grade for the seller with historical prices.
 */
export const apiTradeV1SellDashboardRetrieve = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SellDashboardResponseDTO>(
    { url: `/api/trade/v1/sell-dashboard/`, method: 'GET', signal },
    options
  );
};

export const getApiTradeV1SellDashboardRetrieveQueryKey = () => {
  return [`/api/trade/v1/sell-dashboard/`] as const;
};

export const getApiTradeV1SellDashboardRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1SellDashboardRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>> = ({ signal }) =>
    apiTradeV1SellDashboardRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1SellDashboardRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>
>;
export type ApiTradeV1SellDashboardRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1SellDashboardRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SellDashboardRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SellDashboardRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1SellDashboardRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1SellDashboardRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1SellDashboardRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1SellDashboardRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>> = ({ signal }) =>
    apiTradeV1SellDashboardRetrieve(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1SellDashboardRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>
>;
export type ApiTradeV1SellDashboardRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1SellDashboardRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options: {
  query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SellDashboardRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SellDashboardRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1SellDashboardRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SellDashboardRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customAxios>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1SellDashboardRetrieveSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Confirm a sell offer (Experimental). Check: https://www.notion.so/safi-ltd/Seller-price-page-Experiment-136b8449f7a680a9a755c78aae907e18 for more info.
 */
export const apiTradeV1SellOfferConfirmCreate = (
  sellOfferConfirmDTO: BodyType<SellOfferConfirmDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleResponse>(
    {
      url: `/api/trade/v1/sell-offer-confirm/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sellOfferConfirmDTO,
      signal,
    },
    options
  );
};

export const getApiTradeV1SellOfferConfirmCreateMutationOptions = <
  TError = ErrorType<ApiTradeV1SellOfferConfirmCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SellOfferConfirmCreate>>,
    TError,
    { data: BodyType<SellOfferConfirmDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1SellOfferConfirmCreate>>,
  TError,
  { data: BodyType<SellOfferConfirmDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1SellOfferConfirmCreate>>,
    { data: BodyType<SellOfferConfirmDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return apiTradeV1SellOfferConfirmCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1SellOfferConfirmCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SellOfferConfirmCreate>>
>;
export type ApiTradeV1SellOfferConfirmCreateMutationBody = BodyType<SellOfferConfirmDTO>;
export type ApiTradeV1SellOfferConfirmCreateMutationError = ErrorType<
  ApiTradeV1SellOfferConfirmCreate400 | ErrorResponse
>;

export const useApiTradeV1SellOfferConfirmCreate = <
  TError = ErrorType<ApiTradeV1SellOfferConfirmCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SellOfferConfirmCreate>>,
    TError,
    { data: BodyType<SellOfferConfirmDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1SellOfferConfirmCreate>>,
  TError,
  { data: BodyType<SellOfferConfirmDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1SellOfferConfirmCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1SellerOutreachSiteMaterialOffersCreate = (
  siteMaterialOfferCreateRequestDTO: BodyType<SiteMaterialOfferCreateRequestDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SiteMaterialOfferCreateResponseDTO>(
    {
      url: `/api/trade/v1/seller-outreach/site-material-offers/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: siteMaterialOfferCreateRequestDTO,
      signal,
    },
    options
  );
};

export const getApiTradeV1SellerOutreachSiteMaterialOffersCreateMutationOptions = <
  TError = ErrorType<ApiTradeV1SellerOutreachSiteMaterialOffersCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SellerOutreachSiteMaterialOffersCreate>>,
    TError,
    { data: BodyType<SiteMaterialOfferCreateRequestDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1SellerOutreachSiteMaterialOffersCreate>>,
  TError,
  { data: BodyType<SiteMaterialOfferCreateRequestDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1SellerOutreachSiteMaterialOffersCreate>>,
    { data: BodyType<SiteMaterialOfferCreateRequestDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return apiTradeV1SellerOutreachSiteMaterialOffersCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1SellerOutreachSiteMaterialOffersCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SellerOutreachSiteMaterialOffersCreate>>
>;
export type ApiTradeV1SellerOutreachSiteMaterialOffersCreateMutationBody = BodyType<SiteMaterialOfferCreateRequestDTO>;
export type ApiTradeV1SellerOutreachSiteMaterialOffersCreateMutationError = ErrorType<
  ApiTradeV1SellerOutreachSiteMaterialOffersCreate400 | ErrorResponse
>;

export const useApiTradeV1SellerOutreachSiteMaterialOffersCreate = <
  TError = ErrorType<ApiTradeV1SellerOutreachSiteMaterialOffersCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SellerOutreachSiteMaterialOffersCreate>>,
    TError,
    { data: BodyType<SiteMaterialOfferCreateRequestDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1SellerOutreachSiteMaterialOffersCreate>>,
  TError,
  { data: BodyType<SiteMaterialOfferCreateRequestDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1SellerOutreachSiteMaterialOffersCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1SellerOutreachSiteMaterialOffersSendCreate = (
  offerId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    { url: `/api/trade/v1/seller-outreach/site-material-offers/${offerId}/send/`, method: 'POST', signal },
    options
  );
};

export const getApiTradeV1SellerOutreachSiteMaterialOffersSendCreateMutationOptions = <
  TError = ErrorType<ApiTradeV1SellerOutreachSiteMaterialOffersSendCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SellerOutreachSiteMaterialOffersSendCreate>>,
    TError,
    { offerId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1SellerOutreachSiteMaterialOffersSendCreate>>,
  TError,
  { offerId: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1SellerOutreachSiteMaterialOffersSendCreate>>,
    { offerId: number }
  > = (props) => {
    const { offerId } = props ?? {};

    return apiTradeV1SellerOutreachSiteMaterialOffersSendCreate(offerId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1SellerOutreachSiteMaterialOffersSendCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SellerOutreachSiteMaterialOffersSendCreate>>
>;

export type ApiTradeV1SellerOutreachSiteMaterialOffersSendCreateMutationError = ErrorType<
  ApiTradeV1SellerOutreachSiteMaterialOffersSendCreate400 | ErrorResponse
>;

export const useApiTradeV1SellerOutreachSiteMaterialOffersSendCreate = <
  TError = ErrorType<ApiTradeV1SellerOutreachSiteMaterialOffersSendCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SellerOutreachSiteMaterialOffersSendCreate>>,
    TError,
    { offerId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1SellerOutreachSiteMaterialOffersSendCreate>>,
  TError,
  { offerId: number },
  TContext
> => {
  const mutationOptions = getApiTradeV1SellerOutreachSiteMaterialOffersSendCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1SiteMaterialsCreate = (
  createSiteMaterialDTO: BodyType<CreateSiteMaterialDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CreateSiteMaterialResponse>(
    {
      url: `/api/trade/v1/site-materials/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createSiteMaterialDTO,
      signal,
    },
    options
  );
};

export const getApiTradeV1SiteMaterialsCreateMutationOptions = <
  TError = ErrorType<ApiTradeV1SiteMaterialsCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsCreate>>,
    TError,
    { data: BodyType<CreateSiteMaterialDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsCreate>>,
  TError,
  { data: BodyType<CreateSiteMaterialDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsCreate>>,
    { data: BodyType<CreateSiteMaterialDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return apiTradeV1SiteMaterialsCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1SiteMaterialsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsCreate>>
>;
export type ApiTradeV1SiteMaterialsCreateMutationBody = BodyType<CreateSiteMaterialDTO>;
export type ApiTradeV1SiteMaterialsCreateMutationError = ErrorType<ApiTradeV1SiteMaterialsCreate400 | ErrorResponse>;

export const useApiTradeV1SiteMaterialsCreate = <
  TError = ErrorType<ApiTradeV1SiteMaterialsCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsCreate>>,
    TError,
    { data: BodyType<CreateSiteMaterialDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsCreate>>,
  TError,
  { data: BodyType<CreateSiteMaterialDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1SiteMaterialsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1SiteMaterialsRetrieve = (
  siteMaterialId: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SiteMaterialDetail>(
    { url: `/api/trade/v1/site-materials/${siteMaterialId}/`, method: 'GET', signal },
    options
  );
};

export const getApiTradeV1SiteMaterialsRetrieveQueryKey = (siteMaterialId: string) => {
  return [`/api/trade/v1/site-materials/${siteMaterialId}/`] as const;
};

export const getApiTradeV1SiteMaterialsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1SiteMaterialsRetrieveQueryKey(siteMaterialId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>> = ({ signal }) =>
    apiTradeV1SiteMaterialsRetrieve(siteMaterialId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!siteMaterialId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1SiteMaterialsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>
>;
export type ApiTradeV1SiteMaterialsRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1SiteMaterialsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1SiteMaterialsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1SiteMaterialsRetrieveQueryOptions(siteMaterialId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1SiteMaterialsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1SiteMaterialsRetrieveQueryKey(siteMaterialId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>> = ({ signal }) =>
    apiTradeV1SiteMaterialsRetrieve(siteMaterialId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1SiteMaterialsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>
>;
export type ApiTradeV1SiteMaterialsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1SiteMaterialsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1SiteMaterialsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1SiteMaterialsRetrieveSuspenseQueryOptions(siteMaterialId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1SiteMaterialsUpdate = (
  siteMaterialId: string,
  updateSiteMaterialDTO: BodyType<UpdateSiteMaterialDTO>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<void>(
    {
      url: `/api/trade/v1/site-materials/${siteMaterialId}/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateSiteMaterialDTO,
    },
    options
  );
};

export const getApiTradeV1SiteMaterialsUpdateMutationOptions = <
  TError = ErrorType<ApiTradeV1SiteMaterialsUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsUpdate>>,
    TError,
    { siteMaterialId: string; data: BodyType<UpdateSiteMaterialDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsUpdate>>,
  TError,
  { siteMaterialId: string; data: BodyType<UpdateSiteMaterialDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsUpdate>>,
    { siteMaterialId: string; data: BodyType<UpdateSiteMaterialDTO> }
  > = (props) => {
    const { siteMaterialId, data } = props ?? {};

    return apiTradeV1SiteMaterialsUpdate(siteMaterialId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1SiteMaterialsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsUpdate>>
>;
export type ApiTradeV1SiteMaterialsUpdateMutationBody = BodyType<UpdateSiteMaterialDTO>;
export type ApiTradeV1SiteMaterialsUpdateMutationError = ErrorType<ApiTradeV1SiteMaterialsUpdate400 | ErrorResponse>;

export const useApiTradeV1SiteMaterialsUpdate = <
  TError = ErrorType<ApiTradeV1SiteMaterialsUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsUpdate>>,
    TError,
    { siteMaterialId: string; data: BodyType<UpdateSiteMaterialDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsUpdate>>,
  TError,
  { siteMaterialId: string; data: BodyType<UpdateSiteMaterialDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1SiteMaterialsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1SiteMaterialsEvidenceList = (
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedEvidenceList>(
    { url: `/api/trade/v1/site-materials/${siteMaterialId}/evidence/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1SiteMaterialsEvidenceListQueryKey = (
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceListParams
) => {
  return [`/api/trade/v1/site-materials/${siteMaterialId}/evidence/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1SiteMaterialsEvidenceListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1SiteMaterialsEvidenceListQueryKey(siteMaterialId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>> = ({ signal }) =>
    apiTradeV1SiteMaterialsEvidenceList(siteMaterialId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!siteMaterialId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1SiteMaterialsEvidenceListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>
>;
export type ApiTradeV1SiteMaterialsEvidenceListQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1SiteMaterialsEvidenceList<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params: undefined | ApiTradeV1SiteMaterialsEvidenceListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsEvidenceList<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsEvidenceList<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1SiteMaterialsEvidenceList<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1SiteMaterialsEvidenceListQueryOptions(siteMaterialId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1SiteMaterialsEvidenceListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1SiteMaterialsEvidenceListQueryKey(siteMaterialId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>> = ({ signal }) =>
    apiTradeV1SiteMaterialsEvidenceList(siteMaterialId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1SiteMaterialsEvidenceListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>
>;
export type ApiTradeV1SiteMaterialsEvidenceListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1SiteMaterialsEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params: undefined | ApiTradeV1SiteMaterialsEvidenceListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1SiteMaterialsEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1SiteMaterialsEvidenceListSuspenseQueryOptions(siteMaterialId, params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1SiteMaterialsEvidenceSessionsRetrieve = (
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceSessionsRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SiteMaterialSessionList>(
    { url: `/api/trade/v1/site-materials/${siteMaterialId}/evidence-sessions/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1SiteMaterialsEvidenceSessionsRetrieveQueryKey = (
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceSessionsRetrieveParams
) => {
  return [`/api/trade/v1/site-materials/${siteMaterialId}/evidence-sessions/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1SiteMaterialsEvidenceSessionsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceSessionsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiTradeV1SiteMaterialsEvidenceSessionsRetrieveQueryKey(siteMaterialId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>> = ({
    signal,
  }) => apiTradeV1SiteMaterialsEvidenceSessionsRetrieve(siteMaterialId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!siteMaterialId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1SiteMaterialsEvidenceSessionsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>
>;
export type ApiTradeV1SiteMaterialsEvidenceSessionsRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1SiteMaterialsEvidenceSessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params: undefined | ApiTradeV1SiteMaterialsEvidenceSessionsRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsEvidenceSessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceSessionsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsEvidenceSessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceSessionsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1SiteMaterialsEvidenceSessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceSessionsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1SiteMaterialsEvidenceSessionsRetrieveQueryOptions(siteMaterialId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1SiteMaterialsEvidenceSessionsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceSessionsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiTradeV1SiteMaterialsEvidenceSessionsRetrieveQueryKey(siteMaterialId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>> = ({
    signal,
  }) => apiTradeV1SiteMaterialsEvidenceSessionsRetrieve(siteMaterialId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1SiteMaterialsEvidenceSessionsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>
>;
export type ApiTradeV1SiteMaterialsEvidenceSessionsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1SiteMaterialsEvidenceSessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params: undefined | ApiTradeV1SiteMaterialsEvidenceSessionsRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsEvidenceSessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceSessionsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsEvidenceSessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceSessionsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1SiteMaterialsEvidenceSessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsEvidenceSessionsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceSessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1SiteMaterialsEvidenceSessionsRetrieveSuspenseQueryOptions(
    siteMaterialId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1SiteMaterialsEvidenceRetrieve = (
  siteMaterialId: string,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Evidence>(
    { url: `/api/trade/v1/site-materials/${siteMaterialId}/evidence/${id}/`, method: 'GET', signal },
    options
  );
};

export const getApiTradeV1SiteMaterialsEvidenceRetrieveQueryKey = (siteMaterialId: string, id: number) => {
  return [`/api/trade/v1/site-materials/${siteMaterialId}/evidence/${id}/`] as const;
};

export const getApiTradeV1SiteMaterialsEvidenceRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1SiteMaterialsEvidenceRetrieveQueryKey(siteMaterialId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>> = ({ signal }) =>
    apiTradeV1SiteMaterialsEvidenceRetrieve(siteMaterialId, id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(siteMaterialId && id), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1SiteMaterialsEvidenceRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>
>;
export type ApiTradeV1SiteMaterialsEvidenceRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1SiteMaterialsEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1SiteMaterialsEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1SiteMaterialsEvidenceRetrieveQueryOptions(siteMaterialId, id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1SiteMaterialsEvidenceRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1SiteMaterialsEvidenceRetrieveQueryKey(siteMaterialId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>> = ({ signal }) =>
    apiTradeV1SiteMaterialsEvidenceRetrieve(siteMaterialId, id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1SiteMaterialsEvidenceRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>
>;
export type ApiTradeV1SiteMaterialsEvidenceRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1SiteMaterialsEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1SiteMaterialsEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1SiteMaterialsEvidenceRetrieveSuspenseQueryOptions(siteMaterialId, id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generate an upload URL for large files.
 */
export const apiTradeV1SiteMaterialsEvidenceUploadCreate = (
  siteMaterialId: string,
  generateUploadUrlRequest: BodyType<GenerateUploadUrlRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GenerateUploadUrlResponse>(
    {
      url: `/api/trade/v1/site-materials/${siteMaterialId}/evidence/upload/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: generateUploadUrlRequest,
      signal,
    },
    options
  );
};

export const getApiTradeV1SiteMaterialsEvidenceUploadCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceUploadCreate>>,
    TError,
    { siteMaterialId: string; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceUploadCreate>>,
  TError,
  { siteMaterialId: string; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceUploadCreate>>,
    { siteMaterialId: string; data: BodyType<GenerateUploadUrlRequest> }
  > = (props) => {
    const { siteMaterialId, data } = props ?? {};

    return apiTradeV1SiteMaterialsEvidenceUploadCreate(siteMaterialId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1SiteMaterialsEvidenceUploadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceUploadCreate>>
>;
export type ApiTradeV1SiteMaterialsEvidenceUploadCreateMutationBody = BodyType<GenerateUploadUrlRequest>;
export type ApiTradeV1SiteMaterialsEvidenceUploadCreateMutationError = ErrorType<ErrorResponse>;

export const useApiTradeV1SiteMaterialsEvidenceUploadCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceUploadCreate>>,
    TError,
    { siteMaterialId: string; data: BodyType<GenerateUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceUploadCreate>>,
  TError,
  { siteMaterialId: string; data: BodyType<GenerateUploadUrlRequest> },
  TContext
> => {
  const mutationOptions = getApiTradeV1SiteMaterialsEvidenceUploadCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Saves evidence as bale photo and returns inference results.
 */
export const apiTradeV1SiteMaterialsEvidenceUploadUpdate = (
  siteMaterialId: string,
  processUploadRequest: BodyType<ProcessUploadRequest>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<ProcessUploadResponse>(
    {
      url: `/api/trade/v1/site-materials/${siteMaterialId}/evidence/upload/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: processUploadRequest,
    },
    options
  );
};

export const getApiTradeV1SiteMaterialsEvidenceUploadUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceUploadUpdate>>,
    TError,
    { siteMaterialId: string; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceUploadUpdate>>,
  TError,
  { siteMaterialId: string; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceUploadUpdate>>,
    { siteMaterialId: string; data: BodyType<ProcessUploadRequest> }
  > = (props) => {
    const { siteMaterialId, data } = props ?? {};

    return apiTradeV1SiteMaterialsEvidenceUploadUpdate(siteMaterialId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1SiteMaterialsEvidenceUploadUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceUploadUpdate>>
>;
export type ApiTradeV1SiteMaterialsEvidenceUploadUpdateMutationBody = BodyType<ProcessUploadRequest>;
export type ApiTradeV1SiteMaterialsEvidenceUploadUpdateMutationError = ErrorType<unknown>;

export const useApiTradeV1SiteMaterialsEvidenceUploadUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceUploadUpdate>>,
    TError,
    { siteMaterialId: string; data: BodyType<ProcessUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsEvidenceUploadUpdate>>,
  TError,
  { siteMaterialId: string; data: BodyType<ProcessUploadRequest> },
  TContext
> => {
  const mutationOptions = getApiTradeV1SiteMaterialsEvidenceUploadUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * View for creating/listing site material sessions by external users (e.g. sellers).
 */
export const apiTradeV1SiteMaterialsExternalSessionsRetrieve = (
  siteMaterialId: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ExternalSiteMaterialSessionList>(
    { url: `/api/trade/v1/site-materials/${siteMaterialId}/external-sessions/`, method: 'GET', signal },
    options
  );
};

export const getApiTradeV1SiteMaterialsExternalSessionsRetrieveQueryKey = (siteMaterialId: string) => {
  return [`/api/trade/v1/site-materials/${siteMaterialId}/external-sessions/`] as const;
};

export const getApiTradeV1SiteMaterialsExternalSessionsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1SiteMaterialsExternalSessionsRetrieveQueryKey(siteMaterialId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>> = ({
    signal,
  }) => apiTradeV1SiteMaterialsExternalSessionsRetrieve(siteMaterialId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!siteMaterialId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1SiteMaterialsExternalSessionsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>
>;
export type ApiTradeV1SiteMaterialsExternalSessionsRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1SiteMaterialsExternalSessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsExternalSessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsExternalSessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1SiteMaterialsExternalSessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1SiteMaterialsExternalSessionsRetrieveQueryOptions(siteMaterialId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1SiteMaterialsExternalSessionsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1SiteMaterialsExternalSessionsRetrieveQueryKey(siteMaterialId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>> = ({
    signal,
  }) => apiTradeV1SiteMaterialsExternalSessionsRetrieve(siteMaterialId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1SiteMaterialsExternalSessionsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>
>;
export type ApiTradeV1SiteMaterialsExternalSessionsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1SiteMaterialsExternalSessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsExternalSessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsExternalSessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1SiteMaterialsExternalSessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1SiteMaterialsExternalSessionsRetrieveSuspenseQueryOptions(siteMaterialId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * View for creating/listing site material sessions by external users (e.g. sellers).
 */
export const apiTradeV1SiteMaterialsExternalSessionsCreate = (
  siteMaterialId: string,
  siteMaterialSessionCreateDTO: BodyType<SiteMaterialSessionCreateDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SiteMaterialSessionCreateResponse>(
    {
      url: `/api/trade/v1/site-materials/${siteMaterialId}/external-sessions/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: siteMaterialSessionCreateDTO,
      signal,
    },
    options
  );
};

export const getApiTradeV1SiteMaterialsExternalSessionsCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsCreate>>,
    TError,
    { siteMaterialId: string; data: BodyType<SiteMaterialSessionCreateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsCreate>>,
  TError,
  { siteMaterialId: string; data: BodyType<SiteMaterialSessionCreateDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsCreate>>,
    { siteMaterialId: string; data: BodyType<SiteMaterialSessionCreateDTO> }
  > = (props) => {
    const { siteMaterialId, data } = props ?? {};

    return apiTradeV1SiteMaterialsExternalSessionsCreate(siteMaterialId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1SiteMaterialsExternalSessionsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsCreate>>
>;
export type ApiTradeV1SiteMaterialsExternalSessionsCreateMutationBody = BodyType<SiteMaterialSessionCreateDTO>;
export type ApiTradeV1SiteMaterialsExternalSessionsCreateMutationError = ErrorType<ErrorResponse>;

export const useApiTradeV1SiteMaterialsExternalSessionsCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsCreate>>,
    TError,
    { siteMaterialId: string; data: BodyType<SiteMaterialSessionCreateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsExternalSessionsCreate>>,
  TError,
  { siteMaterialId: string; data: BodyType<SiteMaterialSessionCreateDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1SiteMaterialsExternalSessionsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1SiteMaterialsLatestOfferRetrieve = (
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsLatestOfferRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SiteMaterialLatestOfferDetail>(
    { url: `/api/trade/v1/site-materials/${siteMaterialId}/latest-offer/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1SiteMaterialsLatestOfferRetrieveQueryKey = (
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsLatestOfferRetrieveParams
) => {
  return [`/api/trade/v1/site-materials/${siteMaterialId}/latest-offer/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1SiteMaterialsLatestOfferRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsLatestOfferRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiTradeV1SiteMaterialsLatestOfferRetrieveQueryKey(siteMaterialId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>> = ({ signal }) =>
    apiTradeV1SiteMaterialsLatestOfferRetrieve(siteMaterialId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!siteMaterialId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1SiteMaterialsLatestOfferRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>
>;
export type ApiTradeV1SiteMaterialsLatestOfferRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1SiteMaterialsLatestOfferRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params: undefined | ApiTradeV1SiteMaterialsLatestOfferRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsLatestOfferRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsLatestOfferRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsLatestOfferRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsLatestOfferRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1SiteMaterialsLatestOfferRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsLatestOfferRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1SiteMaterialsLatestOfferRetrieveQueryOptions(siteMaterialId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1SiteMaterialsLatestOfferRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsLatestOfferRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiTradeV1SiteMaterialsLatestOfferRetrieveQueryKey(siteMaterialId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>> = ({ signal }) =>
    apiTradeV1SiteMaterialsLatestOfferRetrieve(siteMaterialId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1SiteMaterialsLatestOfferRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>
>;
export type ApiTradeV1SiteMaterialsLatestOfferRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1SiteMaterialsLatestOfferRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params: undefined | ApiTradeV1SiteMaterialsLatestOfferRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsLatestOfferRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsLatestOfferRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1SiteMaterialsLatestOfferRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsLatestOfferRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1SiteMaterialsLatestOfferRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  params?: ApiTradeV1SiteMaterialsLatestOfferRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1SiteMaterialsLatestOfferRetrieveSuspenseQueryOptions(
    siteMaterialId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1SiteMaterialsLatestOfferRespondCreate = (
  siteMaterialId: string,
  siteMaterialLatestOfferAnswerRequest: BodyType<SiteMaterialLatestOfferAnswerRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SiteMaterialOfferAnswerResponse>(
    {
      url: `/api/trade/v1/site-materials/${siteMaterialId}/latest-offer/respond/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: siteMaterialLatestOfferAnswerRequest,
      signal,
    },
    options
  );
};

export const getApiTradeV1SiteMaterialsLatestOfferRespondCreateMutationOptions = <
  TError = ErrorType<ApiTradeV1SiteMaterialsLatestOfferRespondCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRespondCreate>>,
    TError,
    { siteMaterialId: string; data: BodyType<SiteMaterialLatestOfferAnswerRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRespondCreate>>,
  TError,
  { siteMaterialId: string; data: BodyType<SiteMaterialLatestOfferAnswerRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRespondCreate>>,
    { siteMaterialId: string; data: BodyType<SiteMaterialLatestOfferAnswerRequest> }
  > = (props) => {
    const { siteMaterialId, data } = props ?? {};

    return apiTradeV1SiteMaterialsLatestOfferRespondCreate(siteMaterialId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1SiteMaterialsLatestOfferRespondCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRespondCreate>>
>;
export type ApiTradeV1SiteMaterialsLatestOfferRespondCreateMutationBody =
  BodyType<SiteMaterialLatestOfferAnswerRequest>;
export type ApiTradeV1SiteMaterialsLatestOfferRespondCreateMutationError = ErrorType<
  ApiTradeV1SiteMaterialsLatestOfferRespondCreate400 | ErrorResponse
>;

export const useApiTradeV1SiteMaterialsLatestOfferRespondCreate = <
  TError = ErrorType<ApiTradeV1SiteMaterialsLatestOfferRespondCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRespondCreate>>,
    TError,
    { siteMaterialId: string; data: BodyType<SiteMaterialLatestOfferAnswerRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1SiteMaterialsLatestOfferRespondCreate>>,
  TError,
  { siteMaterialId: string; data: BodyType<SiteMaterialLatestOfferAnswerRequest> },
  TContext
> => {
  const mutationOptions = getApiTradeV1SiteMaterialsLatestOfferRespondCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1SupplySignalCalculateBuyPriceCreate = (
  calculateBuyPriceForSupplySignalRequestDTO: BodyType<CalculateBuyPriceForSupplySignalRequestDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PricedSupplySignalDTO[]>(
    {
      url: `/api/trade/v1/supply-signal/calculate-buy-price/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: calculateBuyPriceForSupplySignalRequestDTO,
      signal,
    },
    options
  );
};

export const getApiTradeV1SupplySignalCalculateBuyPriceCreateMutationOptions = <
  TError = ErrorType<ApiTradeV1SupplySignalCalculateBuyPriceCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SupplySignalCalculateBuyPriceCreate>>,
    TError,
    { data: BodyType<CalculateBuyPriceForSupplySignalRequestDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1SupplySignalCalculateBuyPriceCreate>>,
  TError,
  { data: BodyType<CalculateBuyPriceForSupplySignalRequestDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1SupplySignalCalculateBuyPriceCreate>>,
    { data: BodyType<CalculateBuyPriceForSupplySignalRequestDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return apiTradeV1SupplySignalCalculateBuyPriceCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1SupplySignalCalculateBuyPriceCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SupplySignalCalculateBuyPriceCreate>>
>;
export type ApiTradeV1SupplySignalCalculateBuyPriceCreateMutationBody =
  BodyType<CalculateBuyPriceForSupplySignalRequestDTO>;
export type ApiTradeV1SupplySignalCalculateBuyPriceCreateMutationError = ErrorType<
  ApiTradeV1SupplySignalCalculateBuyPriceCreate400 | ErrorResponse
>;

export const useApiTradeV1SupplySignalCalculateBuyPriceCreate = <
  TError = ErrorType<ApiTradeV1SupplySignalCalculateBuyPriceCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SupplySignalCalculateBuyPriceCreate>>,
    TError,
    { data: BodyType<CalculateBuyPriceForSupplySignalRequestDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1SupplySignalCalculateBuyPriceCreate>>,
  TError,
  { data: BodyType<CalculateBuyPriceForSupplySignalRequestDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1SupplySignalCalculateBuyPriceCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1SupplySignalsCreate = (
  supplySignalCreateDTO: BodyType<SupplySignalCreateDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SupplySignalCreateUpdateResponse>(
    {
      url: `/api/trade/v1/supply-signals/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: supplySignalCreateDTO,
      signal,
    },
    options
  );
};

export const getApiTradeV1SupplySignalsCreateMutationOptions = <
  TError = ErrorType<ApiTradeV1SupplySignalsCreate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SupplySignalsCreate>>,
    TError,
    { data: BodyType<SupplySignalCreateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1SupplySignalsCreate>>,
  TError,
  { data: BodyType<SupplySignalCreateDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1SupplySignalsCreate>>,
    { data: BodyType<SupplySignalCreateDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return apiTradeV1SupplySignalsCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1SupplySignalsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SupplySignalsCreate>>
>;
export type ApiTradeV1SupplySignalsCreateMutationBody = BodyType<SupplySignalCreateDTO>;
export type ApiTradeV1SupplySignalsCreateMutationError = ErrorType<ApiTradeV1SupplySignalsCreate400>;

export const useApiTradeV1SupplySignalsCreate = <
  TError = ErrorType<ApiTradeV1SupplySignalsCreate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SupplySignalsCreate>>,
    TError,
    { data: BodyType<SupplySignalCreateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1SupplySignalsCreate>>,
  TError,
  { data: BodyType<SupplySignalCreateDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1SupplySignalsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1SupplySignalsUpdate = (
  id: number,
  supplySignalUpdateDTO: BodyType<SupplySignalUpdateDTO>,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<SupplySignalCreateUpdateResponse>(
    {
      url: `/api/trade/v1/supply-signals/${id}/`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: supplySignalUpdateDTO,
    },
    options
  );
};

export const getApiTradeV1SupplySignalsUpdateMutationOptions = <
  TError = ErrorType<ApiTradeV1SupplySignalsUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SupplySignalsUpdate>>,
    TError,
    { id: number; data: BodyType<SupplySignalUpdateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1SupplySignalsUpdate>>,
  TError,
  { id: number; data: BodyType<SupplySignalUpdateDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1SupplySignalsUpdate>>,
    { id: number; data: BodyType<SupplySignalUpdateDTO> }
  > = (props) => {
    const { id, data } = props ?? {};

    return apiTradeV1SupplySignalsUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1SupplySignalsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1SupplySignalsUpdate>>
>;
export type ApiTradeV1SupplySignalsUpdateMutationBody = BodyType<SupplySignalUpdateDTO>;
export type ApiTradeV1SupplySignalsUpdateMutationError = ErrorType<ApiTradeV1SupplySignalsUpdate400 | ErrorResponse>;

export const useApiTradeV1SupplySignalsUpdate = <
  TError = ErrorType<ApiTradeV1SupplySignalsUpdate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1SupplySignalsUpdate>>,
    TError,
    { id: number; data: BodyType<SupplySignalUpdateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1SupplySignalsUpdate>>,
  TError,
  { id: number; data: BodyType<SupplySignalUpdateDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1SupplySignalsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiTradeV1TradeCompaniesList = (
  params?: ApiTradeV1TradeCompaniesListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedSimpleTradeCompanyListItemList>(
    { url: `/api/trade/v1/trade-companies/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1TradeCompaniesListQueryKey = (params?: ApiTradeV1TradeCompaniesListParams) => {
  return [`/api/trade/v1/trade-companies/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1TradeCompaniesListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompaniesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>> = ({ signal }) =>
    apiTradeV1TradeCompaniesList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>
>;
export type ApiTradeV1TradeCompaniesListQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompaniesList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiTradeV1TradeCompaniesListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompaniesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompaniesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompaniesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1TradeCompaniesListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompaniesListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>> = ({ signal }) =>
    apiTradeV1TradeCompaniesList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>
>;
export type ApiTradeV1TradeCompaniesListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompaniesListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiTradeV1TradeCompaniesListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompaniesListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompaniesListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompaniesListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiTradeV1TradeCompaniesCreate = (
  tradeCompanyCreateEndUser: BodyType<TradeCompanyCreateEndUser>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<TradeCompanyCreateResponse>(
    {
      url: `/api/trade/v1/trade-companies/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tradeCompanyCreateEndUser,
      signal,
    },
    options
  );
};

export const getApiTradeV1TradeCompaniesCreateMutationOptions = <
  TError = ErrorType<ApiTradeV1TradeCompaniesCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesCreate>>,
    TError,
    { data: BodyType<TradeCompanyCreateEndUser> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesCreate>>,
  TError,
  { data: BodyType<TradeCompanyCreateEndUser> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesCreate>>,
    { data: BodyType<TradeCompanyCreateEndUser> }
  > = (props) => {
    const { data } = props ?? {};

    return apiTradeV1TradeCompaniesCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1TradeCompaniesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesCreate>>
>;
export type ApiTradeV1TradeCompaniesCreateMutationBody = BodyType<TradeCompanyCreateEndUser>;
export type ApiTradeV1TradeCompaniesCreateMutationError = ErrorType<ApiTradeV1TradeCompaniesCreate400 | ErrorResponse>;

export const useApiTradeV1TradeCompaniesCreate = <
  TError = ErrorType<ApiTradeV1TradeCompaniesCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesCreate>>,
    TError,
    { data: BodyType<TradeCompanyCreateEndUser> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesCreate>>,
  TError,
  { data: BodyType<TradeCompanyCreateEndUser> },
  TContext
> => {
  const mutationOptions = getApiTradeV1TradeCompaniesCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1TradeCompaniesRetrieve = (
  tradeCompanyId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<FullTradeCompany>(
    { url: `/api/trade/v1/trade-companies/${tradeCompanyId}/`, method: 'GET', signal },
    options
  );
};

export const getApiTradeV1TradeCompaniesRetrieveQueryKey = (tradeCompanyId: number) => {
  return [`/api/trade/v1/trade-companies/${tradeCompanyId}/`] as const;
};

export const getApiTradeV1TradeCompaniesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesRetrieveQueryKey(tradeCompanyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>> = ({ signal }) =>
    apiTradeV1TradeCompaniesRetrieve(tradeCompanyId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!tradeCompanyId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>
>;
export type ApiTradeV1TradeCompaniesRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompaniesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesRetrieveQueryOptions(tradeCompanyId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1TradeCompaniesRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesRetrieveQueryKey(tradeCompanyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>> = ({ signal }) =>
    apiTradeV1TradeCompaniesRetrieve(tradeCompanyId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>
>;
export type ApiTradeV1TradeCompaniesRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompaniesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesRetrieveSuspenseQueryOptions(tradeCompanyId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve = (
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<BuyerMaterialSpecificationsListResponse>(
    {
      url: `/api/trade/v1/trade-companies/${tradeCompanyId}/buyer-material-specifications/`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveQueryKey = (
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams
) => {
  return [
    `/api/trade/v1/trade-companies/${tradeCompanyId}/buyer-material-specifications/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveQueryKey(tradeCompanyId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>
  > = ({ signal }) =>
    apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve(tradeCompanyId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!tradeCompanyId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>
>;
export type ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params: undefined | ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveQueryOptions(
    tradeCompanyId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveQueryKey(tradeCompanyId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>
  > = ({ signal }) =>
    apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve(tradeCompanyId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>
>;
export type ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params: undefined | ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveSuspenseQueryOptions(
    tradeCompanyId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1TradeCompaniesEmployeesRetrieve = (
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<TradeCompanyEmployeesListResponse>(
    { url: `/api/trade/v1/trade-companies/${tradeCompanyId}/employees/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1TradeCompaniesEmployeesRetrieveQueryKey = (
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams
) => {
  return [`/api/trade/v1/trade-companies/${tradeCompanyId}/employees/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1TradeCompaniesEmployeesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesEmployeesRetrieveQueryKey(tradeCompanyId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>> = ({ signal }) =>
    apiTradeV1TradeCompaniesEmployeesRetrieve(tradeCompanyId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!tradeCompanyId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesEmployeesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>
>;
export type ApiTradeV1TradeCompaniesEmployeesRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompaniesEmployeesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params: undefined | ApiTradeV1TradeCompaniesEmployeesRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesEmployeesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesEmployeesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesEmployeesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesEmployeesRetrieveQueryOptions(tradeCompanyId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1TradeCompaniesEmployeesRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesEmployeesRetrieveQueryKey(tradeCompanyId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>> = ({ signal }) =>
    apiTradeV1TradeCompaniesEmployeesRetrieve(tradeCompanyId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesEmployeesRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>
>;
export type ApiTradeV1TradeCompaniesEmployeesRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompaniesEmployeesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params: undefined | ApiTradeV1TradeCompaniesEmployeesRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesEmployeesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesEmployeesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesEmployeesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesEmployeesRetrieveSuspenseQueryOptions(
    tradeCompanyId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve = (
  tradeCompanyId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PackagingSpecificationsListResponse>(
    { url: `/api/trade/v1/trade-companies/${tradeCompanyId}/packaging-specifications/`, method: 'GET', signal },
    options
  );
};

export const getApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveQueryKey = (tradeCompanyId: number) => {
  return [`/api/trade/v1/trade-companies/${tradeCompanyId}/packaging-specifications/`] as const;
};

export const getApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveQueryKey(tradeCompanyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>> = ({
    signal,
  }) => apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve(tradeCompanyId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!tradeCompanyId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>
>;
export type ApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompaniesPackagingSpecificationsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesPackagingSpecificationsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesPackagingSpecificationsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesPackagingSpecificationsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveQueryOptions(tradeCompanyId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveQueryKey(tradeCompanyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>> = ({
    signal,
  }) => apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve(tradeCompanyId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>
>;
export type ApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveSuspenseQueryOptions(
    tradeCompanyId,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1TradeCompaniesPackagingSpecificationsCreate = (
  tradeCompanyId: number,
  createPackagingSpecificationDTO: BodyType<CreatePackagingSpecificationDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CreatePackagingSpecificationsResponse>(
    {
      url: `/api/trade/v1/trade-companies/${tradeCompanyId}/packaging-specifications/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createPackagingSpecificationDTO,
      signal,
    },
    options
  );
};

export const getApiTradeV1TradeCompaniesPackagingSpecificationsCreateMutationOptions = <
  TError = ErrorType<ApiTradeV1TradeCompaniesPackagingSpecificationsCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsCreate>>,
    TError,
    { tradeCompanyId: number; data: BodyType<CreatePackagingSpecificationDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsCreate>>,
  TError,
  { tradeCompanyId: number; data: BodyType<CreatePackagingSpecificationDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsCreate>>,
    { tradeCompanyId: number; data: BodyType<CreatePackagingSpecificationDTO> }
  > = (props) => {
    const { tradeCompanyId, data } = props ?? {};

    return apiTradeV1TradeCompaniesPackagingSpecificationsCreate(tradeCompanyId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1TradeCompaniesPackagingSpecificationsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsCreate>>
>;
export type ApiTradeV1TradeCompaniesPackagingSpecificationsCreateMutationBody =
  BodyType<CreatePackagingSpecificationDTO>;
export type ApiTradeV1TradeCompaniesPackagingSpecificationsCreateMutationError = ErrorType<
  ApiTradeV1TradeCompaniesPackagingSpecificationsCreate400 | ErrorResponse
>;

export const useApiTradeV1TradeCompaniesPackagingSpecificationsCreate = <
  TError = ErrorType<ApiTradeV1TradeCompaniesPackagingSpecificationsCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsCreate>>,
    TError,
    { tradeCompanyId: number; data: BodyType<CreatePackagingSpecificationDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsCreate>>,
  TError,
  { tradeCompanyId: number; data: BodyType<CreatePackagingSpecificationDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1TradeCompaniesPackagingSpecificationsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * List payment terms for a specific trade company
 */
export const apiTradeV1TradeCompaniesPaymentTermsList = (
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesPaymentTermsListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedSimpleCompanyPaymentTermsList>(
    { url: `/api/trade/v1/trade-companies/${tradeCompanyId}/payment-terms/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1TradeCompaniesPaymentTermsListQueryKey = (
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesPaymentTermsListParams
) => {
  return [`/api/trade/v1/trade-companies/${tradeCompanyId}/payment-terms/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1TradeCompaniesPaymentTermsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesPaymentTermsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesPaymentTermsListQueryKey(tradeCompanyId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>> = ({ signal }) =>
    apiTradeV1TradeCompaniesPaymentTermsList(tradeCompanyId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!tradeCompanyId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesPaymentTermsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>
>;
export type ApiTradeV1TradeCompaniesPaymentTermsListQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompaniesPaymentTermsList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params: undefined | ApiTradeV1TradeCompaniesPaymentTermsListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesPaymentTermsList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesPaymentTermsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesPaymentTermsList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesPaymentTermsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesPaymentTermsList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesPaymentTermsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesPaymentTermsListQueryOptions(tradeCompanyId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1TradeCompaniesPaymentTermsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesPaymentTermsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesPaymentTermsListQueryKey(tradeCompanyId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>> = ({ signal }) =>
    apiTradeV1TradeCompaniesPaymentTermsList(tradeCompanyId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesPaymentTermsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>
>;
export type ApiTradeV1TradeCompaniesPaymentTermsListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompaniesPaymentTermsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params: undefined | ApiTradeV1TradeCompaniesPaymentTermsListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesPaymentTermsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesPaymentTermsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesPaymentTermsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesPaymentTermsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesPaymentTermsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesPaymentTermsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesPaymentTermsListSuspenseQueryOptions(tradeCompanyId, params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1TradeCompaniesSessionsRetrieve = (
  tradeCompanyId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<TradeCompanySessionList>(
    { url: `/api/trade/v1/trade-companies/${tradeCompanyId}/sessions/`, method: 'GET', signal },
    options
  );
};

export const getApiTradeV1TradeCompaniesSessionsRetrieveQueryKey = (tradeCompanyId: number) => {
  return [`/api/trade/v1/trade-companies/${tradeCompanyId}/sessions/`] as const;
};

export const getApiTradeV1TradeCompaniesSessionsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesSessionsRetrieveQueryKey(tradeCompanyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>> = ({ signal }) =>
    apiTradeV1TradeCompaniesSessionsRetrieve(tradeCompanyId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!tradeCompanyId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesSessionsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>
>;
export type ApiTradeV1TradeCompaniesSessionsRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompaniesSessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesSessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesSessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesSessionsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesSessionsRetrieveQueryOptions(tradeCompanyId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1TradeCompaniesSessionsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesSessionsRetrieveQueryKey(tradeCompanyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>> = ({ signal }) =>
    apiTradeV1TradeCompaniesSessionsRetrieve(tradeCompanyId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesSessionsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>
>;
export type ApiTradeV1TradeCompaniesSessionsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompaniesSessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesSessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesSessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesSessionsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesSessionsRetrieveSuspenseQueryOptions(tradeCompanyId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1TradeCompaniesSessionsCreate = (
  tradeCompanyId: number,
  tradeCompanySessionCreateDTO: BodyType<TradeCompanySessionCreateDTO>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<TradeCompanySessionCreateResponse>(
    {
      url: `/api/trade/v1/trade-companies/${tradeCompanyId}/sessions/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tradeCompanySessionCreateDTO,
      signal,
    },
    options
  );
};

export const getApiTradeV1TradeCompaniesSessionsCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsCreate>>,
    TError,
    { tradeCompanyId: number; data: BodyType<TradeCompanySessionCreateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsCreate>>,
  TError,
  { tradeCompanyId: number; data: BodyType<TradeCompanySessionCreateDTO> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsCreate>>,
    { tradeCompanyId: number; data: BodyType<TradeCompanySessionCreateDTO> }
  > = (props) => {
    const { tradeCompanyId, data } = props ?? {};

    return apiTradeV1TradeCompaniesSessionsCreate(tradeCompanyId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTradeV1TradeCompaniesSessionsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsCreate>>
>;
export type ApiTradeV1TradeCompaniesSessionsCreateMutationBody = BodyType<TradeCompanySessionCreateDTO>;
export type ApiTradeV1TradeCompaniesSessionsCreateMutationError = ErrorType<ErrorResponse>;

export const useApiTradeV1TradeCompaniesSessionsCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsCreate>>,
    TError,
    { tradeCompanyId: number; data: BodyType<TradeCompanySessionCreateDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsCreate>>,
  TError,
  { tradeCompanyId: number; data: BodyType<TradeCompanySessionCreateDTO> },
  TContext
> => {
  const mutationOptions = getApiTradeV1TradeCompaniesSessionsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const apiTradeV1TradeCompaniesSiteMaterialsRetrieve = (
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SiteMaterialListResponse>(
    { url: `/api/trade/v1/trade-companies/${tradeCompanyId}/site-materials/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1TradeCompaniesSiteMaterialsRetrieveQueryKey = (
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams
) => {
  return [`/api/trade/v1/trade-companies/${tradeCompanyId}/site-materials/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1TradeCompaniesSiteMaterialsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesSiteMaterialsRetrieveQueryKey(tradeCompanyId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>> = ({
    signal,
  }) => apiTradeV1TradeCompaniesSiteMaterialsRetrieve(tradeCompanyId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!tradeCompanyId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesSiteMaterialsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>
>;
export type ApiTradeV1TradeCompaniesSiteMaterialsRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompaniesSiteMaterialsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params: undefined | ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesSiteMaterialsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesSiteMaterialsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesSiteMaterialsRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesSiteMaterialsRetrieveQueryOptions(tradeCompanyId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1TradeCompaniesSiteMaterialsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesSiteMaterialsRetrieveQueryKey(tradeCompanyId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>> = ({
    signal,
  }) => apiTradeV1TradeCompaniesSiteMaterialsRetrieve(tradeCompanyId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesSiteMaterialsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>
>;
export type ApiTradeV1TradeCompaniesSiteMaterialsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompaniesSiteMaterialsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params: undefined | ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesSiteMaterialsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesSiteMaterialsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesSiteMaterialsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesSiteMaterialsRetrieveSuspenseQueryOptions(
    tradeCompanyId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1TradeCompaniesTradeSitesRetrieve = (
  tradeCompanyId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SimpleTradeSiteListResponse>(
    { url: `/api/trade/v1/trade-companies/${tradeCompanyId}/trade-sites/`, method: 'GET', signal },
    options
  );
};

export const getApiTradeV1TradeCompaniesTradeSitesRetrieveQueryKey = (tradeCompanyId: number) => {
  return [`/api/trade/v1/trade-companies/${tradeCompanyId}/trade-sites/`] as const;
};

export const getApiTradeV1TradeCompaniesTradeSitesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesTradeSitesRetrieveQueryKey(tradeCompanyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>> = ({ signal }) =>
    apiTradeV1TradeCompaniesTradeSitesRetrieve(tradeCompanyId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!tradeCompanyId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesTradeSitesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>
>;
export type ApiTradeV1TradeCompaniesTradeSitesRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompaniesTradeSitesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesTradeSitesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesTradeSitesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesTradeSitesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesTradeSitesRetrieveQueryOptions(tradeCompanyId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1TradeCompaniesTradeSitesRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesTradeSitesRetrieveQueryKey(tradeCompanyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>> = ({ signal }) =>
    apiTradeV1TradeCompaniesTradeSitesRetrieve(tradeCompanyId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesTradeSitesRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>
>;
export type ApiTradeV1TradeCompaniesTradeSitesRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompaniesTradeSitesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesTradeSitesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesTradeSitesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesTradeSitesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  tradeCompanyId: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesTradeSitesRetrieveSuspenseQueryOptions(tradeCompanyId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve = (
  params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AssignedAccountManagersResponse>(
    { url: `/api/trade/v1/trade-companies/assigned-account-managers/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveQueryKey = (
  params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams
) => {
  return [`/api/trade/v1/trade-companies/assigned-account-managers/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
  TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>> = ({
    signal,
  }) => apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>
>;
export type ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveQueryError = ErrorType<
  ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse
>;

export function useApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
  TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>,
>(
  params: undefined | ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
  TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
  TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
  TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
  TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>> = ({
    signal,
  }) => apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>
>;
export type ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveSuspenseQueryError = ErrorType<
  ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse
>;

export function useApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
  TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>,
>(
  params: undefined | ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
  TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
  TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
  TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiTradeV1TradeCompanyLeadsList = (
  params?: ApiTradeV1TradeCompanyLeadsListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedSimpleTradeCompanyLeadListItemList>(
    { url: `/api/trade/v1/trade-company-leads/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1TradeCompanyLeadsListQueryKey = (params?: ApiTradeV1TradeCompanyLeadsListParams) => {
  return [`/api/trade/v1/trade-company-leads/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1TradeCompanyLeadsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompanyLeadsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeCompanyLeadsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>> = ({ signal }) =>
    apiTradeV1TradeCompanyLeadsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompanyLeadsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>
>;
export type ApiTradeV1TradeCompanyLeadsListQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompanyLeadsList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiTradeV1TradeCompanyLeadsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompanyLeadsList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompanyLeadsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompanyLeadsList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompanyLeadsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompanyLeadsList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompanyLeadsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompanyLeadsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1TradeCompanyLeadsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompanyLeadsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeCompanyLeadsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>> = ({ signal }) =>
    apiTradeV1TradeCompanyLeadsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeCompanyLeadsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>
>;
export type ApiTradeV1TradeCompanyLeadsListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeCompanyLeadsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiTradeV1TradeCompanyLeadsListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompanyLeadsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompanyLeadsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeCompanyLeadsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompanyLeadsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeCompanyLeadsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeCompanyLeadsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeCompanyLeadsListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiTradeV1TradeSitesList = (
  params?: ApiTradeV1TradeSitesListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedSimpleTradeSiteListItemList>(
    { url: `/api/trade/v1/trade-sites/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1TradeSitesListQueryKey = (params?: ApiTradeV1TradeSitesListParams) => {
  return [`/api/trade/v1/trade-sites/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1TradeSitesListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeSitesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeSitesListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>> = ({ signal }) =>
    apiTradeV1TradeSitesList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeSitesListQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>>;
export type ApiTradeV1TradeSitesListQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeSitesList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiTradeV1TradeSitesListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeSitesList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeSitesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeSitesList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeSitesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeSitesList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeSitesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeSitesListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1TradeSitesListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeSitesListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeSitesListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>> = ({ signal }) =>
    apiTradeV1TradeSitesList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeSitesListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>
>;
export type ApiTradeV1TradeSitesListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeSitesListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ApiTradeV1TradeSitesListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeSitesListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeSitesListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeSitesListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeSitesListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeSitesListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ApiTradeV1TradeSitesListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeSitesListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1TradeSitesRetrieve = (
  siteId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SiteWithTradeCompany>(
    { url: `/api/trade/v1/trade-sites/${siteId}/`, method: 'GET', signal },
    options
  );
};

export const getApiTradeV1TradeSitesRetrieveQueryKey = (siteId: number) => {
  return [`/api/trade/v1/trade-sites/${siteId}/`] as const;
};

export const getApiTradeV1TradeSitesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeSitesRetrieveQueryKey(siteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>> = ({ signal }) =>
    apiTradeV1TradeSitesRetrieve(siteId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!siteId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeSitesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>
>;
export type ApiTradeV1TradeSitesRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeSitesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeSitesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeSitesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeSitesRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeSitesRetrieveQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1TradeSitesRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeSitesRetrieveQueryKey(siteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>> = ({ signal }) =>
    apiTradeV1TradeSitesRetrieve(siteId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeSitesRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>
>;
export type ApiTradeV1TradeSitesRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeSitesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: number,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeSitesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeSitesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeSitesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeSitesRetrieveSuspenseQueryOptions(siteId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1TradeSitesEvidenceList = (
  siteId: string,
  params?: ApiTradeV1TradeSitesEvidenceListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedEvidenceList>(
    { url: `/api/trade/v1/trade-sites/${siteId}/evidence/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV1TradeSitesEvidenceListQueryKey = (
  siteId: string,
  params?: ApiTradeV1TradeSitesEvidenceListParams
) => {
  return [`/api/trade/v1/trade-sites/${siteId}/evidence/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV1TradeSitesEvidenceListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  params?: ApiTradeV1TradeSitesEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeSitesEvidenceListQueryKey(siteId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>> = ({ signal }) =>
    apiTradeV1TradeSitesEvidenceList(siteId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!siteId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeSitesEvidenceListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>
>;
export type ApiTradeV1TradeSitesEvidenceListQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeSitesEvidenceList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  params: undefined | ApiTradeV1TradeSitesEvidenceListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeSitesEvidenceList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  params?: ApiTradeV1TradeSitesEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeSitesEvidenceList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  params?: ApiTradeV1TradeSitesEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeSitesEvidenceList<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  params?: ApiTradeV1TradeSitesEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeSitesEvidenceListQueryOptions(siteId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1TradeSitesEvidenceListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  params?: ApiTradeV1TradeSitesEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeSitesEvidenceListQueryKey(siteId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>> = ({ signal }) =>
    apiTradeV1TradeSitesEvidenceList(siteId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeSitesEvidenceListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>
>;
export type ApiTradeV1TradeSitesEvidenceListSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeSitesEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  params: undefined | ApiTradeV1TradeSitesEvidenceListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeSitesEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  params?: ApiTradeV1TradeSitesEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeSitesEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  params?: ApiTradeV1TradeSitesEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeSitesEvidenceListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  params?: ApiTradeV1TradeSitesEvidenceListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeSitesEvidenceListSuspenseQueryOptions(siteId, params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV1TradeSitesEvidenceRetrieve = (
  siteId: string,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Evidence>(
    { url: `/api/trade/v1/trade-sites/${siteId}/evidence/${id}/`, method: 'GET', signal },
    options
  );
};

export const getApiTradeV1TradeSitesEvidenceRetrieveQueryKey = (siteId: string, id: number) => {
  return [`/api/trade/v1/trade-sites/${siteId}/evidence/${id}/`] as const;
};

export const getApiTradeV1TradeSitesEvidenceRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeSitesEvidenceRetrieveQueryKey(siteId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>> = ({ signal }) =>
    apiTradeV1TradeSitesEvidenceRetrieve(siteId, id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(siteId && id), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeSitesEvidenceRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>
>;
export type ApiTradeV1TradeSitesEvidenceRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeSitesEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeSitesEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeSitesEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeSitesEvidenceRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeSitesEvidenceRetrieveQueryOptions(siteId, id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV1TradeSitesEvidenceRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV1TradeSitesEvidenceRetrieveQueryKey(siteId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>> = ({ signal }) =>
    apiTradeV1TradeSitesEvidenceRetrieve(siteId, id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV1TradeSitesEvidenceRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>
>;
export type ApiTradeV1TradeSitesEvidenceRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV1TradeSitesEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  id: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeSitesEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV1TradeSitesEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV1TradeSitesEvidenceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteId: string,
  id: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesEvidenceRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV1TradeSitesEvidenceRetrieveSuspenseQueryOptions(siteId, id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * A base view that returns paginated results.

Developers should handle pagination manually using selector methods and then
use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiTradeV2DemandSignalsBulkMatchSiteMaterialsList = (
  params: ApiTradeV2DemandSignalsBulkMatchSiteMaterialsListParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaginatedMatchedSiteMaterialV2List>(
    { url: `/api/trade/v2/demand-signals/bulk-match-site-materials/`, method: 'GET', params, signal },
    options
  );
};

export const getApiTradeV2DemandSignalsBulkMatchSiteMaterialsListQueryKey = (
  params: ApiTradeV2DemandSignalsBulkMatchSiteMaterialsListParams
) => {
  return [`/api/trade/v2/demand-signals/bulk-match-site-materials/`, ...(params ? [params] : [])] as const;
};

export const getApiTradeV2DemandSignalsBulkMatchSiteMaterialsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
  TError = ErrorType<ApiTradeV2DemandSignalsBulkMatchSiteMaterialsList400 | ErrorResponse>,
>(
  params: ApiTradeV2DemandSignalsBulkMatchSiteMaterialsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV2DemandSignalsBulkMatchSiteMaterialsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>> = ({
    signal,
  }) => apiTradeV2DemandSignalsBulkMatchSiteMaterialsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV2DemandSignalsBulkMatchSiteMaterialsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>
>;
export type ApiTradeV2DemandSignalsBulkMatchSiteMaterialsListQueryError = ErrorType<
  ApiTradeV2DemandSignalsBulkMatchSiteMaterialsList400 | ErrorResponse
>;

export function useApiTradeV2DemandSignalsBulkMatchSiteMaterialsList<
  TData = Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
  TError = ErrorType<ApiTradeV2DemandSignalsBulkMatchSiteMaterialsList400 | ErrorResponse>,
>(
  params: ApiTradeV2DemandSignalsBulkMatchSiteMaterialsListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV2DemandSignalsBulkMatchSiteMaterialsList<
  TData = Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
  TError = ErrorType<ApiTradeV2DemandSignalsBulkMatchSiteMaterialsList400 | ErrorResponse>,
>(
  params: ApiTradeV2DemandSignalsBulkMatchSiteMaterialsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV2DemandSignalsBulkMatchSiteMaterialsList<
  TData = Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
  TError = ErrorType<ApiTradeV2DemandSignalsBulkMatchSiteMaterialsList400 | ErrorResponse>,
>(
  params: ApiTradeV2DemandSignalsBulkMatchSiteMaterialsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV2DemandSignalsBulkMatchSiteMaterialsList<
  TData = Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
  TError = ErrorType<ApiTradeV2DemandSignalsBulkMatchSiteMaterialsList400 | ErrorResponse>,
>(
  params: ApiTradeV2DemandSignalsBulkMatchSiteMaterialsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV2DemandSignalsBulkMatchSiteMaterialsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV2DemandSignalsBulkMatchSiteMaterialsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
  TError = ErrorType<ApiTradeV2DemandSignalsBulkMatchSiteMaterialsList400 | ErrorResponse>,
>(
  params: ApiTradeV2DemandSignalsBulkMatchSiteMaterialsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV2DemandSignalsBulkMatchSiteMaterialsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>> = ({
    signal,
  }) => apiTradeV2DemandSignalsBulkMatchSiteMaterialsList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV2DemandSignalsBulkMatchSiteMaterialsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>
>;
export type ApiTradeV2DemandSignalsBulkMatchSiteMaterialsListSuspenseQueryError = ErrorType<
  ApiTradeV2DemandSignalsBulkMatchSiteMaterialsList400 | ErrorResponse
>;

export function useApiTradeV2DemandSignalsBulkMatchSiteMaterialsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
  TError = ErrorType<ApiTradeV2DemandSignalsBulkMatchSiteMaterialsList400 | ErrorResponse>,
>(
  params: ApiTradeV2DemandSignalsBulkMatchSiteMaterialsListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV2DemandSignalsBulkMatchSiteMaterialsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
  TError = ErrorType<ApiTradeV2DemandSignalsBulkMatchSiteMaterialsList400 | ErrorResponse>,
>(
  params: ApiTradeV2DemandSignalsBulkMatchSiteMaterialsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV2DemandSignalsBulkMatchSiteMaterialsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
  TError = ErrorType<ApiTradeV2DemandSignalsBulkMatchSiteMaterialsList400 | ErrorResponse>,
>(
  params: ApiTradeV2DemandSignalsBulkMatchSiteMaterialsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV2DemandSignalsBulkMatchSiteMaterialsListSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
  TError = ErrorType<ApiTradeV2DemandSignalsBulkMatchSiteMaterialsList400 | ErrorResponse>,
>(
  params: ApiTradeV2DemandSignalsBulkMatchSiteMaterialsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiTradeV2DemandSignalsBulkMatchSiteMaterialsList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV2DemandSignalsBulkMatchSiteMaterialsListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTradeV2SiteMaterialsQualityReportRetrieve = (
  siteMaterialId: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<QualityReport>(
    { url: `/api/trade/v2/site-materials/${siteMaterialId}/quality-report/`, method: 'GET', signal },
    options
  );
};

export const getApiTradeV2SiteMaterialsQualityReportRetrieveQueryKey = (siteMaterialId: string) => {
  return [`/api/trade/v2/site-materials/${siteMaterialId}/quality-report/`] as const;
};

export const getApiTradeV2SiteMaterialsQualityReportRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV2SiteMaterialsQualityReportRetrieveQueryKey(siteMaterialId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>> = ({
    signal,
  }) => apiTradeV2SiteMaterialsQualityReportRetrieve(siteMaterialId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!siteMaterialId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV2SiteMaterialsQualityReportRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>
>;
export type ApiTradeV2SiteMaterialsQualityReportRetrieveQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV2SiteMaterialsQualityReportRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV2SiteMaterialsQualityReportRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV2SiteMaterialsQualityReportRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV2SiteMaterialsQualityReportRetrieve<
  TData = Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV2SiteMaterialsQualityReportRetrieveQueryOptions(siteMaterialId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiTradeV2SiteMaterialsQualityReportRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTradeV2SiteMaterialsQualityReportRetrieveQueryKey(siteMaterialId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>> = ({
    signal,
  }) => apiTradeV2SiteMaterialsQualityReportRetrieve(siteMaterialId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ApiTradeV2SiteMaterialsQualityReportRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>
>;
export type ApiTradeV2SiteMaterialsQualityReportRetrieveSuspenseQueryError = ErrorType<ErrorResponse>;

export function useApiTradeV2SiteMaterialsQualityReportRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV2SiteMaterialsQualityReportRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useApiTradeV2SiteMaterialsQualityReportRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useApiTradeV2SiteMaterialsQualityReportRetrieveSuspense<
  TData = Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>,
  TError = ErrorType<ErrorResponse>,
>(
  siteMaterialId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV2SiteMaterialsQualityReportRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getApiTradeV2SiteMaterialsQualityReportRetrieveSuspenseQueryOptions(siteMaterialId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const apiTransportPricesV1BulkRefreshOceanRatesCreate = (
  bulkRefreshOceanRatesInput: BodyType<BulkRefreshOceanRatesInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<BulkRefreshOceanRatesOutput>(
    {
      url: `/api/transport-prices/v1/bulk-refresh-ocean-rates/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: bulkRefreshOceanRatesInput,
      signal,
    },
    options
  );
};

export const getApiTransportPricesV1BulkRefreshOceanRatesCreateMutationOptions = <
  TError = ErrorType<unknown | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTransportPricesV1BulkRefreshOceanRatesCreate>>,
    TError,
    { data: BodyType<BulkRefreshOceanRatesInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTransportPricesV1BulkRefreshOceanRatesCreate>>,
  TError,
  { data: BodyType<BulkRefreshOceanRatesInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTransportPricesV1BulkRefreshOceanRatesCreate>>,
    { data: BodyType<BulkRefreshOceanRatesInput> }
  > = (props) => {
    const { data } = props ?? {};

    return apiTransportPricesV1BulkRefreshOceanRatesCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTransportPricesV1BulkRefreshOceanRatesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTransportPricesV1BulkRefreshOceanRatesCreate>>
>;
export type ApiTransportPricesV1BulkRefreshOceanRatesCreateMutationBody = BodyType<BulkRefreshOceanRatesInput>;
export type ApiTransportPricesV1BulkRefreshOceanRatesCreateMutationError = ErrorType<unknown | ErrorResponse>;

export const useApiTransportPricesV1BulkRefreshOceanRatesCreate = <
  TError = ErrorType<unknown | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTransportPricesV1BulkRefreshOceanRatesCreate>>,
    TError,
    { data: BodyType<BulkRefreshOceanRatesInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTransportPricesV1BulkRefreshOceanRatesCreate>>,
  TError,
  { data: BodyType<BulkRefreshOceanRatesInput> },
  TContext
> => {
  const mutationOptions = getApiTransportPricesV1BulkRefreshOceanRatesCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Clears all cached transport costs data
 * @summary Clear transport costs cache
 */
export const apiTransportPricesV1ClearCacheCreate = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>({ url: `/api/transport-prices/v1/clear-cache/`, method: 'POST', signal }, options);
};

export const getApiTransportPricesV1ClearCacheCreateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTransportPricesV1ClearCacheCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<Awaited<ReturnType<typeof apiTransportPricesV1ClearCacheCreate>>, TError, void, TContext> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTransportPricesV1ClearCacheCreate>>, void> = () => {
    return apiTransportPricesV1ClearCacheCreate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTransportPricesV1ClearCacheCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTransportPricesV1ClearCacheCreate>>
>;

export type ApiTransportPricesV1ClearCacheCreateMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Clear transport costs cache
 */
export const useApiTransportPricesV1ClearCacheCreate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTransportPricesV1ClearCacheCreate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<Awaited<ReturnType<typeof apiTransportPricesV1ClearCacheCreate>>, TError, void, TContext> => {
  const mutationOptions = getApiTransportPricesV1ClearCacheCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Estimate transport costs
 * @summary Estimate transport costs
 */
export const apiTransportPricesV1EstimateCreate = (
  transportCostEstimateInput: BodyType<TransportCostEstimateInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PointToPointTransportCostBreakdownResultDTO>(
    {
      url: `/api/transport-prices/v1/estimate/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: transportCostEstimateInput,
      signal,
    },
    options
  );
};

export const getApiTransportPricesV1EstimateCreateMutationOptions = <
  TError = ErrorType<ApiTransportPricesV1EstimateCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTransportPricesV1EstimateCreate>>,
    TError,
    { data: BodyType<TransportCostEstimateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTransportPricesV1EstimateCreate>>,
  TError,
  { data: BodyType<TransportCostEstimateInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTransportPricesV1EstimateCreate>>,
    { data: BodyType<TransportCostEstimateInput> }
  > = (props) => {
    const { data } = props ?? {};

    return apiTransportPricesV1EstimateCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTransportPricesV1EstimateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTransportPricesV1EstimateCreate>>
>;
export type ApiTransportPricesV1EstimateCreateMutationBody = BodyType<TransportCostEstimateInput>;
export type ApiTransportPricesV1EstimateCreateMutationError = ErrorType<
  ApiTransportPricesV1EstimateCreate400 | ErrorResponse
>;

/**
 * @summary Estimate transport costs
 */
export const useApiTransportPricesV1EstimateCreate = <
  TError = ErrorType<ApiTransportPricesV1EstimateCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTransportPricesV1EstimateCreate>>,
    TError,
    { data: BodyType<TransportCostEstimateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTransportPricesV1EstimateCreate>>,
  TError,
  { data: BodyType<TransportCostEstimateInput> },
  TContext
> => {
  const mutationOptions = getApiTransportPricesV1EstimateCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Estimate transit time for transport routes
 * @summary Estimate transit time
 */
export const apiTransportPricesV1TransitTimeEstimateCreate = (
  transitTimeEstimateInput: BodyType<TransitTimeEstimateInput>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<TransitTimeEstimateResultDTO>(
    {
      url: `/api/transport-prices/v1/transit-time-estimate/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: transitTimeEstimateInput,
      signal,
    },
    options
  );
};

export const getApiTransportPricesV1TransitTimeEstimateCreateMutationOptions = <
  TError = ErrorType<ApiTransportPricesV1TransitTimeEstimateCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTransportPricesV1TransitTimeEstimateCreate>>,
    TError,
    { data: BodyType<TransitTimeEstimateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiTransportPricesV1TransitTimeEstimateCreate>>,
  TError,
  { data: BodyType<TransitTimeEstimateInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTransportPricesV1TransitTimeEstimateCreate>>,
    { data: BodyType<TransitTimeEstimateInput> }
  > = (props) => {
    const { data } = props ?? {};

    return apiTransportPricesV1TransitTimeEstimateCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiTransportPricesV1TransitTimeEstimateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTransportPricesV1TransitTimeEstimateCreate>>
>;
export type ApiTransportPricesV1TransitTimeEstimateCreateMutationBody = BodyType<TransitTimeEstimateInput>;
export type ApiTransportPricesV1TransitTimeEstimateCreateMutationError = ErrorType<
  ApiTransportPricesV1TransitTimeEstimateCreate400 | ErrorResponse
>;

/**
 * @summary Estimate transit time
 */
export const useApiTransportPricesV1TransitTimeEstimateCreate = <
  TError = ErrorType<ApiTransportPricesV1TransitTimeEstimateCreate400 | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTransportPricesV1TransitTimeEstimateCreate>>,
    TError,
    { data: BodyType<TransitTimeEstimateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiTransportPricesV1TransitTimeEstimateCreate>>,
  TError,
  { data: BodyType<TransitTimeEstimateInput> },
  TContext
> => {
  const mutationOptions = getApiTransportPricesV1TransitTimeEstimateCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Get a list of port choices, filtered by name
 */
export const postDealDealhubFilterChoicesPortsRetrieve = (
  params?: PostDealDealhubFilterChoicesPortsRetrieveParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PortChoicesResponse>(
    { url: `/post-deal/dealhub/filter-choices/ports/`, method: 'GET', params, signal },
    options
  );
};

export const getPostDealDealhubFilterChoicesPortsRetrieveQueryKey = (
  params?: PostDealDealhubFilterChoicesPortsRetrieveParams
) => {
  return [`/post-deal/dealhub/filter-choices/ports/`, ...(params ? [params] : [])] as const;
};

export const getPostDealDealhubFilterChoicesPortsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: PostDealDealhubFilterChoicesPortsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPostDealDealhubFilterChoicesPortsRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>> = ({ signal }) =>
    postDealDealhubFilterChoicesPortsRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PostDealDealhubFilterChoicesPortsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>
>;
export type PostDealDealhubFilterChoicesPortsRetrieveQueryError = ErrorType<unknown>;

export function usePostDealDealhubFilterChoicesPortsRetrieve<
  TData = Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | PostDealDealhubFilterChoicesPortsRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePostDealDealhubFilterChoicesPortsRetrieve<
  TData = Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: PostDealDealhubFilterChoicesPortsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>,
          TError,
          TData
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePostDealDealhubFilterChoicesPortsRetrieve<
  TData = Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: PostDealDealhubFilterChoicesPortsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get a list of port choices, filtered by name
 */

export function usePostDealDealhubFilterChoicesPortsRetrieve<
  TData = Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: PostDealDealhubFilterChoicesPortsRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPostDealDealhubFilterChoicesPortsRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPostDealDealhubFilterChoicesPortsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: PostDealDealhubFilterChoicesPortsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPostDealDealhubFilterChoicesPortsRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>> = ({ signal }) =>
    postDealDealhubFilterChoicesPortsRetrieve(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PostDealDealhubFilterChoicesPortsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>
>;
export type PostDealDealhubFilterChoicesPortsRetrieveSuspenseQueryError = ErrorType<unknown>;

export function usePostDealDealhubFilterChoicesPortsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | PostDealDealhubFilterChoicesPortsRetrieveParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePostDealDealhubFilterChoicesPortsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: PostDealDealhubFilterChoicesPortsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePostDealDealhubFilterChoicesPortsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: PostDealDealhubFilterChoicesPortsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get a list of port choices, filtered by name
 */

export function usePostDealDealhubFilterChoicesPortsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>,
  TError = ErrorType<unknown>,
>(
  params?: PostDealDealhubFilterChoicesPortsRetrieveParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof postDealDealhubFilterChoicesPortsRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPostDealDealhubFilterChoicesPortsRetrieveSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
